// Generated by Avo VERSION 147.18.0. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* eslint-disable */

// fetch() polyfill
(function () {
  if (typeof window === "undefined") {
    return;
  }
  var support = {
    searchParams: "URLSearchParams" in self,
    iterable: "Symbol" in self && "iterator" in Symbol,
    blob:
      "FileReader" in self &&
      "Blob" in self &&
      (function () {
        try {
          new Blob();
          return true;
        } catch (e) {
          return false;
        }
      })(),
    formData: "FormData" in self,
    arrayBuffer: "ArrayBuffer" in self,
  };

  function isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj);
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      "[object Int8Array]",
      "[object Uint8Array]",
      "[object Uint8ClampedArray]",
      "[object Int16Array]",
      "[object Uint16Array]",
      "[object Int32Array]",
      "[object Uint32Array]",
      "[object Float32Array]",
      "[object Float64Array]",
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function (obj) {
        return (
          obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
        );
      };
  }

  function normalizeName(name) {
    if (typeof name !== "string") {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError("Invalid character in header field name");
    }
    return name.toLowerCase();
  }

  function normalizeValue(value) {
    if (typeof value !== "string") {
      value = String(value);
    }
    return value;
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function () {
        var value = items.shift();
        return { done: value === undefined, value: value };
      },
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function () {
        return iterator;
      };
    }

    return iterator;
  }

  function Headers(headers) {
    this.map = {};

    if (headers instanceof Headers) {
      headers.forEach(function (value, name) {
        this.append(name, value);
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function (header) {
        this.append(header[0], header[1]);
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function (name) {
        this.append(name, headers[name]);
      }, this);
    }
  }

  Headers.prototype.append = function (name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ", " + value : value;
  };

  Headers.prototype["delete"] = function (name) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function (name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null;
  };

  Headers.prototype.has = function (name) {
    return this.map.hasOwnProperty(normalizeName(name));
  };

  Headers.prototype.set = function (name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function (callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function () {
    var items = [];
    this.forEach(function (value, name) {
      items.push(name);
    });
    return iteratorFor(items);
  };

  Headers.prototype.values = function () {
    var items = [];
    this.forEach(function (value) {
      items.push(value);
    });
    return iteratorFor(items);
  };

  Headers.prototype.entries = function () {
    var items = [];
    this.forEach(function (value, name) {
      items.push([name, value]);
    });
    return iteratorFor(items);
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError("Already read"));
    }
    body.bodyUsed = true;
  }

  function fileReaderReady(reader) {
    return new Promise(function (resolve, reject) {
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function () {
        reject(reader.error);
      };
    });
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise;
  }

  function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise;
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]);
    }
    return chars.join("");
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0);
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer;
    }
  }

  function Body() {
    this.bodyUsed = false;

    this._initBody = function (body) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = "";
      } else if (typeof body === "string") {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (
        support.searchParams &&
        URLSearchParams.prototype.isPrototypeOf(body)
      ) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (
        support.arrayBuffer &&
        (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))
      ) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get("content-type")) {
        if (typeof body === "string") {
          this.headers.set("content-type", "text/plain;charset=UTF-8");
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set("content-type", this._bodyBlob.type);
        } else if (
          support.searchParams &&
          URLSearchParams.prototype.isPrototypeOf(body)
        ) {
          this.headers.set(
            "content-type",
            "application/x-www-form-urlencoded;charset=UTF-8"
          );
        }
      }
    };

    if (support.blob) {
      this.blob = function () {
        var rejected = consumed(this);
        if (rejected) {
          return rejected;
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob);
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]));
        } else if (this._bodyFormData) {
          throw new Error("could not read FormData body as blob");
        } else {
          return Promise.resolve(new Blob([this._bodyText]));
        }
      };

      this.arrayBuffer = function () {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
        } else {
          return this.blob().then(readBlobAsArrayBuffer);
        }
      };
    }

    this.text = function () {
      var rejected = consumed(this);
      if (rejected) {
        return rejected;
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob);
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
      } else if (this._bodyFormData) {
        throw new Error("could not read FormData body as text");
      } else {
        return Promise.resolve(this._bodyText);
      }
    };

    if (support.formData) {
      this.formData = function () {
        return this.text().then(decode);
      };
    }

    this.json = function () {
      return this.text().then(JSON.parse);
    };

    return this;
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];

  function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method;
  }

  function Request(input, options) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError("Already read");
      }
      this.url = input.url;
      this.credentials = input.credentials;
      if (!options.headers) {
        this.headers = new Headers(input.headers);
      }
      this.method = input.method;
      this.mode = input.mode;
      this.signal = input.signal;
      if (!body && input._bodyInit != null) {
        body = input._bodyInit;
        input.bodyUsed = true;
      }
    } else {
      this.url = String(input);
    }

    this.credentials = options.credentials || this.credentials || "same-origin";
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers);
    }
    this.method = normalizeMethod(options.method || this.method || "GET");
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal;
    this.referrer = null;

    if ((this.method === "GET" || this.method === "HEAD") && body) {
      throw new TypeError("Body not allowed for GET or HEAD requests");
    }
    this._initBody(body);
  }

  Request.prototype.clone = function () {
    return new Request(this, { body: this._bodyInit });
  };

  function decode(body) {
    var form = new FormData();
    body
      .trim()
      .split("&")
      .forEach(function (bytes) {
        if (bytes) {
          var split = bytes.split("=");
          var name = split.shift().replace(/\+/g, " ");
          var value = split.join("=").replace(/\+/g, " ");
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form;
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
    preProcessedHeaders.split(/\r?\n/).forEach(function (line) {
      var parts = line.split(":");
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(":").trim();
        headers.append(key, value);
      }
    });
    return headers;
  }

  Body.call(Request.prototype);

  function Response(bodyInit, options) {
    if (!options) {
      options = {};
    }

    this.type = "default";
    this.status = options.status === undefined ? 200 : options.status;
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = "statusText" in options ? options.statusText : "OK";
    this.headers = new Headers(options.headers);
    this.url = options.url || "";
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function () {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url,
    });
  };

  Response.error = function () {
    var response = new Response(null, { status: 0, statusText: "" });
    response.type = "error";
    return response;
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function (url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError("Invalid status code");
    }

    return new Response(null, { status: status, headers: { location: url } });
  };

  self.DOMException = self.DOMException;
  try {
    new self.DOMException();
  } catch (err) {
    self.DOMException = function (message, name) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    self.DOMException.prototype = Object.create(Error.prototype);
    self.DOMException.prototype.constructor = self.DOMException;
  }

  function fetch(input, init) {
    return new Promise(function (resolve, reject) {
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new self.DOMException("Aborted", "AbortError"));
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function () {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || ""),
        };
        options.url =
          "responseURL" in xhr
            ? xhr.responseURL
            : options.headers.get("X-Request-URL");
        var body = "response" in xhr ? xhr.response : xhr.responseText;
        resolve(new Response(body, options));
      };

      xhr.onerror = function () {
        reject(new TypeError("Network request failed"));
      };

      xhr.ontimeout = function () {
        reject(new TypeError("Network request failed"));
      };

      xhr.onabort = function () {
        reject(new self.DOMException("Aborted", "AbortError"));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === "include") {
        xhr.withCredentials = true;
      } else if (request.credentials === "omit") {
        xhr.withCredentials = false;
      }

      if ("responseType" in xhr && support.blob) {
        xhr.responseType = "blob";
      }

      request.headers.forEach(function (value, name) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener("abort", abortXhr);

        xhr.onreadystatechange = function () {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener("abort", abortXhr);
          }
        };
      }

      xhr.send(
        typeof request._bodyInit === "undefined" ? null : request._bodyInit
      );
    });
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    self.fetch = fetch;
    self.Headers = Headers;
    self.Request = Request;
    self.Response = Response;
  }
})();

(function (exports) {
  var __AVO_DEV__ = false;
  var __AVO_NOOP__ = false;
  var __AVO_LOGGER__ = null;
  var __AVO_ENV__ = null;
  var __REPORT_FAILURE_AS__ = null;
  var __STRICT__ = null;

  var __WEB_DEBUGGER__ = true;
  const avoInspectorApiKey = "IhEZFFFbRNHoziUmqG7r";
  var __INSPECTOR__ = null;

  // polyfill Array.isArray
  if (!Array.isArray) {
    Array.isArray = function (arg) {
      return Object.prototype.toString.call(arg) === "[object Array]";
    };
  }

  // polyfill Object.assign
  if (typeof Object.assign !== "function") {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, "assign", {
      value: function assign(target, varArgs) {
        // .length of function is 2
        if (target == null) {
          // TypeError if undefined or null
          throw new TypeError("Cannot convert undefined or null to object");
        }

        var to = Object(target);

        for (var index = 1; index < arguments.length; index++) {
          var nextSource = arguments[index];

          if (nextSource != null) {
            // Skip over if undefined or null
            for (var nextKey in nextSource) {
              // Avoid bugs when hasOwnProperty is shadowed
              if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }
        return to;
      },
      writable: true,
      configurable: true,
    });
  }

  // From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
  if (!Object.keys) {
    Object.keys = (function () {
      "use strict";
      var hasOwnProperty = Object.prototype.hasOwnProperty,
        hasDontEnumBug = !{ toString: null }.propertyIsEnumerable("toString"),
        dontEnums = [
          "toString",
          "toLocaleString",
          "valueOf",
          "hasOwnProperty",
          "isPrototypeOf",
          "propertyIsEnumerable",
          "constructor",
        ],
        dontEnumsLength = dontEnums.length;

      return function (obj) {
        if (
          typeof obj !== "function" &&
          (typeof obj !== "object" || obj === null)
        ) {
          throw new TypeError("Object.keys called on non-object");
        }

        var result = [],
          prop,
          i;

        for (prop in obj) {
          if (hasOwnProperty.call(obj, prop)) {
            result.push(prop);
          }
        }

        if (hasDontEnumBug) {
          for (i = 0; i < dontEnumsLength; i++) {
            if (hasOwnProperty.call(obj, dontEnums[i])) {
              result.push(dontEnums[i]);
            }
          }
        }
        return result;
      };
    })();
  }

  // polyfill Array.indexOf
  if (!Array.prototype.indexOf)
    Array.prototype.indexOf = (function (Object, max, min) {
      "use strict";
      return function indexOf(member, fromIndex) {
        if (this === null || this === undefined)
          throw TypeError(
            "Array.prototype.indexOf called on null or undefined"
          );

        var that = Object(this),
          Len = that.length >>> 0,
          i = min(fromIndex | 0, Len);
        if (i < 0) i = max(0, Len + i);
        else if (i >= Len) return -1;

        if (member === void 0) {
          for (; i !== Len; ++i) if (that[i] === void 0 && i in that) return i; // undefined
        } else if (member !== member) {
          for (; i !== Len; ++i) if (that[i] !== that[i]) return i; // NaN
        } else for (; i !== Len; ++i) if (that[i] === member) return i; // all else

        return -1; // if the value was not found, then return -1
      };
    })(Object, Math.max, Math.min);

  var array_difference, AvoAssert, InternalAvoLogger;
  array_difference = function array_difference(a1, a2) {
    var result = [];
    for (var i = 0; i < a1.length; i++) {
      if (a2.indexOf(a1[i]) === -1) {
        result.push(a1[i]);
      }
    }
    return result;
  };

  AvoAssert = {
    assertObject: function assertObject(propertyId, propName, obj) {
      if (typeof obj !== "object") {
        var message =
          propName +
          " should be of type object but you provided type " +
          typeof obj +
          " with value " +
          JSON.stringify(obj);
        return [
          {
            tag: "expectedObjectType",
            propertyId: propertyId,
            message: message,
            actualType: typeof obj,
          },
        ];
      } else {
        return [];
      }
    },

    assertString: function assertString(propertyId, propName, str) {
      if (typeof str !== "string") {
        var message =
          propName +
          " should be of type string but you provided type " +
          typeof str +
          " with value " +
          JSON.stringify(str);
        return [
          {
            tag: "expectedStringType",
            propertyId: propertyId,
            message: message,
            actualType: typeof str,
          },
        ];
      } else {
        return [];
      }
    },

    assertInt: function assertInt(propertyId, propName, int) {
      if (typeof int === "number" && int !== Math.round(int)) {
        var message =
          propName +
          " should be of type int but you provided type float with value " +
          JSON.stringify(int);
        return [
          {
            tag: "expectedIntType",
            propertyId: propertyId,
            actualType: "float",
          },
        ];
      } else if (typeof int !== "number") {
        var message =
          propName +
          " should be of type int but you provided type " +
          typeof int +
          " with value " +
          JSON.stringify(int);
        return [
          {
            tag: "expectedIntType",
            propertyId: propertyId,
            message: message,
            actualType: typeof int,
          },
        ];
      } else {
        return [];
      }
    },

    assertLong: function assertLong(propertyId, propName, long) {
      if (typeof long === "number" && long !== Math.round(long)) {
        var message =
          propName +
          " should be of type long but you provided type float with value " +
          JSON.stringify(long);
        return [
          {
            tag: "expectedLongType",
            propertyId: propertyId,
            actualType: "float",
          },
        ];
      } else if (typeof long !== "number") {
        var message =
          propName +
          " should be of type long but you provided type " +
          typeof long +
          " with value " +
          JSON.stringify(long);
        return [
          {
            tag: "expectedLongType",
            propertyId: propertyId,
            message: message,
            actualType: typeof long,
          },
        ];
      } else {
        return [];
      }
    },

    assertFloat: function assertFloat(propertyId, propName, float) {
      if (typeof float !== "number") {
        var message =
          propName +
          " should be of type float but you provided type " +
          typeof float +
          " with value " +
          JSON.stringify(float);
        return [
          {
            tag: "expectedFloatType",
            propertyId: propertyId,
            message: message,
            actualType: typeof float,
          },
        ];
      } else {
        return [];
      }
    },

    assertBool: function assertBool(propertyId, propName, bool) {
      if (typeof bool !== "boolean") {
        var message =
          propName +
          " should be of type boolean but you provided type " +
          typeof bool +
          " with value " +
          JSON.stringify(bool);
        return [
          {
            tag: "expectedBoolType",
            propertyId: propertyId,
            message: message,
            actualType: typeof bool,
          },
        ];
      } else {
        return [];
      }
    },

    assertMax: function assertMax(propertyId, propName, max, value) {
      if (value > max) {
        var message =
          propName +
          " has a maximum value of " +
          max +
          " but you provided the value " +
          JSON.stringify(value);
        return [
          { tag: "expectedMax", propertyId: propertyId, message: message },
        ];
      } else {
        return [];
      }
    },

    assertMin: function assertMin(propertyId, propName, min, value) {
      if (value < min) {
        var message =
          propName +
          " has a minimum value of " +
          min +
          " but you provided the value " +
          JSON.stringify(value);
        return [
          { tag: "expectedMin", propertyId: propertyId, message: message },
        ];
      } else {
        return [];
      }
    },

    assertList: function assertList(propertyId, propName, value) {
      if (!Array.isArray(value)) {
        var message =
          propName +
          " should be of type list but you provided type " +
          typeof value;
        return [
          {
            tag: "expectedList",
            propertyId: propertyId,
            message: message,
            actualType: typeof value,
          },
        ];
      } else {
        return [];
      }
    },

    assertNoAdditionalProperties: function assertNoAdditionalProperties(
      eventName,
      input,
      spec
    ) {
      var additionalKeys = array_difference(input, spec);
      if (additionalKeys.length) {
        var message =
          "Additional properties when sending event " +
          eventName +
          ": " +
          JSON.stringify(additionalKeys);
        return [
          {
            tag: "expectedNoAdditionalProperties",
            additionalProperties: additionalKeys,
            message: message,
          },
        ];
      } else {
        return [];
      }
    },

    assertNoAdditionalUserProperties: function assertNoAdditionalProperties(
      eventName,
      input,
      spec
    ) {
      var additionalKeys = array_difference(input, spec);
      if (additionalKeys.length) {
        var message =
          "Additional user properties when sending event " +
          eventName +
          ": " +
          JSON.stringify(additionalKeys);
        return [
          {
            tag: "expectedNoAdditionalUserProperties",
            additionalProperties: additionalKeys,
            message: message,
          },
        ];
      } else {
        return [];
      }
    },
  };

  const WebDebuggerAssertions = {
    hasKey(obj, key) {
      return obj && obj[key] != null;
    },
    assertKey(obj, key, assert) {
      if (this.hasKey(obj, key) && assert(obj[key])) {
        return true;
      } else {
        throw new Error(
          'WebDebugger: Object key: "' + key + '" failed assertion.'
        );
      }
    },
    assertKeys(obj, arrayOfAssertions) {
      return arrayOfAssertions.every((assertionForKey) => {
        if (
          this.hasKey(assertionForKey, "key") &&
          this.hasKey(assertionForKey, "assert")
        ) {
          return this.assertKey(
            obj,
            assertionForKey.key,
            assertionForKey.assert
          );
        } else {
          throw new Error("WebDebugger: Object form for assertion invalid.");
        }
      });
    },
    assertInt(int) {
      return Number.isInteger(int);
    },
  };

  var WebDebuggerPosition = {
    position: {
      BOTTOM_RIGHT: "BottomRight",
      BOTTOM_LEFT: "BottomLeft",
      TOP_RIGHT: "TopRight",
      TOP_LEFT: "TopLeft",
    },
    BottomRight(parameters) {
      return (
        WebDebuggerAssertions.assertKeys(parameters, [
          { key: "bottom", assert: WebDebuggerAssertions.assertInt },
          { key: "right", assert: WebDebuggerAssertions.assertInt },
        ]) && {
          position: this.position.BOTTOM_RIGHT,
          bottom: parameters.bottom,
          right: parameters.right,
        }
      );
    },
    BottomLeft(parameters) {
      return (
        WebDebuggerAssertions.assertKeys(parameters, [
          { key: "bottom", assert: WebDebuggerAssertions.assertInt },
          { key: "left", assert: WebDebuggerAssertions.assertInt },
        ]) && {
          position: this.position.BOTTOM_LEFT,
          bottom: parameters.bottom,
          left: parameters.left,
        }
      );
    },
    TopRight(parameters) {
      return (
        WebDebuggerAssertions.assertKeys(parameters, [
          { key: "top", assert: WebDebuggerAssertions.assertInt },
          { key: "right", assert: WebDebuggerAssertions.assertInt },
        ]) && {
          position: this.position.TOP_RIGHT,
          top: parameters.top,
          right: parameters.right,
        }
      );
    },
    TopLeft(parameters) {
      return (
        WebDebuggerAssertions.assertKeys(parameters, [
          { key: "top", assert: WebDebuggerAssertions.assertInt },
          { key: "left", assert: WebDebuggerAssertions.assertInt },
        ]) && {
          position: this.position.TOP_LEFT,
          top: parameters.top,
          left: parameters.left,
        }
      );
    },
  };

  InternalAvoLogger = {
    logEventSent: function logEventSent(
      eventName,
      eventProperties,
      userProperties,
      groupProperties
    ) {
      const message =
        "Event Sent:" +
        eventName +
        "Event Props:" +
        JSON.stringify(eventProperties) +
        "User Props:" +
        JSON.stringify(userProperties) +
        "Group Props:" +
        JSON.stringify(groupProperties);

      if (
        __AVO_LOGGER__ &&
        __AVO_LOGGER__.logDebug &&
        __AVO_LOGGER__.logDebug(__AVO_ENV__, message)
      ) {
        return;
      }
      typeof console !== "undefined" &&
        console.log(
          "[avo] Event Sent:",
          eventName,
          "Event Props:",
          eventProperties,
          "User Props:",
          userProperties,
          "Group Props:",
          groupProperties
        );
    },

    log: function log(message) {
      if (
        __AVO_LOGGER__ &&
        __AVO_LOGGER__.logDebug &&
        __AVO_LOGGER__.logDebug(__AVO_ENV__, message)
      ) {
        return;
      }
      typeof console !== "undefined" && console.log("[avo] " + message);
    },

    warn: function warn(message) {
      if (
        __AVO_LOGGER__ &&
        __AVO_LOGGER__.logWarn &&
        __AVO_LOGGER__.logWarn(__AVO_ENV__, message)
      ) {
        return;
      }
      typeof console !== "undefined" && console.warn("[avo] " + message);
    },

    error: function error(message, error) {
      if (
        __AVO_LOGGER__ &&
        __AVO_LOGGER__.logError &&
        __AVO_LOGGER__.logError(__AVO_ENV__, message + error)
      ) {
        return;
      }
      typeof console !== "undefined" &&
        console.error("[avo] " + message, error);
    },
  };

  var _avo_invoke, _avo_invoke_meta;
  var _avo_sampling_rate = 1.0;
  function _avo_invoke_payload(body) {
    if (typeof window === "undefined") {
      return;
    }
    if (_avo_sampling_rate > 0) {
      if (Math.random() < _avo_sampling_rate) {
        fetch("https://api.avo.app/i", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body),
        })
          .then(function (res) {
            return res.json();
          })
          .then(function (data) {
            _avo_sampling_rate = data.sa;
          })
          .catch(function () {});
      }
    }
  }

  _avo_invoke = function _avo_invoke(env, eventId, hash, messages, origin) {
    _avo_invoke_payload({
      ac: "LbBaun8UHP5pJkVEmsPl",
      br: "master",
      en: env,
      ev: eventId,
      ha: hash,
      sc: "ATL22HeaAit5ZqQrVv0s",
      se: new Date().toISOString(),
      so: "GAIi_3mSt",
      va: messages.length === 0,
      me: messages,
      or: origin,
    });
  };

  _avo_invoke_meta = function _avo_invoke_meta(env, type, messages, origin) {
    _avo_invoke_payload({
      ac: "LbBaun8UHP5pJkVEmsPl",
      br: "master",
      en: env,
      ty: type,
      sc: "ATL22HeaAit5ZqQrVv0s",
      se: new Date().toISOString(),
      so: "GAIi_3mSt",
      va: messages.length === 0,
      me: messages,
      or: origin,
    });
  };

  var _avo_debugger_log;
  var _avo_debugger_events_during_boot = [];
  var _avo_debugger_ready = false;

  if (typeof window !== "undefined") {
    window.addEventListener("message", function (event) {
      if (event.origin !== "https://www.avo.app") {
        return;
      }
      var iframe = document.getElementById("avo-debugger");
      if (
        iframe &&
        event &&
        event.data &&
        event.data.type_ === "avo-debugger-update-style"
      ) {
        iframe.style = event.data.style;
      } else if (
        iframe &&
        event &&
        event.data &&
        event.data.type_ === "avo-debugger-ready"
      ) {
        var message = {
          type_: "avo-debugger-boot-events",
          schemaId: "ATL22HeaAit5ZqQrVv0s",
          href: window.location.href,
          events: _avo_debugger_events_during_boot,
        };
        _avo_debugger_events_during_boot = [];
        _avo_debugger_ready = true;
        iframe.contentWindow.postMessage(
          message,
          "https://www.avo.app/_debugger"
        );
      }
    });
  }

  _avo_debugger_log = function _avo_debugger_log(
    eventId,
    eventName,
    messages,
    eventProperties,
    userProperties,
    groupProperties
  ) {
    if (typeof window === "undefined") {
      return;
    }
    var event = {
      eventId: eventId,
      eventName: eventName,
      messages: messages,
      timestamp: Date.now(),
      eventProperties: eventProperties,
      userProperties: userProperties,
      groupProperties: groupProperties,
    };

    if (_avo_debugger_ready) {
      var message = { type_: "avo-debugger-events", events: [event] };
      document
        .getElementById("avo-debugger")
        .contentWindow.postMessage(message, "https://www.avo.app/_debugger");
    } else {
      _avo_debugger_events_during_boot.push(event);
    }
  };

  function _avo_debugger_send_position(position) {
    if (typeof window === "undefined") {
      return;
    }
    window.addEventListener("message", function (event) {
      if (event.origin !== "https://www.avo.app") {
        return;
      }
      if (event.data.type_ === "avo-debugger-ready" && position !== null) {
        var message = { type_: "avo-debugger-position", position: position };
        document
          .getElementById("avo-debugger")
          .contentWindow.postMessage(message, "https://www.avo.app/_debugger");
      }
    });
  }

  var TeamsInviteSource = {
    ONBOARDING: "Onboarding",
    USER_PAGE: "User Page",
    OVERVIEW_PAGE: "Overview Page",
  };

  var DownloadFormat = {
    PDF: "PDF",
    CSV: "CSV",
    XLS: "XLS",
  };

  var IntegrationStepName = {
    ADD_EMPLOYEE_ID: "Add Employee ID",
  };

  var TeamsPlanName = {
    TEAMS_LITE: "Teams Lite",
    TEAMS: "Teams",
    TEAMS_PRO: "Teams Pro",
  };

  var UserSelectionAction = {
    SELECT: "Select",
    UNSELECT: "Unselect",
  };

  var PasswordResetFailure = {
    LENGTH: "Length",
    DIGIT: "Digit",
    UPPERCASE: "Uppercase",
    SPECIAL_CHARACTER: "Special Character",
    LOWERCASE: "Lowercase",
  };

  var ConsolidatedReportTimeframe = {
    LAST_30_DAYS: "Last 30 days",
    LAST_3_MONTHS: "Last 3 months",
    LAST_12_MONTHS: "Last 12 months",
    YEAR_TO_DATE: "Year to date",
    ALL_TIME: "All time",
    MONTH: "Month",
  };

  var ResendType = {
    BULK: "Bulk",
    SUBSET: "Subset",
  };

  var SignupOriginProduct = {
    TEAMS: "Teams",
    STANDALONE: "Standalone",
  };

  var ExistingSASubscription = {
    APPLE_MONTHLY: "apple_monthly",
    APPLE_ANNUAL: "apple_annual",
    GOOGLE_MONTHLY: "google_monthly",
    GOOGLE_ANNUAL: "google_annual",
    STRIPE_MONTHLY: "stripe_monthly",
    STRIPE_ANNUAL: "stripe_annual",
    NONE: "none",
  };

  var TeamsSignupStepName = {
    NAME_TEAM: "Name Team",
    SELECT_FEATURES: "Select Features",
    CHOOSE_PLAN: "Choose Plan",
    INVITE_USERS: "Invite Users",
    ORDER_CONFIRMATION: "Order Confirmation",
    ROLE_PICKER: "Role Picker",
    CREATE_TEAM: "Create Team",
  };

  var ReportCreationFailure = {
    SOMETHING_WENT_WRONG: "Something went wrong",
    NO_BUSINESS_DRIVES: "No business drives",
  };

  var FrequentDrivePromptAction = {
    AUTO_CLASSIFY: "Auto Classify",
    NOT_NOW: "Not Now",
    DISMISSED: "Dismissed",
  };

  var CustomPurposeSource = {
    SETTINGS: "Settings",
    ADD_DRIVE: "Add Drive",
    DRIVES_FILTER: "Drives Filter",
  };

  var Page = {
    REPORTS: "Reports",
    MONTHLY_SUMMARIES: "Monthly Summaries",
    REPORT_DETAILS: "Report Details",
    HOME: "Home",
    SETTINGS: "Settings",
    USERS: "Users",
    CUSTOM_RATES: "Custom Rates",
    TUTORIAL: "Tutorial",
    CREATE_REPORT: "Create Report",
    DRIVES: "Drives",
    VEHICLES: "Vehicles",
    DRIVE_DETAILS: "Drive Details",
    NOTIFICATION_SETTINGS: "Notification Settings",
    EMAIL_SETTINGS: "Email Settings",
    SUBSCRIPTION: "Subscription",
    TEAMS: "Teams",
    ONBOARDING: "Onboarding",
    TEAM_LOCATIONS: "Team Locations",
    GET_STARTED: "Get Started",
    WELCOME_DOWNLOAD: "Welcome Download",
    SHARE_REPORT: "Share Report",
    SHARED_WITH_ME: "Shared with me",
    SHARED_REPORTS: "Shared Reports",
  };

  var OverlayCTA = {
    TEXT_ME_A_DOWNLOAD_LINK: "Text me a download link",
    SCHEDULE_A_CALL: "Schedule a call",
  };

  var DistanceUnit = {
    MILES: "Miles",
    KILOMETERS: "Kilometers",
  };

  var OverlayInteraction = {
    COMPLETED_CTA: "Completed CTA",
    DISMISSED: "Dismissed",
  };

  var TeamsSignupSource = {
    WEBSITE: "Website",
    DASHBOARD: "Dashboard",
    INTEGRATIONS_SETTINGS: "Integrations Settings",
    PROFILE_DROPDOWN: "Profile Dropdown",
    NAVIGATION_BAR_POPUP: "Navigation Bar Popup",
    TEAMS_PAGE: "Teams Page",
    CONTACTS_DASHBOARD_STANDALONE: "Contacts Dashboard Standalone",
    CONTACTS_DASHBOARD_NON_DRIVER: "Contacts Dashboard Non Driver",
  };

  var FrequentUnclassifiedDrivesAction = {
    SELECTED: "Selected",
    UNSELECTED: "Unselected",
  };

  var ReportMarkDrives = {
    REPORTED: "Reported",
    UNREPORTED: "Unreported",
  };

  var SignupSource = {
    CONTACTS_DASHBOARD: "Contacts Dashboard",
  };

  var FrequentDrivePreference = {
    ENABLED: "Enabled",
    DISABLED: "Disabled",
  };

  var ReportDownloadSource = {
    REPORT_DETAILS_SIDEBAR: "Report Details Sidebar",
    REPORTS_SIDEBAR: "Reports Sidebar",
    REPORTS_ROW: "Reports Row",
  };

  var OverlayType = {
    POPUP: "Popup",
    BANNER: "Banner",
    FULL_PAGE: "Full Page",
  };

  var OverlayCategory = {
    WELCOME: "Welcome",
    TEAMS_ONBOARDING: "Teams Onboarding",
    FREE_TRIAL: "Free Trial",
  };

  var DriveReportedFilter = {
    INCLUDE: "Include",
    EXCLUDE: "Exclude",
  };

  var TeamsDowngradeSource = {
    SUBSCRIPTION_CANCELLATION_MODAL: "Subscription Cancellation Modal",
  };

  var ReportsDriveFilter = {
    ALL_DRIVES: "All Drives",
    BUSINESS_DRIVES: "Business Drives",
    PERSONAL_DRIVES: "Personal Drives",
  };

  var FilterDriveFrequentDrives = {
    SELECTED: "Selected",
    UNSELECTED: "Unselected",
  };

  var TeamsUpgradeFeature = {
    CONCUR_INTEGRATION: "Concur Integration",
    REPORT_REMINDERS: "Report Reminders",
    TEAMS_LOCATIONS: "Teams Locations",
    EXCLUDE_COMMUTE: "Exclude Commute",
    APPROVE_REJECT: "Approve Reject",
    AUTOMATIC_REVIEW: "Automatic Review",
  };

  var SignupFailure = {
    INVALID_EMAIL: "Invalid Email",
    ACCOUNT_ALREADY_EXISTS: "Account Already Exists",
    INVALID_PASSWORD: "Invalid Password",
    FIRST_NAME_REQUIRED: "First Name Required",
    LAST_NAME_REQUIRED: "Last Name Required",
  };

  var ReviewAction = {
    ACCEPT: "accept",
    REJECT: "reject",
    RESET: "reset",
  };

  var Platform = {
    WEB: "Web",
    I_O_S: "iOS",
    ANDROID: "Android",
  };

  var FilterDriveWithoutNotes = {
    SELECTED: "Selected",
    UNSELECTED: "Unselected",
  };

  var SearchSelectionType = {
    NAMED_LOCATION: "Named Location",
    GENERIC_ADDRESS: "Generic Address",
    NOTES: "Notes",
    ALL_RESULTS: "All Results",
  };

  var ReportCreationStepName = {
    REPORT_TIMEFRAME_SELECTED: "Report timeframe selected",
    REPORT_RECIPIENT_SELECTED: "Report recipient selected",
    REPORT_DETAILS_COMPLETED: "Report details completed",
  };

  var LoginFailure = {
    EMAIL_INCORRECT: "Email Incorrect",
    PASSWORD_INCORRECT: "Password Incorrect",
  };

  var InviteFailureReason = {
    INVALID_EMAIL: "Invalid Email",
    USER_ON_ANOTHER_TEAM: "User On Another Team",
    OTHER: "Other",
  };

  var ReportsDateFilter = {
    THIS_MONTH: "This Month",
    LAST_MONTH: "Last Month",
    LAST_3_MONTHS: "Last 3 Months",
    YEAR_TO_DATE: "Year to Date",
    LAST_YEAR: "Last Year",
    CUSTOM_RANGE: "Custom Range",
    MONTH: "Month",
  };

  var FilterDriveWorkHours = {
    SELECTED: "Selected",
    UNSELECTED: "Unselected",
  };

  var DriveSelectionMethod = {
    INDIVIDUAL: "Individual",
    DAY: "Day",
    ALL: "All",
  };

  var LoginSessionPreference = {
    SINGLE_SESSION: "Single Session",
    MULTI_SESSION: "Multi Session",
  };

  var DashboardSwitchedTo = {
    TEAMS: "Teams",
    DRIVER: "Driver",
  };

  var ReportDetailsDriveFilter = {
    ALL_DRIVES: "All drives",
    MANUALLY_ADDED: "Manually added",
  };

  var Integration = {
    CONCUR: "Concur",
  };

  var WebPage = {
    REPORTS_DRIVER_DASHBOARD: "Reports Driver Dashboard",
    PROFILE_SETTINGS_DRIVER_DASHBOARD: "Profile Settings Driver Dashboard",
    NOTIFICATIONS_SETTINGS_DRIVER_DASHBOARD:
      "Notifications Settings Driver Dashboard",
    INTEGRATIONS_SETTINGS_DRIVER_DASHBOARD:
      "Integrations Settings Driver Dashboard",
    VEHICLE_SETTINGS_DRIVER_DASHBOARD: "Vehicle Settings Driver Dashboard",
    MILEAGE_RATES_SETTINGS_DRIVER_DASHBOARD:
      "Mileage Rates Settings Driver Dashboard",
    AUTO_CLASSIFICATION_SETTINGS_DRIVER_DASHBOARD:
      "Auto classification Settings Driver Dashboard",
    CUSTOM_PURPOSES_SETTINGS_DRIVER_DASHBOARD:
      "Custom Purposes Settings Driver Dashboard",
    AUTOMATIC_REPORTS_SETTINGS_DRIVER_DASHBOARD:
      "Automatic Reports Settings Driver Dashboard",
    SUBSCRIPTION_DRIVER_DASHBOARD: "Subscription Driver Dashboard",
    SHARE_MILEIQ_DRIVER_DASHBOARD: "Share MileIQ Driver Dashboard",
    OVERVIEW_TEAM_DASHBOARD: "Overview Team Dashboard",
    MEMBERS_TEAM_DASHBOARD: "Members Team Dashboard",
    REPORTS_TEAM_DASHBOARD: "Reports Team Dashboard",
    CUSTOM_RATES_TEAM_DASHBOARD: "Custom Rates Team Dashboard",
    TEAM_LOCATIONS_TEAM_DASHBOARD: "Team Locations Team Dashboard",
    SUBSCRIPTION_TEAM_DASHBOARD: "Subscription Team Dashboard",
    SETTINGS_TEAM_DASHBOARD: "Settings Team Dashboard",
    GET_STARTED_DRIVER_DASHBOARD: "Get Started Driver Dashboard",
    DRIVES_DRIVER_DASHBOARD: "Drives Driver Dashboard",
    LOGIN: "Login",
    SIGNUP: "Signup",
    DRIVES_SUMMARY_TEAM_DASHBOARD: "Drives Summary Team Dashboard",
    DRIVES_LIST_TEAM_DASHBOARD: "Drives List Team Dashboard",
    APPROVE_DRIVES_SUMMARY_TEAM_DASHBOARD:
      "Approve Drives Summary Team Dashboard",
    APPROVE_DRIVES_LIST_TEAM_DASHBOARD: "Approve Drives List Team Dashboard",
    SHARED_REPORTS: "Shared Reports",
    SHARED_WITH_ME: "Shared with me",
  };

  var DriveClassificationPurpose = {
    BUSINESS: "Business",
    BETWEEN_OFFICES: "Between offices",
    CUSTOMER_VISIT: "Customer visit",
    MEETING: "Meeting",
    ERRAND_SUPPLIES: "Errand/Supplies",
    TEMPORARY_SITE: "Temporary site",
    AIRPORT_TRAVEL: "Airport/Travel",
    CUSTOM: "Custom",
    COMMUTE: "Commute",
    MEDICAL: "Medical",
    CHARITY: "Charity",
    MOVING: "Moving",
    PERSONAL: "Personal",
    MEAL: "Meal",
    BUSINESS_PLUS_COMMUTE: "Business + Commute",
  };

  var CancellationAbandonedMethod = {
    MODAL_DISMISS: "Modal dismiss",
    KEEP_MY_PLAN_CTA: "Keep my Plan CTA",
  };

  var AutoClassifyOutsideWorkHoursPreference = {
    ENABLED: "Enabled",
    DISABLED: "Disabled",
  };

  var EditUsernameStepName = {
    ADD_EMAIL: "Add Email",
    ADD_PASSWORD: "Add Password",
  };

  var WorkHoursUpdateSource = {
    AUTO_CLASSIFY_PERSONAL: "Auto Classify Personal",
    AUTO_CLASSIFY_BUSINESS: "Auto Classify Business",
    CHANGE_HOURS: "Change Hours",
  };

  var ConsolidatedReportFormat = {
    WEEKLY: "Weekly",
    BIWEEKLY: "Biweekly",
    MONTHLY: "Monthly",
  };

  var VehiclePriority = {
    PRIMARY: "Primary",
    NON_MINUS_PRIMARY: "Non-Primary",
  };

  var PaymentService = {
    STRIPE: "STRIPE",
    APPLE: "APPLE",
    GOOGLE: "GOOGLE",
    APPLEMINUS_SANDBO_X: "APPLE-SANDBOX",
  };

  var DriveSearch = {
    APPLIED: "Applied",
    UNAPPLIED: "Unapplied",
  };

  var IntegrationStatus = {
    ACTIVE: "Active",
    INACTIVE: "Inactive",
  };

  var UserAction = {
    DELETE_DRIVE: "Delete Drive",
    JOIN_DRIVE: "Join Drive",
    CLASSIFY_DRIVE: "Classify Drive",
  };

  var TeamSetting = {
    COMPANY_NAME: "Company Name",
    CUSTOM_RATE: "Custom Rate",
  };

  var TeamsUpdatePaymentSource = {
    URL_PARAMS: "URL Params",
    RESUBSCRIBE_MODAL: "Resubscribe Modal",
    TOP_BANNER: "Top Banner",
    DUNNING_WARNING_MODAL: "Dunning Warning Modal",
    MANAGE_SUBSCRIPTION_DROPDOWN: "Manage Subscription Dropdown",
    INVITE_DRIVERS: "Invite drivers",
    UPGRADE_SUBSCRIPTION: "Upgrade subscription",
  };

  var VehiclePriorityUpdate = {
    UPDATED: "Updated",
    UNCHANGED: "Unchanged",
  };

  var TeamsResubscribeModalSource = {
    URL_PARAMS: "URL Params",
    DASHBOARD_CTAS: "Dashboard CTAs",
  };

  var TeamDrivesDriversFilter = {
    MULTIPLE: "Multiple",
    INDIVIDUAL: "Individual",
    NONE: "None",
  };

  var UserSelectionType = {
    BULK: "Bulk",
    INDIVIDUAL: "Individual",
  };

  var CustomPurposeUpdate = {
    HIDE: "Hide",
    UNHIDE: "Unhide",
    ORDER: "Order",
  };

  var DashboardSwitchFrom = {
    DRIVER_DASHBOARD_SIDEBAR: "Driver Dashboard Sidebar",
    TEAMS_DASHBOARD_SIDEBAR: "Teams Dashboard Sidebar",
  };

  var TeamsPlanSelectionName = {
    TEAMS: "Teams",
    TEAMS_LITE: "Teams Lite",
    TEAMS_PRO: "Teams Pro",
  };

  var BlogSource = {
    HELP: "Help",
    QUICK_TIPS: "Quick Tips",
    ENABLE_CONCUR_INTEGRATION: "Enable Concur Integration",
  };

  var OtherEmailPreferenceChange = {
    ENABLED: "Enabled",
    DISABLED: "Disabled",
  };

  var TeamsUpgradeSource = {
    ONBOARDING: "Onboarding",
    SETTINGS_PAGE: "Settings Page",
    USERS_PAGE: "Users Page",
    SUBSCRIPTION_PAGE: "Subscription Page",
    USER_INVITE: "User Invite",
    REPORTS_PAGE: "Reports Page",
    TEAMS_LOCATIONS_PAGE: "Teams Locations Page",
    TEAMS_OVERVIEW_PAGE: "Teams Overview Page",
    ALL_DRIVES_PAGE: "All Drives Page",
    DRIVES_TO_APPROVE_PAGE: "Drives to Approve Page",
  };

  var SharedNamedLocationStepName = {
    ADDRESS: "Address",
    LOCATION_NAME: "Location name",
  };

  var LoginSource = {
    CONTACTS_DASHBOARD: "Contacts Dashboard",
  };

  var ExistingDriveClassificationType = {
    UNCLASSIFIED: "Unclassified",
    BUSINESS: "Business",
    PERSONAL: "Personal",
  };

  var ReportReminderRepeatsScheduleSettingType = {
    WEEKLY: "weekly",
    MONTHLY: "monthly",
    CUSTOM: "custom",
  };

  var ReviewDriveTypeFilter = {
    ALL: "All",
    MANUAL: "Manual",
    AUTOMATIC: "Automatic",
  };

  var EmailValidationMethod = {
    SENDGRID: "Sendgrid",
    MANUAL: "Manual",
  };

  var TeamsSignupStepInteraction = {
    COMPLETED: "Completed",
    SKIPPED: "Skipped",
  };

  var TeamsPlanInterval = {
    MONTHLY: "Monthly",
    ANNUAL: "Annual",
    DAILY: "Daily",
  };

  var DriveDeletionReason = {
    PHYSICAL_ACTIVITY: "Physical Activity",
    PUBLIC_TRANSPORT: "Public Transport",
    OTHER: "Other",
  };

  var TeamUserRole = {
    ADMIN: "Admin",
    DRIVER: "Driver",
    ADMIN_DRIVER: "Admin Driver",
  };

  var TeamsPlanSelectionInterval = {
    MONTHLY: "Monthly",
    ANNUAL: "Annual",
    DAILY: "Daily",
  };

  var AutomaticReportsRecurrence = {
    DAILY: "Daily",
    WEEKLY: "Weekly",
    MONTHLY: "Monthly",
  };

  var ShareSource = {
    EMAIL: "Email",
    TWITTER: "Twitter",
    LINKED_IN: "LinkedIn",
    FACEBOOK: "Facebook",
    URL: "URL",
  };

  var DriveDetail = {
    DISTANCE: "Distance",
    PARKING: "Parking",
    TOLLS: "Tolls",
    VEHICLE: "Vehicle",
    NOTES: "Notes",
    START_LOCATION_NAME: "Start Location Name",
    END_LOCATION_NAME: "End Location Name",
  };

  var VehicleDetailsUpdate = {
    UPDATED: "Updated",
    UNCHANGED: "Unchanged",
  };

  var UpgradeSource = {
    ONBOARDING: "Onboarding",
    SUBSCRIPTION_PAGE: "Subscription Page",
    DRIVES_PAGE: "Drives Page",
    SIDEBAR: "Sidebar",
  };

  var VehicleVisibility = {
    HIDDEN: "Hidden",
    VIEWABLE: "Viewable",
  };

  var ReviewStatusFilter = {
    ALL: "All",
    APPROVED: "Approved",
    REJECTED: "Rejected",
    NO_STATUS: "No Status",
  };

  var TeamsUserUpdate = {
    UPGRADE_TO_ADMIN_DRIVER: "Upgrade To Admin & Driver",
    DOWNGRADE_TO_ADMIN: "Downgrade To Admin",
    DOWNGRADE_TO_DRIVER: "Downgrade To Driver",
    REMOVE_FROM_TEAM: "Remove From Team",
  };

  var EmailAuthenticationMethod = {
    MANUAL: "Manual",
  };

  var VehicleVisibilityUpdate = {
    UPDATED: "Updated",
    UNCHANGED: "Unchanged",
  };

  var Currency = {
    USD: "USD",
    CAD: "CAD",
    GBP: "GBP",
  };

  var PreviousWebPage = {
    REPORTS_DRIVER_DASHBOARD: "Reports Driver Dashboard",
    PROFILE_SETTINGS_DRIVER_DASHBOARD: "Profile Settings Driver Dashboard",
    NOTIFICATIONS_SETTINGS_DRIVER_DASHBOARD:
      "Notifications Settings Driver Dashboard",
    INTEGRATIONS_SETTINGS_DRIVER_DASHBOARD:
      "Integrations Settings Driver Dashboard",
    VEHICLE_SETTINGS_DRIVER_DASHBOARD: "Vehicle Settings Driver Dashboard",
    MILEAGE_RATES_SETTINGS_DRIVER_DASHBOARD:
      "Mileage Rates Settings Driver Dashboard",
    AUTO_CLASSIFICATION_SETTINGS_DRIVER_DASHBOARD:
      "Auto classification Settings Driver Dashboard",
    CUSTOM_PURPOSES_SETTINGS_DRIVER_DASHBOARD:
      "Custom Purposes Settings Driver Dashboard",
    AUTOMATIC_REPORTS_SETTINGS_DRIVER_DASHBOARD:
      "Automatic Reports Settings Driver Dashboard",
    SUBSCRIPTION_DRIVER_DASHBOARD: "Subscription Driver Dashboard",
    SHARE_MILEIQ_DRIVER_DASHBOARD: "Share MileIQ Driver Dashboard",
    OVERVIEW_TEAM_DASHBOARD: "Overview Team Dashboard",
    MEMBERS_TEAM_DASHBOARD: "Members Team Dashboard",
    REPORTS_TEAM_DASHBOARD: "Reports Team Dashboard",
    CUSTOM_RATES_TEAM_DASHBOARD: "Custom Rates Team Dashboard",
    TEAM_LOCATIONS_TEAM_DASHBOARD: "Team Locations Team Dashboard",
    SUBSCRIPTION_TEAM_DASHBOARD: "Subscription Team Dashboard",
    SETTINGS_TEAM_DASHBOARD: "Settings Team Dashboard",
    GET_STARTED_DRIVER_DASHBOARD: "Get Started Driver Dashboard",
    DRIVES_DRIVER_DASHBOARD: "Drives Driver Dashboard",
    LOGIN: "Login",
    SIGNUP: "Signup",
    DRIVES_SUMMARY_TEAM_DASHBOARD: "Drives Summary Team Dashboard",
    DRIVES_LIST_TEAM_DASHBOARD: "Drives List Team Dashboard",
    APPROVE_DRIVES_SUMMARY_TEAM_DASHBOARD:
      "Approve Drives Summary Team Dashboard",
    APPROVE_DRIVES_LIST_TEAM_DASHBOARD: "Approve Drives List Team Dashboard",
  };

  var DriveReviewCTA = {
    ALL_DRIVES: "All drives",
    CONTINUE_REVIEW: "Continue Review",
  };

  var SignupOriginSubscription = {
    FREE: "Free",
    UNLIMITED: "Unlimited",
    LITE: "Lite",
    STANDARD: "Standard",
    PRO: "Pro",
    PRO_MINUS_TRIAL: "Pro - Trial",
  };

  var ReportRecipientType = {
    TEAM_ADMIN: "Team Admin",
    EMAIL: "Email",
    CONCUR: "Concur",
    CONTACT: "Contact",
    MYSELF: "Myself",
  };

  var BulkUploadStepName = {
    UPLOAD_FILE: "Upload File",
  };

  var PromotionalEmailPreferenceChange = {
    ENABLED: "Enabled",
    DISABLED: "Disabled",
  };

  var InviteAdminStepName = {
    ADMIN_EMAIL_ENTERED: "Admin Email Entered",
    YOUR_NAME_ENTERED: "Your Name Entered",
  };

  var WeeklyEmailPreferenceChange = {
    ENABLED: "Enabled",
    DISABLED: "Disabled",
  };

  var EmailPreferenceChangeMethod = {
    SELECT: "Select",
    UNSUBSCRIBE_ALL: "Unsubscribe All",
  };

  var AppDownloadRequestMethod = {
    TEXT_TO_DOWNLOAD: "Text to Download",
    QR_CODE: "QR Code",
    CLICK_TO_DOWNLOAD: "Click to Download",
  };

  var AddVehicleMethod = {
    MANUAL: "Manual",
    BLUETOOTH: "Bluetooth",
  };

  var IntegrationProcess = {
    AUTOMATIC: "Automatic",
    MANUAL: "Manual",
  };

  var ReportsVehicleFilter = {
    ALL_VEHICLES: "All Vehicles",
    SELECT_VEHICLES: "Select Vehicles",
  };

  var TeamsReportsSubmissionFilter = {
    LAST_30_DAYS: "Last 30 days",
    LAST_3_MONTHS: "Last 3 months",
    LAST_12_MONTHS: "Last 12 months",
    YEAR_TO_DATE: "Year to date",
    ALL_TIME: "All time",
  };

  var DriveDateFilter = {
    THIS_MONTH: "This month",
    LAST_MONTH: "Last month",
    LAST_3_MONTHS: "Last 3 months",
    YEAR_TO_DATE: "Year to date",
    LAST_YEAR: "Last year",
    CUSTOM_RANGE: "Custom range",
    MONTH: "Month",
  };

  var FrequentDriveEditAction = {
    STOP_AUTO_CLASSIFY: "Stop Auto Classify",
    CANCEL: "Cancel",
    DISMISSED: "Dismissed",
  };

  var WorkHourFailure = {
    OVERLAPPING_TIME: "Overlapping Time",
  };

  var DriveClassificationType = {
    BUSINESS: "Business",
    PERSONAL: "Personal",
  };

  var Country = {
    US: "US",
    UK: "UK",
    CA: "CA",
    GB: "GB",
  };

  var ReportDetailsSearchFilter = {
    APPLIED: "Applied",
    NOT_APPLIED: "Not Applied",
  };

  var CustomRatesEffectiveDate = {
    IMMEDIATE: "Immediate",
    FUTURE: "Future",
  };

  var CustomRatesUpdateType = {
    CHANGE: "Change",
    REVERT_TO_PREVIOUS: "Revert to Previous",
    REMOVE: "Remove",
    REVERT_TO_DEFAULT: "Revert to Default",
  };

  var SharedNamedLocationFailure = {
    ADDRESS_IS_ALREADY_A_TEAM_LOCATION: "Address is already a Team Location",
    NAME_ALREADY_EXISTS: "Name already exists",
    AREA_IS_ALREADY_A_TEAM_LOCATION: "Area is already a Team Location",
    OTHER: "Other",
  };

  var TeamsSubscriptionCancellationStep = {
    CANCELLATION_REASON: "Cancellation Reason",
    DOWNGRADE_SUBSCRIPTION: "Downgrade Subscription",
    CLAIM_DISCOUNT: "Claim Discount",
    TEAM_ALL_TIME_STATS: "Team All Time Stats",
  };

  var NamedLocationEdit = {
    RENAME: "Rename",
    CREATE_NEW_LOCATION: "Create new location",
  };

  var TeamDrivesPurposeFilter = {
    BUSINESS: "Business",
    MEETING: "Meeting",
    ERRAND_SUPPLIES: "Errand/Supplies",
    AIRPORT_TRAVEL: "Airport/Travel",
    OTHER: "Other",
    COMMUTE: "Commute",
    MEDICAL: "Medical",
    CHARITY: "Charity",
    MOVING: "Moving",
    PERSONAL: "Personal",
    BUSINESS_PLUS_COMMUTE: "Business + Commute",
    BETWEEN_OFFICES: "Between Offices",
    CUSTOMER_VISIT: "Customer Visit",
    MEAL_ENTERTAIN: "Meal/Entertain",
    TEMPORARY_SITE: "Temporary Site",
  };

  var SubscriptionType = {
    MONTHLY: "Monthly",
    ANNUAL: "Annual",
  };

  var ReportOpenSource = {
    REPORT_ROW: "Report Row",
    EYE_ICON: "Eye Icon",
    SIDEBAR_DETAILS: "Sidebar Details",
  };

  var CustomRatesSelection = {
    CURRENT: "Current",
    UPCOMING: "Upcoming",
    PAST: "Past",
  };

  var FilterDriveManuallyClassified = {
    SELECTED: "Selected",
    UNSELECTED: "Unselected",
  };

  var MonthlyEmailPreferenceChange = {
    ENABLED: "Enabled",
    DISABLED: "Disabled",
  };

  var DriveClassificationFilter = {
    ALL: "All",
    UNCLASSIFIED: "Unclassified",
    BUSINESS: "Business",
    PERSONAL: "Personal",
  };

  var OverlayDescription = {
    TEXT_TO_DOWNLOAD: "Text to Download",
    OFFER_HELP_TO_COMPLETING_ORDER: "Offer Help to Completing Order",
  };

  var ModalAbandonMethod = {
    MODAL_DISMISS: "Modal dismiss",
    CLOSE_CTA: "Close CTA",
  };

  var TeamsReportsDriversFilter = {
    INDIVIDUAL: "Individual",
    MULTIPLE: "Multiple",
  };

  var ReportEmailSource = {
    REPORTS_SIDEBAR: "Reports Sidebar",
    REPORT_DETAILS_SIDEBAR: "Report Details Sidebar",
  };

  var DriverReportSelectionType = {
    INDIVIDUAL: "Individual",
    ALL: "All",
  };

  var AutoClassifyDuringWorkHoursPreference = {
    ENABLED: "Enabled",
    DISABLED: "Disabled",
  };

  var VehicleType = {
    CAR: "Car",
    MOTORCYCLE: "Motorcycle",
    BIKE: "Bike",
  };

  var WorkHoursSchedule = {
    SIMPLE: "Simple",
    COMPLEX: "Complex",
  };

  var SignupOriginBillingCycle = {
    MONTHLY: "Monthly",
    ANNUAL: "Annual",
  };

  var Intent = {
    JOIN_TEAM: "join team",
    CREATE_TEAM: "create team",
    USE_PERSONAL: "use personal",
  };

  function assertTeamsInviteSource(teamsInviteSource, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "-4HuA8Lgpq",
        label_ ? "Teams Invite Source" + ": " + label_ : "Teams Invite Source",
        teamsInviteSource
      )
    );
    if (
      "Onboarding" !== teamsInviteSource &&
      "User Page" !== teamsInviteSource &&
      "Overview Page" !== teamsInviteSource
    ) {
      var message =
        (label_
          ? "Teams Invite Source" + ": " + label_
          : "Teams Invite Source") +
        " should match one of the following values [ Onboarding | User Page | Overview Page ] but you provided the value " +
        teamsInviteSource;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "-4HuA8Lgpq",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertOptionalName(name, label_) {
    var messages = [];
    if (name !== undefined && name !== null) {
      messages = messages.concat(
        AvoAssert.assertString(
          "-GjIYlnhA",
          label_ ? "Name" + ": " + label_ : "Name",
          name
        )
      );
    }
    return messages;
  }

  function assertName(name, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "-GjIYlnhA",
        label_ ? "Name" + ": " + label_ : "Name",
        name
      )
    );
    return messages;
  }

  function assertDownloadFormat(downloadFormat, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "-PkiBW72m",
        label_ ? "Download Format" + ": " + label_ : "Download Format",
        downloadFormat
      )
    );
    if (
      "PDF" !== downloadFormat &&
      "CSV" !== downloadFormat &&
      "XLS" !== downloadFormat
    ) {
      var message =
        (label_ ? "Download Format" + ": " + label_ : "Download Format") +
        " should match one of the following values [ PDF | CSV | XLS ] but you provided the value " +
        downloadFormat;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "-PkiBW72m",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertOptionalOrganizationID(organizationId, label_) {
    var messages = [];
    if (organizationId !== undefined && organizationId !== null) {
      messages = messages.concat(
        AvoAssert.assertString(
          "-WqF2QiMYl",
          label_ ? "Organization ID" + ": " + label_ : "Organization ID",
          organizationId
        )
      );
    }
    return messages;
  }

  function assertIntegrationStepName(integrationStepName, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "0oLcCLWo-",
        label_
          ? "Integration Step Name" + ": " + label_
          : "Integration Step Name",
        integrationStepName
      )
    );
    if ("Add Employee ID" !== integrationStepName) {
      var message =
        (label_
          ? "Integration Step Name" + ": " + label_
          : "Integration Step Name") +
        " should match one of the following values [ Add Employee ID ] but you provided the value " +
        integrationStepName;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "0oLcCLWo-",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertOptionalTeamsPlanName(teamsPlanName, label_) {
    var messages = [];
    if (teamsPlanName !== undefined && teamsPlanName !== null) {
      messages = messages.concat(
        AvoAssert.assertString(
          "125AY5RLNY",
          label_ ? "Teams Plan Name" + ": " + label_ : "Teams Plan Name",
          teamsPlanName
        )
      );
      if (
        "Teams Lite" !== teamsPlanName &&
        "Teams" !== teamsPlanName &&
        "Teams Pro" !== teamsPlanName
      ) {
        var message =
          (label_ ? "Teams Plan Name" + ": " + label_ : "Teams Plan Name") +
          " should match one of the following values [ Teams Lite | Teams | Teams Pro ] but you provided the value " +
          teamsPlanName;
        messages = messages.concat([
          {
            tag: "expectedStringMatch",
            propertyId: "125AY5RLNY",
            message: message,
          },
        ]);
      }
    }
    return messages;
  }

  function assertUserSelectionAction(userSelectionAction, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "1B4einUjHw",
        label_
          ? "User Selection Action" + ": " + label_
          : "User Selection Action",
        userSelectionAction
      )
    );
    if (
      "Select" !== userSelectionAction &&
      "Unselect" !== userSelectionAction
    ) {
      var message =
        (label_
          ? "User Selection Action" + ": " + label_
          : "User Selection Action") +
        " should match one of the following values [ Select | Unselect ] but you provided the value " +
        userSelectionAction;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "1B4einUjHw",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertPasswordResetFailure(passwordResetFailure, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertList(
        "1Bskghj-kT",
        "Password Reset Failure",
        passwordResetFailure
      )
    );
    if (
      passwordResetFailure !== null &&
      passwordResetFailure !== undefined &&
      passwordResetFailure.forEach
    ) {
      passwordResetFailure.forEach(function (value, index) {
        messages = messages.concat(
          AvoAssert.assertString(
            "1Bskghj-kT",
            "item at index " + index + " in Password Reset Failure",
            value
          )
        );
        if (
          "Length" !== value &&
          "Digit" !== value &&
          "Uppercase" !== value &&
          "Special Character" !== value &&
          "Lowercase" !== value
        ) {
          var message =
            (label_
              ? "item at index " +
                index +
                " in Password Reset Failure" +
                ": " +
                label_
              : "item at index " + index + " in Password Reset Failure") +
            " should match one of the following values [ Length | Digit | Uppercase | Special Character | Lowercase ] but you provided the value " +
            value;
          messages = messages.concat([
            {
              tag: "expectedStringMatch",
              propertyId: "1Bskghj-kT",
              message: message,
            },
          ]);
        }
      });
    }
    return messages;
  }

  function assertConsolidatedReportTimeframe(
    consolidatedReportTimeframe,
    label_
  ) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "1Qs7wUeGe",
        label_
          ? "Consolidated Report Timeframe" + ": " + label_
          : "Consolidated Report Timeframe",
        consolidatedReportTimeframe
      )
    );
    if (
      "Last 30 days" !== consolidatedReportTimeframe &&
      "Last 3 months" !== consolidatedReportTimeframe &&
      "Last 12 months" !== consolidatedReportTimeframe &&
      "Year to date" !== consolidatedReportTimeframe &&
      "All time" !== consolidatedReportTimeframe &&
      "Month" !== consolidatedReportTimeframe
    ) {
      var message =
        (label_
          ? "Consolidated Report Timeframe" + ": " + label_
          : "Consolidated Report Timeframe") +
        " should match one of the following values [ Last 30 days | Last 3 months | Last 12 months | Year to date | All time | Month ] but you provided the value " +
        consolidatedReportTimeframe;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "1Qs7wUeGe",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertOptionalExportedDriverCount(exportedDriverCount, label_) {
    var messages = [];
    if (exportedDriverCount !== undefined && exportedDriverCount !== null) {
      messages = messages.concat(
        AvoAssert.assertInt(
          "1vX-ssoiI",
          label_
            ? "Exported Driver Count" + ": " + label_
            : "Exported Driver Count",
          exportedDriverCount
        )
      );
    }
    return messages;
  }

  function assertResendType(resendType, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "2Bd1esJeWE",
        label_ ? "Resend Type" + ": " + label_ : "Resend Type",
        resendType
      )
    );
    if ("Bulk" !== resendType && "Subset" !== resendType) {
      var message =
        (label_ ? "Resend Type" + ": " + label_ : "Resend Type") +
        " should match one of the following values [ Bulk | Subset ] but you provided the value " +
        resendType;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "2Bd1esJeWE",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertOptionalSignupOriginProduct(signupOriginProduct, label_) {
    var messages = [];
    if (signupOriginProduct !== undefined && signupOriginProduct !== null) {
      messages = messages.concat(
        AvoAssert.assertString(
          "2jyHUaEjz",
          label_
            ? "Signup Origin Product" + ": " + label_
            : "Signup Origin Product",
          signupOriginProduct
        )
      );
      if (
        "Teams" !== signupOriginProduct &&
        "Standalone" !== signupOriginProduct
      ) {
        var message =
          (label_
            ? "Signup Origin Product" + ": " + label_
            : "Signup Origin Product") +
          " should match one of the following values [ Teams | Standalone ] but you provided the value " +
          signupOriginProduct;
        messages = messages.concat([
          {
            tag: "expectedStringMatch",
            propertyId: "2jyHUaEjz",
            message: message,
          },
        ]);
      }
    }
    return messages;
  }

  function assertOptionalExistingSASubscription(
    existingSaSubscription,
    label_
  ) {
    var messages = [];
    if (
      existingSaSubscription !== undefined &&
      existingSaSubscription !== null
    ) {
      messages = messages.concat(
        AvoAssert.assertString(
          "2sbualRk4",
          label_
            ? "Existing SA Subscription" + ": " + label_
            : "Existing SA Subscription",
          existingSaSubscription
        )
      );
      if (
        "apple_monthly" !== existingSaSubscription &&
        "apple_annual" !== existingSaSubscription &&
        "google_monthly" !== existingSaSubscription &&
        "google_annual" !== existingSaSubscription &&
        "stripe_monthly" !== existingSaSubscription &&
        "stripe_annual" !== existingSaSubscription &&
        "none" !== existingSaSubscription
      ) {
        var message =
          (label_
            ? "Existing SA Subscription" + ": " + label_
            : "Existing SA Subscription") +
          " should match one of the following values [ apple_monthly | apple_annual | google_monthly | google_annual | stripe_monthly | stripe_annual | none ] but you provided the value " +
          existingSaSubscription;
        messages = messages.concat([
          {
            tag: "expectedStringMatch",
            propertyId: "2sbualRk4",
            message: message,
          },
        ]);
      }
    }
    return messages;
  }

  function assertDriveAdvancedFilterCount(driveAdvancedFilterCount, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertInt(
        "32VoH_Ayk",
        label_
          ? "Drive Advanced Filter Count" + ": " + label_
          : "Drive Advanced Filter Count",
        driveAdvancedFilterCount
      )
    );
    messages = messages.concat(
      AvoAssert.assertMin(
        "32VoH_Ayk",
        label_
          ? "Drive Advanced Filter Count" + ": " + label_
          : "Drive Advanced Filter Count",
        0,
        driveAdvancedFilterCount
      )
    );
    return messages;
  }

  function assertTeamsSignupStepName(teamsSignupStepName, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "34JIBRdGGG",
        label_
          ? "Teams Signup Step Name" + ": " + label_
          : "Teams Signup Step Name",
        teamsSignupStepName
      )
    );
    if (
      "Name Team" !== teamsSignupStepName &&
      "Select Features" !== teamsSignupStepName &&
      "Choose Plan" !== teamsSignupStepName &&
      "Invite Users" !== teamsSignupStepName &&
      "Order Confirmation" !== teamsSignupStepName &&
      "Role Picker" !== teamsSignupStepName &&
      "Create Team" !== teamsSignupStepName
    ) {
      var message =
        (label_
          ? "Teams Signup Step Name" + ": " + label_
          : "Teams Signup Step Name") +
        " should match one of the following values [ Name Team | Select Features | Choose Plan | Invite Users | Order Confirmation | Role Picker | Create Team ] but you provided the value " +
        teamsSignupStepName;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "34JIBRdGGG",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertReportCreationFailure(reportCreationFailure, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "3ZA9BthdP",
        label_
          ? "Report Creation Failure" + ": " + label_
          : "Report Creation Failure",
        reportCreationFailure
      )
    );
    if (
      "Something went wrong" !== reportCreationFailure &&
      "No business drives" !== reportCreationFailure
    ) {
      var message =
        (label_
          ? "Report Creation Failure" + ": " + label_
          : "Report Creation Failure") +
        " should match one of the following values [ Something went wrong | No business drives ] but you provided the value " +
        reportCreationFailure;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "3ZA9BthdP",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertFrequentDrivePromptAction(frequentDrivePromptAction, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "42qU5Rs27",
        label_
          ? "Frequent Drive Prompt Action" + ": " + label_
          : "Frequent Drive Prompt Action",
        frequentDrivePromptAction
      )
    );
    if (
      "Auto Classify" !== frequentDrivePromptAction &&
      "Not Now" !== frequentDrivePromptAction &&
      "Dismissed" !== frequentDrivePromptAction
    ) {
      var message =
        (label_
          ? "Frequent Drive Prompt Action" + ": " + label_
          : "Frequent Drive Prompt Action") +
        " should match one of the following values [ Auto Classify | Not Now | Dismissed ] but you provided the value " +
        frequentDrivePromptAction;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "42qU5Rs27",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertCustomPurposeSource(customPurposeSource, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "4Y4Sy8Xnx",
        label_
          ? "Custom Purpose Source" + ": " + label_
          : "Custom Purpose Source",
        customPurposeSource
      )
    );
    if (
      "Settings" !== customPurposeSource &&
      "Add Drive" !== customPurposeSource &&
      "Drives Filter" !== customPurposeSource
    ) {
      var message =
        (label_
          ? "Custom Purpose Source" + ": " + label_
          : "Custom Purpose Source") +
        " should match one of the following values [ Settings | Add Drive | Drives Filter ] but you provided the value " +
        customPurposeSource;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "4Y4Sy8Xnx",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertPage(page, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "4j_Pu5zIMW",
        label_ ? "Page" + ": " + label_ : "Page",
        page
      )
    );
    if (
      "Reports" !== page &&
      "Monthly Summaries" !== page &&
      "Report Details" !== page &&
      "Home" !== page &&
      "Settings" !== page &&
      "Users" !== page &&
      "Custom Rates" !== page &&
      "Tutorial" !== page &&
      "Create Report" !== page &&
      "Drives" !== page &&
      "Vehicles" !== page &&
      "Drive Details" !== page &&
      "Notification Settings" !== page &&
      "Email Settings" !== page &&
      "Subscription" !== page &&
      "Teams" !== page &&
      "Onboarding" !== page &&
      "Team Locations" !== page &&
      "Get Started" !== page &&
      "Welcome Download" !== page &&
      "Share Report" !== page &&
      "Shared with me" !== page &&
      "Shared Reports" !== page
    ) {
      var message =
        (label_ ? "Page" + ": " + label_ : "Page") +
        " should match one of the following values [ Reports | Monthly Summaries | Report Details | Home | Settings | Users | Custom Rates | Tutorial | Create Report | Drives | Vehicles | Drive Details | Notification Settings | Email Settings | Subscription | Teams | Onboarding | Team Locations | Get Started | Welcome Download | Share Report | Shared with me | Shared Reports ] but you provided the value " +
        page;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "4j_Pu5zIMW",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertOptionalPage(page, label_) {
    var messages = [];
    if (page !== undefined && page !== null) {
      messages = messages.concat(
        AvoAssert.assertString(
          "4j_Pu5zIMW",
          label_ ? "Page" + ": " + label_ : "Page",
          page
        )
      );
      if (
        "Reports" !== page &&
        "Monthly Summaries" !== page &&
        "Report Details" !== page &&
        "Home" !== page &&
        "Settings" !== page &&
        "Users" !== page &&
        "Custom Rates" !== page &&
        "Tutorial" !== page &&
        "Create Report" !== page &&
        "Drives" !== page &&
        "Vehicles" !== page &&
        "Drive Details" !== page &&
        "Notification Settings" !== page &&
        "Email Settings" !== page &&
        "Subscription" !== page &&
        "Teams" !== page &&
        "Onboarding" !== page &&
        "Team Locations" !== page &&
        "Get Started" !== page &&
        "Welcome Download" !== page &&
        "Share Report" !== page &&
        "Shared with me" !== page &&
        "Shared Reports" !== page
      ) {
        var message =
          (label_ ? "Page" + ": " + label_ : "Page") +
          " should match one of the following values [ Reports | Monthly Summaries | Report Details | Home | Settings | Users | Custom Rates | Tutorial | Create Report | Drives | Vehicles | Drive Details | Notification Settings | Email Settings | Subscription | Teams | Onboarding | Team Locations | Get Started | Welcome Download | Share Report | Shared with me | Shared Reports ] but you provided the value " +
          page;
        messages = messages.concat([
          {
            tag: "expectedStringMatch",
            propertyId: "4j_Pu5zIMW",
            message: message,
          },
        ]);
      }
    }
    return messages;
  }

  function assertOptionalOverlayCTA(overlayCta, label_) {
    var messages = [];
    if (overlayCta !== undefined && overlayCta !== null) {
      messages = messages.concat(
        AvoAssert.assertString(
          "5ZszlqnTtw",
          label_ ? "Overlay CTA" + ": " + label_ : "Overlay CTA",
          overlayCta
        )
      );
      if (
        "Text me a download link" !== overlayCta &&
        "Schedule a call" !== overlayCta
      ) {
        var message =
          (label_ ? "Overlay CTA" + ": " + label_ : "Overlay CTA") +
          " should match one of the following values [ Text me a download link | Schedule a call ] but you provided the value " +
          overlayCta;
        messages = messages.concat([
          {
            tag: "expectedStringMatch",
            propertyId: "5ZszlqnTtw",
            message: message,
          },
        ]);
      }
    }
    return messages;
  }

  function assertDistanceUnit(distanceUnit, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "66VK90YPq",
        label_ ? "Distance Unit" + ": " + label_ : "Distance Unit",
        distanceUnit
      )
    );
    if ("Miles" !== distanceUnit && "Kilometers" !== distanceUnit) {
      var message =
        (label_ ? "Distance Unit" + ": " + label_ : "Distance Unit") +
        " should match one of the following values [ Miles | Kilometers ] but you provided the value " +
        distanceUnit;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "66VK90YPq",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertTeamsPlanSelectionID(teamsPlanSelectionId, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertInt(
        "6pTFwqFl49",
        label_
          ? "Teams Plan Selection ID" + ": " + label_
          : "Teams Plan Selection ID",
        teamsPlanSelectionId
      )
    );
    messages = messages.concat(
      AvoAssert.assertMin(
        "6pTFwqFl49",
        label_
          ? "Teams Plan Selection ID" + ": " + label_
          : "Teams Plan Selection ID",
        9,
        teamsPlanSelectionId
      )
    );
    messages = messages.concat(
      AvoAssert.assertMax(
        "6pTFwqFl49",
        label_
          ? "Teams Plan Selection ID" + ": " + label_
          : "Teams Plan Selection ID",
        11,
        teamsPlanSelectionId
      )
    );
    return messages;
  }

  function assertOverlayInteraction(overlayInteraction, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "73yZ69XG6-",
        label_ ? "Overlay Interaction" + ": " + label_ : "Overlay Interaction",
        overlayInteraction
      )
    );
    if (
      "Completed CTA" !== overlayInteraction &&
      "Dismissed" !== overlayInteraction
    ) {
      var message =
        (label_
          ? "Overlay Interaction" + ": " + label_
          : "Overlay Interaction") +
        " should match one of the following values [ Completed CTA | Dismissed ] but you provided the value " +
        overlayInteraction;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "73yZ69XG6-",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertOptionalContactRelationship(contactRelationship, label_) {
    var messages = [];
    if (contactRelationship !== undefined && contactRelationship !== null) {
      messages = messages.concat(
        AvoAssert.assertString(
          "8BiIah0U4",
          label_
            ? "Contact Relationship" + ": " + label_
            : "Contact Relationship",
          contactRelationship
        )
      );
    }
    return messages;
  }

  function assertContactRelationship(contactRelationship, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "8BiIah0U4",
        label_
          ? "Contact Relationship" + ": " + label_
          : "Contact Relationship",
        contactRelationship
      )
    );
    return messages;
  }

  function assertOptionalTeamsReportsMonthOfDrivesFilter(
    teamsReportsMonthOfDrivesFilter,
    label_
  ) {
    var messages = [];
    if (
      teamsReportsMonthOfDrivesFilter !== undefined &&
      teamsReportsMonthOfDrivesFilter !== null
    ) {
      messages = messages.concat(
        AvoAssert.assertString(
          "90lHtUV6D",
          label_
            ? "Teams Reports Month of Drives Filter" + ": " + label_
            : "Teams Reports Month of Drives Filter",
          teamsReportsMonthOfDrivesFilter
        )
      );
    }
    return messages;
  }

  function assertInviteCount(inviteCount, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertInt(
        "9uGZsL65PR",
        label_ ? "Invite Count" + ": " + label_ : "Invite Count",
        inviteCount
      )
    );
    messages = messages.concat(
      AvoAssert.assertMin(
        "9uGZsL65PR",
        label_ ? "Invite Count" + ": " + label_ : "Invite Count",
        1,
        inviteCount
      )
    );
    return messages;
  }

  function assertTeamsSignupSource(teamsSignupSource, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "AItZaE-Us-",
        label_ ? "Teams Signup Source" + ": " + label_ : "Teams Signup Source",
        teamsSignupSource
      )
    );
    if (
      "Website" !== teamsSignupSource &&
      "Dashboard" !== teamsSignupSource &&
      "Integrations Settings" !== teamsSignupSource &&
      "Profile Dropdown" !== teamsSignupSource &&
      "Navigation Bar Popup" !== teamsSignupSource &&
      "Teams Page" !== teamsSignupSource &&
      "Contacts Dashboard Standalone" !== teamsSignupSource &&
      "Contacts Dashboard Non Driver" !== teamsSignupSource
    ) {
      var message =
        (label_
          ? "Teams Signup Source" + ": " + label_
          : "Teams Signup Source") +
        " should match one of the following values [ Website | Dashboard | Integrations Settings | Profile Dropdown | Navigation Bar Popup | Teams Page | Contacts Dashboard Standalone | Contacts Dashboard Non Driver ] but you provided the value " +
        teamsSignupSource;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "AItZaE-Us-",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertFrequentUnclassifiedDrivesAction(
    frequentUnclassifiedDrivesAction,
    label_
  ) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "Ac-lsPbaP",
        label_
          ? "Frequent Unclassified Drives Action" + ": " + label_
          : "Frequent Unclassified Drives Action",
        frequentUnclassifiedDrivesAction
      )
    );
    if (
      "Selected" !== frequentUnclassifiedDrivesAction &&
      "Unselected" !== frequentUnclassifiedDrivesAction
    ) {
      var message =
        (label_
          ? "Frequent Unclassified Drives Action" + ": " + label_
          : "Frequent Unclassified Drives Action") +
        " should match one of the following values [ Selected | Unselected ] but you provided the value " +
        frequentUnclassifiedDrivesAction;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "Ac-lsPbaP",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertOptionalAutomaticReviewEnabled(
    automaticReviewEnabled,
    label_
  ) {
    var messages = [];
    if (
      automaticReviewEnabled !== undefined &&
      automaticReviewEnabled !== null
    ) {
      messages = messages.concat(
        AvoAssert.assertBool(
          "Ak-PHZQ7S",
          label_
            ? "Automatic Review Enabled" + ": " + label_
            : "Automatic Review Enabled",
          automaticReviewEnabled
        )
      );
    }
    return messages;
  }

  function assertOptionalReportMarkDrives(reportMarkDrives, label_) {
    var messages = [];
    if (reportMarkDrives !== undefined && reportMarkDrives !== null) {
      messages = messages.concat(
        AvoAssert.assertString(
          "AtIut9HHF",
          label_ ? "Report Mark Drives" + ": " + label_ : "Report Mark Drives",
          reportMarkDrives
        )
      );
      if (
        "Reported" !== reportMarkDrives &&
        "Unreported" !== reportMarkDrives
      ) {
        var message =
          (label_
            ? "Report Mark Drives" + ": " + label_
            : "Report Mark Drives") +
          " should match one of the following values [ Reported | Unreported ] but you provided the value " +
          reportMarkDrives;
        messages = messages.concat([
          {
            tag: "expectedStringMatch",
            propertyId: "AtIut9HHF",
            message: message,
          },
        ]);
      }
    }
    return messages;
  }

  function assertUrl(url, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "B3qjZSqogW",
        label_ ? "URL" + ": " + label_ : "URL",
        url
      )
    );
    return messages;
  }

  function assertOptionalSignupSource(signupSource, label_) {
    var messages = [];
    if (signupSource !== undefined && signupSource !== null) {
      messages = messages.concat(
        AvoAssert.assertString(
          "BR56CVJcO",
          label_ ? "Signup Source" + ": " + label_ : "Signup Source",
          signupSource
        )
      );
      if ("Contacts Dashboard" !== signupSource) {
        var message =
          (label_ ? "Signup Source" + ": " + label_ : "Signup Source") +
          " should match one of the following values [ Contacts Dashboard ] but you provided the value " +
          signupSource;
        messages = messages.concat([
          {
            tag: "expectedStringMatch",
            propertyId: "BR56CVJcO",
            message: message,
          },
        ]);
      }
    }
    return messages;
  }

  function assertFrequentDrivePreference(frequentDrivePreference, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "BT7rdgeb-",
        label_
          ? "Frequent Drive Preference" + ": " + label_
          : "Frequent Drive Preference",
        frequentDrivePreference
      )
    );
    if (
      "Enabled" !== frequentDrivePreference &&
      "Disabled" !== frequentDrivePreference
    ) {
      var message =
        (label_
          ? "Frequent Drive Preference" + ": " + label_
          : "Frequent Drive Preference") +
        " should match one of the following values [ Enabled | Disabled ] but you provided the value " +
        frequentDrivePreference;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "BT7rdgeb-",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertReportDownloadSource(reportDownloadSource, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "C1Tw7ptiU",
        label_
          ? "Report Download Source" + ": " + label_
          : "Report Download Source",
        reportDownloadSource
      )
    );
    if (
      "Report Details Sidebar" !== reportDownloadSource &&
      "Reports Sidebar" !== reportDownloadSource &&
      "Reports Row" !== reportDownloadSource
    ) {
      var message =
        (label_
          ? "Report Download Source" + ": " + label_
          : "Report Download Source") +
        " should match one of the following values [ Report Details Sidebar | Reports Sidebar | Reports Row ] but you provided the value " +
        reportDownloadSource;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "C1Tw7ptiU",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertOverlayType(overlayType, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "CSsraVojcP",
        label_ ? "Overlay Type" + ": " + label_ : "Overlay Type",
        overlayType
      )
    );
    if (
      "Popup" !== overlayType &&
      "Banner" !== overlayType &&
      "Full Page" !== overlayType
    ) {
      var message =
        (label_ ? "Overlay Type" + ": " + label_ : "Overlay Type") +
        " should match one of the following values [ Popup | Banner | Full Page ] but you provided the value " +
        overlayType;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "CSsraVojcP",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertOverlayCategory(overlayCategory, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "D3qM3rRSyw",
        label_ ? "Overlay Category" + ": " + label_ : "Overlay Category",
        overlayCategory
      )
    );
    if (
      "Welcome" !== overlayCategory &&
      "Teams Onboarding" !== overlayCategory &&
      "Free Trial" !== overlayCategory
    ) {
      var message =
        (label_ ? "Overlay Category" + ": " + label_ : "Overlay Category") +
        " should match one of the following values [ Welcome | Teams Onboarding | Free Trial ] but you provided the value " +
        overlayCategory;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "D3qM3rRSyw",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertDriveReportedFilter(driveReportedFilter, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "D4Tul0Xys",
        label_
          ? "Drive Reported Filter" + ": " + label_
          : "Drive Reported Filter",
        driveReportedFilter
      )
    );
    if (
      "Include" !== driveReportedFilter &&
      "Exclude" !== driveReportedFilter
    ) {
      var message =
        (label_
          ? "Drive Reported Filter" + ": " + label_
          : "Drive Reported Filter") +
        " should match one of the following values [ Include | Exclude ] but you provided the value " +
        driveReportedFilter;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "D4Tul0Xys",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertOptionalOrganizationGroupID(organizationGroupId, label_) {
    var messages = [];
    if (organizationGroupId !== undefined && organizationGroupId !== null) {
      messages = messages.concat(
        AvoAssert.assertString(
          "DTTXRDLbGJ",
          label_
            ? "Organization Group ID" + ": " + label_
            : "Organization Group ID",
          organizationGroupId
        )
      );
    }
    return messages;
  }

  function assertTeamsDowngradeSource(teamsDowngradeSource, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "EL_wSUVYa",
        label_
          ? "Teams Downgrade Source" + ": " + label_
          : "Teams Downgrade Source",
        teamsDowngradeSource
      )
    );
    if ("Subscription Cancellation Modal" !== teamsDowngradeSource) {
      var message =
        (label_
          ? "Teams Downgrade Source" + ": " + label_
          : "Teams Downgrade Source") +
        " should match one of the following values [ Subscription Cancellation Modal ] but you provided the value " +
        teamsDowngradeSource;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "EL_wSUVYa",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertReportsDriveFilter(reportsDriveFilter, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "EPgAk6V-T",
        label_
          ? "Reports Drive Filter" + ": " + label_
          : "Reports Drive Filter",
        reportsDriveFilter
      )
    );
    if (
      "All Drives" !== reportsDriveFilter &&
      "Business Drives" !== reportsDriveFilter &&
      "Personal Drives" !== reportsDriveFilter
    ) {
      var message =
        (label_
          ? "Reports Drive Filter" + ": " + label_
          : "Reports Drive Filter") +
        " should match one of the following values [ All Drives | Business Drives | Personal Drives ] but you provided the value " +
        reportsDriveFilter;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "EPgAk6V-T",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertAllDrivers(allDrivers, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertBool(
        "EdylnfTLU",
        label_ ? "All Drivers" + ": " + label_ : "All Drivers",
        allDrivers
      )
    );
    return messages;
  }

  function assertFilterDriveFrequentDrives(filterDriveFrequentDrives, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "Et8FL0ioR",
        label_
          ? "Filter Drive Frequent Drives" + ": " + label_
          : "Filter Drive Frequent Drives",
        filterDriveFrequentDrives
      )
    );
    if (
      "Selected" !== filterDriveFrequentDrives &&
      "Unselected" !== filterDriveFrequentDrives
    ) {
      var message =
        (label_
          ? "Filter Drive Frequent Drives" + ": " + label_
          : "Filter Drive Frequent Drives") +
        " should match one of the following values [ Selected | Unselected ] but you provided the value " +
        filterDriveFrequentDrives;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "Et8FL0ioR",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertOptionalTeamsUpgradeFeature(teamsUpgradeFeature, label_) {
    var messages = [];
    if (teamsUpgradeFeature !== undefined && teamsUpgradeFeature !== null) {
      messages = messages.concat(
        AvoAssert.assertString(
          "FKrYUvbmL",
          label_
            ? "Teams Upgrade Feature" + ": " + label_
            : "Teams Upgrade Feature",
          teamsUpgradeFeature
        )
      );
      if (
        "Concur Integration" !== teamsUpgradeFeature &&
        "Report Reminders" !== teamsUpgradeFeature &&
        "Teams Locations" !== teamsUpgradeFeature &&
        "Exclude Commute" !== teamsUpgradeFeature &&
        "Approve Reject" !== teamsUpgradeFeature &&
        "Automatic Review" !== teamsUpgradeFeature
      ) {
        var message =
          (label_
            ? "Teams Upgrade Feature" + ": " + label_
            : "Teams Upgrade Feature") +
          " should match one of the following values [ Concur Integration | Report Reminders | Teams Locations | Exclude Commute | Approve Reject | Automatic Review ] but you provided the value " +
          teamsUpgradeFeature;
        messages = messages.concat([
          {
            tag: "expectedStringMatch",
            propertyId: "FKrYUvbmL",
            message: message,
          },
        ]);
      }
    }
    return messages;
  }

  function assertSignupFailure(signupFailure, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "FQMnEG9KE",
        label_ ? "Signup Failure" + ": " + label_ : "Signup Failure",
        signupFailure
      )
    );
    if (
      "Invalid Email" !== signupFailure &&
      "Account Already Exists" !== signupFailure &&
      "Invalid Password" !== signupFailure &&
      "First Name Required" !== signupFailure &&
      "Last Name Required" !== signupFailure
    ) {
      var message =
        (label_ ? "Signup Failure" + ": " + label_ : "Signup Failure") +
        " should match one of the following values [ Invalid Email | Account Already Exists | Invalid Password | First Name Required | Last Name Required ] but you provided the value " +
        signupFailure;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "FQMnEG9KE",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertReviewAction(reviewAction, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "FWTawJHUN",
        label_ ? "Review Action" + ": " + label_ : "Review Action",
        reviewAction
      )
    );
    if (
      "accept" !== reviewAction &&
      "reject" !== reviewAction &&
      "reset" !== reviewAction
    ) {
      var message =
        (label_ ? "Review Action" + ": " + label_ : "Review Action") +
        " should match one of the following values [ accept | reject | reset ] but you provided the value " +
        reviewAction;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "FWTawJHUN",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertPlatform(platform, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "FfkzdkMHsZ",
        label_ ? "Platform" + ": " + label_ : "Platform",
        platform
      )
    );
    if ("Web" !== platform && "iOS" !== platform && "Android" !== platform) {
      var message =
        (label_ ? "Platform" + ": " + label_ : "Platform") +
        " should match one of the following values [ Web | iOS | Android ] but you provided the value " +
        platform;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "FfkzdkMHsZ",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertFilterDriveWithoutNotes(filterDriveWithoutNotes, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "Fg3Z-uxvl",
        label_
          ? "Filter Drive Without Notes" + ": " + label_
          : "Filter Drive Without Notes",
        filterDriveWithoutNotes
      )
    );
    if (
      "Selected" !== filterDriveWithoutNotes &&
      "Unselected" !== filterDriveWithoutNotes
    ) {
      var message =
        (label_
          ? "Filter Drive Without Notes" + ": " + label_
          : "Filter Drive Without Notes") +
        " should match one of the following values [ Selected | Unselected ] but you provided the value " +
        filterDriveWithoutNotes;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "Fg3Z-uxvl",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertSearchSelectionType(searchSelectionType, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "FqbzTAJB2",
        label_
          ? "Search Selection Type" + ": " + label_
          : "Search Selection Type",
        searchSelectionType
      )
    );
    if (
      "Named Location" !== searchSelectionType &&
      "Generic Address" !== searchSelectionType &&
      "Notes" !== searchSelectionType &&
      "All Results" !== searchSelectionType
    ) {
      var message =
        (label_
          ? "Search Selection Type" + ": " + label_
          : "Search Selection Type") +
        " should match one of the following values [ Named Location | Generic Address | Notes | All Results ] but you provided the value " +
        searchSelectionType;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "FqbzTAJB2",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertReportReminderRepeatsScheduleSetting(
    reportReminderRepeatsScheduleSetting,
    label_
  ) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "GT-hcInJ8",
        label_
          ? "Report Reminder Repeats Schedule Setting" + ": " + label_
          : "Report Reminder Repeats Schedule Setting",
        reportReminderRepeatsScheduleSetting
      )
    );
    return messages;
  }

  function assertReportCreationStepName(reportCreationStepName, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "Gk0YhZ6oD",
        label_
          ? "Report Creation Step Name" + ": " + label_
          : "Report Creation Step Name",
        reportCreationStepName
      )
    );
    if (
      "Report timeframe selected" !== reportCreationStepName &&
      "Report recipient selected" !== reportCreationStepName &&
      "Report details completed" !== reportCreationStepName
    ) {
      var message =
        (label_
          ? "Report Creation Step Name" + ": " + label_
          : "Report Creation Step Name") +
        " should match one of the following values [ Report timeframe selected | Report recipient selected | Report details completed ] but you provided the value " +
        reportCreationStepName;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "Gk0YhZ6oD",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertLoginFailure(loginFailure, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "Gq94nV2ad3",
        label_ ? "Login Failure" + ": " + label_ : "Login Failure",
        loginFailure
      )
    );
    if (
      "Email Incorrect" !== loginFailure &&
      "Password Incorrect" !== loginFailure
    ) {
      var message =
        (label_ ? "Login Failure" + ": " + label_ : "Login Failure") +
        " should match one of the following values [ Email Incorrect | Password Incorrect ] but you provided the value " +
        loginFailure;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "Gq94nV2ad3",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertTeamsSignupStepNumber(teamsSignupStepNumber, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertInt(
        "HpIIjC8z9E",
        label_
          ? "Teams Signup Step Number" + ": " + label_
          : "Teams Signup Step Number",
        teamsSignupStepNumber
      )
    );
    messages = messages.concat(
      AvoAssert.assertMin(
        "HpIIjC8z9E",
        label_
          ? "Teams Signup Step Number" + ": " + label_
          : "Teams Signup Step Number",
        1,
        teamsSignupStepNumber
      )
    );
    messages = messages.concat(
      AvoAssert.assertMax(
        "HpIIjC8z9E",
        label_
          ? "Teams Signup Step Number" + ": " + label_
          : "Teams Signup Step Number",
        4,
        teamsSignupStepNumber
      )
    );
    return messages;
  }

  function assertInviteFailureReason(inviteFailureReason, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "I0lNR1CZs8",
        label_
          ? "Invite Failure Reason" + ": " + label_
          : "Invite Failure Reason",
        inviteFailureReason
      )
    );
    if (
      "Invalid Email" !== inviteFailureReason &&
      "User On Another Team" !== inviteFailureReason &&
      "Other" !== inviteFailureReason
    ) {
      var message =
        (label_
          ? "Invite Failure Reason" + ": " + label_
          : "Invite Failure Reason") +
        " should match one of the following values [ Invalid Email | User On Another Team | Other ] but you provided the value " +
        inviteFailureReason;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "I0lNR1CZs8",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertFirstReportReminderDateSetting(
    firstReportReminderDateSetting,
    label_
  ) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "I95-6spf_",
        label_
          ? "First Report Reminder Date Setting" + ": " + label_
          : "First Report Reminder Date Setting",
        firstReportReminderDateSetting
      )
    );
    return messages;
  }

  function assertOptionalEligibleToDiscounts(eligibleToDiscounts, label_) {
    var messages = [];
    if (eligibleToDiscounts !== undefined && eligibleToDiscounts !== null) {
      messages = messages.concat(
        AvoAssert.assertBool(
          "IaqLx6O9U",
          label_
            ? "Eligible to Discounts" + ": " + label_
            : "Eligible to Discounts",
          eligibleToDiscounts
        )
      );
    }
    return messages;
  }

  function assertEligibleToDiscounts(eligibleToDiscounts, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertBool(
        "IaqLx6O9U",
        label_
          ? "Eligible to Discounts" + ": " + label_
          : "Eligible to Discounts",
        eligibleToDiscounts
      )
    );
    return messages;
  }

  function assertReportsDateFilter(reportsDateFilter, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "IrRajt9Rv",
        label_ ? "Reports Date Filter" + ": " + label_ : "Reports Date Filter",
        reportsDateFilter
      )
    );
    if (
      "This Month" !== reportsDateFilter &&
      "Last Month" !== reportsDateFilter &&
      "Last 3 Months" !== reportsDateFilter &&
      "Year to Date" !== reportsDateFilter &&
      "Last Year" !== reportsDateFilter &&
      "Custom Range" !== reportsDateFilter &&
      "Month" !== reportsDateFilter
    ) {
      var message =
        (label_
          ? "Reports Date Filter" + ": " + label_
          : "Reports Date Filter") +
        " should match one of the following values [ This Month | Last Month | Last 3 Months | Year to Date | Last Year | Custom Range | Month ] but you provided the value " +
        reportsDateFilter;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "IrRajt9Rv",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertDriveCount(driveCount, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertInt(
        "JDI2RsZke",
        label_ ? "Drive Count" + ": " + label_ : "Drive Count",
        driveCount
      )
    );
    messages = messages.concat(
      AvoAssert.assertMin(
        "JDI2RsZke",
        label_ ? "Drive Count" + ": " + label_ : "Drive Count",
        0,
        driveCount
      )
    );
    return messages;
  }

  function assertFilterDriveWorkHours(filterDriveWorkHours, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "JQ3AfPhRR",
        label_
          ? "Filter Drive Work Hours" + ": " + label_
          : "Filter Drive Work Hours",
        filterDriveWorkHours
      )
    );
    if (
      "Selected" !== filterDriveWorkHours &&
      "Unselected" !== filterDriveWorkHours
    ) {
      var message =
        (label_
          ? "Filter Drive Work Hours" + ": " + label_
          : "Filter Drive Work Hours") +
        " should match one of the following values [ Selected | Unselected ] but you provided the value " +
        filterDriveWorkHours;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "JQ3AfPhRR",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertDriveSelectionMethod(driveSelectionMethod, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "JcKYzo7cC",
        label_
          ? "Drive Selection Method" + ": " + label_
          : "Drive Selection Method",
        driveSelectionMethod
      )
    );
    if (
      "Individual" !== driveSelectionMethod &&
      "Day" !== driveSelectionMethod &&
      "All" !== driveSelectionMethod
    ) {
      var message =
        (label_
          ? "Drive Selection Method" + ": " + label_
          : "Drive Selection Method") +
        " should match one of the following values [ Individual | Day | All ] but you provided the value " +
        driveSelectionMethod;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "JcKYzo7cC",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertVariationName(variationName, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "JoQpUcp-3B",
        label_ ? "Variation Name" + ": " + label_ : "Variation Name",
        variationName
      )
    );
    return messages;
  }

  function assertVariationID(variationId, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertInt(
        "KKUJskjFz2",
        label_ ? "Variation ID" + ": " + label_ : "Variation ID",
        variationId
      )
    );
    return messages;
  }

  function assertLoginSessionPreference(loginSessionPreference, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "KjfLC6Db-r",
        label_
          ? "Login Session Preference" + ": " + label_
          : "Login Session Preference",
        loginSessionPreference
      )
    );
    if (
      "Single Session" !== loginSessionPreference &&
      "Multi Session" !== loginSessionPreference
    ) {
      var message =
        (label_
          ? "Login Session Preference" + ": " + label_
          : "Login Session Preference") +
        " should match one of the following values [ Single Session | Multi Session ] but you provided the value " +
        loginSessionPreference;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "KjfLC6Db-r",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertDashboardSwitchedTo(dashboardSwitchedTo, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "KtZI6fuaf",
        label_
          ? "Dashboard Switched To" + ": " + label_
          : "Dashboard Switched To",
        dashboardSwitchedTo
      )
    );
    if ("Teams" !== dashboardSwitchedTo && "Driver" !== dashboardSwitchedTo) {
      var message =
        (label_
          ? "Dashboard Switched To" + ": " + label_
          : "Dashboard Switched To") +
        " should match one of the following values [ Teams | Driver ] but you provided the value " +
        dashboardSwitchedTo;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "KtZI6fuaf",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertEmail(email, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "KwJDoiNGCh",
        label_ ? "Email" + ": " + label_ : "Email",
        email
      )
    );
    return messages;
  }

  function assertOptionalEmail(email, label_) {
    var messages = [];
    if (email !== undefined && email !== null) {
      messages = messages.concat(
        AvoAssert.assertString(
          "KwJDoiNGCh",
          label_ ? "Email" + ": " + label_ : "Email",
          email
        )
      );
    }
    return messages;
  }

  function assertOptionalReportDetailsDriveFilter(
    reportDetailsDriveFilter,
    label_
  ) {
    var messages = [];
    if (
      reportDetailsDriveFilter !== undefined &&
      reportDetailsDriveFilter !== null
    ) {
      messages = messages.concat(
        AvoAssert.assertString(
          "LudSgovtA",
          label_
            ? "Report Details Drive Filter" + ": " + label_
            : "Report Details Drive Filter",
          reportDetailsDriveFilter
        )
      );
      if (
        "All drives" !== reportDetailsDriveFilter &&
        "Manually added" !== reportDetailsDriveFilter
      ) {
        var message =
          (label_
            ? "Report Details Drive Filter" + ": " + label_
            : "Report Details Drive Filter") +
          " should match one of the following values [ All drives | Manually added ] but you provided the value " +
          reportDetailsDriveFilter;
        messages = messages.concat([
          {
            tag: "expectedStringMatch",
            propertyId: "LudSgovtA",
            message: message,
          },
        ]);
      }
    }
    return messages;
  }

  function assertBusinessPurposeCount(businessPurposeCount, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertInt(
        "M68_gGgjq",
        label_
          ? "Business Purpose Count" + ": " + label_
          : "Business Purpose Count",
        businessPurposeCount
      )
    );
    messages = messages.concat(
      AvoAssert.assertMin(
        "M68_gGgjq",
        label_
          ? "Business Purpose Count" + ": " + label_
          : "Business Purpose Count",
        0,
        businessPurposeCount
      )
    );
    return messages;
  }

  function assertPersonalPurposeCount(personalPurposeCount, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertInt(
        "MF1NUk3Ox",
        label_
          ? "Personal Purpose Count" + ": " + label_
          : "Personal Purpose Count",
        personalPurposeCount
      )
    );
    messages = messages.concat(
      AvoAssert.assertMin(
        "MF1NUk3Ox",
        label_
          ? "Personal Purpose Count" + ": " + label_
          : "Personal Purpose Count",
        0,
        personalPurposeCount
      )
    );
    return messages;
  }

  function assertIntegration(integration, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "MPoe6Hqy5",
        label_ ? "Integration" + ": " + label_ : "Integration",
        integration
      )
    );
    if ("Concur" !== integration) {
      var message =
        (label_ ? "Integration" + ": " + label_ : "Integration") +
        " should match one of the following values [ Concur ] but you provided the value " +
        integration;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "MPoe6Hqy5",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertWebPage(webPage, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "MZLkJ3Cmi",
        label_ ? "Web Page" + ": " + label_ : "Web Page",
        webPage
      )
    );
    if (
      "Reports Driver Dashboard" !== webPage &&
      "Profile Settings Driver Dashboard" !== webPage &&
      "Notifications Settings Driver Dashboard" !== webPage &&
      "Integrations Settings Driver Dashboard" !== webPage &&
      "Vehicle Settings Driver Dashboard" !== webPage &&
      "Mileage Rates Settings Driver Dashboard" !== webPage &&
      "Auto classification Settings Driver Dashboard" !== webPage &&
      "Custom Purposes Settings Driver Dashboard" !== webPage &&
      "Automatic Reports Settings Driver Dashboard" !== webPage &&
      "Subscription Driver Dashboard" !== webPage &&
      "Share MileIQ Driver Dashboard" !== webPage &&
      "Overview Team Dashboard" !== webPage &&
      "Members Team Dashboard" !== webPage &&
      "Reports Team Dashboard" !== webPage &&
      "Custom Rates Team Dashboard" !== webPage &&
      "Team Locations Team Dashboard" !== webPage &&
      "Subscription Team Dashboard" !== webPage &&
      "Settings Team Dashboard" !== webPage &&
      "Get Started Driver Dashboard" !== webPage &&
      "Drives Driver Dashboard" !== webPage &&
      "Login" !== webPage &&
      "Signup" !== webPage &&
      "Drives Summary Team Dashboard" !== webPage &&
      "Drives List Team Dashboard" !== webPage &&
      "Approve Drives Summary Team Dashboard" !== webPage &&
      "Approve Drives List Team Dashboard" !== webPage &&
      "Shared Reports" !== webPage &&
      "Shared with me" !== webPage
    ) {
      var message =
        (label_ ? "Web Page" + ": " + label_ : "Web Page") +
        " should match one of the following values [ Reports Driver Dashboard | Profile Settings Driver Dashboard | Notifications Settings Driver Dashboard | Integrations Settings Driver Dashboard | Vehicle Settings Driver Dashboard | Mileage Rates Settings Driver Dashboard | Auto classification Settings Driver Dashboard | Custom Purposes Settings Driver Dashboard | Automatic Reports Settings Driver Dashboard | Subscription Driver Dashboard | Share MileIQ Driver Dashboard | Overview Team Dashboard | Members Team Dashboard | Reports Team Dashboard | Custom Rates Team Dashboard | Team Locations Team Dashboard | Subscription Team Dashboard | Settings Team Dashboard | Get Started Driver Dashboard | Drives Driver Dashboard | Login | Signup | Drives Summary Team Dashboard | Drives List Team Dashboard | Approve Drives Summary Team Dashboard | Approve Drives List Team Dashboard | Shared Reports | Shared with me ] but you provided the value " +
        webPage;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "MZLkJ3Cmi",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertOptionalWebPage(webPage, label_) {
    var messages = [];
    if (webPage !== undefined && webPage !== null) {
      messages = messages.concat(
        AvoAssert.assertString(
          "MZLkJ3Cmi",
          label_ ? "Web Page" + ": " + label_ : "Web Page",
          webPage
        )
      );
      if (
        "Reports Driver Dashboard" !== webPage &&
        "Profile Settings Driver Dashboard" !== webPage &&
        "Notifications Settings Driver Dashboard" !== webPage &&
        "Integrations Settings Driver Dashboard" !== webPage &&
        "Vehicle Settings Driver Dashboard" !== webPage &&
        "Mileage Rates Settings Driver Dashboard" !== webPage &&
        "Auto classification Settings Driver Dashboard" !== webPage &&
        "Custom Purposes Settings Driver Dashboard" !== webPage &&
        "Automatic Reports Settings Driver Dashboard" !== webPage &&
        "Subscription Driver Dashboard" !== webPage &&
        "Share MileIQ Driver Dashboard" !== webPage &&
        "Overview Team Dashboard" !== webPage &&
        "Members Team Dashboard" !== webPage &&
        "Reports Team Dashboard" !== webPage &&
        "Custom Rates Team Dashboard" !== webPage &&
        "Team Locations Team Dashboard" !== webPage &&
        "Subscription Team Dashboard" !== webPage &&
        "Settings Team Dashboard" !== webPage &&
        "Get Started Driver Dashboard" !== webPage &&
        "Drives Driver Dashboard" !== webPage &&
        "Login" !== webPage &&
        "Signup" !== webPage &&
        "Drives Summary Team Dashboard" !== webPage &&
        "Drives List Team Dashboard" !== webPage &&
        "Approve Drives Summary Team Dashboard" !== webPage &&
        "Approve Drives List Team Dashboard" !== webPage &&
        "Shared Reports" !== webPage &&
        "Shared with me" !== webPage
      ) {
        var message =
          (label_ ? "Web Page" + ": " + label_ : "Web Page") +
          " should match one of the following values [ Reports Driver Dashboard | Profile Settings Driver Dashboard | Notifications Settings Driver Dashboard | Integrations Settings Driver Dashboard | Vehicle Settings Driver Dashboard | Mileage Rates Settings Driver Dashboard | Auto classification Settings Driver Dashboard | Custom Purposes Settings Driver Dashboard | Automatic Reports Settings Driver Dashboard | Subscription Driver Dashboard | Share MileIQ Driver Dashboard | Overview Team Dashboard | Members Team Dashboard | Reports Team Dashboard | Custom Rates Team Dashboard | Team Locations Team Dashboard | Subscription Team Dashboard | Settings Team Dashboard | Get Started Driver Dashboard | Drives Driver Dashboard | Login | Signup | Drives Summary Team Dashboard | Drives List Team Dashboard | Approve Drives Summary Team Dashboard | Approve Drives List Team Dashboard | Shared Reports | Shared with me ] but you provided the value " +
          webPage;
        messages = messages.concat([
          {
            tag: "expectedStringMatch",
            propertyId: "MZLkJ3Cmi",
            message: message,
          },
        ]);
      }
    }
    return messages;
  }

  function assertDriveClassificationPurpose(
    driveClassificationPurpose,
    label_
  ) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "NXh-hfXZ-",
        label_
          ? "Drive Classification Purpose" + ": " + label_
          : "Drive Classification Purpose",
        driveClassificationPurpose
      )
    );
    if (
      "Business" !== driveClassificationPurpose &&
      "Between offices" !== driveClassificationPurpose &&
      "Customer visit" !== driveClassificationPurpose &&
      "Meeting" !== driveClassificationPurpose &&
      "Errand/Supplies" !== driveClassificationPurpose &&
      "Temporary site" !== driveClassificationPurpose &&
      "Airport/Travel" !== driveClassificationPurpose &&
      "Custom" !== driveClassificationPurpose &&
      "Commute" !== driveClassificationPurpose &&
      "Medical" !== driveClassificationPurpose &&
      "Charity" !== driveClassificationPurpose &&
      "Moving" !== driveClassificationPurpose &&
      "Personal" !== driveClassificationPurpose &&
      "Meal" !== driveClassificationPurpose &&
      "Business + Commute" !== driveClassificationPurpose
    ) {
      var message =
        (label_
          ? "Drive Classification Purpose" + ": " + label_
          : "Drive Classification Purpose") +
        " should match one of the following values [ Business | Between offices | Customer visit | Meeting | Errand/Supplies | Temporary site | Airport/Travel | Custom | Commute | Medical | Charity | Moving | Personal | Meal | Business + Commute ] but you provided the value " +
        driveClassificationPurpose;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "NXh-hfXZ-",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertIntegrationFailure(integrationFailure, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "NYO6CRT6w",
        label_ ? "Integration Failure" + ": " + label_ : "Integration Failure",
        integrationFailure
      )
    );
    return messages;
  }

  function assertOptionalSubscriptionCancelReasonFeedback(
    subscriptionCancelReasonFeedback,
    label_
  ) {
    var messages = [];
    if (
      subscriptionCancelReasonFeedback !== undefined &&
      subscriptionCancelReasonFeedback !== null
    ) {
      messages = messages.concat(
        AvoAssert.assertString(
          "Nt3_iEQ7e",
          label_
            ? "Subscription Cancel Reason Feedback" + ": " + label_
            : "Subscription Cancel Reason Feedback",
          subscriptionCancelReasonFeedback
        )
      );
    }
    return messages;
  }

  function assertCancellationAbandonedMethod(
    cancellationAbandonedMethod,
    label_
  ) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "O3VMtWs8j",
        label_
          ? "Cancellation Abandoned Method" + ": " + label_
          : "Cancellation Abandoned Method",
        cancellationAbandonedMethod
      )
    );
    if (
      "Modal dismiss" !== cancellationAbandonedMethod &&
      "Keep my Plan CTA" !== cancellationAbandonedMethod
    ) {
      var message =
        (label_
          ? "Cancellation Abandoned Method" + ": " + label_
          : "Cancellation Abandoned Method") +
        " should match one of the following values [ Modal dismiss | Keep my Plan CTA ] but you provided the value " +
        cancellationAbandonedMethod;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "O3VMtWs8j",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertAutoClassifyOutsideWorkHoursPreference(
    autoClassifyOutsideWorkHoursPreference,
    label_
  ) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "Oh1Cp64hH",
        label_
          ? "Auto Classify Outside Work Hours Preference" + ": " + label_
          : "Auto Classify Outside Work Hours Preference",
        autoClassifyOutsideWorkHoursPreference
      )
    );
    if (
      "Enabled" !== autoClassifyOutsideWorkHoursPreference &&
      "Disabled" !== autoClassifyOutsideWorkHoursPreference
    ) {
      var message =
        (label_
          ? "Auto Classify Outside Work Hours Preference" + ": " + label_
          : "Auto Classify Outside Work Hours Preference") +
        " should match one of the following values [ Enabled | Disabled ] but you provided the value " +
        autoClassifyOutsideWorkHoursPreference;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "Oh1Cp64hH",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertEditUsernameStepName(editUsernameStepName, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "OqLN7y296",
        label_
          ? "Edit Username Step Name" + ": " + label_
          : "Edit Username Step Name",
        editUsernameStepName
      )
    );
    if (
      "Add Email" !== editUsernameStepName &&
      "Add Password" !== editUsernameStepName
    ) {
      var message =
        (label_
          ? "Edit Username Step Name" + ": " + label_
          : "Edit Username Step Name") +
        " should match one of the following values [ Add Email | Add Password ] but you provided the value " +
        editUsernameStepName;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "OqLN7y296",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertWorkHoursUpdateSource(workHoursUpdateSource, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "OtNyEyNwj",
        label_
          ? "Work Hours Update Source" + ": " + label_
          : "Work Hours Update Source",
        workHoursUpdateSource
      )
    );
    if (
      "Auto Classify Personal" !== workHoursUpdateSource &&
      "Auto Classify Business" !== workHoursUpdateSource &&
      "Change Hours" !== workHoursUpdateSource
    ) {
      var message =
        (label_
          ? "Work Hours Update Source" + ": " + label_
          : "Work Hours Update Source") +
        " should match one of the following values [ Auto Classify Personal | Auto Classify Business | Change Hours ] but you provided the value " +
        workHoursUpdateSource;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "OtNyEyNwj",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertConsolidatedReportFormat(consolidatedReportFormat, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "Owm1CLq9u",
        label_
          ? "Consolidated Report Format" + ": " + label_
          : "Consolidated Report Format",
        consolidatedReportFormat
      )
    );
    if (
      "Weekly" !== consolidatedReportFormat &&
      "Biweekly" !== consolidatedReportFormat &&
      "Monthly" !== consolidatedReportFormat
    ) {
      var message =
        (label_
          ? "Consolidated Report Format" + ": " + label_
          : "Consolidated Report Format") +
        " should match one of the following values [ Weekly | Biweekly | Monthly ] but you provided the value " +
        consolidatedReportFormat;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "Owm1CLq9u",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertVehiclePriority(vehiclePriority, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "P7ky4xsaf",
        label_ ? "Vehicle Priority" + ": " + label_ : "Vehicle Priority",
        vehiclePriority
      )
    );
    if ("Primary" !== vehiclePriority && "Non-Primary" !== vehiclePriority) {
      var message =
        (label_ ? "Vehicle Priority" + ": " + label_ : "Vehicle Priority") +
        " should match one of the following values [ Primary | Non-Primary ] but you provided the value " +
        vehiclePriority;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "P7ky4xsaf",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertPaymentService(paymentService, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "PFrUGiD-O",
        label_ ? "payment_service" + ": " + label_ : "payment_service",
        paymentService
      )
    );
    if (
      "STRIPE" !== paymentService &&
      "APPLE" !== paymentService &&
      "GOOGLE" !== paymentService &&
      "APPLE-SANDBOX" !== paymentService
    ) {
      var message =
        (label_ ? "payment_service" + ": " + label_ : "payment_service") +
        " should match one of the following values [ STRIPE | APPLE | GOOGLE | APPLE-SANDBOX ] but you provided the value " +
        paymentService;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "PFrUGiD-O",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertDriveSearch(driveSearch, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "PkUfqXS21",
        label_ ? "Drive Search" + ": " + label_ : "Drive Search",
        driveSearch
      )
    );
    if ("Applied" !== driveSearch && "Unapplied" !== driveSearch) {
      var message =
        (label_ ? "Drive Search" + ": " + label_ : "Drive Search") +
        " should match one of the following values [ Applied | Unapplied ] but you provided the value " +
        driveSearch;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "PkUfqXS21",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertIntegrationStatus(integrationStatus, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "Q46D2yJ9r",
        label_ ? "Integration Status" + ": " + label_ : "Integration Status",
        integrationStatus
      )
    );
    if ("Active" !== integrationStatus && "Inactive" !== integrationStatus) {
      var message =
        (label_ ? "Integration Status" + ": " + label_ : "Integration Status") +
        " should match one of the following values [ Active | Inactive ] but you provided the value " +
        integrationStatus;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "Q46D2yJ9r",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertUserAction(userAction, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "QOk1tKWD6",
        label_ ? "User Action" + ": " + label_ : "User Action",
        userAction
      )
    );
    if (
      "Delete Drive" !== userAction &&
      "Join Drive" !== userAction &&
      "Classify Drive" !== userAction
    ) {
      var message =
        (label_ ? "User Action" + ": " + label_ : "User Action") +
        " should match one of the following values [ Delete Drive | Join Drive | Classify Drive ] but you provided the value " +
        userAction;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "QOk1tKWD6",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertTeamSetting(teamSetting, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "QWZnW3egBF",
        label_ ? "Team Setting" + ": " + label_ : "Team Setting",
        teamSetting
      )
    );
    if ("Company Name" !== teamSetting && "Custom Rate" !== teamSetting) {
      var message =
        (label_ ? "Team Setting" + ": " + label_ : "Team Setting") +
        " should match one of the following values [ Company Name | Custom Rate ] but you provided the value " +
        teamSetting;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "QWZnW3egBF",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertOptionalTeamsUpdatePaymentSource(
    teamsUpdatePaymentSource,
    label_
  ) {
    var messages = [];
    if (
      teamsUpdatePaymentSource !== undefined &&
      teamsUpdatePaymentSource !== null
    ) {
      messages = messages.concat(
        AvoAssert.assertString(
          "QemLemsma",
          label_
            ? "Teams Update Payment Source" + ": " + label_
            : "Teams Update Payment Source",
          teamsUpdatePaymentSource
        )
      );
      if (
        "URL Params" !== teamsUpdatePaymentSource &&
        "Resubscribe Modal" !== teamsUpdatePaymentSource &&
        "Top Banner" !== teamsUpdatePaymentSource &&
        "Dunning Warning Modal" !== teamsUpdatePaymentSource &&
        "Manage Subscription Dropdown" !== teamsUpdatePaymentSource &&
        "Invite drivers" !== teamsUpdatePaymentSource &&
        "Upgrade subscription" !== teamsUpdatePaymentSource
      ) {
        var message =
          (label_
            ? "Teams Update Payment Source" + ": " + label_
            : "Teams Update Payment Source") +
          " should match one of the following values [ URL Params | Resubscribe Modal | Top Banner | Dunning Warning Modal | Manage Subscription Dropdown | Invite drivers | Upgrade subscription ] but you provided the value " +
          teamsUpdatePaymentSource;
        messages = messages.concat([
          {
            tag: "expectedStringMatch",
            propertyId: "QemLemsma",
            message: message,
          },
        ]);
      }
    }
    return messages;
  }

  function assertExperimentName(experimentName, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "QqVMDEQjyL",
        label_ ? "Experiment Name" + ": " + label_ : "Experiment Name",
        experimentName
      )
    );
    return messages;
  }

  function assertVehiclePriorityUpdate(vehiclePriorityUpdate, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "R2S4y5CHV",
        label_
          ? "Vehicle Priority Update" + ": " + label_
          : "Vehicle Priority Update",
        vehiclePriorityUpdate
      )
    );
    if (
      "Updated" !== vehiclePriorityUpdate &&
      "Unchanged" !== vehiclePriorityUpdate
    ) {
      var message =
        (label_
          ? "Vehicle Priority Update" + ": " + label_
          : "Vehicle Priority Update") +
        " should match one of the following values [ Updated | Unchanged ] but you provided the value " +
        vehiclePriorityUpdate;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "R2S4y5CHV",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertOptionalTeamsResubscribeModalSource(
    teamsResubscribeModalSource,
    label_
  ) {
    var messages = [];
    if (
      teamsResubscribeModalSource !== undefined &&
      teamsResubscribeModalSource !== null
    ) {
      messages = messages.concat(
        AvoAssert.assertString(
          "Rgnqsm5P5",
          label_
            ? "Teams Resubscribe Modal Source" + ": " + label_
            : "Teams Resubscribe Modal Source",
          teamsResubscribeModalSource
        )
      );
      if (
        "URL Params" !== teamsResubscribeModalSource &&
        "Dashboard CTAs" !== teamsResubscribeModalSource
      ) {
        var message =
          (label_
            ? "Teams Resubscribe Modal Source" + ": " + label_
            : "Teams Resubscribe Modal Source") +
          " should match one of the following values [ URL Params | Dashboard CTAs ] but you provided the value " +
          teamsResubscribeModalSource;
        messages = messages.concat([
          {
            tag: "expectedStringMatch",
            propertyId: "Rgnqsm5P5",
            message: message,
          },
        ]);
      }
    }
    return messages;
  }

  function assertOptionalTeamDrivesDriversFilter(
    teamDrivesDriversFilter,
    label_
  ) {
    var messages = [];
    if (
      teamDrivesDriversFilter !== undefined &&
      teamDrivesDriversFilter !== null
    ) {
      messages = messages.concat(
        AvoAssert.assertString(
          "Rx2HKmjkp",
          label_
            ? "Team Drives Drivers Filter" + ": " + label_
            : "Team Drives Drivers Filter",
          teamDrivesDriversFilter
        )
      );
      if (
        "Multiple" !== teamDrivesDriversFilter &&
        "Individual" !== teamDrivesDriversFilter &&
        "None" !== teamDrivesDriversFilter
      ) {
        var message =
          (label_
            ? "Team Drives Drivers Filter" + ": " + label_
            : "Team Drives Drivers Filter") +
          " should match one of the following values [ Multiple | Individual | None ] but you provided the value " +
          teamDrivesDriversFilter;
        messages = messages.concat([
          {
            tag: "expectedStringMatch",
            propertyId: "Rx2HKmjkp",
            message: message,
          },
        ]);
      }
    }
    return messages;
  }

  function assertUserSelectionType(userSelectionType, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "SJgfdz28BI",
        label_ ? "User Selection Type" + ": " + label_ : "User Selection Type",
        userSelectionType
      )
    );
    if ("Bulk" !== userSelectionType && "Individual" !== userSelectionType) {
      var message =
        (label_
          ? "User Selection Type" + ": " + label_
          : "User Selection Type") +
        " should match one of the following values [ Bulk | Individual ] but you provided the value " +
        userSelectionType;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "SJgfdz28BI",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertCustomPurposeUpdate(customPurposeUpdate, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "Sul-LTTMY",
        label_
          ? "Custom Purpose Update" + ": " + label_
          : "Custom Purpose Update",
        customPurposeUpdate
      )
    );
    if (
      "Hide" !== customPurposeUpdate &&
      "Unhide" !== customPurposeUpdate &&
      "Order" !== customPurposeUpdate
    ) {
      var message =
        (label_
          ? "Custom Purpose Update" + ": " + label_
          : "Custom Purpose Update") +
        " should match one of the following values [ Hide | Unhide | Order ] but you provided the value " +
        customPurposeUpdate;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "Sul-LTTMY",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertDashboardSwitchFrom(dashboardSwitchFrom, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "SzhpD2tNX",
        label_
          ? "Dashboard Switch From" + ": " + label_
          : "Dashboard Switch From",
        dashboardSwitchFrom
      )
    );
    if (
      "Driver Dashboard Sidebar" !== dashboardSwitchFrom &&
      "Teams Dashboard Sidebar" !== dashboardSwitchFrom
    ) {
      var message =
        (label_
          ? "Dashboard Switch From" + ": " + label_
          : "Dashboard Switch From") +
        " should match one of the following values [ Driver Dashboard Sidebar | Teams Dashboard Sidebar ] but you provided the value " +
        dashboardSwitchFrom;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "SzhpD2tNX",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertTeamsPlanSelectionName(teamsPlanSelectionName, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "T9hGL4ArX7",
        label_
          ? "Teams Plan Selection Name" + ": " + label_
          : "Teams Plan Selection Name",
        teamsPlanSelectionName
      )
    );
    if (
      "Teams" !== teamsPlanSelectionName &&
      "Teams Lite" !== teamsPlanSelectionName &&
      "Teams Pro" !== teamsPlanSelectionName
    ) {
      var message =
        (label_
          ? "Teams Plan Selection Name" + ": " + label_
          : "Teams Plan Selection Name") +
        " should match one of the following values [ Teams | Teams Lite | Teams Pro ] but you provided the value " +
        teamsPlanSelectionName;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "T9hGL4ArX7",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertSubscriptionId(subscriptionId, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertInt(
        "TDTeQm2UP",
        label_ ? "subscription_id" + ": " + label_ : "subscription_id",
        subscriptionId
      )
    );
    messages = messages.concat(
      AvoAssert.assertMin(
        "TDTeQm2UP",
        label_ ? "subscription_id" + ": " + label_ : "subscription_id",
        0,
        subscriptionId
      )
    );
    messages = messages.concat(
      AvoAssert.assertMax(
        "TDTeQm2UP",
        label_ ? "subscription_id" + ": " + label_ : "subscription_id",
        11,
        subscriptionId
      )
    );
    return messages;
  }

  function assertOptionalNumberOfReports(numberOfReports, label_) {
    var messages = [];
    if (numberOfReports !== undefined && numberOfReports !== null) {
      messages = messages.concat(
        AvoAssert.assertInt(
          "TJoEB3Vqt",
          label_ ? "Number of Reports" + ": " + label_ : "Number of Reports",
          numberOfReports
        )
      );
      messages = messages.concat(
        AvoAssert.assertMin(
          "TJoEB3Vqt",
          label_ ? "Number of Reports" + ": " + label_ : "Number of Reports",
          1,
          numberOfReports
        )
      );
    }
    return messages;
  }

  function assertOptionalTeamsPlanID(teamsPlanId, label_) {
    var messages = [];
    if (teamsPlanId !== undefined && teamsPlanId !== null) {
      messages = messages.concat(
        AvoAssert.assertInt(
          "TbSVW_o_GH",
          label_ ? "Teams Plan ID" + ": " + label_ : "Teams Plan ID",
          teamsPlanId
        )
      );
      messages = messages.concat(
        AvoAssert.assertMin(
          "TbSVW_o_GH",
          label_ ? "Teams Plan ID" + ": " + label_ : "Teams Plan ID",
          9,
          teamsPlanId
        )
      );
      messages = messages.concat(
        AvoAssert.assertMax(
          "TbSVW_o_GH",
          label_ ? "Teams Plan ID" + ": " + label_ : "Teams Plan ID",
          11,
          teamsPlanId
        )
      );
    }
    return messages;
  }

  function assertOptionalCompanySize(companySize, label_) {
    var messages = [];
    if (companySize !== undefined && companySize !== null) {
      messages = messages.concat(
        AvoAssert.assertString(
          "Tvq2wwl5J",
          label_ ? "Company Size" + ": " + label_ : "Company Size",
          companySize
        )
      );
    }
    return messages;
  }

  function assertBlogSource(blogSource, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "UMJ3rLw2H",
        label_ ? "Blog Source" + ": " + label_ : "Blog Source",
        blogSource
      )
    );
    if (
      "Help" !== blogSource &&
      "Quick Tips" !== blogSource &&
      "Enable Concur Integration" !== blogSource
    ) {
      var message =
        (label_ ? "Blog Source" + ": " + label_ : "Blog Source") +
        " should match one of the following values [ Help | Quick Tips | Enable Concur Integration ] but you provided the value " +
        blogSource;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "UMJ3rLw2H",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertOptionalOtherEmailPreferenceChange(
    otherEmailPreferenceChange,
    label_
  ) {
    var messages = [];
    if (
      otherEmailPreferenceChange !== undefined &&
      otherEmailPreferenceChange !== null
    ) {
      messages = messages.concat(
        AvoAssert.assertString(
          "UNTR59L6v",
          label_
            ? "Other Email Preference Change" + ": " + label_
            : "Other Email Preference Change",
          otherEmailPreferenceChange
        )
      );
      if (
        "Enabled" !== otherEmailPreferenceChange &&
        "Disabled" !== otherEmailPreferenceChange
      ) {
        var message =
          (label_
            ? "Other Email Preference Change" + ": " + label_
            : "Other Email Preference Change") +
          " should match one of the following values [ Enabled | Disabled ] but you provided the value " +
          otherEmailPreferenceChange;
        messages = messages.concat([
          {
            tag: "expectedStringMatch",
            propertyId: "UNTR59L6v",
            message: message,
          },
        ]);
      }
    }
    return messages;
  }

  function assertTeamsUpgradeSource(teamsUpgradeSource, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "USd0VeLlZc",
        label_
          ? "Teams Upgrade Source" + ": " + label_
          : "Teams Upgrade Source",
        teamsUpgradeSource
      )
    );
    if (
      "Onboarding" !== teamsUpgradeSource &&
      "Settings Page" !== teamsUpgradeSource &&
      "Users Page" !== teamsUpgradeSource &&
      "Subscription Page" !== teamsUpgradeSource &&
      "User Invite" !== teamsUpgradeSource &&
      "Reports Page" !== teamsUpgradeSource &&
      "Teams Locations Page" !== teamsUpgradeSource &&
      "Teams Overview Page" !== teamsUpgradeSource &&
      "All Drives Page" !== teamsUpgradeSource &&
      "Drives to Approve Page" !== teamsUpgradeSource
    ) {
      var message =
        (label_
          ? "Teams Upgrade Source" + ": " + label_
          : "Teams Upgrade Source") +
        " should match one of the following values [ Onboarding | Settings Page | Users Page | Subscription Page | User Invite | Reports Page | Teams Locations Page | Teams Overview Page | All Drives Page | Drives to Approve Page ] but you provided the value " +
        teamsUpgradeSource;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "USd0VeLlZc",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertSharedNamedLocationStepName(
    sharedNamedLocationStepName,
    label_
  ) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "VcM7896xn",
        label_
          ? "Shared Named Location Step Name" + ": " + label_
          : "Shared Named Location Step Name",
        sharedNamedLocationStepName
      )
    );
    if (
      "Address" !== sharedNamedLocationStepName &&
      "Location name" !== sharedNamedLocationStepName
    ) {
      var message =
        (label_
          ? "Shared Named Location Step Name" + ": " + label_
          : "Shared Named Location Step Name") +
        " should match one of the following values [ Address | Location name ] but you provided the value " +
        sharedNamedLocationStepName;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "VcM7896xn",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertOptionalLoginSource(loginSource, label_) {
    var messages = [];
    if (loginSource !== undefined && loginSource !== null) {
      messages = messages.concat(
        AvoAssert.assertString(
          "VeesjotyF",
          label_ ? "Login Source" + ": " + label_ : "Login Source",
          loginSource
        )
      );
      if ("Contacts Dashboard" !== loginSource) {
        var message =
          (label_ ? "Login Source" + ": " + label_ : "Login Source") +
          " should match one of the following values [ Contacts Dashboard ] but you provided the value " +
          loginSource;
        messages = messages.concat([
          {
            tag: "expectedStringMatch",
            propertyId: "VeesjotyF",
            message: message,
          },
        ]);
      }
    }
    return messages;
  }

  function assertCancelationReason(cancelationReason, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "VfvB5TTnB",
        label_ ? "Cancelation Reason" + ": " + label_ : "Cancelation Reason",
        cancelationReason
      )
    );
    return messages;
  }

  function assertExistingDriveClassificationType(
    existingDriveClassificationType,
    label_
  ) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertList(
        "VlHqlX93L",
        "Existing Drive Classification Type",
        existingDriveClassificationType
      )
    );
    if (
      existingDriveClassificationType !== null &&
      existingDriveClassificationType !== undefined &&
      existingDriveClassificationType.forEach
    ) {
      existingDriveClassificationType.forEach(function (value, index) {
        messages = messages.concat(
          AvoAssert.assertString(
            "VlHqlX93L",
            "item at index " + index + " in Existing Drive Classification Type",
            value
          )
        );
        if (
          "Unclassified" !== value &&
          "Business" !== value &&
          "Personal" !== value
        ) {
          var message =
            (label_
              ? "item at index " +
                index +
                " in Existing Drive Classification Type" +
                ": " +
                label_
              : "item at index " +
                index +
                " in Existing Drive Classification Type") +
            " should match one of the following values [ Unclassified | Business | Personal ] but you provided the value " +
            value;
          messages = messages.concat([
            {
              tag: "expectedStringMatch",
              propertyId: "VlHqlX93L",
              message: message,
            },
          ]);
        }
      });
    }
    return messages;
  }

  function assertReportReminderRepeatsScheduleSettingType(
    reportReminderRepeatsScheduleSettingType,
    label_
  ) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "Vx3Lv-Etq",
        label_
          ? "Report Reminder Repeats Schedule Setting Type" + ": " + label_
          : "Report Reminder Repeats Schedule Setting Type",
        reportReminderRepeatsScheduleSettingType
      )
    );
    if (
      "weekly" !== reportReminderRepeatsScheduleSettingType &&
      "monthly" !== reportReminderRepeatsScheduleSettingType &&
      "custom" !== reportReminderRepeatsScheduleSettingType
    ) {
      var message =
        (label_
          ? "Report Reminder Repeats Schedule Setting Type" + ": " + label_
          : "Report Reminder Repeats Schedule Setting Type") +
        " should match one of the following values [ weekly | monthly | custom ] but you provided the value " +
        reportReminderRepeatsScheduleSettingType;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "Vx3Lv-Etq",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertOptionalReviewDriveTypeFilter(reviewDriveTypeFilter, label_) {
    var messages = [];
    if (reviewDriveTypeFilter !== undefined && reviewDriveTypeFilter !== null) {
      messages = messages.concat(
        AvoAssert.assertString(
          "Vz1F0wsyf",
          label_
            ? "Review Drive Type Filter" + ": " + label_
            : "Review Drive Type Filter",
          reviewDriveTypeFilter
        )
      );
      if (
        "All" !== reviewDriveTypeFilter &&
        "Manual" !== reviewDriveTypeFilter &&
        "Automatic" !== reviewDriveTypeFilter
      ) {
        var message =
          (label_
            ? "Review Drive Type Filter" + ": " + label_
            : "Review Drive Type Filter") +
          " should match one of the following values [ All | Manual | Automatic ] but you provided the value " +
          reviewDriveTypeFilter;
        messages = messages.concat([
          {
            tag: "expectedStringMatch",
            propertyId: "Vz1F0wsyf",
            message: message,
          },
        ]);
      }
    }
    return messages;
  }

  function assertEmailValidationMethod(emailValidationMethod, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "WFrPJqTmcN",
        label_
          ? "Email Validation Method" + ": " + label_
          : "Email Validation Method",
        emailValidationMethod
      )
    );
    if (
      "Sendgrid" !== emailValidationMethod &&
      "Manual" !== emailValidationMethod
    ) {
      var message =
        (label_
          ? "Email Validation Method" + ": " + label_
          : "Email Validation Method") +
        " should match one of the following values [ Sendgrid | Manual ] but you provided the value " +
        emailValidationMethod;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "WFrPJqTmcN",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertUTMCampaign(utmCampaign, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "X0Bc-NE2Dt",
        label_ ? "UTM Campaign" + ": " + label_ : "UTM Campaign",
        utmCampaign
      )
    );
    return messages;
  }

  function assertTeamsSignupStepInteraction(
    teamsSignupStepInteraction,
    label_
  ) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "X4uy6Z1wSX",
        label_
          ? "Teams Signup Step Interaction" + ": " + label_
          : "Teams Signup Step Interaction",
        teamsSignupStepInteraction
      )
    );
    if (
      "Completed" !== teamsSignupStepInteraction &&
      "Skipped" !== teamsSignupStepInteraction
    ) {
      var message =
        (label_
          ? "Teams Signup Step Interaction" + ": " + label_
          : "Teams Signup Step Interaction") +
        " should match one of the following values [ Completed | Skipped ] but you provided the value " +
        teamsSignupStepInteraction;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "X4uy6Z1wSX",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertAdCategory(adCategory, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "XKoTMNW18o",
        label_ ? "Ad Category" + ": " + label_ : "Ad Category",
        adCategory
      )
    );
    return messages;
  }

  function assertOptionalTeamsPlanInterval(teamsPlanInterval, label_) {
    var messages = [];
    if (teamsPlanInterval !== undefined && teamsPlanInterval !== null) {
      messages = messages.concat(
        AvoAssert.assertString(
          "XcK728z2q",
          label_
            ? "Teams Plan Interval" + ": " + label_
            : "Teams Plan Interval",
          teamsPlanInterval
        )
      );
      if (
        "Monthly" !== teamsPlanInterval &&
        "Annual" !== teamsPlanInterval &&
        "Daily" !== teamsPlanInterval
      ) {
        var message =
          (label_
            ? "Teams Plan Interval" + ": " + label_
            : "Teams Plan Interval") +
          " should match one of the following values [ Monthly | Annual | Daily ] but you provided the value " +
          teamsPlanInterval;
        messages = messages.concat([
          {
            tag: "expectedStringMatch",
            propertyId: "XcK728z2q",
            message: message,
          },
        ]);
      }
    }
    return messages;
  }

  function assertTeamsPlanInterval(teamsPlanInterval, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "XcK728z2q",
        label_ ? "Teams Plan Interval" + ": " + label_ : "Teams Plan Interval",
        teamsPlanInterval
      )
    );
    if (
      "Monthly" !== teamsPlanInterval &&
      "Annual" !== teamsPlanInterval &&
      "Daily" !== teamsPlanInterval
    ) {
      var message =
        (label_
          ? "Teams Plan Interval" + ": " + label_
          : "Teams Plan Interval") +
        " should match one of the following values [ Monthly | Annual | Daily ] but you provided the value " +
        teamsPlanInterval;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "XcK728z2q",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertBulkUploadStepNumber(bulkUploadStepNumber, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertInt(
        "YHIX7HQjNP",
        label_
          ? "Bulk Upload Step Number" + ": " + label_
          : "Bulk Upload Step Number",
        bulkUploadStepNumber
      )
    );
    messages = messages.concat(
      AvoAssert.assertMin(
        "YHIX7HQjNP",
        label_
          ? "Bulk Upload Step Number" + ": " + label_
          : "Bulk Upload Step Number",
        1,
        bulkUploadStepNumber
      )
    );
    messages = messages.concat(
      AvoAssert.assertMax(
        "YHIX7HQjNP",
        label_
          ? "Bulk Upload Step Number" + ": " + label_
          : "Bulk Upload Step Number",
        1,
        bulkUploadStepNumber
      )
    );
    return messages;
  }

  function assertOptionalDriveDeletionReason(driveDeletionReason, label_) {
    var messages = [];
    if (driveDeletionReason !== undefined && driveDeletionReason !== null) {
      messages = messages.concat(
        AvoAssert.assertString(
          "YZSO71UQCu",
          label_
            ? "Drive Deletion Reason" + ": " + label_
            : "Drive Deletion Reason",
          driveDeletionReason
        )
      );
      if (
        "Physical Activity" !== driveDeletionReason &&
        "Public Transport" !== driveDeletionReason &&
        "Other" !== driveDeletionReason
      ) {
        var message =
          (label_
            ? "Drive Deletion Reason" + ": " + label_
            : "Drive Deletion Reason") +
          " should match one of the following values [ Physical Activity | Public Transport | Other ] but you provided the value " +
          driveDeletionReason;
        messages = messages.concat([
          {
            tag: "expectedStringMatch",
            propertyId: "YZSO71UQCu",
            message: message,
          },
        ]);
      }
    }
    return messages;
  }

  function assertTeamUserRole(teamUserRole, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "YqoK2DIvT",
        label_ ? "Team User Role" + ": " + label_ : "Team User Role",
        teamUserRole
      )
    );
    if (
      "Admin" !== teamUserRole &&
      "Driver" !== teamUserRole &&
      "Admin Driver" !== teamUserRole
    ) {
      var message =
        (label_ ? "Team User Role" + ": " + label_ : "Team User Role") +
        " should match one of the following values [ Admin | Driver | Admin Driver ] but you provided the value " +
        teamUserRole;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "YqoK2DIvT",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertTeamsPlanSelectionInterval(
    teamsPlanSelectionInterval,
    label_
  ) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "ZcBOdB-fW",
        label_
          ? "Teams Plan Selection Interval" + ": " + label_
          : "Teams Plan Selection Interval",
        teamsPlanSelectionInterval
      )
    );
    if (
      "Monthly" !== teamsPlanSelectionInterval &&
      "Annual" !== teamsPlanSelectionInterval &&
      "Daily" !== teamsPlanSelectionInterval
    ) {
      var message =
        (label_
          ? "Teams Plan Selection Interval" + ": " + label_
          : "Teams Plan Selection Interval") +
        " should match one of the following values [ Monthly | Annual | Daily ] but you provided the value " +
        teamsPlanSelectionInterval;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "ZcBOdB-fW",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertOptionalAutomaticReportsRecurrence(
    automaticReportsRecurrence,
    label_
  ) {
    var messages = [];
    if (
      automaticReportsRecurrence !== undefined &&
      automaticReportsRecurrence !== null
    ) {
      messages = messages.concat(
        AvoAssert.assertString(
          "Zr7LvUpVN",
          label_
            ? "Automatic Reports Recurrence" + ": " + label_
            : "Automatic Reports Recurrence",
          automaticReportsRecurrence
        )
      );
      if (
        "Daily" !== automaticReportsRecurrence &&
        "Weekly" !== automaticReportsRecurrence &&
        "Monthly" !== automaticReportsRecurrence
      ) {
        var message =
          (label_
            ? "Automatic Reports Recurrence" + ": " + label_
            : "Automatic Reports Recurrence") +
          " should match one of the following values [ Daily | Weekly | Monthly ] but you provided the value " +
          automaticReportsRecurrence;
        messages = messages.concat([
          {
            tag: "expectedStringMatch",
            propertyId: "Zr7LvUpVN",
            message: message,
          },
        ]);
      }
    }
    return messages;
  }

  function assertAutomaticReportsRecurrence(
    automaticReportsRecurrence,
    label_
  ) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "Zr7LvUpVN",
        label_
          ? "Automatic Reports Recurrence" + ": " + label_
          : "Automatic Reports Recurrence",
        automaticReportsRecurrence
      )
    );
    if (
      "Daily" !== automaticReportsRecurrence &&
      "Weekly" !== automaticReportsRecurrence &&
      "Monthly" !== automaticReportsRecurrence
    ) {
      var message =
        (label_
          ? "Automatic Reports Recurrence" + ": " + label_
          : "Automatic Reports Recurrence") +
        " should match one of the following values [ Daily | Weekly | Monthly ] but you provided the value " +
        automaticReportsRecurrence;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "Zr7LvUpVN",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertShareSource(shareSource, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "_AOL0-p1J",
        label_ ? "Share Source" + ": " + label_ : "Share Source",
        shareSource
      )
    );
    if (
      "Email" !== shareSource &&
      "Twitter" !== shareSource &&
      "LinkedIn" !== shareSource &&
      "Facebook" !== shareSource &&
      "URL" !== shareSource
    ) {
      var message =
        (label_ ? "Share Source" + ": " + label_ : "Share Source") +
        " should match one of the following values [ Email | Twitter | LinkedIn | Facebook | URL ] but you provided the value " +
        shareSource;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "_AOL0-p1J",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertDriveDetail(driveDetail, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "_MdrmlLsf",
        label_ ? "Drive Detail" + ": " + label_ : "Drive Detail",
        driveDetail
      )
    );
    if (
      "Distance" !== driveDetail &&
      "Parking" !== driveDetail &&
      "Tolls" !== driveDetail &&
      "Vehicle" !== driveDetail &&
      "Notes" !== driveDetail &&
      "Start Location Name" !== driveDetail &&
      "End Location Name" !== driveDetail
    ) {
      var message =
        (label_ ? "Drive Detail" + ": " + label_ : "Drive Detail") +
        " should match one of the following values [ Distance | Parking | Tolls | Vehicle | Notes | Start Location Name | End Location Name ] but you provided the value " +
        driveDetail;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "_MdrmlLsf",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertVehicleDetailsUpdate(vehicleDetailsUpdate, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "_fPjNDD2Q",
        label_
          ? "Vehicle Details Update" + ": " + label_
          : "Vehicle Details Update",
        vehicleDetailsUpdate
      )
    );
    if (
      "Updated" !== vehicleDetailsUpdate &&
      "Unchanged" !== vehicleDetailsUpdate
    ) {
      var message =
        (label_
          ? "Vehicle Details Update" + ": " + label_
          : "Vehicle Details Update") +
        " should match one of the following values [ Updated | Unchanged ] but you provided the value " +
        vehicleDetailsUpdate;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "_fPjNDD2Q",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertUpgradeSource(upgradeSource, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "a2CcoRxZb0",
        label_ ? "Upgrade Source" + ": " + label_ : "Upgrade Source",
        upgradeSource
      )
    );
    if (
      "Onboarding" !== upgradeSource &&
      "Subscription Page" !== upgradeSource &&
      "Drives Page" !== upgradeSource &&
      "Sidebar" !== upgradeSource
    ) {
      var message =
        (label_ ? "Upgrade Source" + ": " + label_ : "Upgrade Source") +
        " should match one of the following values [ Onboarding | Subscription Page | Drives Page | Sidebar ] but you provided the value " +
        upgradeSource;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "a2CcoRxZb0",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertVehicleVisibility(vehicleVisibility, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "ahdn60zVz",
        label_ ? "Vehicle Visibility" + ": " + label_ : "Vehicle Visibility",
        vehicleVisibility
      )
    );
    if ("Hidden" !== vehicleVisibility && "Viewable" !== vehicleVisibility) {
      var message =
        (label_ ? "Vehicle Visibility" + ": " + label_ : "Vehicle Visibility") +
        " should match one of the following values [ Hidden | Viewable ] but you provided the value " +
        vehicleVisibility;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "ahdn60zVz",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertCustomDestinationPageName_(
    customDestinationPageName_,
    label_
  ) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "avo-enriched-type-page-custom-name",
        label_
          ? "Custom Destination Page Name" + ": " + label_
          : "Custom Destination Page Name",
        customDestinationPageName_
      )
    );
    return messages;
  }

  function assertUserId_(userId_, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "avo-enriched-type-user-id",
        label_ ? "User Id" + ": " + label_ : "User Id",
        userId_
      )
    );
    return messages;
  }

  function assertExperimentID(experimentId, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertInt(
        "bC6IZD17aF",
        label_ ? "Experiment ID" + ": " + label_ : "Experiment ID",
        experimentId
      )
    );
    return messages;
  }

  function assertOptionalReviewStatusFilter(reviewStatusFilter, label_) {
    var messages = [];
    if (reviewStatusFilter !== undefined && reviewStatusFilter !== null) {
      messages = messages.concat(
        AvoAssert.assertString(
          "bcKD803TJ",
          label_
            ? "Review Status Filter" + ": " + label_
            : "Review Status Filter",
          reviewStatusFilter
        )
      );
      if (
        "All" !== reviewStatusFilter &&
        "Approved" !== reviewStatusFilter &&
        "Rejected" !== reviewStatusFilter &&
        "No Status" !== reviewStatusFilter
      ) {
        var message =
          (label_
            ? "Review Status Filter" + ": " + label_
            : "Review Status Filter") +
          " should match one of the following values [ All | Approved | Rejected | No Status ] but you provided the value " +
          reviewStatusFilter;
        messages = messages.concat([
          {
            tag: "expectedStringMatch",
            propertyId: "bcKD803TJ",
            message: message,
          },
        ]);
      }
    }
    return messages;
  }

  function assertTeamsUserUpdate(teamsUserUpdate, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "c-453YUQ-v",
        label_ ? "Teams User Update" + ": " + label_ : "Teams User Update",
        teamsUserUpdate
      )
    );
    if (
      "Upgrade To Admin & Driver" !== teamsUserUpdate &&
      "Downgrade To Admin" !== teamsUserUpdate &&
      "Downgrade To Driver" !== teamsUserUpdate &&
      "Remove From Team" !== teamsUserUpdate
    ) {
      var message =
        (label_ ? "Teams User Update" + ": " + label_ : "Teams User Update") +
        " should match one of the following values [ Upgrade To Admin & Driver | Downgrade To Admin | Downgrade To Driver | Remove From Team ] but you provided the value " +
        teamsUserUpdate;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "c-453YUQ-v",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertEmailAuthenticationMethod(emailAuthenticationMethod, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "cJhB1KlyFW",
        label_
          ? "Email Authentication Method" + ": " + label_
          : "Email Authentication Method",
        emailAuthenticationMethod
      )
    );
    if ("Manual" !== emailAuthenticationMethod) {
      var message =
        (label_
          ? "Email Authentication Method" + ": " + label_
          : "Email Authentication Method") +
        " should match one of the following values [ Manual ] but you provided the value " +
        emailAuthenticationMethod;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "cJhB1KlyFW",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertVehicleVisibilityUpdate(vehicleVisibilityUpdate, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "ct3SJ5mAn",
        label_
          ? "Vehicle Visibility Update" + ": " + label_
          : "Vehicle Visibility Update",
        vehicleVisibilityUpdate
      )
    );
    if (
      "Updated" !== vehicleVisibilityUpdate &&
      "Unchanged" !== vehicleVisibilityUpdate
    ) {
      var message =
        (label_
          ? "Vehicle Visibility Update" + ": " + label_
          : "Vehicle Visibility Update") +
        " should match one of the following values [ Updated | Unchanged ] but you provided the value " +
        vehicleVisibilityUpdate;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "ct3SJ5mAn",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertOptionalSubscriptionExpired(subscriptionExpired, label_) {
    var messages = [];
    if (subscriptionExpired !== undefined && subscriptionExpired !== null) {
      messages = messages.concat(
        AvoAssert.assertBool(
          "dKx5VI1W7",
          label_
            ? "Subscription Expired" + ": " + label_
            : "Subscription Expired",
          subscriptionExpired
        )
      );
    }
    return messages;
  }

  function assertFreeTrial(freeTrial, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertBool(
        "dVaX1T1uG",
        label_ ? "Free Trial" + ": " + label_ : "Free Trial",
        freeTrial
      )
    );
    return messages;
  }

  function assertOptionalFreeTrial(freeTrial, label_) {
    var messages = [];
    if (freeTrial !== undefined && freeTrial !== null) {
      messages = messages.concat(
        AvoAssert.assertBool(
          "dVaX1T1uG",
          label_ ? "Free Trial" + ": " + label_ : "Free Trial",
          freeTrial
        )
      );
    }
    return messages;
  }

  function assertOptionalRevenue(revenue, label_) {
    var messages = [];
    if (revenue !== undefined && revenue !== null) {
      messages = messages.concat(
        AvoAssert.assertFloat(
          "dj1v6t5AJ",
          label_ ? "revenue" + ": " + label_ : "revenue",
          revenue
        )
      );
    }
    return messages;
  }

  function assertOptionalCurrency(currency, label_) {
    var messages = [];
    if (currency !== undefined && currency !== null) {
      messages = messages.concat(
        AvoAssert.assertString(
          "dnMIs8rIY",
          label_ ? "currency" + ": " + label_ : "currency",
          currency
        )
      );
      if ("USD" !== currency && "CAD" !== currency && "GBP" !== currency) {
        var message =
          (label_ ? "currency" + ": " + label_ : "currency") +
          " should match one of the following values [ USD | CAD | GBP ] but you provided the value " +
          currency;
        messages = messages.concat([
          {
            tag: "expectedStringMatch",
            propertyId: "dnMIs8rIY",
            message: message,
          },
        ]);
      }
    }
    return messages;
  }

  function assertOptionalCommuteMileageEnabled(commuteMileageEnabled, label_) {
    var messages = [];
    if (commuteMileageEnabled !== undefined && commuteMileageEnabled !== null) {
      messages = messages.concat(
        AvoAssert.assertBool(
          "eIcjynGHp",
          label_
            ? "Commute Mileage Enabled" + ": " + label_
            : "Commute Mileage Enabled",
          commuteMileageEnabled
        )
      );
    }
    return messages;
  }

  function assertOptionalPreviousWebPage(previousWebPage, label_) {
    var messages = [];
    if (previousWebPage !== undefined && previousWebPage !== null) {
      messages = messages.concat(
        AvoAssert.assertString(
          "erhYEd3eU",
          label_ ? "Previous Web Page" + ": " + label_ : "Previous Web Page",
          previousWebPage
        )
      );
      if (
        "Reports Driver Dashboard" !== previousWebPage &&
        "Profile Settings Driver Dashboard" !== previousWebPage &&
        "Notifications Settings Driver Dashboard" !== previousWebPage &&
        "Integrations Settings Driver Dashboard" !== previousWebPage &&
        "Vehicle Settings Driver Dashboard" !== previousWebPage &&
        "Mileage Rates Settings Driver Dashboard" !== previousWebPage &&
        "Auto classification Settings Driver Dashboard" !== previousWebPage &&
        "Custom Purposes Settings Driver Dashboard" !== previousWebPage &&
        "Automatic Reports Settings Driver Dashboard" !== previousWebPage &&
        "Subscription Driver Dashboard" !== previousWebPage &&
        "Share MileIQ Driver Dashboard" !== previousWebPage &&
        "Overview Team Dashboard" !== previousWebPage &&
        "Members Team Dashboard" !== previousWebPage &&
        "Reports Team Dashboard" !== previousWebPage &&
        "Custom Rates Team Dashboard" !== previousWebPage &&
        "Team Locations Team Dashboard" !== previousWebPage &&
        "Subscription Team Dashboard" !== previousWebPage &&
        "Settings Team Dashboard" !== previousWebPage &&
        "Get Started Driver Dashboard" !== previousWebPage &&
        "Drives Driver Dashboard" !== previousWebPage &&
        "Login" !== previousWebPage &&
        "Signup" !== previousWebPage &&
        "Drives Summary Team Dashboard" !== previousWebPage &&
        "Drives List Team Dashboard" !== previousWebPage &&
        "Approve Drives Summary Team Dashboard" !== previousWebPage &&
        "Approve Drives List Team Dashboard" !== previousWebPage
      ) {
        var message =
          (label_ ? "Previous Web Page" + ": " + label_ : "Previous Web Page") +
          " should match one of the following values [ Reports Driver Dashboard | Profile Settings Driver Dashboard | Notifications Settings Driver Dashboard | Integrations Settings Driver Dashboard | Vehicle Settings Driver Dashboard | Mileage Rates Settings Driver Dashboard | Auto classification Settings Driver Dashboard | Custom Purposes Settings Driver Dashboard | Automatic Reports Settings Driver Dashboard | Subscription Driver Dashboard | Share MileIQ Driver Dashboard | Overview Team Dashboard | Members Team Dashboard | Reports Team Dashboard | Custom Rates Team Dashboard | Team Locations Team Dashboard | Subscription Team Dashboard | Settings Team Dashboard | Get Started Driver Dashboard | Drives Driver Dashboard | Login | Signup | Drives Summary Team Dashboard | Drives List Team Dashboard | Approve Drives Summary Team Dashboard | Approve Drives List Team Dashboard ] but you provided the value " +
          previousWebPage;
        messages = messages.concat([
          {
            tag: "expectedStringMatch",
            propertyId: "erhYEd3eU",
            message: message,
          },
        ]);
      }
    }
    return messages;
  }

  function assertDriveReviewCTA(driveReviewCta, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "evNSdcoS7",
        label_ ? "Drive Review CTA" + ": " + label_ : "Drive Review CTA",
        driveReviewCta
      )
    );
    if (
      "All drives" !== driveReviewCta &&
      "Continue Review" !== driveReviewCta
    ) {
      var message =
        (label_ ? "Drive Review CTA" + ": " + label_ : "Drive Review CTA") +
        " should match one of the following values [ All drives | Continue Review ] but you provided the value " +
        driveReviewCta;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "evNSdcoS7",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertOptionalSignupOriginSubscription(
    signupOriginSubscription,
    label_
  ) {
    var messages = [];
    if (
      signupOriginSubscription !== undefined &&
      signupOriginSubscription !== null
    ) {
      messages = messages.concat(
        AvoAssert.assertString(
          "fMsKmI16b",
          label_
            ? "Signup Origin Subscription" + ": " + label_
            : "Signup Origin Subscription",
          signupOriginSubscription
        )
      );
      if (
        "Free" !== signupOriginSubscription &&
        "Unlimited" !== signupOriginSubscription &&
        "Lite" !== signupOriginSubscription &&
        "Standard" !== signupOriginSubscription &&
        "Pro" !== signupOriginSubscription &&
        "Pro - Trial" !== signupOriginSubscription
      ) {
        var message =
          (label_
            ? "Signup Origin Subscription" + ": " + label_
            : "Signup Origin Subscription") +
          " should match one of the following values [ Free | Unlimited | Lite | Standard | Pro | Pro - Trial ] but you provided the value " +
          signupOriginSubscription;
        messages = messages.concat([
          {
            tag: "expectedStringMatch",
            propertyId: "fMsKmI16b",
            message: message,
          },
        ]);
      }
    }
    return messages;
  }

  function assertOptionalIndustry(industry, label_) {
    var messages = [];
    if (industry !== undefined && industry !== null) {
      messages = messages.concat(
        AvoAssert.assertString(
          "fU92KYufq",
          label_ ? "Industry" + ": " + label_ : "Industry",
          industry
        )
      );
    }
    return messages;
  }

  function assertReportRecipientType(reportRecipientType, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "fgug2PGnqJ",
        label_
          ? "Report Recipient Type" + ": " + label_
          : "Report Recipient Type",
        reportRecipientType
      )
    );
    if (
      "Team Admin" !== reportRecipientType &&
      "Email" !== reportRecipientType &&
      "Concur" !== reportRecipientType &&
      "Contact" !== reportRecipientType &&
      "Myself" !== reportRecipientType
    ) {
      var message =
        (label_
          ? "Report Recipient Type" + ": " + label_
          : "Report Recipient Type") +
        " should match one of the following values [ Team Admin | Email | Concur | Contact | Myself ] but you provided the value " +
        reportRecipientType;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "fgug2PGnqJ",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertOptionalReportRecipientType(reportRecipientType, label_) {
    var messages = [];
    if (reportRecipientType !== undefined && reportRecipientType !== null) {
      messages = messages.concat(
        AvoAssert.assertString(
          "fgug2PGnqJ",
          label_
            ? "Report Recipient Type" + ": " + label_
            : "Report Recipient Type",
          reportRecipientType
        )
      );
      if (
        "Team Admin" !== reportRecipientType &&
        "Email" !== reportRecipientType &&
        "Concur" !== reportRecipientType &&
        "Contact" !== reportRecipientType &&
        "Myself" !== reportRecipientType
      ) {
        var message =
          (label_
            ? "Report Recipient Type" + ": " + label_
            : "Report Recipient Type") +
          " should match one of the following values [ Team Admin | Email | Concur | Contact | Myself ] but you provided the value " +
          reportRecipientType;
        messages = messages.concat([
          {
            tag: "expectedStringMatch",
            propertyId: "fgug2PGnqJ",
            message: message,
          },
        ]);
      }
    }
    return messages;
  }

  function assertBulkUploadStepName(bulkUploadStepName, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "fzQ_UrSVl0",
        label_
          ? "Bulk Upload Step Name" + ": " + label_
          : "Bulk Upload Step Name",
        bulkUploadStepName
      )
    );
    if ("Upload File" !== bulkUploadStepName) {
      var message =
        (label_
          ? "Bulk Upload Step Name" + ": " + label_
          : "Bulk Upload Step Name") +
        " should match one of the following values [ Upload File ] but you provided the value " +
        bulkUploadStepName;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "fzQ_UrSVl0",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertReportBusinessDrives(reportBusinessDrives, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertInt(
        "gtLqSg8tJ",
        label_
          ? "Report Business Drives" + ": " + label_
          : "Report Business Drives",
        reportBusinessDrives
      )
    );
    messages = messages.concat(
      AvoAssert.assertMin(
        "gtLqSg8tJ",
        label_
          ? "Report Business Drives" + ": " + label_
          : "Report Business Drives",
        0,
        reportBusinessDrives
      )
    );
    return messages;
  }

  function assertTeamsDriverCount(teamsDriverCount, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertInt(
        "h2UcigKyW",
        label_ ? "Teams Driver Count" + ": " + label_ : "Teams Driver Count",
        teamsDriverCount
      )
    );
    messages = messages.concat(
      AvoAssert.assertMin(
        "h2UcigKyW",
        label_ ? "Teams Driver Count" + ": " + label_ : "Teams Driver Count",
        0,
        teamsDriverCount
      )
    );
    return messages;
  }

  function assertOptionalTeamsDriverCount(teamsDriverCount, label_) {
    var messages = [];
    if (teamsDriverCount !== undefined && teamsDriverCount !== null) {
      messages = messages.concat(
        AvoAssert.assertInt(
          "h2UcigKyW",
          label_ ? "Teams Driver Count" + ": " + label_ : "Teams Driver Count",
          teamsDriverCount
        )
      );
      messages = messages.concat(
        AvoAssert.assertMin(
          "h2UcigKyW",
          label_ ? "Teams Driver Count" + ": " + label_ : "Teams Driver Count",
          0,
          teamsDriverCount
        )
      );
    }
    return messages;
  }

  function assertAcceptedFromEmailLink(acceptedFromEmailLink, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertBool(
        "h3S2U4O-Z",
        label_
          ? "Accepted From Email Link" + ": " + label_
          : "Accepted From Email Link",
        acceptedFromEmailLink
      )
    );
    return messages;
  }

  function assertOptionalPromotionalEmailPreferenceChange(
    promotionalEmailPreferenceChange,
    label_
  ) {
    var messages = [];
    if (
      promotionalEmailPreferenceChange !== undefined &&
      promotionalEmailPreferenceChange !== null
    ) {
      messages = messages.concat(
        AvoAssert.assertString(
          "hPXdy4ttZ",
          label_
            ? "Promotional Email Preference Change" + ": " + label_
            : "Promotional Email Preference Change",
          promotionalEmailPreferenceChange
        )
      );
      if (
        "Enabled" !== promotionalEmailPreferenceChange &&
        "Disabled" !== promotionalEmailPreferenceChange
      ) {
        var message =
          (label_
            ? "Promotional Email Preference Change" + ": " + label_
            : "Promotional Email Preference Change") +
          " should match one of the following values [ Enabled | Disabled ] but you provided the value " +
          promotionalEmailPreferenceChange;
        messages = messages.concat([
          {
            tag: "expectedStringMatch",
            propertyId: "hPXdy4ttZ",
            message: message,
          },
        ]);
      }
    }
    return messages;
  }

  function assertInviteAdminStepName(inviteAdminStepName, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "hUOJ4Vm6Y",
        label_
          ? "Invite Admin Step Name" + ": " + label_
          : "Invite Admin Step Name",
        inviteAdminStepName
      )
    );
    if (
      "Admin Email Entered" !== inviteAdminStepName &&
      "Your Name Entered" !== inviteAdminStepName
    ) {
      var message =
        (label_
          ? "Invite Admin Step Name" + ": " + label_
          : "Invite Admin Step Name") +
        " should match one of the following values [ Admin Email Entered | Your Name Entered ] but you provided the value " +
        inviteAdminStepName;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "hUOJ4Vm6Y",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertOptionalWeeklyEmailPreferenceChange(
    weeklyEmailPreferenceChange,
    label_
  ) {
    var messages = [];
    if (
      weeklyEmailPreferenceChange !== undefined &&
      weeklyEmailPreferenceChange !== null
    ) {
      messages = messages.concat(
        AvoAssert.assertString(
          "hpNqFkv7e",
          label_
            ? "Weekly Email Preference Change" + ": " + label_
            : "Weekly Email Preference Change",
          weeklyEmailPreferenceChange
        )
      );
      if (
        "Enabled" !== weeklyEmailPreferenceChange &&
        "Disabled" !== weeklyEmailPreferenceChange
      ) {
        var message =
          (label_
            ? "Weekly Email Preference Change" + ": " + label_
            : "Weekly Email Preference Change") +
          " should match one of the following values [ Enabled | Disabled ] but you provided the value " +
          weeklyEmailPreferenceChange;
        messages = messages.concat([
          {
            tag: "expectedStringMatch",
            propertyId: "hpNqFkv7e",
            message: message,
          },
        ]);
      }
    }
    return messages;
  }

  function assertOptionalEmailPreferenceChangeMethod(
    emailPreferenceChangeMethod,
    label_
  ) {
    var messages = [];
    if (
      emailPreferenceChangeMethod !== undefined &&
      emailPreferenceChangeMethod !== null
    ) {
      messages = messages.concat(
        AvoAssert.assertString(
          "iqd98lcTV",
          label_
            ? "Email Preference Change Method" + ": " + label_
            : "Email Preference Change Method",
          emailPreferenceChangeMethod
        )
      );
      if (
        "Select" !== emailPreferenceChangeMethod &&
        "Unsubscribe All" !== emailPreferenceChangeMethod
      ) {
        var message =
          (label_
            ? "Email Preference Change Method" + ": " + label_
            : "Email Preference Change Method") +
          " should match one of the following values [ Select | Unsubscribe All ] but you provided the value " +
          emailPreferenceChangeMethod;
        messages = messages.concat([
          {
            tag: "expectedStringMatch",
            propertyId: "iqd98lcTV",
            message: message,
          },
        ]);
      }
    }
    return messages;
  }

  function assertOptionalTeamDrivesDateFilter(teamDrivesDateFilter, label_) {
    var messages = [];
    if (teamDrivesDateFilter !== undefined && teamDrivesDateFilter !== null) {
      messages = messages.concat(
        AvoAssert.assertString(
          "jv44-OJMO",
          label_
            ? "Team Drives Date Filter" + ": " + label_
            : "Team Drives Date Filter",
          teamDrivesDateFilter
        )
      );
    }
    return messages;
  }

  function assertAppDownloadRequestMethod(appDownloadRequestMethod, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "kCCdZER_S",
        label_
          ? "App Download Request Method" + ": " + label_
          : "App Download Request Method",
        appDownloadRequestMethod
      )
    );
    if (
      "Text to Download" !== appDownloadRequestMethod &&
      "QR Code" !== appDownloadRequestMethod &&
      "Click to Download" !== appDownloadRequestMethod
    ) {
      var message =
        (label_
          ? "App Download Request Method" + ": " + label_
          : "App Download Request Method") +
        " should match one of the following values [ Text to Download | QR Code | Click to Download ] but you provided the value " +
        appDownloadRequestMethod;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "kCCdZER_S",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertAddVehicleMethod(addVehicleMethod, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "kFeiOMZm8",
        label_ ? "Add Vehicle Method" + ": " + label_ : "Add Vehicle Method",
        addVehicleMethod
      )
    );
    if ("Manual" !== addVehicleMethod && "Bluetooth" !== addVehicleMethod) {
      var message =
        (label_ ? "Add Vehicle Method" + ": " + label_ : "Add Vehicle Method") +
        " should match one of the following values [ Manual | Bluetooth ] but you provided the value " +
        addVehicleMethod;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "kFeiOMZm8",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertIntegrationProcess(integrationProcess, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "kIO9IcVmz",
        label_ ? "Integration Process" + ": " + label_ : "Integration Process",
        integrationProcess
      )
    );
    if ("Automatic" !== integrationProcess && "Manual" !== integrationProcess) {
      var message =
        (label_
          ? "Integration Process" + ": " + label_
          : "Integration Process") +
        " should match one of the following values [ Automatic | Manual ] but you provided the value " +
        integrationProcess;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "kIO9IcVmz",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertReportsVehicleFilter(reportsVehicleFilter, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "kkaUYVCew",
        label_
          ? "Reports Vehicle Filter" + ": " + label_
          : "Reports Vehicle Filter",
        reportsVehicleFilter
      )
    );
    if (
      "All Vehicles" !== reportsVehicleFilter &&
      "Select Vehicles" !== reportsVehicleFilter
    ) {
      var message =
        (label_
          ? "Reports Vehicle Filter" + ": " + label_
          : "Reports Vehicle Filter") +
        " should match one of the following values [ All Vehicles | Select Vehicles ] but you provided the value " +
        reportsVehicleFilter;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "kkaUYVCew",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertOptionalTeamsReportsSubmissionFilter(
    teamsReportsSubmissionFilter,
    label_
  ) {
    var messages = [];
    if (
      teamsReportsSubmissionFilter !== undefined &&
      teamsReportsSubmissionFilter !== null
    ) {
      messages = messages.concat(
        AvoAssert.assertString(
          "la6RYKAJ9",
          label_
            ? "Teams Reports Submission Filter" + ": " + label_
            : "Teams Reports Submission Filter",
          teamsReportsSubmissionFilter
        )
      );
      if (
        "Last 30 days" !== teamsReportsSubmissionFilter &&
        "Last 3 months" !== teamsReportsSubmissionFilter &&
        "Last 12 months" !== teamsReportsSubmissionFilter &&
        "Year to date" !== teamsReportsSubmissionFilter &&
        "All time" !== teamsReportsSubmissionFilter
      ) {
        var message =
          (label_
            ? "Teams Reports Submission Filter" + ": " + label_
            : "Teams Reports Submission Filter") +
          " should match one of the following values [ Last 30 days | Last 3 months | Last 12 months | Year to date | All time ] but you provided the value " +
          teamsReportsSubmissionFilter;
        messages = messages.concat([
          {
            tag: "expectedStringMatch",
            propertyId: "la6RYKAJ9",
            message: message,
          },
        ]);
      }
    }
    return messages;
  }

  function assertResentUserCount(resentUserCount, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertInt(
        "mCaLIQOaUq",
        label_ ? "Resent User Count" + ": " + label_ : "Resent User Count",
        resentUserCount
      )
    );
    messages = messages.concat(
      AvoAssert.assertMin(
        "mCaLIQOaUq",
        label_ ? "Resent User Count" + ": " + label_ : "Resent User Count",
        1,
        resentUserCount
      )
    );
    return messages;
  }

  function assertDriveDateFilter(driveDateFilter, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "mUalaEu4z",
        label_ ? "Drive Date Filter" + ": " + label_ : "Drive Date Filter",
        driveDateFilter
      )
    );
    if (
      "This month" !== driveDateFilter &&
      "Last month" !== driveDateFilter &&
      "Last 3 months" !== driveDateFilter &&
      "Year to date" !== driveDateFilter &&
      "Last year" !== driveDateFilter &&
      "Custom range" !== driveDateFilter &&
      "Month" !== driveDateFilter
    ) {
      var message =
        (label_ ? "Drive Date Filter" + ": " + label_ : "Drive Date Filter") +
        " should match one of the following values [ This month | Last month | Last 3 months | Year to date | Last year | Custom range | Month ] but you provided the value " +
        driveDateFilter;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "mUalaEu4z",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertDiscountCouponCode(discountCouponCode, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "ma7AAeRIY",
        label_
          ? "Discount Coupon Code" + ": " + label_
          : "Discount Coupon Code",
        discountCouponCode
      )
    );
    return messages;
  }

  function assertInviteAdminStep(inviteAdminStep, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertInt(
        "n-fLdMdct",
        label_ ? "Invite Admin Step" + ": " + label_ : "Invite Admin Step",
        inviteAdminStep
      )
    );
    messages = messages.concat(
      AvoAssert.assertMin(
        "n-fLdMdct",
        label_ ? "Invite Admin Step" + ": " + label_ : "Invite Admin Step",
        0,
        inviteAdminStep
      )
    );
    messages = messages.concat(
      AvoAssert.assertMax(
        "n-fLdMdct",
        label_ ? "Invite Admin Step" + ": " + label_ : "Invite Admin Step",
        2,
        inviteAdminStep
      )
    );
    return messages;
  }

  function assertFrequentDriveEditAction(frequentDriveEditAction, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "n6k_-xtwc",
        label_
          ? "Frequent Drive Edit Action" + ": " + label_
          : "Frequent Drive Edit Action",
        frequentDriveEditAction
      )
    );
    if (
      "Stop Auto Classify" !== frequentDriveEditAction &&
      "Cancel" !== frequentDriveEditAction &&
      "Dismissed" !== frequentDriveEditAction
    ) {
      var message =
        (label_
          ? "Frequent Drive Edit Action" + ": " + label_
          : "Frequent Drive Edit Action") +
        " should match one of the following values [ Stop Auto Classify | Cancel | Dismissed ] but you provided the value " +
        frequentDriveEditAction;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "n6k_-xtwc",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertReportUnclassifiedDrives(reportUnclassifiedDrives, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertInt(
        "nUhX3A1DT",
        label_
          ? "Report Unclassified Drives" + ": " + label_
          : "Report Unclassified Drives",
        reportUnclassifiedDrives
      )
    );
    messages = messages.concat(
      AvoAssert.assertMin(
        "nUhX3A1DT",
        label_
          ? "Report Unclassified Drives" + ": " + label_
          : "Report Unclassified Drives",
        0,
        reportUnclassifiedDrives
      )
    );
    return messages;
  }

  function assertTeamsSeatsPurchaseCount(teamsSeatsPurchaseCount, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertInt(
        "o2HIGOy0wz",
        label_
          ? "Teams Seats Purchase Count" + ": " + label_
          : "Teams Seats Purchase Count",
        teamsSeatsPurchaseCount
      )
    );
    messages = messages.concat(
      AvoAssert.assertMin(
        "o2HIGOy0wz",
        label_
          ? "Teams Seats Purchase Count" + ": " + label_
          : "Teams Seats Purchase Count",
        0,
        teamsSeatsPurchaseCount
      )
    );
    return messages;
  }

  function assertWorkHourFailure(workHourFailure, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "oJV7MaqyD",
        label_ ? "Work Hour Failure" + ": " + label_ : "Work Hour Failure",
        workHourFailure
      )
    );
    if ("Overlapping Time" !== workHourFailure) {
      var message =
        (label_ ? "Work Hour Failure" + ": " + label_ : "Work Hour Failure") +
        " should match one of the following values [ Overlapping Time ] but you provided the value " +
        workHourFailure;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "oJV7MaqyD",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertDriveClassificationType(driveClassificationType, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "oMiAPbzL8",
        label_
          ? "Drive Classification Type" + ": " + label_
          : "Drive Classification Type",
        driveClassificationType
      )
    );
    if (
      "Business" !== driveClassificationType &&
      "Personal" !== driveClassificationType
    ) {
      var message =
        (label_
          ? "Drive Classification Type" + ": " + label_
          : "Drive Classification Type") +
        " should match one of the following values [ Business | Personal ] but you provided the value " +
        driveClassificationType;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "oMiAPbzL8",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertTeamId(teamId, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertInt(
        "oeDBOcvZ5e",
        label_ ? "team_id" + ": " + label_ : "team_id",
        teamId
      )
    );
    return messages;
  }

  function assertOptionalTeamsUpdatePaymentFailReason(
    teamsUpdatePaymentFailReason,
    label_
  ) {
    var messages = [];
    if (
      teamsUpdatePaymentFailReason !== undefined &&
      teamsUpdatePaymentFailReason !== null
    ) {
      messages = messages.concat(
        AvoAssert.assertString(
          "ol0C1rRCB",
          label_
            ? "Teams Update Payment Fail Reason" + ": " + label_
            : "Teams Update Payment Fail Reason",
          teamsUpdatePaymentFailReason
        )
      );
    }
    return messages;
  }

  function assertCountry(country, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "p0_feuKMRI",
        label_ ? "Country" + ": " + label_ : "Country",
        country
      )
    );
    if (
      "US" !== country &&
      "UK" !== country &&
      "CA" !== country &&
      "GB" !== country
    ) {
      var message =
        (label_ ? "Country" + ": " + label_ : "Country") +
        " should match one of the following values [ US | UK | CA | GB ] but you provided the value " +
        country;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "p0_feuKMRI",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertReportPersonalDrives(reportPersonalDrives, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertInt(
        "pIO_2RvM0",
        label_
          ? "Report Personal Drives" + ": " + label_
          : "Report Personal Drives",
        reportPersonalDrives
      )
    );
    messages = messages.concat(
      AvoAssert.assertMin(
        "pIO_2RvM0",
        label_
          ? "Report Personal Drives" + ": " + label_
          : "Report Personal Drives",
        0,
        reportPersonalDrives
      )
    );
    return messages;
  }

  function assertReportDetailsSearchFilter(reportDetailsSearchFilter, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "pM-3_WWOM",
        label_
          ? "Report Details Search Filter" + ": " + label_
          : "Report Details Search Filter",
        reportDetailsSearchFilter
      )
    );
    if (
      "Applied" !== reportDetailsSearchFilter &&
      "Not Applied" !== reportDetailsSearchFilter
    ) {
      var message =
        (label_
          ? "Report Details Search Filter" + ": " + label_
          : "Report Details Search Filter") +
        " should match one of the following values [ Applied | Not Applied ] but you provided the value " +
        reportDetailsSearchFilter;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "pM-3_WWOM",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertOptionalCustomRatesEffectiveDate(
    customRatesEffectiveDate,
    label_
  ) {
    var messages = [];
    if (
      customRatesEffectiveDate !== undefined &&
      customRatesEffectiveDate !== null
    ) {
      messages = messages.concat(
        AvoAssert.assertString(
          "pMIlytsFWc",
          label_
            ? "Custom Rates Effective Date" + ": " + label_
            : "Custom Rates Effective Date",
          customRatesEffectiveDate
        )
      );
      if (
        "Immediate" !== customRatesEffectiveDate &&
        "Future" !== customRatesEffectiveDate
      ) {
        var message =
          (label_
            ? "Custom Rates Effective Date" + ": " + label_
            : "Custom Rates Effective Date") +
          " should match one of the following values [ Immediate | Future ] but you provided the value " +
          customRatesEffectiveDate;
        messages = messages.concat([
          {
            tag: "expectedStringMatch",
            propertyId: "pMIlytsFWc",
            message: message,
          },
        ]);
      }
    }
    return messages;
  }

  function assertCustomRatesUpdateType(customRatesUpdateType, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "p_aYbLlADo",
        label_
          ? "Custom Rates Update Type" + ": " + label_
          : "Custom Rates Update Type",
        customRatesUpdateType
      )
    );
    if (
      "Change" !== customRatesUpdateType &&
      "Revert to Previous" !== customRatesUpdateType &&
      "Remove" !== customRatesUpdateType &&
      "Revert to Default" !== customRatesUpdateType
    ) {
      var message =
        (label_
          ? "Custom Rates Update Type" + ": " + label_
          : "Custom Rates Update Type") +
        " should match one of the following values [ Change | Revert to Previous | Remove | Revert to Default ] but you provided the value " +
        customRatesUpdateType;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "p_aYbLlADo",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertSharedNamedLocationFailure(
    sharedNamedLocationFailure,
    label_
  ) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "pjut28haR",
        label_
          ? "Shared Named Location Failure" + ": " + label_
          : "Shared Named Location Failure",
        sharedNamedLocationFailure
      )
    );
    if (
      "Address is already a Team Location" !== sharedNamedLocationFailure &&
      "Name already exists" !== sharedNamedLocationFailure &&
      "Area is already a Team Location" !== sharedNamedLocationFailure &&
      "Other" !== sharedNamedLocationFailure
    ) {
      var message =
        (label_
          ? "Shared Named Location Failure" + ": " + label_
          : "Shared Named Location Failure") +
        " should match one of the following values [ Address is already a Team Location | Name already exists | Area is already a Team Location | Other ] but you provided the value " +
        sharedNamedLocationFailure;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "pjut28haR",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertOptionalTeamsSubscriptionCancellationStep(
    teamsSubscriptionCancellationStep,
    label_
  ) {
    var messages = [];
    if (
      teamsSubscriptionCancellationStep !== undefined &&
      teamsSubscriptionCancellationStep !== null
    ) {
      messages = messages.concat(
        AvoAssert.assertString(
          "ps4aByRzM",
          label_
            ? "Teams Subscription Cancellation Step" + ": " + label_
            : "Teams Subscription Cancellation Step",
          teamsSubscriptionCancellationStep
        )
      );
      if (
        "Cancellation Reason" !== teamsSubscriptionCancellationStep &&
        "Downgrade Subscription" !== teamsSubscriptionCancellationStep &&
        "Claim Discount" !== teamsSubscriptionCancellationStep &&
        "Team All Time Stats" !== teamsSubscriptionCancellationStep
      ) {
        var message =
          (label_
            ? "Teams Subscription Cancellation Step" + ": " + label_
            : "Teams Subscription Cancellation Step") +
          " should match one of the following values [ Cancellation Reason | Downgrade Subscription | Claim Discount | Team All Time Stats ] but you provided the value " +
          teamsSubscriptionCancellationStep;
        messages = messages.concat([
          {
            tag: "expectedStringMatch",
            propertyId: "ps4aByRzM",
            message: message,
          },
        ]);
      }
    }
    return messages;
  }

  function assertTeamsSubscriptionCancellationStep(
    teamsSubscriptionCancellationStep,
    label_
  ) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "ps4aByRzM",
        label_
          ? "Teams Subscription Cancellation Step" + ": " + label_
          : "Teams Subscription Cancellation Step",
        teamsSubscriptionCancellationStep
      )
    );
    if (
      "Cancellation Reason" !== teamsSubscriptionCancellationStep &&
      "Downgrade Subscription" !== teamsSubscriptionCancellationStep &&
      "Claim Discount" !== teamsSubscriptionCancellationStep &&
      "Team All Time Stats" !== teamsSubscriptionCancellationStep
    ) {
      var message =
        (label_
          ? "Teams Subscription Cancellation Step" + ": " + label_
          : "Teams Subscription Cancellation Step") +
        " should match one of the following values [ Cancellation Reason | Downgrade Subscription | Claim Discount | Team All Time Stats ] but you provided the value " +
        teamsSubscriptionCancellationStep;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "ps4aByRzM",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertOptionalPaymentAmountDue(paymentAmountDue, label_) {
    var messages = [];
    if (paymentAmountDue !== undefined && paymentAmountDue !== null) {
      messages = messages.concat(
        AvoAssert.assertFloat(
          "qP671jcZS",
          label_ ? "Payment Amount Due" + ": " + label_ : "Payment Amount Due",
          paymentAmountDue
        )
      );
    }
    return messages;
  }

  function assertNamedLocationEdit(namedLocationEdit, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "qsH2osMFv",
        label_ ? "Named Location Edit" + ": " + label_ : "Named Location Edit",
        namedLocationEdit
      )
    );
    if (
      "Rename" !== namedLocationEdit &&
      "Create new location" !== namedLocationEdit
    ) {
      var message =
        (label_
          ? "Named Location Edit" + ": " + label_
          : "Named Location Edit") +
        " should match one of the following values [ Rename | Create new location ] but you provided the value " +
        namedLocationEdit;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "qsH2osMFv",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertOptionalTeamDrivesPurposeFilter(
    teamDrivesPurposeFilter,
    label_
  ) {
    var messages = [];
    if (
      teamDrivesPurposeFilter !== undefined &&
      teamDrivesPurposeFilter !== null
    ) {
      messages = messages.concat(
        AvoAssert.assertString(
          "rEaF8yiKv",
          label_
            ? "Team Drives Purpose Filter" + ": " + label_
            : "Team Drives Purpose Filter",
          teamDrivesPurposeFilter
        )
      );
      if (
        "Business" !== teamDrivesPurposeFilter &&
        "Meeting" !== teamDrivesPurposeFilter &&
        "Errand/Supplies" !== teamDrivesPurposeFilter &&
        "Airport/Travel" !== teamDrivesPurposeFilter &&
        "Other" !== teamDrivesPurposeFilter &&
        "Commute" !== teamDrivesPurposeFilter &&
        "Medical" !== teamDrivesPurposeFilter &&
        "Charity" !== teamDrivesPurposeFilter &&
        "Moving" !== teamDrivesPurposeFilter &&
        "Personal" !== teamDrivesPurposeFilter &&
        "Business + Commute" !== teamDrivesPurposeFilter &&
        "Between Offices" !== teamDrivesPurposeFilter &&
        "Customer Visit" !== teamDrivesPurposeFilter &&
        "Meal/Entertain" !== teamDrivesPurposeFilter &&
        "Temporary Site" !== teamDrivesPurposeFilter
      ) {
        var message =
          (label_
            ? "Team Drives Purpose Filter" + ": " + label_
            : "Team Drives Purpose Filter") +
          " should match one of the following values [ Business | Meeting | Errand/Supplies | Airport/Travel | Other | Commute | Medical | Charity | Moving | Personal | Business + Commute | Between Offices | Customer Visit | Meal/Entertain | Temporary Site ] but you provided the value " +
          teamDrivesPurposeFilter;
        messages = messages.concat([
          {
            tag: "expectedStringMatch",
            propertyId: "rEaF8yiKv",
            message: message,
          },
        ]);
      }
    }
    return messages;
  }

  function assertOptionalSubscriptionType(subscriptionType, label_) {
    var messages = [];
    if (subscriptionType !== undefined && subscriptionType !== null) {
      messages = messages.concat(
        AvoAssert.assertString(
          "rN6HAJ5vu",
          label_ ? "subscription_type" + ": " + label_ : "subscription_type",
          subscriptionType
        )
      );
      if ("Monthly" !== subscriptionType && "Annual" !== subscriptionType) {
        var message =
          (label_ ? "subscription_type" + ": " + label_ : "subscription_type") +
          " should match one of the following values [ Monthly | Annual ] but you provided the value " +
          subscriptionType;
        messages = messages.concat([
          {
            tag: "expectedStringMatch",
            propertyId: "rN6HAJ5vu",
            message: message,
          },
        ]);
      }
    }
    return messages;
  }

  function assertSubscriptionType(subscriptionType, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "rN6HAJ5vu",
        label_ ? "subscription_type" + ": " + label_ : "subscription_type",
        subscriptionType
      )
    );
    if ("Monthly" !== subscriptionType && "Annual" !== subscriptionType) {
      var message =
        (label_ ? "subscription_type" + ": " + label_ : "subscription_type") +
        " should match one of the following values [ Monthly | Annual ] but you provided the value " +
        subscriptionType;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "rN6HAJ5vu",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertReportOpenSource(reportOpenSource, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "sDjxHAr4i",
        label_ ? "Report Open Source" + ": " + label_ : "Report Open Source",
        reportOpenSource
      )
    );
    if (
      "Report Row" !== reportOpenSource &&
      "Eye Icon" !== reportOpenSource &&
      "Sidebar Details" !== reportOpenSource
    ) {
      var message =
        (label_ ? "Report Open Source" + ": " + label_ : "Report Open Source") +
        " should match one of the following values [ Report Row | Eye Icon | Sidebar Details ] but you provided the value " +
        reportOpenSource;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "sDjxHAr4i",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertOptionalCustomRatesSelection(customRatesSelection, label_) {
    var messages = [];
    if (customRatesSelection !== undefined && customRatesSelection !== null) {
      messages = messages.concat(
        AvoAssert.assertString(
          "sj8Oob-_yQ",
          label_
            ? "Custom Rates Selection" + ": " + label_
            : "Custom Rates Selection",
          customRatesSelection
        )
      );
      if (
        "Current" !== customRatesSelection &&
        "Upcoming" !== customRatesSelection &&
        "Past" !== customRatesSelection
      ) {
        var message =
          (label_
            ? "Custom Rates Selection" + ": " + label_
            : "Custom Rates Selection") +
          " should match one of the following values [ Current | Upcoming | Past ] but you provided the value " +
          customRatesSelection;
        messages = messages.concat([
          {
            tag: "expectedStringMatch",
            propertyId: "sj8Oob-_yQ",
            message: message,
          },
        ]);
      }
    }
    return messages;
  }

  function assertFilterDriveManuallyClassified(
    filterDriveManuallyClassified,
    label_
  ) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "ss43OmmE_",
        label_
          ? "Filter Drive Manually Classified" + ": " + label_
          : "Filter Drive Manually Classified",
        filterDriveManuallyClassified
      )
    );
    if (
      "Selected" !== filterDriveManuallyClassified &&
      "Unselected" !== filterDriveManuallyClassified
    ) {
      var message =
        (label_
          ? "Filter Drive Manually Classified" + ": " + label_
          : "Filter Drive Manually Classified") +
        " should match one of the following values [ Selected | Unselected ] but you provided the value " +
        filterDriveManuallyClassified;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "ss43OmmE_",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertOptionalMonthlyEmailPreferenceChange(
    monthlyEmailPreferenceChange,
    label_
  ) {
    var messages = [];
    if (
      monthlyEmailPreferenceChange !== undefined &&
      monthlyEmailPreferenceChange !== null
    ) {
      messages = messages.concat(
        AvoAssert.assertString(
          "t-gDmCpz8",
          label_
            ? "Monthly Email Preference Change" + ": " + label_
            : "Monthly Email Preference Change",
          monthlyEmailPreferenceChange
        )
      );
      if (
        "Enabled" !== monthlyEmailPreferenceChange &&
        "Disabled" !== monthlyEmailPreferenceChange
      ) {
        var message =
          (label_
            ? "Monthly Email Preference Change" + ": " + label_
            : "Monthly Email Preference Change") +
          " should match one of the following values [ Enabled | Disabled ] but you provided the value " +
          monthlyEmailPreferenceChange;
        messages = messages.concat([
          {
            tag: "expectedStringMatch",
            propertyId: "t-gDmCpz8",
            message: message,
          },
        ]);
      }
    }
    return messages;
  }

  function assertOptionalDaysUntilGracePeriodEnds(
    daysUntilGracePeriodEnds,
    label_
  ) {
    var messages = [];
    if (
      daysUntilGracePeriodEnds !== undefined &&
      daysUntilGracePeriodEnds !== null
    ) {
      messages = messages.concat(
        AvoAssert.assertInt(
          "tll649ar0",
          label_
            ? "Days Until Grace Period Ends" + ": " + label_
            : "Days Until Grace Period Ends",
          daysUntilGracePeriodEnds
        )
      );
      messages = messages.concat(
        AvoAssert.assertMin(
          "tll649ar0",
          label_
            ? "Days Until Grace Period Ends" + ": " + label_
            : "Days Until Grace Period Ends",
          0,
          daysUntilGracePeriodEnds
        )
      );
    }
    return messages;
  }

  function assertUTMContent(utmContent, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "uFzvwV4V4V",
        label_ ? "UTM Content" + ": " + label_ : "UTM Content",
        utmContent
      )
    );
    return messages;
  }

  function assertDriveClassificationFilter(driveClassificationFilter, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "uRQ78ipPA",
        label_
          ? "Drive Classification Filter" + ": " + label_
          : "Drive Classification Filter",
        driveClassificationFilter
      )
    );
    if (
      "All" !== driveClassificationFilter &&
      "Unclassified" !== driveClassificationFilter &&
      "Business" !== driveClassificationFilter &&
      "Personal" !== driveClassificationFilter
    ) {
      var message =
        (label_
          ? "Drive Classification Filter" + ": " + label_
          : "Drive Classification Filter") +
        " should match one of the following values [ All | Unclassified | Business | Personal ] but you provided the value " +
        driveClassificationFilter;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "uRQ78ipPA",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertFeatureName(featureName, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "ugJQWcfws",
        label_ ? "Feature Name" + ": " + label_ : "Feature Name",
        featureName
      )
    );
    return messages;
  }

  function assertOptionalOverlayDescription(overlayDescription, label_) {
    var messages = [];
    if (overlayDescription !== undefined && overlayDescription !== null) {
      messages = messages.concat(
        AvoAssert.assertString(
          "v0ylP6zR_w",
          label_
            ? "Overlay Description" + ": " + label_
            : "Overlay Description",
          overlayDescription
        )
      );
      if (
        "Text to Download" !== overlayDescription &&
        "Offer Help to Completing Order" !== overlayDescription
      ) {
        var message =
          (label_
            ? "Overlay Description" + ": " + label_
            : "Overlay Description") +
          " should match one of the following values [ Text to Download | Offer Help to Completing Order ] but you provided the value " +
          overlayDescription;
        messages = messages.concat([
          {
            tag: "expectedStringMatch",
            propertyId: "v0ylP6zR_w",
            message: message,
          },
        ]);
      }
    }
    return messages;
  }

  function assertVehicleCount(vehicleCount, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertInt(
        "v4aPRYQeW",
        label_ ? "Vehicle Count" + ": " + label_ : "Vehicle Count",
        vehicleCount
      )
    );
    messages = messages.concat(
      AvoAssert.assertMin(
        "v4aPRYQeW",
        label_ ? "Vehicle Count" + ": " + label_ : "Vehicle Count",
        0,
        vehicleCount
      )
    );
    return messages;
  }

  function assertOptionalModalAbandonMethod(modalAbandonMethod, label_) {
    var messages = [];
    if (modalAbandonMethod !== undefined && modalAbandonMethod !== null) {
      messages = messages.concat(
        AvoAssert.assertString(
          "vb2dwipxd",
          label_
            ? "Modal Abandon Method" + ": " + label_
            : "Modal Abandon Method",
          modalAbandonMethod
        )
      );
      if (
        "Modal dismiss" !== modalAbandonMethod &&
        "Close CTA" !== modalAbandonMethod
      ) {
        var message =
          (label_
            ? "Modal Abandon Method" + ": " + label_
            : "Modal Abandon Method") +
          " should match one of the following values [ Modal dismiss | Close CTA ] but you provided the value " +
          modalAbandonMethod;
        messages = messages.concat([
          {
            tag: "expectedStringMatch",
            propertyId: "vb2dwipxd",
            message: message,
          },
        ]);
      }
    }
    return messages;
  }

  function assertSubscriptionCancelReason(subscriptionCancelReason, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "vluEV5X6S",
        label_
          ? "Subscription Cancel Reason" + ": " + label_
          : "Subscription Cancel Reason",
        subscriptionCancelReason
      )
    );
    return messages;
  }

  function assertOptionalTeamsReportsDriversFilter(
    teamsReportsDriversFilter,
    label_
  ) {
    var messages = [];
    if (
      teamsReportsDriversFilter !== undefined &&
      teamsReportsDriversFilter !== null
    ) {
      messages = messages.concat(
        AvoAssert.assertString(
          "vtg1sPIz-",
          label_
            ? "Teams Reports Drivers Filter" + ": " + label_
            : "Teams Reports Drivers Filter",
          teamsReportsDriversFilter
        )
      );
      if (
        "Individual" !== teamsReportsDriversFilter &&
        "Multiple" !== teamsReportsDriversFilter
      ) {
        var message =
          (label_
            ? "Teams Reports Drivers Filter" + ": " + label_
            : "Teams Reports Drivers Filter") +
          " should match one of the following values [ Individual | Multiple ] but you provided the value " +
          teamsReportsDriversFilter;
        messages = messages.concat([
          {
            tag: "expectedStringMatch",
            propertyId: "vtg1sPIz-",
            message: message,
          },
        ]);
      }
    }
    return messages;
  }

  function assertReportEmailSource(reportEmailSource, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "wVHtepkwX",
        label_ ? "Report Email Source" + ": " + label_ : "Report Email Source",
        reportEmailSource
      )
    );
    if (
      "Reports Sidebar" !== reportEmailSource &&
      "Report Details Sidebar" !== reportEmailSource
    ) {
      var message =
        (label_
          ? "Report Email Source" + ": " + label_
          : "Report Email Source") +
        " should match one of the following values [ Reports Sidebar | Report Details Sidebar ] but you provided the value " +
        reportEmailSource;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "wVHtepkwX",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertDriverReportSelectionType(driverReportSelectionType, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "x9ydpXsb6",
        label_
          ? "Driver Report Selection Type" + ": " + label_
          : "Driver Report Selection Type",
        driverReportSelectionType
      )
    );
    if (
      "Individual" !== driverReportSelectionType &&
      "All" !== driverReportSelectionType
    ) {
      var message =
        (label_
          ? "Driver Report Selection Type" + ": " + label_
          : "Driver Report Selection Type") +
        " should match one of the following values [ Individual | All ] but you provided the value " +
        driverReportSelectionType;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "x9ydpXsb6",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertAutoClassifyDuringWorkHoursPreference(
    autoClassifyDuringWorkHoursPreference,
    label_
  ) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "xFeOzRR8i",
        label_
          ? "Auto Classify During Work Hours Preference" + ": " + label_
          : "Auto Classify During Work Hours Preference",
        autoClassifyDuringWorkHoursPreference
      )
    );
    if (
      "Enabled" !== autoClassifyDuringWorkHoursPreference &&
      "Disabled" !== autoClassifyDuringWorkHoursPreference
    ) {
      var message =
        (label_
          ? "Auto Classify During Work Hours Preference" + ": " + label_
          : "Auto Classify During Work Hours Preference") +
        " should match one of the following values [ Enabled | Disabled ] but you provided the value " +
        autoClassifyDuringWorkHoursPreference;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "xFeOzRR8i",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertRevokedUserCount(revokedUserCount, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertInt(
        "xhgkr-VsdS",
        label_ ? "Revoked User Count" + ": " + label_ : "Revoked User Count",
        revokedUserCount
      )
    );
    messages = messages.concat(
      AvoAssert.assertMin(
        "xhgkr-VsdS",
        label_ ? "Revoked User Count" + ": " + label_ : "Revoked User Count",
        1,
        revokedUserCount
      )
    );
    return messages;
  }

  function assertVehicleType(vehicleType, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "yAUGC1YVE",
        label_ ? "Vehicle Type" + ": " + label_ : "Vehicle Type",
        vehicleType
      )
    );
    if (
      "Car" !== vehicleType &&
      "Motorcycle" !== vehicleType &&
      "Bike" !== vehicleType
    ) {
      var message =
        (label_ ? "Vehicle Type" + ": " + label_ : "Vehicle Type") +
        " should match one of the following values [ Car | Motorcycle | Bike ] but you provided the value " +
        vehicleType;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "yAUGC1YVE",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertWorkHoursSchedule(workHoursSchedule, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "yQPukTxGs",
        label_ ? "Work Hours Schedule" + ": " + label_ : "Work Hours Schedule",
        workHoursSchedule
      )
    );
    if ("Simple" !== workHoursSchedule && "Complex" !== workHoursSchedule) {
      var message =
        (label_
          ? "Work Hours Schedule" + ": " + label_
          : "Work Hours Schedule") +
        " should match one of the following values [ Simple | Complex ] but you provided the value " +
        workHoursSchedule;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "yQPukTxGs",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function assertUTMSource(utmSource, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "yRYklsveXX",
        label_ ? "UTM Source" + ": " + label_ : "UTM Source",
        utmSource
      )
    );
    return messages;
  }

  function assertTeamName(teamName, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "zEyW0825ou",
        label_ ? "Team Name" + ": " + label_ : "Team Name",
        teamName
      )
    );
    return messages;
  }

  function assertBulkUploadUserCount(bulkUploadUserCount, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertInt(
        "zQHDfCEM6P",
        label_
          ? "Bulk Upload User Count" + ": " + label_
          : "Bulk Upload User Count",
        bulkUploadUserCount
      )
    );
    return messages;
  }

  function assertOptionalSignupOriginBillingCycle(
    signupOriginBillingCycle,
    label_
  ) {
    var messages = [];
    if (
      signupOriginBillingCycle !== undefined &&
      signupOriginBillingCycle !== null
    ) {
      messages = messages.concat(
        AvoAssert.assertString(
          "zpI7ysLkd",
          label_
            ? "Signup Origin Billing Cycle" + ": " + label_
            : "Signup Origin Billing Cycle",
          signupOriginBillingCycle
        )
      );
      if (
        "Monthly" !== signupOriginBillingCycle &&
        "Annual" !== signupOriginBillingCycle
      ) {
        var message =
          (label_
            ? "Signup Origin Billing Cycle" + ": " + label_
            : "Signup Origin Billing Cycle") +
          " should match one of the following values [ Monthly | Annual ] but you provided the value " +
          signupOriginBillingCycle;
        messages = messages.concat([
          {
            tag: "expectedStringMatch",
            propertyId: "zpI7ysLkd",
            message: message,
          },
        ]);
      }
    }
    return messages;
  }

  function assertIntent(intent, label_) {
    var messages = [];
    messages = messages.concat(
      AvoAssert.assertString(
        "zv_WuIxy3",
        label_ ? "Intent" + ": " + label_ : "Intent",
        intent
      )
    );
    if (
      "join team" !== intent &&
      "create team" !== intent &&
      "use personal" !== intent
    ) {
      var message =
        (label_ ? "Intent" + ": " + label_ : "Intent") +
        " should match one of the following values [ join team | create team | use personal ] but you provided the value " +
        intent;
      messages = messages.concat([
        {
          tag: "expectedStringMatch",
          propertyId: "zv_WuIxy3",
          message: message,
        },
      ]);
    }
    return messages;
  }

  function setAvoLogger(avoLogger) {
    __AVO_LOGGER__ = avoLogger;
  }

  var RudderStackWebDashboard;

  var SegmentWebDashboard;

  var Mixpanel;

  var Braze;
  function setup_(
    options,
    systemProperties,
    RudderStackWebDashboardDestination,
    SegmentWebDashboardDestination,
    MixpanelDestination,
    BrazeDestination,
    destinationOptions
  ) {
    __WEB_DEBUGGER__ = false;
    if (options.validateProperties === true) {
      __AVO_DEV__ = true;
    }

    destinationOptions = destinationOptions || {};

    if (!__AVO_NOOP__) {
      if (options.useProductionKey) {
      } else {
      }

      RudderStackWebDashboard = RudderStackWebDashboardDestination;
      RudderStackWebDashboard.make(options.useProductionKey);

      SegmentWebDashboard = SegmentWebDashboardDestination;
      SegmentWebDashboard.make(options.useProductionKey);

      Mixpanel = MixpanelDestination;
      Mixpanel.make(options.useProductionKey);

      Braze = BrazeDestination;
      Braze.make(options.useProductionKey);
      if (__AVO_DEV__) {
        // debug console in Avo
        _avo_invoke_meta(__AVO_ENV__, "setup", [], "setup");
      }
    }
  }

  function initAvo(
    options,
    systemProperties,
    destinationOptions,
    RudderStackWebDashboardDestination,
    SegmentWebDashboardDestination,
    MixpanelDestination,
    BrazeDestination
  ) {
    if (__AVO_ENV__ !== null) {
      return;
    }
    __AVO_ENV__ = options.env.toLowerCase();
    if (options.avoLogger !== undefined) {
      __AVO_LOGGER__ = options.avoLogger;
    }
    if (options.noop === true) {
      __AVO_NOOP__ = true;
    }
    if (__AVO_NOOP__ && __AVO_ENV__ == "prod") {
      InternalAvoLogger.warn(
        "****************************************************"
      );
      InternalAvoLogger.warn(
        "WARNING Avo cannot be initialized in noop mode in production:"
      );
      InternalAvoLogger.warn("- Overwriting configuration with noop=false.");
      InternalAvoLogger.warn(
        "- Please reach out if you want to be able to run Avo in production mode with noop=true"
      );
      InternalAvoLogger.warn(
        "****************************************************"
      );
      __AVO_NOOP__ = false;
    }
    if (__AVO_NOOP__) {
      InternalAvoLogger.log(
        "****************************************************"
      );
      InternalAvoLogger.log("Avo is now initialized in noop mode. This means:");
      InternalAvoLogger.log("- No events will be sent");
      InternalAvoLogger.log("- No network requests are made");
      InternalAvoLogger.log(
        "****************************************************"
      );
    }
    if (options.strict !== undefined) {
      __STRICT__ = options.strict !== false;
    }
    if (options.reportFailureAs !== undefined) {
      __REPORT_FAILURE_AS__ = options.reportFailureAs;
    }
    __WEB_DEBUGGER__ =
      !__AVO_NOOP__ &&
      ((typeof window !== "undefined" &&
        window.location.search.indexOf("avo_debug=1") > -1) ||
        (options.webDebugger !== false && __AVO_ENV__ !== "prod"));
    if (!__AVO_NOOP__ && options.inspector !== undefined) {
      __INSPECTOR__ = options.inspector;
    } else if (__AVO_ENV__ !== "prod") {
      InternalAvoLogger.warn("Avo Inspector not provided in initAvo() call");
    }
    if (__AVO_ENV__ !== "prod") {
      __AVO_DEV__ = true;
    }

    destinationOptions = destinationOptions || {};

    if (__WEB_DEBUGGER__ && !__AVO_NOOP__) {
      if (options.webDebuggerOptions && options.webDebuggerOptions.position) {
        const { BOTTOM_RIGHT, BOTTOM_LEFT, TOP_RIGHT, TOP_LEFT } =
          WebDebuggerPosition.position;

        try {
          WebDebuggerAssertions.assertKey(
            options.webDebuggerOptions.position,
            "position",
            (position) => {
              return (
                position === BOTTOM_RIGHT ||
                position === BOTTOM_LEFT ||
                position === TOP_RIGHT ||
                position === TOP_LEFT
              );
            }
          );
        } catch (e) {
          throw new Error(
            "WebDebugger: Position object incorrect. Use methods from WebDebuggerPosition."
          );
        }

        const top = options.webDebuggerOptions.position.top || 0;
        const right = options.webDebuggerOptions.position.right || 0;
        const bottom = options.webDebuggerOptions.position.bottom || 0;
        const left = options.webDebuggerOptions.position.left || 0;

        let positionParams;

        switch (options.webDebuggerOptions.position.position) {
          case BOTTOM_RIGHT:
            positionParams = {
              position: BOTTOM_RIGHT,
              bottom,
              right,
            };
            break;
          case BOTTOM_LEFT:
            positionParams = {
              position: BOTTOM_LEFT,
              bottom,
              left,
            };
            break;
          case TOP_RIGHT:
            positionParams = {
              position: TOP_RIGHT,
              top,
              right,
            };
            break;
          case TOP_LEFT:
            positionParams = {
              position: TOP_LEFT,
              top,
              left,
            };
            break;
          default:
            throw new Error(
              "WebDebugger: Position object incorrect. Use methods from WebDebuggerPosition."
            );
        }

        _avo_debugger_send_position(positionParams);
      }

      (function () {
        if (typeof window === "undefined") {
          return;
        }
        var init = function () {
          if (document.getElementById("avo-debugger") === null) {
            var iframe = document.createElement("iframe");
            document.body.appendChild(iframe);
            iframe.id = "avo-debugger";
            iframe.src = "https://www.avo.app/_debugger";
            iframe.style = "display: none;";
          }
        };

        if (document.body) {
          init();
        } else {
          document.addEventListener("DOMContentLoaded", init);
        }
      })();
    }
    if (!__AVO_NOOP__) {
      if (__AVO_ENV__ === "prod") {
      }
      if (__AVO_ENV__ === "dev") {
      }

      RudderStackWebDashboard = RudderStackWebDashboardDestination;
      if (__AVO_ENV__ === "prod") {
        RudderStackWebDashboard.make &&
          RudderStackWebDashboard.make(
            __AVO_ENV__,
            "2E2vo4MN3gqX9Eib7iONwRz2BFf"
          );
      } else if (__AVO_ENV__ === "dev") {
        RudderStackWebDashboard.make &&
          RudderStackWebDashboard.make(
            __AVO_ENV__,
            "2E2xG2xX2xnajbqHXZCLwISWAQC"
          );
      } else {
        console[__REPORT_FAILURE_AS__ || "error"](
          "[avo] No staging key is set for RudderStack - Web Dashboard. Head to destination settings in Avo to set a staging key."
        );
        RudderStackWebDashboard.make &&
          RudderStackWebDashboard.make(__AVO_ENV__, null);
      }

      SegmentWebDashboard = SegmentWebDashboardDestination;
      if (__AVO_ENV__ === "prod") {
        SegmentWebDashboard.make &&
          SegmentWebDashboard.make(
            __AVO_ENV__,
            "ohn1ATKcknwFfUL1PXBWNiLJB88fE6kw"
          );
      } else if (__AVO_ENV__ === "dev") {
        SegmentWebDashboard.make &&
          SegmentWebDashboard.make(
            __AVO_ENV__,
            "3qNww4BNRSzDwwiWDksXwwyKtxvL7Wup"
          );
      } else {
        console[__REPORT_FAILURE_AS__ || "error"](
          "[avo] No staging key is set for Segment - Web Dashboard. Head to destination settings in Avo to set a staging key."
        );
        SegmentWebDashboard.make && SegmentWebDashboard.make(__AVO_ENV__, null);
      }

      Mixpanel = MixpanelDestination;
      if (__AVO_ENV__ === "prod") {
        Mixpanel.make &&
          Mixpanel.make(__AVO_ENV__, "8a123cad9b17eec519eb596d7bf417d6");
      } else if (__AVO_ENV__ === "dev") {
        Mixpanel.make &&
          Mixpanel.make(__AVO_ENV__, "d8bc49894f145a52dd3103836577d1ce");
      } else {
        console[__REPORT_FAILURE_AS__ || "error"](
          "[avo] No staging key is set for Mixpanel. Head to destination settings in Avo to set a staging key."
        );
        Mixpanel.make && Mixpanel.make(__AVO_ENV__, null);
      }

      Braze = BrazeDestination;
      if (__AVO_ENV__ === "prod") {
        Braze.make && Braze.make(__AVO_ENV__, null);
      } else if (__AVO_ENV__ === "dev") {
        Braze.make && Braze.make(__AVO_ENV__, null);
      } else {
        console[__REPORT_FAILURE_AS__ || "error"](
          "[avo] No staging key is set for Braze. Head to destination settings in Avo to set a staging key."
        );
        Braze.make && Braze.make(__AVO_ENV__, null);
      }
      if (__AVO_DEV__) {
        // debug console in Avo
        _avo_invoke_meta(__AVO_ENV__, "init", [], "init");
      }
    }
  }

  /**
   * Signup Email Added: When a user sets their email in the signup flow and clicks continue
   *
   * When to trigger this event:
   * 1. User enters an acceptable email in the email input field
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/ypby_7b4MC/trigger/6atD_BDeG
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.emailAuthenticationMethod - This property describes how the user sets their email. Email authentication will either be manual or one of the social login providers. If the user does not use a social login, the authentication is manual.
   * @param {string} properties.emailValidationMethod - This property describes how the email was validated upon being set. The email address should primarily be validated by Sendgrid, but the user can optionally ignore any domain corrections.
   * @param {string} properties.adCategory - Category of the advertisement
   * @param {string} properties.url - Full page url
   * @param {string} properties.utmCampaign - Ad campaign from the UTM
   * @param {string} properties.utmContent - Content of the advertisement
   * @param {string} properties.utmSource - Source of the ad
   * @param {string} properties.email - Email address captured during event
   * @param {string} properties.platform - Platform the user was on at the time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/ypby_7b4MC}
   */
  function signupEmailAdded(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(
        assertEmailAuthenticationMethod(properties.emailAuthenticationMethod)
      );
      messages = messages.concat(
        assertEmailValidationMethod(properties.emailValidationMethod)
      );
      messages = messages.concat(assertAdCategory(properties.adCategory));
      messages = messages.concat(assertUrl(properties.url));
      messages = messages.concat(assertUTMCampaign(properties.utmCampaign));
      messages = messages.concat(assertUTMContent(properties.utmContent));
      messages = messages.concat(assertUTMSource(properties.utmSource));
      messages = messages.concat(assertEmail(properties.email));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Signup Email Added",
          Object.keys(properties),
          [
            "emailAuthenticationMethod",
            "emailValidationMethod",
            "adCategory",
            "url",
            "utmCampaign",
            "utmContent",
            "utmSource",
            "email",
            "platform",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "ypby_7b4MC",
          "8e676156a2549e14ec94f64347a6ce425eeb117bc09371cb2d7c9525e66d389d",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Signup Email Added",
        {
          "Email Authentication Method": properties.emailAuthenticationMethod,
          "Email Validation Method": properties.emailValidationMethod,
          "Ad Category": properties.adCategory,
          URL: properties.url,
          "UTM Campaign": properties.utmCampaign,
          "UTM Content": properties.utmContent,
          "UTM Source": properties.utmSource,
          Email: properties.email,
          Platform: properties.platform,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "ypby_7b4MC",
          "Signup Email Added",
          messages,
          [
            { id: "B3qjZSqogW", name: "URL", value: properties.url },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            { id: "KwJDoiNGCh", name: "Email", value: properties.email },
            {
              id: "WFrPJqTmcN",
              name: "Email Validation Method",
              value: properties.emailValidationMethod,
            },
            {
              id: "X0Bc-NE2Dt",
              name: "UTM Campaign",
              value: properties.utmCampaign,
            },
            {
              id: "XKoTMNW18o",
              name: "Ad Category",
              value: properties.adCategory,
            },
            {
              id: "cJhB1KlyFW",
              name: "Email Authentication Method",
              value: properties.emailAuthenticationMethod,
            },
            {
              id: "uFzvwV4V4V",
              name: "UTM Content",
              value: properties.utmContent,
            },
            {
              id: "yRYklsveXX",
              name: "UTM Source",
              value: properties.utmSource,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Signup Email Added': " + messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Signup Email Added",
          {
            "Email Authentication Method": properties.emailAuthenticationMethod,
            "Email Validation Method": properties.emailValidationMethod,
            "Ad Category": properties.adCategory,
            URL: properties.url,
            "UTM Campaign": properties.utmCampaign,
            "UTM Content": properties.utmContent,
            "UTM Source": properties.utmSource,
            Email: properties.email,
            Platform: properties.platform,
          },
          "ypby_7b4MC",
          "8e676156a2549e14ec94f64347a6ce425eeb117bc09371cb2d7c9525e66d389d"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Signup Email Added", {
        "Email Authentication Method": properties.emailAuthenticationMethod,
        "Email Validation Method": properties.emailValidationMethod,
        "Ad Category": properties.adCategory,
        URL: properties.url,
        "UTM Campaign": properties.utmCampaign,
        "UTM Content": properties.utmContent,
        "UTM Source": properties.utmSource,
        Email: properties.email,
        Platform: properties.platform,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Signup Email Added", {
        "Email Authentication Method": properties.emailAuthenticationMethod,
        "Email Validation Method": properties.emailValidationMethod,
        "Ad Category": properties.adCategory,
        URL: properties.url,
        "UTM Campaign": properties.utmCampaign,
        "UTM Content": properties.utmContent,
        "UTM Source": properties.utmSource,
        Email: properties.email,
        Platform: properties.platform,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Signup Email Added", {
        "Email Authentication Method": properties.emailAuthenticationMethod,
        "Email Validation Method": properties.emailValidationMethod,
        "Ad Category": properties.adCategory,
        URL: properties.url,
        "UTM Campaign": properties.utmCampaign,
        "UTM Content": properties.utmContent,
        "UTM Source": properties.utmSource,
        Email: properties.email,
        Platform: properties.platform,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Signup Completed: User completes the signup process and submits request to create account.
   *
   * When to trigger this event:
   * 1. User completes the signup with acceptable email and password
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/iih8W6z0Cf/trigger/lPhd-mcys
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.userId_ - The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
   * @param {string} properties.adCategory - Category of the advertisement
   * @param {string} properties.url - Full page url
   * @param {string} properties.utmCampaign - Ad campaign from the UTM
   * @param {string} properties.utmContent - Content of the advertisement
   * @param {string} properties.utmSource - Source of the ad
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.signupOriginProduct] - Product details of the 'get started' or 'signup' click-through
   * @param {string} [properties.signupOriginSubscription] - Product subscription details of the 'get started' or 'signup' click-through
   * @param {string} [properties.signupOriginBillingCycle] - Product subscription billing cycle details of the 'get started' or 'signup' click-through
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/iih8W6z0Cf}
   */
  function signupCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertUserId_(properties.userId_));
      messages = messages.concat(assertAdCategory(properties.adCategory));
      messages = messages.concat(assertUrl(properties.url));
      messages = messages.concat(assertUTMCampaign(properties.utmCampaign));
      messages = messages.concat(assertUTMContent(properties.utmContent));
      messages = messages.concat(assertUTMSource(properties.utmSource));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalSignupOriginProduct(properties.signupOriginProduct)
      );
      messages = messages.concat(
        assertOptionalSignupOriginSubscription(
          properties.signupOriginSubscription
        )
      );
      messages = messages.concat(
        assertOptionalSignupOriginBillingCycle(
          properties.signupOriginBillingCycle
        )
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Signup Completed",
          Object.keys(properties),
          [
            "userId_",
            "adCategory",
            "url",
            "utmCampaign",
            "utmContent",
            "utmSource",
            "platform",
            "signupOriginProduct",
            "signupOriginSubscription",
            "signupOriginBillingCycle",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "iih8W6z0Cf",
          "43f362231f36c1a8685dfe9ca99b7d3b2be4c49ea530c87b0368cb5e61084e61",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Signup Completed",
        {
          "Ad Category": properties.adCategory,
          URL: properties.url,
          "UTM Campaign": properties.utmCampaign,
          "UTM Content": properties.utmContent,
          "UTM Source": properties.utmSource,
          Platform: properties.platform,
          "Signup Origin Product": properties.signupOriginProduct,
          "Signup Origin Subscription": properties.signupOriginSubscription,
          "Signup Origin Billing Cycle": properties.signupOriginBillingCycle,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "iih8W6z0Cf",
          "Signup Completed",
          messages,
          [
            {
              id: "2jyHUaEjz",
              name: "Signup Origin Product",
              value: properties.signupOriginProduct,
            },
            { id: "B3qjZSqogW", name: "URL", value: properties.url },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "X0Bc-NE2Dt",
              name: "UTM Campaign",
              value: properties.utmCampaign,
            },
            {
              id: "XKoTMNW18o",
              name: "Ad Category",
              value: properties.adCategory,
            },
            {
              id: "fMsKmI16b",
              name: "Signup Origin Subscription",
              value: properties.signupOriginSubscription,
            },
            {
              id: "uFzvwV4V4V",
              name: "UTM Content",
              value: properties.utmContent,
            },
            {
              id: "yRYklsveXX",
              name: "UTM Source",
              value: properties.utmSource,
            },
            {
              id: "zpI7ysLkd",
              name: "Signup Origin Billing Cycle",
              value: properties.signupOriginBillingCycle,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Signup Completed': " + messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Signup Completed",
          {
            "Ad Category": properties.adCategory,
            URL: properties.url,
            "UTM Campaign": properties.utmCampaign,
            "UTM Content": properties.utmContent,
            "UTM Source": properties.utmSource,
            Platform: properties.platform,
            "Signup Origin Product": properties.signupOriginProduct,
            "Signup Origin Subscription": properties.signupOriginSubscription,
            "Signup Origin Billing Cycle": properties.signupOriginBillingCycle,
          },
          "iih8W6z0Cf",
          "43f362231f36c1a8685dfe9ca99b7d3b2be4c49ea530c87b0368cb5e61084e61"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.identify(properties.userId_);
      RudderStackWebDashboard.logEvent("Signup Completed", {
        "Ad Category": properties.adCategory,
        URL: properties.url,
        "UTM Campaign": properties.utmCampaign,
        "UTM Content": properties.utmContent,
        "UTM Source": properties.utmSource,
        Platform: properties.platform,
        "Signup Origin Product": properties.signupOriginProduct,
        "Signup Origin Subscription": properties.signupOriginSubscription,
        "Signup Origin Billing Cycle": properties.signupOriginBillingCycle,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.identify(properties.userId_);
      SegmentWebDashboard.logEvent("Signup Completed", {
        "Ad Category": properties.adCategory,
        URL: properties.url,
        "UTM Campaign": properties.utmCampaign,
        "UTM Content": properties.utmContent,
        "UTM Source": properties.utmSource,
        Platform: properties.platform,
        "Signup Origin Product": properties.signupOriginProduct,
        "Signup Origin Subscription": properties.signupOriginSubscription,
        "Signup Origin Billing Cycle": properties.signupOriginBillingCycle,
      });

      // destination Mixpanel
      Mixpanel.identify(properties.userId_);
      Mixpanel.logEvent("Signup Completed", {
        "Ad Category": properties.adCategory,
        URL: properties.url,
        "UTM Campaign": properties.utmCampaign,
        "UTM Content": properties.utmContent,
        "UTM Source": properties.utmSource,
        Platform: properties.platform,
        "Signup Origin Product": properties.signupOriginProduct,
        "Signup Origin Subscription": properties.signupOriginSubscription,
        "Signup Origin Billing Cycle": properties.signupOriginBillingCycle,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Signup Started: This event signals a user's first intent to signup.
   *
   * When to trigger this event:
   * 1. User lands on signup page on web
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/iVNgXz_huQ/trigger/6EANYZN3i
   * 2. Report recipient who is not a standlaone driver is viewing contacts dashboard and clicks sign up from shared reports page
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/iVNgXz_huQ/trigger/I_CPe3mgE
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.url - Full page url
   * @param {string} properties.adCategory - Category of the advertisement
   * @param {string} properties.utmSource - Source of the ad
   * @param {string} properties.utmCampaign - Ad campaign from the UTM
   * @param {string} properties.utmContent - Content of the advertisement
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.signupOriginProduct] - Product details of the 'get started' or 'signup' click-through
   * @param {string} [properties.signupOriginSubscription] - Product subscription details of the 'get started' or 'signup' click-through
   * @param {string} [properties.signupOriginBillingCycle] - Product subscription billing cycle details of the 'get started' or 'signup' click-through
   * @param {string} [properties.signupSource] - Now that we are adding other platforms like the contacts dashboard, we want to track where users are signing up from beyond platform like web/android/iOS without polluting that event.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/iVNgXz_huQ}
   */
  function signupStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertUrl(properties.url));
      messages = messages.concat(assertAdCategory(properties.adCategory));
      messages = messages.concat(assertUTMSource(properties.utmSource));
      messages = messages.concat(assertUTMCampaign(properties.utmCampaign));
      messages = messages.concat(assertUTMContent(properties.utmContent));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalSignupOriginProduct(properties.signupOriginProduct)
      );
      messages = messages.concat(
        assertOptionalSignupOriginSubscription(
          properties.signupOriginSubscription
        )
      );
      messages = messages.concat(
        assertOptionalSignupOriginBillingCycle(
          properties.signupOriginBillingCycle
        )
      );
      messages = messages.concat(
        assertOptionalSignupSource(properties.signupSource)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Signup Started",
          Object.keys(properties),
          [
            "url",
            "adCategory",
            "utmSource",
            "utmCampaign",
            "utmContent",
            "platform",
            "signupOriginProduct",
            "signupOriginSubscription",
            "signupOriginBillingCycle",
            "signupSource",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "iVNgXz_huQ",
          "1720485f4b0775ec04d0b7b8dd930f8b7503d9ca0c27970bccd82c44880cda39",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Signup Started",
        {
          URL: properties.url,
          "Ad Category": properties.adCategory,
          "UTM Source": properties.utmSource,
          "UTM Campaign": properties.utmCampaign,
          "UTM Content": properties.utmContent,
          Platform: properties.platform,
          "Signup Origin Product": properties.signupOriginProduct,
          "Signup Origin Subscription": properties.signupOriginSubscription,
          "Signup Origin Billing Cycle": properties.signupOriginBillingCycle,
          "Signup Source": properties.signupSource,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "iVNgXz_huQ",
          "Signup Started",
          messages,
          [
            {
              id: "2jyHUaEjz",
              name: "Signup Origin Product",
              value: properties.signupOriginProduct,
            },
            { id: "B3qjZSqogW", name: "URL", value: properties.url },
            {
              id: "BR56CVJcO",
              name: "Signup Source",
              value: properties.signupSource,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "X0Bc-NE2Dt",
              name: "UTM Campaign",
              value: properties.utmCampaign,
            },
            {
              id: "XKoTMNW18o",
              name: "Ad Category",
              value: properties.adCategory,
            },
            {
              id: "fMsKmI16b",
              name: "Signup Origin Subscription",
              value: properties.signupOriginSubscription,
            },
            {
              id: "uFzvwV4V4V",
              name: "UTM Content",
              value: properties.utmContent,
            },
            {
              id: "yRYklsveXX",
              name: "UTM Source",
              value: properties.utmSource,
            },
            {
              id: "zpI7ysLkd",
              name: "Signup Origin Billing Cycle",
              value: properties.signupOriginBillingCycle,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Signup Started': " + messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Signup Started",
          {
            URL: properties.url,
            "Ad Category": properties.adCategory,
            "UTM Source": properties.utmSource,
            "UTM Campaign": properties.utmCampaign,
            "UTM Content": properties.utmContent,
            Platform: properties.platform,
            "Signup Origin Product": properties.signupOriginProduct,
            "Signup Origin Subscription": properties.signupOriginSubscription,
            "Signup Origin Billing Cycle": properties.signupOriginBillingCycle,
            "Signup Source": properties.signupSource,
          },
          "iVNgXz_huQ",
          "1720485f4b0775ec04d0b7b8dd930f8b7503d9ca0c27970bccd82c44880cda39"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Signup Started", {
        URL: properties.url,
        "Ad Category": properties.adCategory,
        "UTM Source": properties.utmSource,
        "UTM Campaign": properties.utmCampaign,
        "UTM Content": properties.utmContent,
        Platform: properties.platform,
        "Signup Origin Product": properties.signupOriginProduct,
        "Signup Origin Subscription": properties.signupOriginSubscription,
        "Signup Origin Billing Cycle": properties.signupOriginBillingCycle,
        "Signup Source": properties.signupSource,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Signup Started", {
        URL: properties.url,
        "Ad Category": properties.adCategory,
        "UTM Source": properties.utmSource,
        "UTM Campaign": properties.utmCampaign,
        "UTM Content": properties.utmContent,
        Platform: properties.platform,
        "Signup Origin Product": properties.signupOriginProduct,
        "Signup Origin Subscription": properties.signupOriginSubscription,
        "Signup Origin Billing Cycle": properties.signupOriginBillingCycle,
        "Signup Source": properties.signupSource,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Signup Started", {
        URL: properties.url,
        "Ad Category": properties.adCategory,
        "UTM Source": properties.utmSource,
        "UTM Campaign": properties.utmCampaign,
        "UTM Content": properties.utmContent,
        Platform: properties.platform,
        "Signup Origin Product": properties.signupOriginProduct,
        "Signup Origin Subscription": properties.signupOriginSubscription,
        "Signup Origin Billing Cycle": properties.signupOriginBillingCycle,
        "Signup Source": properties.signupSource,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Overlay Item Interacted: A user's interaction with overlay items like popups or banners.
   *
   * When to trigger this event:
   * 1. Interacting with the Start your free trial modal
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/TwGaZ0X6bt/trigger/u3TfHAt2-
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.overlayCategory - Category of the overlay
   * @param {string} [properties.overlayDescription] - More details on the overlay in case there are multiple overlays for one category
   * @param {string} properties.overlayType - Type of overlay displayed
   * @param {string} [properties.overlayCta] - The Call to Action of the overlay.
   * @param {string} properties.overlayInteraction - User's interaction with the display.
   * @param {string} properties.platform - Platform the user was on at the time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/TwGaZ0X6bt}
   */
  function overlayItemInteracted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(
        assertOverlayCategory(properties.overlayCategory)
      );
      messages = messages.concat(
        assertOptionalOverlayDescription(properties.overlayDescription)
      );
      messages = messages.concat(assertOverlayType(properties.overlayType));
      messages = messages.concat(
        assertOptionalOverlayCTA(properties.overlayCta)
      );
      messages = messages.concat(
        assertOverlayInteraction(properties.overlayInteraction)
      );
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Overlay Item Interacted",
          Object.keys(properties),
          [
            "overlayCategory",
            "overlayDescription",
            "overlayType",
            "overlayCta",
            "overlayInteraction",
            "platform",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "TwGaZ0X6bt",
          "bd58423c5a531dc17884699f2428f65eefb28c78a4a94f94f1baa42a1512bffa",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Overlay Item Interacted",
        {
          "Overlay Category": properties.overlayCategory,
          "Overlay Description": properties.overlayDescription,
          "Overlay Type": properties.overlayType,
          "Overlay CTA": properties.overlayCta,
          "Overlay Interaction": properties.overlayInteraction,
          Platform: properties.platform,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "TwGaZ0X6bt",
          "Overlay Item Interacted",
          messages,
          [
            {
              id: "5ZszlqnTtw",
              name: "Overlay CTA",
              value: properties.overlayCta,
            },
            {
              id: "73yZ69XG6-",
              name: "Overlay Interaction",
              value: properties.overlayInteraction,
            },
            {
              id: "CSsraVojcP",
              name: "Overlay Type",
              value: properties.overlayType,
            },
            {
              id: "D3qM3rRSyw",
              name: "Overlay Category",
              value: properties.overlayCategory,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "v0ylP6zR_w",
              name: "Overlay Description",
              value: properties.overlayDescription,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Overlay Item Interacted': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Overlay Item Interacted",
          {
            "Overlay Category": properties.overlayCategory,
            "Overlay Description": properties.overlayDescription,
            "Overlay Type": properties.overlayType,
            "Overlay CTA": properties.overlayCta,
            "Overlay Interaction": properties.overlayInteraction,
            Platform: properties.platform,
          },
          "TwGaZ0X6bt",
          "bd58423c5a531dc17884699f2428f65eefb28c78a4a94f94f1baa42a1512bffa"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Overlay Item Interacted", {
        "Overlay Category": properties.overlayCategory,
        "Overlay Description": properties.overlayDescription,
        "Overlay Type": properties.overlayType,
        "Overlay CTA": properties.overlayCta,
        "Overlay Interaction": properties.overlayInteraction,
        Platform: properties.platform,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Overlay Item Interacted", {
        "Overlay Category": properties.overlayCategory,
        "Overlay Description": properties.overlayDescription,
        "Overlay Type": properties.overlayType,
        "Overlay CTA": properties.overlayCta,
        "Overlay Interaction": properties.overlayInteraction,
        Platform: properties.platform,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Overlay Item Interacted", {
        "Overlay Category": properties.overlayCategory,
        "Overlay Description": properties.overlayDescription,
        "Overlay Type": properties.overlayType,
        "Overlay CTA": properties.overlayCta,
        "Overlay Interaction": properties.overlayInteraction,
        Platform: properties.platform,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Login Started: User starts the login flow
   *
   * When to trigger this event:
   * 1. If a standalone user receives a report email and is viewing the contacts dashboard but they aren't logged in to their MileIQ account, they can login from the Shared Reports page.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/RVGbFdf4ox/trigger/qgG0oHZF1
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.loginSource] - Now that we are adding other platforms like the contacts dashboard, we want to track where users are logging in from beyond platform like web/android/iOS without polluting that event.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/RVGbFdf4ox}
   */
  function loginStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalLoginSource(properties.loginSource)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Login Started",
          Object.keys(properties),
          ["platform", "loginSource"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "RVGbFdf4ox",
          "8a6802f50d4ae8c6e13246c3819815d1841ad143dac37f93f7c3865dc29d9c08",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Login Started",
        {
          Platform: properties.platform,
          "Login Source": properties.loginSource,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "RVGbFdf4ox",
          "Login Started",
          messages,
          [
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "VeesjotyF",
              name: "Login Source",
              value: properties.loginSource,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Login Started': " + messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Login Started",
          {
            Platform: properties.platform,
            "Login Source": properties.loginSource,
          },
          "RVGbFdf4ox",
          "8a6802f50d4ae8c6e13246c3819815d1841ad143dac37f93f7c3865dc29d9c08"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Login Started", {
        Platform: properties.platform,
        "Login Source": properties.loginSource,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Login Started", {
        Platform: properties.platform,
        "Login Source": properties.loginSource,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Login Started", {
        Platform: properties.platform,
        "Login Source": properties.loginSource,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Login Email Added: User adds their email address to the login flow and continue to add password.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.email - Email address captured during event
   * @param {string} properties.platform - Platform the user was on at the time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/rDNjtwGRxL}
   */
  function loginEmailAdded(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertEmail(properties.email));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Login Email Added",
          Object.keys(properties),
          ["email", "platform"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "rDNjtwGRxL",
          "4eedf527ba8ceaa2ad0f4adf1cb26e0633072a52a1e21e569a2ab7ff4c92e7e8",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Login Email Added",
        {
          Email: properties.email,
          Platform: properties.platform,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "rDNjtwGRxL",
          "Login Email Added",
          messages,
          [
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            { id: "KwJDoiNGCh", name: "Email", value: properties.email },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Login Email Added': " + messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Login Email Added",
          {
            Email: properties.email,
            Platform: properties.platform,
          },
          "rDNjtwGRxL",
          "4eedf527ba8ceaa2ad0f4adf1cb26e0633072a52a1e21e569a2ab7ff4c92e7e8"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Login Email Added", {
        Email: properties.email,
        Platform: properties.platform,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Login Email Added", {
        Email: properties.email,
        Platform: properties.platform,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Login Email Added", {
        Email: properties.email,
        Platform: properties.platform,
      });

      // destination Braze
      Braze.logEvent("Login Email Added", {
        Email: properties.email,
        Platform: properties.platform,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Login Completed: User completes login flow
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.userId_ - The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
   * @param {string} properties.loginSessionPreference - User's preference for single or multi-session login (remember me)

Single Session - user does not select 'remember me'
Multi Session - user selected 'remember me'
   * @param {string} properties.platform - Platform the user was on at the time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/Hn3NSgikAE}
   */
  function loginCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertUserId_(properties.userId_));
      messages = messages.concat(
        assertLoginSessionPreference(properties.loginSessionPreference)
      );
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Login Completed",
          Object.keys(properties),
          ["userId_", "loginSessionPreference", "platform"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "Hn3NSgikAE",
          "67df6f3693c70e19a21aa231f5e79b4bbaeff428ea377f6786feb9173b0cb381",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Login Completed",
        {
          "Login Session Preference": properties.loginSessionPreference,
          Platform: properties.platform,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "Hn3NSgikAE",
          "Login Completed",
          messages,
          [
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "KjfLC6Db-r",
              name: "Login Session Preference",
              value: properties.loginSessionPreference,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Login Completed': " + messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Login Completed",
          {
            "Login Session Preference": properties.loginSessionPreference,
            Platform: properties.platform,
          },
          "Hn3NSgikAE",
          "67df6f3693c70e19a21aa231f5e79b4bbaeff428ea377f6786feb9173b0cb381"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.identify(properties.userId_);
      RudderStackWebDashboard.logEvent("Login Completed", {
        "Login Session Preference": properties.loginSessionPreference,
        Platform: properties.platform,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.identify(properties.userId_);
      SegmentWebDashboard.logEvent("Login Completed", {
        "Login Session Preference": properties.loginSessionPreference,
        Platform: properties.platform,
      });

      // destination Mixpanel
      Mixpanel.identify(properties.userId_);
      Mixpanel.logEvent("Login Completed", {
        "Login Session Preference": properties.loginSessionPreference,
        Platform: properties.platform,
      });

      // destination Braze
      Braze.identify(properties.userId_);
      Braze.logEvent("Login Completed", {
        "Login Session Preference": properties.loginSessionPreference,
        Platform: properties.platform,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Password Reset Started: User starts the password reset flow
   *
   * When to trigger this event:
   * 1. User starts the password reset through Change Password option
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/nReCnWEmwZ/trigger/17Kh4vS69
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.email - Email address captured during event
   * @param {string} properties.platform - Platform the user was on at the time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/nReCnWEmwZ}
   */
  function passwordResetStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertEmail(properties.email));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Password Reset Started",
          Object.keys(properties),
          ["email", "platform"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "nReCnWEmwZ",
          "65bb95a7cf5c367c9d6b6dfd3bf97c26966c61a3d3ecd53c834207c6d3dedffe",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Password Reset Started",
        {
          Email: properties.email,
          Platform: properties.platform,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "nReCnWEmwZ",
          "Password Reset Started",
          messages,
          [
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            { id: "KwJDoiNGCh", name: "Email", value: properties.email },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Password Reset Started': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Password Reset Started",
          {
            Email: properties.email,
            Platform: properties.platform,
          },
          "nReCnWEmwZ",
          "65bb95a7cf5c367c9d6b6dfd3bf97c26966c61a3d3ecd53c834207c6d3dedffe"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Password Reset Started", {
        Email: properties.email,
        Platform: properties.platform,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Password Reset Started", {
        Email: properties.email,
        Platform: properties.platform,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Password Reset Started", {
        Email: properties.email,
        Platform: properties.platform,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Password Reset Requested: User requests password reset after starting the reset password flow
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.email - Email address captured during event
   * @param {string} properties.platform - Platform the user was on at the time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/VvpFquu3Ap}
   */
  function passwordResetRequested(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertEmail(properties.email));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Password Reset Requested",
          Object.keys(properties),
          ["email", "platform"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "VvpFquu3Ap",
          "f584012cb51d6852ea7214d7a19ce2ab452bd02c3f5f2ce5e12923c197a89545",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Password Reset Requested",
        {
          Email: properties.email,
          Platform: properties.platform,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "VvpFquu3Ap",
          "Password Reset Requested",
          messages,
          [
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            { id: "KwJDoiNGCh", name: "Email", value: properties.email },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Password Reset Requested': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Password Reset Requested",
          {
            Email: properties.email,
            Platform: properties.platform,
          },
          "VvpFquu3Ap",
          "f584012cb51d6852ea7214d7a19ce2ab452bd02c3f5f2ce5e12923c197a89545"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Password Reset Requested", {
        Email: properties.email,
        Platform: properties.platform,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Password Reset Requested", {
        Email: properties.email,
        Platform: properties.platform,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Password Reset Requested", {
        Email: properties.email,
        Platform: properties.platform,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Password Reset Completed: User completes the password reset flow by successfully confirming the new password. If the password reset fails after clicking confirm it should trigger a different event.
   *
   * When to trigger this event:
   * 1. User completes the password reset through the Change Password flow
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/-BVzXjHNfW/trigger/l2zev4fEi
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.email - Email address captured during event
   * @param {string} properties.platform - Platform the user was on at the time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/-BVzXjHNfW}
   */
  function passwordResetCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertEmail(properties.email));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Password Reset Completed",
          Object.keys(properties),
          ["email", "platform"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "-BVzXjHNfW",
          "666a1383bc52a1fab49e8851b1c801972f14a389a512c99551034cbe0adaab5d",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Password Reset Completed",
        {
          Email: properties.email,
          Platform: properties.platform,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "-BVzXjHNfW",
          "Password Reset Completed",
          messages,
          [
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            { id: "KwJDoiNGCh", name: "Email", value: properties.email },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Password Reset Completed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Password Reset Completed",
          {
            Email: properties.email,
            Platform: properties.platform,
          },
          "-BVzXjHNfW",
          "666a1383bc52a1fab49e8851b1c801972f14a389a512c99551034cbe0adaab5d"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Password Reset Completed", {
        Email: properties.email,
        Platform: properties.platform,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Password Reset Completed", {
        Email: properties.email,
        Platform: properties.platform,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Password Reset Completed", {
        Email: properties.email,
        Platform: properties.platform,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Login Failed: User's login attempt fails. Login failure point is detailed in the properties.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} properties.email - Email address captured during event
   * @param {string} properties.loginFailure - The reason of failure of the login.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/XATaEEfQ8a}
   */
  function loginFailed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertEmail(properties.email));
      messages = messages.concat(assertLoginFailure(properties.loginFailure));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Login Failed",
          Object.keys(properties),
          ["platform", "email", "loginFailure"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "XATaEEfQ8a",
          "777b85783119d26b950c15f6462e0a58b0d0418a7fc0a9679e171b01024a85ce",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Login Failed",
        {
          Platform: properties.platform,
          Email: properties.email,
          "Login Failure": properties.loginFailure,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "XATaEEfQ8a",
          "Login Failed",
          messages,
          [
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "Gq94nV2ad3",
              name: "Login Failure",
              value: properties.loginFailure,
            },
            { id: "KwJDoiNGCh", name: "Email", value: properties.email },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Login Failed': " + messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Login Failed",
          {
            Platform: properties.platform,
            Email: properties.email,
            "Login Failure": properties.loginFailure,
          },
          "XATaEEfQ8a",
          "777b85783119d26b950c15f6462e0a58b0d0418a7fc0a9679e171b01024a85ce"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Login Failed", {
        Platform: properties.platform,
        Email: properties.email,
        "Login Failure": properties.loginFailure,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Login Failed", {
        Platform: properties.platform,
        Email: properties.email,
        "Login Failure": properties.loginFailure,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Login Failed", {
        Platform: properties.platform,
        Email: properties.email,
        "Login Failure": properties.loginFailure,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Password Reset Failed: User fails to reset their password due to an expected failure point.
   *
   * When to trigger this event:
   * 1. User clicks Confirm with a password that does not meet password criteria.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/s9ElIJZIU8/trigger/g3I7V-x-E
   * 2. User hits a failure point in the Change Password flow
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/s9ElIJZIU8/trigger/BBnQIet4V
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.email - Email address captured during event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {Array<string>} properties.passwordResetFailure - Failure(s) of the password reset. At least one failure criteria must be met:
- Length, password does not have enough characters
- Digit, password does not contain the required amount of digits
- Lowercase, password does not contain the required amount of lowercase characters
- Uppercase, password does not contain the required amount of uppercase characters
- Special Character, password does not contain the required amount of special characters
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/s9ElIJZIU8}
   */
  function passwordResetFailed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertEmail(properties.email));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertPasswordResetFailure(properties.passwordResetFailure)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Password Reset Failed",
          Object.keys(properties),
          ["email", "platform", "passwordResetFailure"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "s9ElIJZIU8",
          "e8f65d0d9c193cae8bda0266b1142fda2306b03540a6e02a002c14a7bdf1a32c",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Password Reset Failed",
        {
          Email: properties.email,
          Platform: properties.platform,
          "Password Reset Failure": properties.passwordResetFailure,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "s9ElIJZIU8",
          "Password Reset Failed",
          messages,
          [
            {
              id: "1Bskghj-kT",
              name: "Password Reset Failure",
              value: properties.passwordResetFailure,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            { id: "KwJDoiNGCh", name: "Email", value: properties.email },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Password Reset Failed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Password Reset Failed",
          {
            Email: properties.email,
            Platform: properties.platform,
            "Password Reset Failure": properties.passwordResetFailure,
          },
          "s9ElIJZIU8",
          "e8f65d0d9c193cae8bda0266b1142fda2306b03540a6e02a002c14a7bdf1a32c"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Password Reset Failed", {
        Email: properties.email,
        Platform: properties.platform,
        "Password Reset Failure": properties.passwordResetFailure,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Password Reset Failed", {
        Email: properties.email,
        Platform: properties.platform,
        "Password Reset Failure": properties.passwordResetFailure,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Password Reset Failed", {
        Email: properties.email,
        Platform: properties.platform,
        "Password Reset Failure": properties.passwordResetFailure,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Upgrade Started: User starts the upgrade process once presented with the upgrade options.
   *
   * When to trigger this event:
   * 1. User clicks on one of the plans to subscribe.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/heQmfKl-LVC/trigger/HzkgiMdf4
   * 2. User starts the upgrade flow from the subscription page on any of the CTAs.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/heQmfKl-LVC/trigger/-wC2kRKNM
   * 3. Upgrade from Drives Page
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/heQmfKl-LVC/trigger/hqQV2b4Lb
   * 4. Start Upgrade from Sidebar
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/heQmfKl-LVC/trigger/jXpShtxF4
   * 5. User is directed to Stripe upgrade screen from the web signup flow for Unlimited Plan
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/heQmfKl-LVC/trigger/olu0pDxlB
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.subscriptionType] - Subscription interval type
   * @param {string} properties.upgradeSource - Describes the location of the upgrade screen.
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} properties.page - The page or screen in app or on the web where the event sourced from.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/heQmfKl-LVC}
   */
  function upgradeStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(
        assertOptionalSubscriptionType(properties.subscriptionType)
      );
      messages = messages.concat(assertUpgradeSource(properties.upgradeSource));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertPage(properties.page));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Upgrade Started",
          Object.keys(properties),
          ["subscriptionType", "upgradeSource", "platform", "page"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "heQmfKl-LVC",
          "fd75a4ee92746ca3d7c75ee5b9f28e225db8f488a565e3c2e19904017ea0c970",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Upgrade Started",
        {
          subscription_type: properties.subscriptionType,
          "Upgrade Source": properties.upgradeSource,
          Platform: properties.platform,
          Page: properties.page,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "heQmfKl-LVC",
          "Upgrade Started",
          messages,
          [
            { id: "4j_Pu5zIMW", name: "Page", value: properties.page },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "a2CcoRxZb0",
              name: "Upgrade Source",
              value: properties.upgradeSource,
            },
            {
              id: "rN6HAJ5vu",
              name: "subscription_type",
              value: properties.subscriptionType,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Upgrade Started': " + messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Upgrade Started",
          {
            subscription_type: properties.subscriptionType,
            "Upgrade Source": properties.upgradeSource,
            Platform: properties.platform,
            Page: properties.page,
          },
          "heQmfKl-LVC",
          "fd75a4ee92746ca3d7c75ee5b9f28e225db8f488a565e3c2e19904017ea0c970"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Upgrade Started", {
        subscription_type: properties.subscriptionType,
        "Upgrade Source": properties.upgradeSource,
        Platform: properties.platform,
        Page: properties.page,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Upgrade Started", {
        subscription_type: properties.subscriptionType,
        "Upgrade Source": properties.upgradeSource,
        Platform: properties.platform,
        Page: properties.page,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Upgrade Started", {
        subscription_type: properties.subscriptionType,
        "Upgrade Source": properties.upgradeSource,
        Platform: properties.platform,
        Page: properties.page,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Signup Started: User starts the signup process for Teams product.
   *
   * When to trigger this event:
   * 1. User clicks on the create a team CTA from Integrations page
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/coPRPTb9CG/trigger/TBZxYxLn-
   * 2. Start from profile dropdown
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/coPRPTb9CG/trigger/gUySPowwK
   * 3. Start from sidebar
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/coPRPTb9CG/trigger/dqCzlmq1x
   * 4. Start from Teams page
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/coPRPTb9CG/trigger/uvdnsrNtY
   * 5. Report recipient who is not a standalone driver clicks upsell CTA on Shared Reports section of contacts dashboard
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/coPRPTb9CG/trigger/x-uIAc99J
   * 6. Report recipient who is a standalone driver taps start free trial from upsell on shared with me section of contacts dashboard
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/coPRPTb9CG/trigger/I4yy3R3jE
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.teamsSignupSource - Source of the Call to Action to create a team. Typically a Get Started or Create Team button.
   * @param {string} properties.platform - Platform the user was on at the time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/coPRPTb9CG}
   */
  function teamsSignupStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(
        assertTeamsSignupSource(properties.teamsSignupSource)
      );
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Signup Started",
          Object.keys(properties),
          ["teamsSignupSource", "platform"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "coPRPTb9CG",
          "fe5fea8f8bf34e94aa824c9304413dd750b841e45bf6b0535cc35f14c6f5f757",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Signup Started",
        {
          "Teams Signup Source": properties.teamsSignupSource,
          Platform: properties.platform,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "coPRPTb9CG",
          "Teams Signup Started",
          messages,
          [
            {
              id: "AItZaE-Us-",
              name: "Teams Signup Source",
              value: properties.teamsSignupSource,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Signup Started': " + messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Signup Started",
          {
            "Teams Signup Source": properties.teamsSignupSource,
            Platform: properties.platform,
          },
          "coPRPTb9CG",
          "fe5fea8f8bf34e94aa824c9304413dd750b841e45bf6b0535cc35f14c6f5f757"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Signup Started", {
        "Teams Signup Source": properties.teamsSignupSource,
        Platform: properties.platform,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Teams Signup Started", {
        "Teams Signup Source": properties.teamsSignupSource,
        Platform: properties.platform,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Signup Started", {
        "Teams Signup Source": properties.teamsSignupSource,
        Platform: properties.platform,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Signup Step Completed: User completes a step in the teams signup process.
   *
   * When to trigger this event:
   * 1. User complete any of the signup steps:
Name Team
Select Features
Select Plan
Invite Users
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/WkVHMEIHRK/trigger/g4r-VOxM2
   * 2. Clicking the blue button. Step Name: Create Team. Free Trial: True.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/WkVHMEIHRK/trigger/u2rUG_37q
   * 3. Clicking the blue button. Step Name: Create Team. Free Trial: False.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/WkVHMEIHRK/trigger/z-i7NxfQG
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.teamsSignupStepName - Name of the Signup Step in the Teams funnel.
   * @param {int} properties.teamsSignupStepNumber - The Step Number in the Teams Signup Funnel. Step number is shown at the top of the screen.
   * @param {string} properties.teamsSignupStepInteraction - Interaction taken by user on the signup step. Completed if they complete the CTA. Skipped if the skip and move to the next step.
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.existingSaSubscription] - If the user is an existing premium standalone user (user has an existing standalone subscription) at the time of this event, log the payment platform and interval (monthly/annual) of their standalone subscription.  This can be used to customize the teams onboarding experience and to remind users to cancel their standalone subscription after they create or join a team.
   * @param {string} [properties.industry] - Industry in which the team's company operates, as selected by the admin creating the team.
   * @param {string} [properties.companySize] - Size (number of employees) of the company in which the team operates, as selected by the admin during teams creation.  Expressed as a range of the company head count, e.g. "1-10".
   * @param {bool} properties.freeTrial - Indicates whether the event is associated with a free trial plan.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/WkVHMEIHRK}
   */
  function teamsSignupStepCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(
        assertTeamsSignupStepName(properties.teamsSignupStepName)
      );
      messages = messages.concat(
        assertTeamsSignupStepNumber(properties.teamsSignupStepNumber)
      );
      messages = messages.concat(
        assertTeamsSignupStepInteraction(properties.teamsSignupStepInteraction)
      );
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalExistingSASubscription(properties.existingSaSubscription)
      );
      messages = messages.concat(assertOptionalIndustry(properties.industry));
      messages = messages.concat(
        assertOptionalCompanySize(properties.companySize)
      );
      messages = messages.concat(assertFreeTrial(properties.freeTrial));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Signup Step Completed",
          Object.keys(properties),
          [
            "teamsSignupStepName",
            "teamsSignupStepNumber",
            "teamsSignupStepInteraction",
            "platform",
            "existingSaSubscription",
            "industry",
            "companySize",
            "freeTrial",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "WkVHMEIHRK",
          "e701c187d5e1c68f8cb5ea737b09f42c1c848b6df0dac2fb5ec182c38cb1b0be",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Signup Step Completed",
        {
          "Teams Signup Step Name": properties.teamsSignupStepName,
          "Teams Signup Step Number": properties.teamsSignupStepNumber,
          "Teams Signup Step Interaction":
            properties.teamsSignupStepInteraction,
          Platform: properties.platform,
          "Existing SA Subscription": properties.existingSaSubscription,
          Industry: properties.industry,
          "Company Size": properties.companySize,
          "Free Trial": properties.freeTrial,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "WkVHMEIHRK",
          "Teams Signup Step Completed",
          messages,
          [
            {
              id: "2sbualRk4",
              name: "Existing SA Subscription",
              value: properties.existingSaSubscription,
            },
            {
              id: "34JIBRdGGG",
              name: "Teams Signup Step Name",
              value: properties.teamsSignupStepName,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "HpIIjC8z9E",
              name: "Teams Signup Step Number",
              value: properties.teamsSignupStepNumber,
            },
            {
              id: "Tvq2wwl5J",
              name: "Company Size",
              value: properties.companySize,
            },
            {
              id: "X4uy6Z1wSX",
              name: "Teams Signup Step Interaction",
              value: properties.teamsSignupStepInteraction,
            },
            {
              id: "dVaX1T1uG",
              name: "Free Trial",
              value: properties.freeTrial,
            },
            { id: "fU92KYufq", name: "Industry", value: properties.industry },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Signup Step Completed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Signup Step Completed",
          {
            "Teams Signup Step Name": properties.teamsSignupStepName,
            "Teams Signup Step Number": properties.teamsSignupStepNumber,
            "Teams Signup Step Interaction":
              properties.teamsSignupStepInteraction,
            Platform: properties.platform,
            "Existing SA Subscription": properties.existingSaSubscription,
            Industry: properties.industry,
            "Company Size": properties.companySize,
            "Free Trial": properties.freeTrial,
          },
          "WkVHMEIHRK",
          "e701c187d5e1c68f8cb5ea737b09f42c1c848b6df0dac2fb5ec182c38cb1b0be"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Signup Step Completed", {
        "Teams Signup Step Name": properties.teamsSignupStepName,
        "Teams Signup Step Number": properties.teamsSignupStepNumber,
        "Teams Signup Step Interaction": properties.teamsSignupStepInteraction,
        Platform: properties.platform,
        "Existing SA Subscription": properties.existingSaSubscription,
        Industry: properties.industry,
        "Company Size": properties.companySize,
        "Free Trial": properties.freeTrial,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Teams Signup Step Completed", {
        "Teams Signup Step Name": properties.teamsSignupStepName,
        "Teams Signup Step Number": properties.teamsSignupStepNumber,
        "Teams Signup Step Interaction": properties.teamsSignupStepInteraction,
        Platform: properties.platform,
        "Existing SA Subscription": properties.existingSaSubscription,
        Industry: properties.industry,
        "Company Size": properties.companySize,
        "Free Trial": properties.freeTrial,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Signup Step Completed", {
        "Teams Signup Step Name": properties.teamsSignupStepName,
        "Teams Signup Step Number": properties.teamsSignupStepNumber,
        "Teams Signup Step Interaction": properties.teamsSignupStepInteraction,
        Platform: properties.platform,
        "Existing SA Subscription": properties.existingSaSubscription,
        Industry: properties.industry,
        "Company Size": properties.companySize,
        "Free Trial": properties.freeTrial,
      });

      // destination Braze
      Braze.logEvent("Teams Signup Step Completed", {
        "Teams Signup Step Name": properties.teamsSignupStepName,
        "Teams Signup Step Number": properties.teamsSignupStepNumber,
        "Teams Signup Step Interaction": properties.teamsSignupStepInteraction,
        Platform: properties.platform,
        "Existing SA Subscription": properties.existingSaSubscription,
        Industry: properties.industry,
        "Company Size": properties.companySize,
        "Free Trial": properties.freeTrial,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Signup Completed: User completes the signup process for Teams.
   *
   * When to trigger this event:
   * 1. User completes the Team signup flow and Team is created.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/SfUGqoj3W5/trigger/s_R6mOxd0
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {int} [properties.teamsPlanId] - Plan Type ID of the Team at time of event. If a team is not on a plan, do not send property.
   * @param {string} [properties.teamsPlanName] - Name of the Team's plan at time of event. If a team is not on a plan, do not send property.
   * @param {int} properties.teamsSeatsPurchaseCount - Number of teams seats purchased at time of event.
   * @param {bool} [properties.freeTrial] - Indicates whether the event is associated with a free trial plan.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/SfUGqoj3W5}
   */
  function teamsSignupCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalTeamsPlanID(properties.teamsPlanId)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanName(properties.teamsPlanName)
      );
      messages = messages.concat(
        assertTeamsSeatsPurchaseCount(properties.teamsSeatsPurchaseCount)
      );
      messages = messages.concat(assertOptionalFreeTrial(properties.freeTrial));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Signup Completed",
          Object.keys(properties),
          [
            "platform",
            "teamsPlanId",
            "teamsPlanName",
            "teamsSeatsPurchaseCount",
            "freeTrial",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "SfUGqoj3W5",
          "912c418b1b3b1e1957e3b3c4645af46e47314dfa4dd5f39045cce72a0ee4296e",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Signup Completed",
        {
          Platform: properties.platform,
          "Teams Plan ID": properties.teamsPlanId,
          "Teams Plan Name": properties.teamsPlanName,
          "Teams Seats Purchase Count": properties.teamsSeatsPurchaseCount,
          "Free Trial": properties.freeTrial,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "SfUGqoj3W5",
          "Teams Signup Completed",
          messages,
          [
            {
              id: "125AY5RLNY",
              name: "Teams Plan Name",
              value: properties.teamsPlanName,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "TbSVW_o_GH",
              name: "Teams Plan ID",
              value: properties.teamsPlanId,
            },
            {
              id: "dVaX1T1uG",
              name: "Free Trial",
              value: properties.freeTrial,
            },
            {
              id: "o2HIGOy0wz",
              name: "Teams Seats Purchase Count",
              value: properties.teamsSeatsPurchaseCount,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Signup Completed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Signup Completed",
          {
            Platform: properties.platform,
            "Teams Plan ID": properties.teamsPlanId,
            "Teams Plan Name": properties.teamsPlanName,
            "Teams Seats Purchase Count": properties.teamsSeatsPurchaseCount,
            "Free Trial": properties.freeTrial,
          },
          "SfUGqoj3W5",
          "912c418b1b3b1e1957e3b3c4645af46e47314dfa4dd5f39045cce72a0ee4296e"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Signup Completed", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Seats Purchase Count": properties.teamsSeatsPurchaseCount,
        "Free Trial": properties.freeTrial,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Teams Signup Completed", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Seats Purchase Count": properties.teamsSeatsPurchaseCount,
        "Free Trial": properties.freeTrial,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Signup Completed", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Seats Purchase Count": properties.teamsSeatsPurchaseCount,
        "Free Trial": properties.freeTrial,
      });

      // destination Braze
      Braze.logEvent("Teams Signup Completed", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Seats Purchase Count": properties.teamsSeatsPurchaseCount,
        "Free Trial": properties.freeTrial,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Upgrade Started: Admin starts the process to upgrade Team's plan.
   *
   * When to trigger this event:
   * 1. User clicks through a CTA to upgrade Teams plan.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/Vi4CDDSqYB/trigger/1khsqSa3o
   * 2. Start through concur integration
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/Vi4CDDSqYB/trigger/1A12B8zYl
   * 3. Upgrade from the report reminders feature button, in the settings page
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/Vi4CDDSqYB/trigger/qMM-fPLl8
   * 4. Upgrade from A/R
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/Vi4CDDSqYB/trigger/03TVVX63Q
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} properties.teamsUpgradeSource - Source of the CTA to start the upgrade flow.
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.teamsUpgradeFeature] - The product feature associated with an upgrade CTA.  An indicator of the feature that prompted the admin to upgrade their plan.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/Vi4CDDSqYB}
   */
  function teamsUpgradeStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertTeamsUpgradeSource(properties.teamsUpgradeSource)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalTeamsUpgradeFeature(properties.teamsUpgradeFeature)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Upgrade Started",
          Object.keys(properties),
          [
            "platform",
            "teamsUpgradeSource",
            "organizationGroupId",
            "organizationId",
            "teamsUpgradeFeature",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "Vi4CDDSqYB",
          "5c82e6223951ca12b1bd585dfd72a132b406e6bd80defc93a36465399b43e29c",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Upgrade Started",
        {
          Platform: properties.platform,
          "Teams Upgrade Source": properties.teamsUpgradeSource,
          "Organization Group ID": properties.organizationGroupId,
          "Organization ID": properties.organizationId,
          "Teams Upgrade Feature": properties.teamsUpgradeFeature,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "Vi4CDDSqYB",
          "Teams Upgrade Started",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            {
              id: "FKrYUvbmL",
              name: "Teams Upgrade Feature",
              value: properties.teamsUpgradeFeature,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "USd0VeLlZc",
              name: "Teams Upgrade Source",
              value: properties.teamsUpgradeSource,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Upgrade Started': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Upgrade Started",
          {
            Platform: properties.platform,
            "Teams Upgrade Source": properties.teamsUpgradeSource,
            "Organization Group ID": properties.organizationGroupId,
            "Organization ID": properties.organizationId,
            "Teams Upgrade Feature": properties.teamsUpgradeFeature,
          },
          "Vi4CDDSqYB",
          "5c82e6223951ca12b1bd585dfd72a132b406e6bd80defc93a36465399b43e29c"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Upgrade Started", {
        Platform: properties.platform,
        "Teams Upgrade Source": properties.teamsUpgradeSource,
        "Organization Group ID": properties.organizationGroupId,
        "Organization ID": properties.organizationId,
        "Teams Upgrade Feature": properties.teamsUpgradeFeature,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Teams Upgrade Started", {
        Platform: properties.platform,
        "Teams Upgrade Source": properties.teamsUpgradeSource,
        "Organization Group ID": properties.organizationGroupId,
        "Organization ID": properties.organizationId,
        "Teams Upgrade Feature": properties.teamsUpgradeFeature,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Upgrade Started", {
        Platform: properties.platform,
        "Teams Upgrade Source": properties.teamsUpgradeSource,
        "Organization Group ID": properties.organizationGroupId,
        "Organization ID": properties.organizationId,
        "Teams Upgrade Feature": properties.teamsUpgradeFeature,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Upgrade Plan Selected: User selects a plan for upgrade
   *
   * When to trigger this event:
   * 1. User picks a plan and proceeds to confirmation
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/O8xWqDh3Nl/trigger/6zIuSLgVV
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {int} [properties.teamsPlanId] - Plan Type ID of the Team at time of event. If a team is not on a plan, do not send property.
   * @param {string} [properties.teamsPlanName] - Name of the Team's plan at time of event. If a team is not on a plan, do not send property.
   * @param {string} properties.teamsPlanSelectionName - Plan selected for upgrade.
   * @param {int} properties.teamsPlanSelectionId - ID of teams plan selected for upgrade
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/O8xWqDh3Nl}
   */
  function teamsUpgradePlanSelected(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalTeamsPlanID(properties.teamsPlanId)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanName(properties.teamsPlanName)
      );
      messages = messages.concat(
        assertTeamsPlanSelectionName(properties.teamsPlanSelectionName)
      );
      messages = messages.concat(
        assertTeamsPlanSelectionID(properties.teamsPlanSelectionId)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Upgrade Plan Selected",
          Object.keys(properties),
          [
            "platform",
            "teamsPlanId",
            "teamsPlanName",
            "teamsPlanSelectionName",
            "teamsPlanSelectionId",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "O8xWqDh3Nl",
          "10d5abc2b92c26e860a5df58789871e910f64114b150cc3e6474b0fbd2e654c0",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Upgrade Plan Selected",
        {
          Platform: properties.platform,
          "Teams Plan ID": properties.teamsPlanId,
          "Teams Plan Name": properties.teamsPlanName,
          "Teams Plan Selection Name": properties.teamsPlanSelectionName,
          "Teams Plan Selection ID": properties.teamsPlanSelectionId,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "O8xWqDh3Nl",
          "Teams Upgrade Plan Selected",
          messages,
          [
            {
              id: "125AY5RLNY",
              name: "Teams Plan Name",
              value: properties.teamsPlanName,
            },
            {
              id: "6pTFwqFl49",
              name: "Teams Plan Selection ID",
              value: properties.teamsPlanSelectionId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "T9hGL4ArX7",
              name: "Teams Plan Selection Name",
              value: properties.teamsPlanSelectionName,
            },
            {
              id: "TbSVW_o_GH",
              name: "Teams Plan ID",
              value: properties.teamsPlanId,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Upgrade Plan Selected': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Upgrade Plan Selected",
          {
            Platform: properties.platform,
            "Teams Plan ID": properties.teamsPlanId,
            "Teams Plan Name": properties.teamsPlanName,
            "Teams Plan Selection Name": properties.teamsPlanSelectionName,
            "Teams Plan Selection ID": properties.teamsPlanSelectionId,
          },
          "O8xWqDh3Nl",
          "10d5abc2b92c26e860a5df58789871e910f64114b150cc3e6474b0fbd2e654c0"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Upgrade Plan Selected", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan Selection Name": properties.teamsPlanSelectionName,
        "Teams Plan Selection ID": properties.teamsPlanSelectionId,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Teams Upgrade Plan Selected", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan Selection Name": properties.teamsPlanSelectionName,
        "Teams Plan Selection ID": properties.teamsPlanSelectionId,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Upgrade Plan Selected", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan Selection Name": properties.teamsPlanSelectionName,
        "Teams Plan Selection ID": properties.teamsPlanSelectionId,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Upgrade Completed: User completes the purchase/upgrade flow for Teams product
   *
   * When to trigger this event:
   * 1. User confirms upgrade or completes initial purchase of teams plan
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/9zjzgoiqyy/trigger/0L5Jot8zB
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {int} [properties.teamsPlanId] - Plan Type ID of the Team at time of event. If a team is not on a plan, do not send property.
   * @param {string} [properties.teamsPlanName] - Name of the Team's plan at time of event. If a team is not on a plan, do not send property.
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {int} properties.teamsSeatsPurchaseCount - Number of teams seats purchased at time of event.
   * @param {int} properties.teamsPlanSelectionId - ID of teams plan selected for upgrade
   * @param {string} properties.teamsPlanSelectionName - Plan selected for upgrade.
   * @param {int} properties.teamsDriverCount - Count of drivers in Team at time of event.
   * @param {bool} [properties.freeTrial] - Indicates whether the event is associated with a free trial plan.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/9zjzgoiqyy}
   */
  function teamsUpgradeCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalTeamsPlanID(properties.teamsPlanId)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanName(properties.teamsPlanName)
      );
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertTeamsSeatsPurchaseCount(properties.teamsSeatsPurchaseCount)
      );
      messages = messages.concat(
        assertTeamsPlanSelectionID(properties.teamsPlanSelectionId)
      );
      messages = messages.concat(
        assertTeamsPlanSelectionName(properties.teamsPlanSelectionName)
      );
      messages = messages.concat(
        assertTeamsDriverCount(properties.teamsDriverCount)
      );
      messages = messages.concat(assertOptionalFreeTrial(properties.freeTrial));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Upgrade Completed",
          Object.keys(properties),
          [
            "platform",
            "teamsPlanId",
            "teamsPlanName",
            "organizationId",
            "organizationGroupId",
            "teamsSeatsPurchaseCount",
            "teamsPlanSelectionId",
            "teamsPlanSelectionName",
            "teamsDriverCount",
            "freeTrial",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "9zjzgoiqyy",
          "361c5b56ebdc68a311f7648bc7258af1a2c7c95b98de7524a0007c4971d1584a",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Upgrade Completed",
        {
          Platform: properties.platform,
          "Teams Plan ID": properties.teamsPlanId,
          "Teams Plan Name": properties.teamsPlanName,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          "Teams Seats Purchase Count": properties.teamsSeatsPurchaseCount,
          "Teams Plan Selection ID": properties.teamsPlanSelectionId,
          "Teams Plan Selection Name": properties.teamsPlanSelectionName,
          "Teams Driver Count": properties.teamsDriverCount,
          "Free Trial": properties.freeTrial,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "9zjzgoiqyy",
          "Teams Upgrade Completed",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "125AY5RLNY",
              name: "Teams Plan Name",
              value: properties.teamsPlanName,
            },
            {
              id: "6pTFwqFl49",
              name: "Teams Plan Selection ID",
              value: properties.teamsPlanSelectionId,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "T9hGL4ArX7",
              name: "Teams Plan Selection Name",
              value: properties.teamsPlanSelectionName,
            },
            {
              id: "TbSVW_o_GH",
              name: "Teams Plan ID",
              value: properties.teamsPlanId,
            },
            {
              id: "dVaX1T1uG",
              name: "Free Trial",
              value: properties.freeTrial,
            },
            {
              id: "h2UcigKyW",
              name: "Teams Driver Count",
              value: properties.teamsDriverCount,
            },
            {
              id: "o2HIGOy0wz",
              name: "Teams Seats Purchase Count",
              value: properties.teamsSeatsPurchaseCount,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Upgrade Completed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Upgrade Completed",
          {
            Platform: properties.platform,
            "Teams Plan ID": properties.teamsPlanId,
            "Teams Plan Name": properties.teamsPlanName,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            "Teams Seats Purchase Count": properties.teamsSeatsPurchaseCount,
            "Teams Plan Selection ID": properties.teamsPlanSelectionId,
            "Teams Plan Selection Name": properties.teamsPlanSelectionName,
            "Teams Driver Count": properties.teamsDriverCount,
            "Free Trial": properties.freeTrial,
          },
          "9zjzgoiqyy",
          "361c5b56ebdc68a311f7648bc7258af1a2c7c95b98de7524a0007c4971d1584a"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Upgrade Completed", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Seats Purchase Count": properties.teamsSeatsPurchaseCount,
        "Teams Plan Selection ID": properties.teamsPlanSelectionId,
        "Teams Plan Selection Name": properties.teamsPlanSelectionName,
        "Teams Driver Count": properties.teamsDriverCount,
        "Free Trial": properties.freeTrial,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Teams Upgrade Completed", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Seats Purchase Count": properties.teamsSeatsPurchaseCount,
        "Teams Plan Selection ID": properties.teamsPlanSelectionId,
        "Teams Plan Selection Name": properties.teamsPlanSelectionName,
        "Teams Driver Count": properties.teamsDriverCount,
        "Free Trial": properties.freeTrial,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Upgrade Completed", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Seats Purchase Count": properties.teamsSeatsPurchaseCount,
        "Teams Plan Selection ID": properties.teamsPlanSelectionId,
        "Teams Plan Selection Name": properties.teamsPlanSelectionName,
        "Teams Driver Count": properties.teamsDriverCount,
        "Free Trial": properties.freeTrial,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Invite Started: Admin starts the process to invite team member(s)
   *
   * When to trigger this event:
   * 1. Admin clicks through to invite or lands on the invite page in onboarding
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/RyITye28Hw/trigger/tGjJtdyBb
   * 2. Triggers when an admin taps "Invite drivers" CTA on the admin dashboard overview page
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/RyITye28Hw/trigger/PH9lZuoZK
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} properties.teamsInviteSource - Starting point for the invite flow
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/RyITye28Hw}
   */
  function teamsInviteStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertTeamsInviteSource(properties.teamsInviteSource)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Invite Started",
          Object.keys(properties),
          ["platform", "teamsInviteSource"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "RyITye28Hw",
          "75f5b913c5cb645e585728823a5d6addb0e8d6fb1a2cb4a9cdebeede9ae6ac7a",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Invite Started",
        {
          Platform: properties.platform,
          "Teams Invite Source": properties.teamsInviteSource,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "RyITye28Hw",
          "Teams Invite Started",
          messages,
          [
            {
              id: "-4HuA8Lgpq",
              name: "Teams Invite Source",
              value: properties.teamsInviteSource,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Invite Started': " + messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Invite Started",
          {
            Platform: properties.platform,
            "Teams Invite Source": properties.teamsInviteSource,
          },
          "RyITye28Hw",
          "75f5b913c5cb645e585728823a5d6addb0e8d6fb1a2cb4a9cdebeede9ae6ac7a"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Invite Started", {
        Platform: properties.platform,
        "Teams Invite Source": properties.teamsInviteSource,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Teams Invite Started", {
        Platform: properties.platform,
        "Teams Invite Source": properties.teamsInviteSource,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Invite Started", {
        Platform: properties.platform,
        "Teams Invite Source": properties.teamsInviteSource,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Invite Email Added: Admin adds a user's email address to the invite flow
   *
   * When to trigger this event:
   * 1. User clicks through to proceed to confirmation after adding email(s) to invite flow
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/VnE1qXlQ_I/trigger/nKnFRZvCU
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.email - Email address captured during event
   * @param {string} properties.platform - Platform the user was on at the time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/VnE1qXlQ_I}
   */
  function teamsInviteEmailAdded(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertEmail(properties.email));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Invite Email Added",
          Object.keys(properties),
          ["email", "platform"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "VnE1qXlQ_I",
          "e81a6a4eeb22b80131dcdeb3cad9a6538fd94405533fb450217b6b5f811303ab",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Invite Email Added",
        {
          Email: properties.email,
          Platform: properties.platform,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "VnE1qXlQ_I",
          "Teams Invite Email Added",
          messages,
          [
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            { id: "KwJDoiNGCh", name: "Email", value: properties.email },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Invite Email Added': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Invite Email Added",
          {
            Email: properties.email,
            Platform: properties.platform,
          },
          "VnE1qXlQ_I",
          "e81a6a4eeb22b80131dcdeb3cad9a6538fd94405533fb450217b6b5f811303ab"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Invite Email Added", {
        Email: properties.email,
        Platform: properties.platform,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Teams Invite Email Added", {
        Email: properties.email,
        Platform: properties.platform,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Invite Email Added", {
        Email: properties.email,
        Platform: properties.platform,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Invite Completed: Admin completes the team member invite flow
   *
   * When to trigger this event:
   * 1. Admin completes the team member invite flow
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/QDGg1t-uTD/trigger/SSzTzmoxE
   * 2. Triggers when an admin taps "Confirm and invite" on confirm invitation screen from Users page on admin dashboard
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/QDGg1t-uTD/trigger/HyD6XCPXg
   *
   * @param {object} properties - the properties associatied with this event
   * @param {int} properties.teamsSeatsPurchaseCount - Number of teams seats purchased at time of event.
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {int} properties.inviteCount - Number of invited users to the team
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/QDGg1t-uTD}
   */
  function teamsInviteCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(
        assertTeamsSeatsPurchaseCount(properties.teamsSeatsPurchaseCount)
      );
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertInviteCount(properties.inviteCount));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Invite Completed",
          Object.keys(properties),
          ["teamsSeatsPurchaseCount", "platform", "inviteCount"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "QDGg1t-uTD",
          "bfc2c9a2b3d4b70a261cfc00ea02766d674565bd0ff40876c8c63271ea22991c",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Invite Completed",
        {
          "Teams Seats Purchase Count": properties.teamsSeatsPurchaseCount,
          Platform: properties.platform,
          "Invite Count": properties.inviteCount,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "QDGg1t-uTD",
          "Teams Invite Completed",
          messages,
          [
            {
              id: "9uGZsL65PR",
              name: "Invite Count",
              value: properties.inviteCount,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "o2HIGOy0wz",
              name: "Teams Seats Purchase Count",
              value: properties.teamsSeatsPurchaseCount,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Invite Completed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Invite Completed",
          {
            "Teams Seats Purchase Count": properties.teamsSeatsPurchaseCount,
            Platform: properties.platform,
            "Invite Count": properties.inviteCount,
          },
          "QDGg1t-uTD",
          "bfc2c9a2b3d4b70a261cfc00ea02766d674565bd0ff40876c8c63271ea22991c"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Invite Completed", {
        "Teams Seats Purchase Count": properties.teamsSeatsPurchaseCount,
        Platform: properties.platform,
        "Invite Count": properties.inviteCount,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Teams Invite Completed", {
        "Teams Seats Purchase Count": properties.teamsSeatsPurchaseCount,
        Platform: properties.platform,
        "Invite Count": properties.inviteCount,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Invite Completed", {
        "Teams Seats Purchase Count": properties.teamsSeatsPurchaseCount,
        Platform: properties.platform,
        "Invite Count": properties.inviteCount,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Invite Failed: Invite to team fails through user or backend error
   *
   * When to trigger this event:
   * 1. Users errors: Errors through by the frontend when email is incorrect or user exists in another team.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/0J2RZzEmYe/trigger/OcY0w3P47
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.inviteFailureReason - Failure types for invites
   * @param {string} properties.platform - Platform the user was on at the time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/0J2RZzEmYe}
   */
  function teamsInviteFailed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(
        assertInviteFailureReason(properties.inviteFailureReason)
      );
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Invite Failed",
          Object.keys(properties),
          ["inviteFailureReason", "platform"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "0J2RZzEmYe",
          "16c213d265e0e83b18016a19d748c9dc8d75a469a33dce1088209faff0b5b0e8",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Invite Failed",
        {
          "Invite Failure Reason": properties.inviteFailureReason,
          Platform: properties.platform,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "0J2RZzEmYe",
          "Teams Invite Failed",
          messages,
          [
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "I0lNR1CZs8",
              name: "Invite Failure Reason",
              value: properties.inviteFailureReason,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Invite Failed': " + messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Invite Failed",
          {
            "Invite Failure Reason": properties.inviteFailureReason,
            Platform: properties.platform,
          },
          "0J2RZzEmYe",
          "16c213d265e0e83b18016a19d748c9dc8d75a469a33dce1088209faff0b5b0e8"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Invite Failed", {
        "Invite Failure Reason": properties.inviteFailureReason,
        Platform: properties.platform,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Teams Invite Failed", {
        "Invite Failure Reason": properties.inviteFailureReason,
        Platform: properties.platform,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Invite Failed", {
        "Invite Failure Reason": properties.inviteFailureReason,
        Platform: properties.platform,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Deletion Started: Admin starts the process to delete a team
   *
   * When to trigger this event:
   * 1. Click on delete my team in settings
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/IsqE7agmO3/trigger/bY88TyfVh
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/IsqE7agmO3}
   */
  function teamsDeletionStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Deletion Started",
          Object.keys(properties),
          ["platform"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "IsqE7agmO3",
          "c72cec283863116a9d44621891c441a655a11e8b693290b218bfbb1503009263",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Deletion Started",
        {
          Platform: properties.platform,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "IsqE7agmO3",
          "Teams Deletion Started",
          messages,
          [{ id: "FfkzdkMHsZ", name: "Platform", value: properties.platform }],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Deletion Started': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Deletion Started",
          {
            Platform: properties.platform,
          },
          "IsqE7agmO3",
          "c72cec283863116a9d44621891c441a655a11e8b693290b218bfbb1503009263"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Deletion Started", {
        Platform: properties.platform,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Teams Deletion Started", {
        Platform: properties.platform,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Deletion Started", {
        Platform: properties.platform,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Deletion Completed: Admin successfully completes the deletion flow
   *
   * When to trigger this event:
   * 1. Complete the deletion flow and successfully click delete my team
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/i9laLPXM4x/trigger/1Hmub11Xl
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/i9laLPXM4x}
   */
  function teamsDeletionCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Deletion Completed",
          Object.keys(properties),
          ["platform"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "i9laLPXM4x",
          "10ed58742c90cfc3976e221dc6a395c16a3d93df01471044e32fa32717ed78b2",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Deletion Completed",
        {
          Platform: properties.platform,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "i9laLPXM4x",
          "Teams Deletion Completed",
          messages,
          [{ id: "FfkzdkMHsZ", name: "Platform", value: properties.platform }],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Deletion Completed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Deletion Completed",
          {
            Platform: properties.platform,
          },
          "i9laLPXM4x",
          "10ed58742c90cfc3976e221dc6a395c16a3d93df01471044e32fa32717ed78b2"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Deletion Completed", {
        Platform: properties.platform,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Teams Deletion Completed", {
        Platform: properties.platform,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Deletion Completed", {
        Platform: properties.platform,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Setting Updated: Admin updates a setting for their team
   *
   * When to trigger this event:
   * 1. Admin saves an update on the settings page
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/NSX6pKnfXy/trigger/y-77zOkoD
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} properties.teamSetting - Team setting available for update
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/NSX6pKnfXy}
   */
  function teamsSettingUpdated(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertTeamSetting(properties.teamSetting));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Setting Updated",
          Object.keys(properties),
          ["platform", "teamSetting"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "NSX6pKnfXy",
          "7ee3f7729821df62f5241e4da60884edf0abde5ad4acbf61fa0839704bd3dd66",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Setting Updated",
        {
          Platform: properties.platform,
          "Team Setting": properties.teamSetting,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "NSX6pKnfXy",
          "Teams Setting Updated",
          messages,
          [
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "QWZnW3egBF",
              name: "Team Setting",
              value: properties.teamSetting,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Setting Updated': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Setting Updated",
          {
            Platform: properties.platform,
            "Team Setting": properties.teamSetting,
          },
          "NSX6pKnfXy",
          "7ee3f7729821df62f5241e4da60884edf0abde5ad4acbf61fa0839704bd3dd66"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Setting Updated", {
        Platform: properties.platform,
        "Team Setting": properties.teamSetting,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Teams Setting Updated", {
        Platform: properties.platform,
        "Team Setting": properties.teamSetting,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Setting Updated", {
        Platform: properties.platform,
        "Team Setting": properties.teamSetting,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Help Selected: User clicks on the Help modal
   *
   * When to trigger this event:
   * 1. User clicks through for help
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/BoikcfseGB/trigger/wr77Ozpks
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/BoikcfseGB}
   */
  function helpSelected(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Help Selected",
          Object.keys(properties),
          ["platform"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "BoikcfseGB",
          "5503c9b184a55062d5df139ed0b191a198a1e5492648a35d704f755cc0dfed75",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Help Selected",
        {
          Platform: properties.platform,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "BoikcfseGB",
          "Help Selected",
          messages,
          [{ id: "FfkzdkMHsZ", name: "Platform", value: properties.platform }],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Help Selected': " + messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Help Selected",
          {
            Platform: properties.platform,
          },
          "BoikcfseGB",
          "5503c9b184a55062d5df139ed0b191a198a1e5492648a35d704f755cc0dfed75"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Help Selected", {
        Platform: properties.platform,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Help Selected", {
        Platform: properties.platform,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Help Selected", {
        Platform: properties.platform,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Remove User Started: Admin starts the process to remove a team member
   *
   * When to trigger this event:
   * 1. Admin clicks through the start a user removal flow
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/5-OMWtbdyT/trigger/UwKxyIZyP
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} properties.email - Email address captured during event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/5-OMWtbdyT}
   */
  function teamsRemoveUserStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertEmail(properties.email));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Remove User Started",
          Object.keys(properties),
          ["platform", "email"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "5-OMWtbdyT",
          "d28205d04133cb7662d77716bc9c3c3a572077106a4361c45b4b58db18a7f9ce",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Remove User Started",
        {
          Platform: properties.platform,
          Email: properties.email,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "5-OMWtbdyT",
          "Teams Remove User Started",
          messages,
          [
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            { id: "KwJDoiNGCh", name: "Email", value: properties.email },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Remove User Started': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Remove User Started",
          {
            Platform: properties.platform,
            Email: properties.email,
          },
          "5-OMWtbdyT",
          "d28205d04133cb7662d77716bc9c3c3a572077106a4361c45b4b58db18a7f9ce"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Remove User Started", {
        Platform: properties.platform,
        Email: properties.email,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Teams Remove User Started", {
        Platform: properties.platform,
        Email: properties.email,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Remove User Started", {
        Platform: properties.platform,
        Email: properties.email,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Remove User Completed: Admin successfully completes the user removal process
   *
   * When to trigger this event:
   * 1. Admin completes the user removal flow
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/TKh0WR_Zko/trigger/T3ohp2GRF
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.email - Email address captured during event
   * @param {string} properties.platform - Platform the user was on at the time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/TKh0WR_Zko}
   */
  function teamsRemoveUserCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertEmail(properties.email));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Remove User Completed",
          Object.keys(properties),
          ["email", "platform"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "TKh0WR_Zko",
          "07a6c0df5d8cb4066fdf2b7e1d53ef525d82140bde93cfe678502f3751c5fef7",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Remove User Completed",
        {
          Email: properties.email,
          Platform: properties.platform,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "TKh0WR_Zko",
          "Teams Remove User Completed",
          messages,
          [
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            { id: "KwJDoiNGCh", name: "Email", value: properties.email },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Remove User Completed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Remove User Completed",
          {
            Email: properties.email,
            Platform: properties.platform,
          },
          "TKh0WR_Zko",
          "07a6c0df5d8cb4066fdf2b7e1d53ef525d82140bde93cfe678502f3751c5fef7"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Remove User Completed", {
        Email: properties.email,
        Platform: properties.platform,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Teams Remove User Completed", {
        Email: properties.email,
        Platform: properties.platform,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Remove User Completed", {
        Email: properties.email,
        Platform: properties.platform,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Update User Started: Admin starts the process to update a team member's status
   *
   * When to trigger this event:
   * 1. Admin clicks through the upgrade or downgrade a user
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/0eqW6SPf9u/trigger/rPFzu4HYw
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.email - Email address captured during event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} properties.teamsUserUpdate - Type of update performed on team member
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/0eqW6SPf9u}
   */
  function teamsUpdateUserStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertEmail(properties.email));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertTeamsUserUpdate(properties.teamsUserUpdate)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Update User Started",
          Object.keys(properties),
          ["email", "platform", "teamsUserUpdate"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "0eqW6SPf9u",
          "04833b2ab0f9072b6421584dbbddde845f9c58b3c5dadae10b46ad639dab92b3",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Update User Started",
        {
          Email: properties.email,
          Platform: properties.platform,
          "Teams User Update": properties.teamsUserUpdate,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "0eqW6SPf9u",
          "Teams Update User Started",
          messages,
          [
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            { id: "KwJDoiNGCh", name: "Email", value: properties.email },
            {
              id: "c-453YUQ-v",
              name: "Teams User Update",
              value: properties.teamsUserUpdate,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Update User Started': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Update User Started",
          {
            Email: properties.email,
            Platform: properties.platform,
            "Teams User Update": properties.teamsUserUpdate,
          },
          "0eqW6SPf9u",
          "04833b2ab0f9072b6421584dbbddde845f9c58b3c5dadae10b46ad639dab92b3"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Update User Started", {
        Email: properties.email,
        Platform: properties.platform,
        "Teams User Update": properties.teamsUserUpdate,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Teams Update User Started", {
        Email: properties.email,
        Platform: properties.platform,
        "Teams User Update": properties.teamsUserUpdate,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Update User Started", {
        Email: properties.email,
        Platform: properties.platform,
        "Teams User Update": properties.teamsUserUpdate,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Update User Completed: Admin completes the process to update a team member
   *
   * When to trigger this event:
   * 1. Admin clicks through the complete the update user flow
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/9zOby0zRlS/trigger/9N9Ib5CL0
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.email - Email address captured during event
   * @param {string} properties.teamsUserUpdate - Type of update performed on team member
   * @param {string} properties.platform - Platform the user was on at the time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/9zOby0zRlS}
   */
  function teamsUpdateUserCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertEmail(properties.email));
      messages = messages.concat(
        assertTeamsUserUpdate(properties.teamsUserUpdate)
      );
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Update User Completed",
          Object.keys(properties),
          ["email", "teamsUserUpdate", "platform"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "9zOby0zRlS",
          "dec90db12966070b3ee8a9591b496bf34cd4b24ebd66cd83992b7e3f5cfa8f43",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Update User Completed",
        {
          Email: properties.email,
          "Teams User Update": properties.teamsUserUpdate,
          Platform: properties.platform,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "9zOby0zRlS",
          "Teams Update User Completed",
          messages,
          [
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            { id: "KwJDoiNGCh", name: "Email", value: properties.email },
            {
              id: "c-453YUQ-v",
              name: "Teams User Update",
              value: properties.teamsUserUpdate,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Update User Completed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Update User Completed",
          {
            Email: properties.email,
            "Teams User Update": properties.teamsUserUpdate,
            Platform: properties.platform,
          },
          "9zOby0zRlS",
          "dec90db12966070b3ee8a9591b496bf34cd4b24ebd66cd83992b7e3f5cfa8f43"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Update User Completed", {
        Email: properties.email,
        "Teams User Update": properties.teamsUserUpdate,
        Platform: properties.platform,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Teams Update User Completed", {
        Email: properties.email,
        "Teams User Update": properties.teamsUserUpdate,
        Platform: properties.platform,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Update User Completed", {
        Email: properties.email,
        "Teams User Update": properties.teamsUserUpdate,
        Platform: properties.platform,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Driver Report Downloaded: Admin selects a download method for a driver report
   *
   * When to trigger this event:
   * 1. Admin downloads a report from a Reports Page row
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/7OwXn9563r/trigger/2KItgy91F
   * 2. Admin downloads a report page sidebar
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/7OwXn9563r/trigger/9lwhyWUHq
   * 3. Admin downloads a report details sidebar
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/7OwXn9563r/trigger/IL2v0MLhb
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} properties.downloadFormat - File format of a report download
   * @param {string} properties.reportDownloadSource - Source of the report download
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {int} properties.subscriptionId - User's MileIQ Subscription ID at time of event
   * @param {int} [properties.numberOfReports] - Count of reports downloaded by download action
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/7OwXn9563r}
   */
  function driverReportDownloaded(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertDownloadFormat(properties.downloadFormat)
      );
      messages = messages.concat(
        assertReportDownloadSource(properties.reportDownloadSource)
      );
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertSubscriptionId(properties.subscriptionId)
      );
      messages = messages.concat(
        assertOptionalNumberOfReports(properties.numberOfReports)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Driver Report Downloaded",
          Object.keys(properties),
          [
            "platform",
            "downloadFormat",
            "reportDownloadSource",
            "organizationId",
            "organizationGroupId",
            "subscriptionId",
            "numberOfReports",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "7OwXn9563r",
          "04d70a94e72c92910e921eb073e49756e0bdc7ecee2693009a009d9a2b69ce52",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Driver Report Downloaded",
        {
          Platform: properties.platform,
          "Download Format": properties.downloadFormat,
          "Report Download Source": properties.reportDownloadSource,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          subscription_id: properties.subscriptionId,
          "Number of Reports": properties.numberOfReports,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "7OwXn9563r",
          "Driver Report Downloaded",
          messages,
          [
            {
              id: "-PkiBW72m",
              name: "Download Format",
              value: properties.downloadFormat,
            },
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "C1Tw7ptiU",
              name: "Report Download Source",
              value: properties.reportDownloadSource,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "TDTeQm2UP",
              name: "subscription_id",
              value: properties.subscriptionId,
            },
            {
              id: "TJoEB3Vqt",
              name: "Number of Reports",
              value: properties.numberOfReports,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Driver Report Downloaded': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Driver Report Downloaded",
          {
            Platform: properties.platform,
            "Download Format": properties.downloadFormat,
            "Report Download Source": properties.reportDownloadSource,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            subscription_id: properties.subscriptionId,
            "Number of Reports": properties.numberOfReports,
          },
          "7OwXn9563r",
          "04d70a94e72c92910e921eb073e49756e0bdc7ecee2693009a009d9a2b69ce52"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Driver Report Downloaded", {
        Platform: properties.platform,
        "Download Format": properties.downloadFormat,
        "Report Download Source": properties.reportDownloadSource,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        subscription_id: properties.subscriptionId,
        "Number of Reports": properties.numberOfReports,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Driver Report Downloaded", {
        Platform: properties.platform,
        "Download Format": properties.downloadFormat,
        "Report Download Source": properties.reportDownloadSource,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        subscription_id: properties.subscriptionId,
        "Number of Reports": properties.numberOfReports,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Driver Report Email Started: Admin starts process the email a report
   *
   * When to trigger this event:
   * 1. Admin clicks through the
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/HobKZeC7i8/trigger/J5nlkGYbP
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {string} properties.reportEmailSource - Source of action for emailing a report
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/HobKZeC7i8}
   */
  function driverReportEmailStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertReportEmailSource(properties.reportEmailSource)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Driver Report Email Started",
          Object.keys(properties),
          [
            "platform",
            "organizationId",
            "organizationGroupId",
            "reportEmailSource",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "HobKZeC7i8",
          "73f2cbec3edf0a04ba8f088c6c1d3865bc6019d7861fba4db28cd8bbb7d2f850",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Driver Report Email Started",
        {
          Platform: properties.platform,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          "Report Email Source": properties.reportEmailSource,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "HobKZeC7i8",
          "Driver Report Email Started",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "wVHtepkwX",
              name: "Report Email Source",
              value: properties.reportEmailSource,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Driver Report Email Started': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Driver Report Email Started",
          {
            Platform: properties.platform,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            "Report Email Source": properties.reportEmailSource,
          },
          "HobKZeC7i8",
          "73f2cbec3edf0a04ba8f088c6c1d3865bc6019d7861fba4db28cd8bbb7d2f850"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Driver Report Email Started", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Report Email Source": properties.reportEmailSource,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Driver Report Email Started", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Report Email Source": properties.reportEmailSource,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Driver Report Email Completed: Admin completes report email flow
   *
   * When to trigger this event:
   * 1. Admin clicks through to send a report in email
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/bQ_UJLNiQ_/trigger/Zhepvdzqv
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.email - Email address captured during event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} properties.reportEmailSource - Source of action for emailing a report
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/bQ_UJLNiQ_}
   */
  function driverReportEmailCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertEmail(properties.email));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertReportEmailSource(properties.reportEmailSource)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Driver Report Email Completed",
          Object.keys(properties),
          ["email", "platform", "reportEmailSource"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "bQ_UJLNiQ_",
          "30cca700bb5464386c2d055009afa1540d92e2be93aba1fd07876ce6172652b3",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Driver Report Email Completed",
        {
          Email: properties.email,
          Platform: properties.platform,
          "Report Email Source": properties.reportEmailSource,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "bQ_UJLNiQ_",
          "Driver Report Email Completed",
          messages,
          [
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            { id: "KwJDoiNGCh", name: "Email", value: properties.email },
            {
              id: "wVHtepkwX",
              name: "Report Email Source",
              value: properties.reportEmailSource,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Driver Report Email Completed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Driver Report Email Completed",
          {
            Email: properties.email,
            Platform: properties.platform,
            "Report Email Source": properties.reportEmailSource,
          },
          "bQ_UJLNiQ_",
          "30cca700bb5464386c2d055009afa1540d92e2be93aba1fd07876ce6172652b3"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Driver Report Email Completed", {
        Email: properties.email,
        Platform: properties.platform,
        "Report Email Source": properties.reportEmailSource,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Driver Report Email Completed", {
        Email: properties.email,
        Platform: properties.platform,
        "Report Email Source": properties.reportEmailSource,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Driver Report Rejection Started: Admin starts the process to reject a report submitted by driver
   *
   * When to trigger this event:
   * 1. Admin selects Reject Report
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/JXgjsZIpsA/trigger/EetCGW3Be
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/JXgjsZIpsA}
   */
  function driverReportRejectionStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Driver Report Rejection Started",
          Object.keys(properties),
          ["platform", "organizationId", "organizationGroupId"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "JXgjsZIpsA",
          "8dad7535133ef56b3c31d3dcf972fa84499b39fde53faa3ff5794556660af209",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Driver Report Rejection Started",
        {
          Platform: properties.platform,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "JXgjsZIpsA",
          "Driver Report Rejection Started",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Driver Report Rejection Started': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Driver Report Rejection Started",
          {
            Platform: properties.platform,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
          },
          "JXgjsZIpsA",
          "8dad7535133ef56b3c31d3dcf972fa84499b39fde53faa3ff5794556660af209"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Driver Report Rejection Started", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Driver Report Rejection Started", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Driver Report Rejection Started", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Driver Report Rejection Completed: Admin successfully completes the report rejection process
   *
   * When to trigger this event:
   * 1. Admin completes the report rejection
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/K0gkWjWzB6/trigger/5P6OnJsAo
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/K0gkWjWzB6}
   */
  function driverReportRejectionCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Driver Report Rejection Completed",
          Object.keys(properties),
          ["platform", "organizationId", "organizationGroupId"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "K0gkWjWzB6",
          "a5181bfac4d82362a68d20c950a20ff860c0849bb23a2fdcfbd0bc89fd80fcd0",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Driver Report Rejection Completed",
        {
          Platform: properties.platform,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "K0gkWjWzB6",
          "Driver Report Rejection Completed",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Driver Report Rejection Completed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Driver Report Rejection Completed",
          {
            Platform: properties.platform,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
          },
          "K0gkWjWzB6",
          "a5181bfac4d82362a68d20c950a20ff860c0849bb23a2fdcfbd0bc89fd80fcd0"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Driver Report Rejection Completed", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Driver Report Rejection Completed", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Driver Report Rejection Completed", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Driver Report Rejection Cancelled: Admin cancels the report rejection process
   *
   * When to trigger this event:
   * 1. Admin cancels the report rejection process by clicking on cancel
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/4reS1Tb28C/trigger/Ei9tM0ajf
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/4reS1Tb28C}
   */
  function driverReportRejectionCancelled(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Driver Report Rejection Cancelled",
          Object.keys(properties),
          ["platform", "organizationId", "organizationGroupId"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "4reS1Tb28C",
          "a22e7d27b443d72a9e32c3d004701b0993de8a0b40fcc371459f3c9e89187ae9",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Driver Report Rejection Cancelled",
        {
          Platform: properties.platform,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "4reS1Tb28C",
          "Driver Report Rejection Cancelled",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Driver Report Rejection Cancelled': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Driver Report Rejection Cancelled",
          {
            Platform: properties.platform,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
          },
          "4reS1Tb28C",
          "a22e7d27b443d72a9e32c3d004701b0993de8a0b40fcc371459f3c9e89187ae9"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Driver Report Rejection Cancelled", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Driver Report Rejection Cancelled", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Driver Report Rejection Cancelled", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Invite Accepted: Teams member accepts an invite
   *
   * When to trigger this event:
   * 1. User clicks on Accept Invitation
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/7lT6mRlnUL/trigger/aVEgoKwLL
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {bool} properties.acceptedFromEmailLink - Did the user accept the invite from the invite email link? If false, they accepted the invite after going to the website, creating an account, and being prompted to accept a team invite based on their email having been invited to a team.
   * @param {string} [properties.existingSaSubscription] - If the user is an existing premium standalone user (user has an existing standalone subscription) at the time of this event, log the payment platform and interval (monthly/annual) of their standalone subscription.  This can be used to customize the teams onboarding experience and to remind users to cancel their standalone subscription after they create or join a team.
   * @param {int} [properties.teamsPlanId] - Plan Type ID of the Team at time of event. If a team is not on a plan, do not send property.
   * @param {string} [properties.teamsPlanName] - Name of the Team's plan at time of event. If a team is not on a plan, do not send property.
   * @param {string} properties.teamName - Team name for Teams service events
   * @param {string} properties.teamUserRole - Permission assigned to a member within the team
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/7lT6mRlnUL}
   */
  function teamsInviteAccepted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertAcceptedFromEmailLink(properties.acceptedFromEmailLink)
      );
      messages = messages.concat(
        assertOptionalExistingSASubscription(properties.existingSaSubscription)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanID(properties.teamsPlanId)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanName(properties.teamsPlanName)
      );
      messages = messages.concat(assertTeamName(properties.teamName));
      messages = messages.concat(assertTeamUserRole(properties.teamUserRole));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Invite Accepted",
          Object.keys(properties),
          [
            "platform",
            "organizationId",
            "organizationGroupId",
            "acceptedFromEmailLink",
            "existingSaSubscription",
            "teamsPlanId",
            "teamsPlanName",
            "teamName",
            "teamUserRole",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "7lT6mRlnUL",
          "555a6f0670ce9e54e325bc04531f582cd14928e06f3f18050d798ae3e835647c",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Invite Accepted",
        {
          Platform: properties.platform,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          "Accepted From Email Link": properties.acceptedFromEmailLink,
          "Existing SA Subscription": properties.existingSaSubscription,
          "Teams Plan ID": properties.teamsPlanId,
          "Teams Plan Name": properties.teamsPlanName,
          "Team Name": properties.teamName,
          "Team User Role": properties.teamUserRole,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "7lT6mRlnUL",
          "Teams Invite Accepted",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "125AY5RLNY",
              name: "Teams Plan Name",
              value: properties.teamsPlanName,
            },
            {
              id: "2sbualRk4",
              name: "Existing SA Subscription",
              value: properties.existingSaSubscription,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "TbSVW_o_GH",
              name: "Teams Plan ID",
              value: properties.teamsPlanId,
            },
            {
              id: "YqoK2DIvT",
              name: "Team User Role",
              value: properties.teamUserRole,
            },
            {
              id: "h3S2U4O-Z",
              name: "Accepted From Email Link",
              value: properties.acceptedFromEmailLink,
            },
            { id: "zEyW0825ou", name: "Team Name", value: properties.teamName },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Invite Accepted': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Invite Accepted",
          {
            Platform: properties.platform,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            "Accepted From Email Link": properties.acceptedFromEmailLink,
            "Existing SA Subscription": properties.existingSaSubscription,
            "Teams Plan ID": properties.teamsPlanId,
            "Teams Plan Name": properties.teamsPlanName,
            "Team Name": properties.teamName,
            "Team User Role": properties.teamUserRole,
          },
          "7lT6mRlnUL",
          "555a6f0670ce9e54e325bc04531f582cd14928e06f3f18050d798ae3e835647c"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Invite Accepted", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Accepted From Email Link": properties.acceptedFromEmailLink,
        "Existing SA Subscription": properties.existingSaSubscription,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        "Team Name": properties.teamName,
        "Team User Role": properties.teamUserRole,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Teams Invite Accepted", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Accepted From Email Link": properties.acceptedFromEmailLink,
        "Existing SA Subscription": properties.existingSaSubscription,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        "Team Name": properties.teamName,
        "Team User Role": properties.teamUserRole,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Invite Accepted", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Accepted From Email Link": properties.acceptedFromEmailLink,
        "Existing SA Subscription": properties.existingSaSubscription,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        "Team Name": properties.teamName,
        "Team User Role": properties.teamUserRole,
      });

      // destination Braze
      Braze.logEvent("Teams Invite Accepted", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Accepted From Email Link": properties.acceptedFromEmailLink,
        "Existing SA Subscription": properties.existingSaSubscription,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        "Team Name": properties.teamName,
        "Team User Role": properties.teamUserRole,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Invite Resent: Admin resends a team invite
   *
   * When to trigger this event:
   * 1. Admin resends a team invite from the users page from the bulk banner or subset option.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/X2j6tp9x6/trigger/lqww_Lvxr2
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {int} properties.resentUserCount - Count of users resent their Teams invite.
   * @param {string} properties.resendType - Type of resend action.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/X2j6tp9x6}
   */
  function teamsInviteResent(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertResentUserCount(properties.resentUserCount)
      );
      messages = messages.concat(assertResendType(properties.resendType));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Invite Resent",
          Object.keys(properties),
          [
            "platform",
            "organizationGroupId",
            "organizationId",
            "resentUserCount",
            "resendType",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "X2j6tp9x6",
          "7f31893c7984ebe6279d3997975549aabf873be814e0ccacafa220c24ff2dc71",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Invite Resent",
        {
          Platform: properties.platform,
          "Organization Group ID": properties.organizationGroupId,
          "Organization ID": properties.organizationId,
          "Resent User Count": properties.resentUserCount,
          "Resend Type": properties.resendType,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "X2j6tp9x6",
          "Teams Invite Resent",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "2Bd1esJeWE",
              name: "Resend Type",
              value: properties.resendType,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "mCaLIQOaUq",
              name: "Resent User Count",
              value: properties.resentUserCount,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Invite Resent': " + messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Invite Resent",
          {
            Platform: properties.platform,
            "Organization Group ID": properties.organizationGroupId,
            "Organization ID": properties.organizationId,
            "Resent User Count": properties.resentUserCount,
            "Resend Type": properties.resendType,
          },
          "X2j6tp9x6",
          "7f31893c7984ebe6279d3997975549aabf873be814e0ccacafa220c24ff2dc71"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Invite Resent", {
        Platform: properties.platform,
        "Organization Group ID": properties.organizationGroupId,
        "Organization ID": properties.organizationId,
        "Resent User Count": properties.resentUserCount,
        "Resend Type": properties.resendType,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Teams Invite Resent", {
        Platform: properties.platform,
        "Organization Group ID": properties.organizationGroupId,
        "Organization ID": properties.organizationId,
        "Resent User Count": properties.resentUserCount,
        "Resend Type": properties.resendType,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Invite Resent", {
        Platform: properties.platform,
        "Organization Group ID": properties.organizationGroupId,
        "Organization ID": properties.organizationId,
        "Resent User Count": properties.resentUserCount,
        "Resend Type": properties.resendType,
      });

      // destination Braze
      Braze.logEvent("Teams Invite Resent", {
        Platform: properties.platform,
        "Organization Group ID": properties.organizationGroupId,
        "Organization ID": properties.organizationId,
        "Resent User Count": properties.resentUserCount,
        "Resend Type": properties.resendType,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Invite Revoked: Admin revokes a team invite(s).

   *
   * When to trigger this event:
   * 1. Admin revokes a team invite from the users page on the user subset options.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/RxIyJPfx8/trigger/pAWkdA6EQt
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {int} properties.revokedUserCount - Count of users revoked in the admin's revoke action.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/RxIyJPfx8}
   */
  function teamsInviteRevoked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertRevokedUserCount(properties.revokedUserCount)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Invite Revoked",
          Object.keys(properties),
          [
            "platform",
            "organizationGroupId",
            "organizationId",
            "revokedUserCount",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "RxIyJPfx8",
          "5d7bbddc002e6867b1339ff86383f90195b7ced6a13e169eb99f0b202d039570",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Invite Revoked",
        {
          Platform: properties.platform,
          "Organization Group ID": properties.organizationGroupId,
          "Organization ID": properties.organizationId,
          "Revoked User Count": properties.revokedUserCount,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "RxIyJPfx8",
          "Teams Invite Revoked",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "xhgkr-VsdS",
              name: "Revoked User Count",
              value: properties.revokedUserCount,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Invite Revoked': " + messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Invite Revoked",
          {
            Platform: properties.platform,
            "Organization Group ID": properties.organizationGroupId,
            "Organization ID": properties.organizationId,
            "Revoked User Count": properties.revokedUserCount,
          },
          "RxIyJPfx8",
          "5d7bbddc002e6867b1339ff86383f90195b7ced6a13e169eb99f0b202d039570"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Invite Revoked", {
        Platform: properties.platform,
        "Organization Group ID": properties.organizationGroupId,
        "Organization ID": properties.organizationId,
        "Revoked User Count": properties.revokedUserCount,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Teams Invite Revoked", {
        Platform: properties.platform,
        "Organization Group ID": properties.organizationGroupId,
        "Organization ID": properties.organizationId,
        "Revoked User Count": properties.revokedUserCount,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Invite Revoked", {
        Platform: properties.platform,
        "Organization Group ID": properties.organizationGroupId,
        "Organization ID": properties.organizationId,
        "Revoked User Count": properties.revokedUserCount,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Experiment Viewed: When a user views a design test
   *
   * @param {object} properties - the properties associatied with this event
   * @param {int} properties.experimentId - The experiment's ID
   * @param {string} properties.experimentName - The experiment's human-readable name
   * @param {int} properties.variationId - The variation's ID
   * @param {string} properties.variationName - The variation's human-readable name
   * @param {string} properties.platform - Platform the user was on at the time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/r46-LIbAGu}
   */
  function experimentViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertExperimentID(properties.experimentId));
      messages = messages.concat(
        assertExperimentName(properties.experimentName)
      );
      messages = messages.concat(assertVariationID(properties.variationId));
      messages = messages.concat(assertVariationName(properties.variationName));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Experiment Viewed",
          Object.keys(properties),
          [
            "experimentId",
            "experimentName",
            "variationId",
            "variationName",
            "platform",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "r46-LIbAGu",
          "7f7cdf3bc5c32413a9d569d10876918cca30006aa31825b9cee46db9b9eaf6b3",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Experiment Viewed",
        {
          "Experiment ID": properties.experimentId,
          "Experiment Name": properties.experimentName,
          "Variation ID": properties.variationId,
          "Variation Name": properties.variationName,
          Platform: properties.platform,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "r46-LIbAGu",
          "Experiment Viewed",
          messages,
          [
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "JoQpUcp-3B",
              name: "Variation Name",
              value: properties.variationName,
            },
            {
              id: "KKUJskjFz2",
              name: "Variation ID",
              value: properties.variationId,
            },
            {
              id: "QqVMDEQjyL",
              name: "Experiment Name",
              value: properties.experimentName,
            },
            {
              id: "bC6IZD17aF",
              name: "Experiment ID",
              value: properties.experimentId,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Experiment Viewed': " + messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Experiment Viewed",
          {
            "Experiment ID": properties.experimentId,
            "Experiment Name": properties.experimentName,
            "Variation ID": properties.variationId,
            "Variation Name": properties.variationName,
            Platform: properties.platform,
          },
          "r46-LIbAGu",
          "7f7cdf3bc5c32413a9d569d10876918cca30006aa31825b9cee46db9b9eaf6b3"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Experiment Viewed", {
        "Experiment ID": properties.experimentId,
        "Experiment Name": properties.experimentName,
        "Variation ID": properties.variationId,
        "Variation Name": properties.variationName,
        Platform: properties.platform,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Experiment Viewed", {
        "Experiment ID": properties.experimentId,
        "Experiment Name": properties.experimentName,
        "Variation ID": properties.variationId,
        "Variation Name": properties.variationName,
        Platform: properties.platform,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Bulk Upload Started: Teams Admin starts the process to upload a bulk list of users to the invite flow
   *
   * When to trigger this event:
   * 1. Click through to add bulk lists in invite flows
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/R2TVZ2FPKB/trigger/DehyZ74ta
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {int} [properties.teamsPlanId] - Plan Type ID of the Team at time of event. If a team is not on a plan, do not send property.
   * @param {string} [properties.teamsPlanName] - Name of the Team's plan at time of event. If a team is not on a plan, do not send property.
   * @param {string} properties.platform - Platform the user was on at the time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/R2TVZ2FPKB}
   */
  function bulkUploadStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanID(properties.teamsPlanId)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanName(properties.teamsPlanName)
      );
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Bulk Upload Started",
          Object.keys(properties),
          [
            "organizationId",
            "organizationGroupId",
            "teamsPlanId",
            "teamsPlanName",
            "platform",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "R2TVZ2FPKB",
          "f788ee7058e219abd5660124d187b52ec9366df62fabaf504d1a9fa00c72ef55",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Bulk Upload Started",
        {
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          "Teams Plan ID": properties.teamsPlanId,
          "Teams Plan Name": properties.teamsPlanName,
          Platform: properties.platform,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "R2TVZ2FPKB",
          "Bulk Upload Started",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "125AY5RLNY",
              name: "Teams Plan Name",
              value: properties.teamsPlanName,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "TbSVW_o_GH",
              name: "Teams Plan ID",
              value: properties.teamsPlanId,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Bulk Upload Started': " + messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Bulk Upload Started",
          {
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            "Teams Plan ID": properties.teamsPlanId,
            "Teams Plan Name": properties.teamsPlanName,
            Platform: properties.platform,
          },
          "R2TVZ2FPKB",
          "f788ee7058e219abd5660124d187b52ec9366df62fabaf504d1a9fa00c72ef55"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Bulk Upload Started", {
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        Platform: properties.platform,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Bulk Upload Started", {
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        Platform: properties.platform,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Bulk Upload Started", {
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        Platform: properties.platform,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Bulk Upload Step Completed: User successfully completes an intermediary step in the bulk upload process.
   *
   * When to trigger this event:
   * 1. STEP: Upload File

Successful completion of intermediary step (upload file).
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/2U7cIf8NW/trigger/CZ1HG2w2sB
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {int} [properties.teamsPlanId] - Plan Type ID of the Team at time of event. If a team is not on a plan, do not send property.
   * @param {string} [properties.teamsPlanName] - Name of the Team's plan at time of event. If a team is not on a plan, do not send property.
   * @param {string} properties.bulkUploadStepName - Step name in the the bulk upload flow.
   * @param {int} properties.bulkUploadStepNumber - Step number of the step in the bulk upload flow.
   * @param {string} properties.platform - Platform the user was on at the time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/2U7cIf8NW}
   */
  function bulkUploadStepCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanID(properties.teamsPlanId)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanName(properties.teamsPlanName)
      );
      messages = messages.concat(
        assertBulkUploadStepName(properties.bulkUploadStepName)
      );
      messages = messages.concat(
        assertBulkUploadStepNumber(properties.bulkUploadStepNumber)
      );
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Bulk Upload Step Completed",
          Object.keys(properties),
          [
            "organizationId",
            "organizationGroupId",
            "teamsPlanId",
            "teamsPlanName",
            "bulkUploadStepName",
            "bulkUploadStepNumber",
            "platform",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "2U7cIf8NW",
          "a2e658c92db01c80990e24da1f59c1d26ab97db32be70836738e9e71b1fedc47",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Bulk Upload Step Completed",
        {
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          "Teams Plan ID": properties.teamsPlanId,
          "Teams Plan Name": properties.teamsPlanName,
          "Bulk Upload Step Name": properties.bulkUploadStepName,
          "Bulk Upload Step Number": properties.bulkUploadStepNumber,
          Platform: properties.platform,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "2U7cIf8NW",
          "Bulk Upload Step Completed",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "125AY5RLNY",
              name: "Teams Plan Name",
              value: properties.teamsPlanName,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "TbSVW_o_GH",
              name: "Teams Plan ID",
              value: properties.teamsPlanId,
            },
            {
              id: "YHIX7HQjNP",
              name: "Bulk Upload Step Number",
              value: properties.bulkUploadStepNumber,
            },
            {
              id: "fzQ_UrSVl0",
              name: "Bulk Upload Step Name",
              value: properties.bulkUploadStepName,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Bulk Upload Step Completed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Bulk Upload Step Completed",
          {
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            "Teams Plan ID": properties.teamsPlanId,
            "Teams Plan Name": properties.teamsPlanName,
            "Bulk Upload Step Name": properties.bulkUploadStepName,
            "Bulk Upload Step Number": properties.bulkUploadStepNumber,
            Platform: properties.platform,
          },
          "2U7cIf8NW",
          "a2e658c92db01c80990e24da1f59c1d26ab97db32be70836738e9e71b1fedc47"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Bulk Upload Step Completed", {
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        "Bulk Upload Step Name": properties.bulkUploadStepName,
        "Bulk Upload Step Number": properties.bulkUploadStepNumber,
        Platform: properties.platform,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Bulk Upload Step Completed", {
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        "Bulk Upload Step Name": properties.bulkUploadStepName,
        "Bulk Upload Step Number": properties.bulkUploadStepNumber,
        Platform: properties.platform,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Bulk Upload Step Completed", {
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        "Bulk Upload Step Name": properties.bulkUploadStepName,
        "Bulk Upload Step Number": properties.bulkUploadStepNumber,
        Platform: properties.platform,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Bulk Upload Completed: Teams Admin completes the process to upload a bulk list of users to the invite flow.
   *
   * When to trigger this event:
   * 1. Click through to review users
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/mvTBCKzhl/trigger/Gy4MK1hooV
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {int} [properties.teamsPlanId] - Plan Type ID of the Team at time of event. If a team is not on a plan, do not send property.
   * @param {string} [properties.teamsPlanName] - Name of the Team's plan at time of event. If a team is not on a plan, do not send property.
   * @param {int} properties.bulkUploadUserCount - Count of users added to invite through bulk upload.
   * @param {string} properties.platform - Platform the user was on at the time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/mvTBCKzhl}
   */
  function bulkUploadCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanID(properties.teamsPlanId)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanName(properties.teamsPlanName)
      );
      messages = messages.concat(
        assertBulkUploadUserCount(properties.bulkUploadUserCount)
      );
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Bulk Upload Completed",
          Object.keys(properties),
          [
            "organizationId",
            "organizationGroupId",
            "teamsPlanId",
            "teamsPlanName",
            "bulkUploadUserCount",
            "platform",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "mvTBCKzhl",
          "0174dad63e8cb44a3c5fcfeecb7ef9b3f55142ebef255a104a56bc80fc750140",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Bulk Upload Completed",
        {
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          "Teams Plan ID": properties.teamsPlanId,
          "Teams Plan Name": properties.teamsPlanName,
          "Bulk Upload User Count": properties.bulkUploadUserCount,
          Platform: properties.platform,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "mvTBCKzhl",
          "Bulk Upload Completed",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "125AY5RLNY",
              name: "Teams Plan Name",
              value: properties.teamsPlanName,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "TbSVW_o_GH",
              name: "Teams Plan ID",
              value: properties.teamsPlanId,
            },
            {
              id: "zQHDfCEM6P",
              name: "Bulk Upload User Count",
              value: properties.bulkUploadUserCount,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Bulk Upload Completed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Bulk Upload Completed",
          {
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            "Teams Plan ID": properties.teamsPlanId,
            "Teams Plan Name": properties.teamsPlanName,
            "Bulk Upload User Count": properties.bulkUploadUserCount,
            Platform: properties.platform,
          },
          "mvTBCKzhl",
          "0174dad63e8cb44a3c5fcfeecb7ef9b3f55142ebef255a104a56bc80fc750140"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Bulk Upload Completed", {
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        "Bulk Upload User Count": properties.bulkUploadUserCount,
        Platform: properties.platform,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Bulk Upload Completed", {
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        "Bulk Upload User Count": properties.bulkUploadUserCount,
        Platform: properties.platform,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Bulk Upload Completed", {
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        "Bulk Upload User Count": properties.bulkUploadUserCount,
        Platform: properties.platform,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Bulk Upload Failed: Bulk upload attempt fails
   *
   * When to trigger this event:
   * 1. Failure displayed to user
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/e24tg1FZS/trigger/BCza-chkA1
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {int} [properties.teamsPlanId] - Plan Type ID of the Team at time of event. If a team is not on a plan, do not send property.
   * @param {string} [properties.teamsPlanName] - Name of the Team's plan at time of event. If a team is not on a plan, do not send property.
   * @param {string} properties.platform - Platform the user was on at the time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/e24tg1FZS}
   */
  function bulkUploadFailed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanID(properties.teamsPlanId)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanName(properties.teamsPlanName)
      );
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Bulk Upload Failed",
          Object.keys(properties),
          [
            "organizationId",
            "organizationGroupId",
            "teamsPlanId",
            "teamsPlanName",
            "platform",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "e24tg1FZS",
          "03c9d03deb89a93570fdefad0fb1d43b5af8437382e914a1315618c58d3f45fa",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Bulk Upload Failed",
        {
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          "Teams Plan ID": properties.teamsPlanId,
          "Teams Plan Name": properties.teamsPlanName,
          Platform: properties.platform,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "e24tg1FZS",
          "Bulk Upload Failed",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "125AY5RLNY",
              name: "Teams Plan Name",
              value: properties.teamsPlanName,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "TbSVW_o_GH",
              name: "Teams Plan ID",
              value: properties.teamsPlanId,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Bulk Upload Failed': " + messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Bulk Upload Failed",
          {
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            "Teams Plan ID": properties.teamsPlanId,
            "Teams Plan Name": properties.teamsPlanName,
            Platform: properties.platform,
          },
          "e24tg1FZS",
          "03c9d03deb89a93570fdefad0fb1d43b5af8437382e914a1315618c58d3f45fa"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Bulk Upload Failed", {
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        Platform: properties.platform,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Bulk Upload Failed", {
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        Platform: properties.platform,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Bulk Upload Failed", {
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        Platform: properties.platform,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams User List Downloaded: Teams Admin downloads user list.
   *
   * When to trigger this event:
   * 1. Click through to download a list of users.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/PqIWAUfii/trigger/cZi5zsVvvd
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {int} [properties.teamsPlanId] - Plan Type ID of the Team at time of event. If a team is not on a plan, do not send property.
   * @param {string} [properties.teamsPlanName] - Name of the Team's plan at time of event. If a team is not on a plan, do not send property.
   * @param {string} properties.platform - Platform the user was on at the time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/PqIWAUfii}
   */
  function teamsUserListDownloaded(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanID(properties.teamsPlanId)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanName(properties.teamsPlanName)
      );
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams User List Downloaded",
          Object.keys(properties),
          [
            "organizationId",
            "organizationGroupId",
            "teamsPlanId",
            "teamsPlanName",
            "platform",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "PqIWAUfii",
          "08870eca6fed1e4208dd7e9150af46a8bb0130d3796c2da7b3f71f7988e7f348",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams User List Downloaded",
        {
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          "Teams Plan ID": properties.teamsPlanId,
          "Teams Plan Name": properties.teamsPlanName,
          Platform: properties.platform,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "PqIWAUfii",
          "Teams User List Downloaded",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "125AY5RLNY",
              name: "Teams Plan Name",
              value: properties.teamsPlanName,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "TbSVW_o_GH",
              name: "Teams Plan ID",
              value: properties.teamsPlanId,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams User List Downloaded': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams User List Downloaded",
          {
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            "Teams Plan ID": properties.teamsPlanId,
            "Teams Plan Name": properties.teamsPlanName,
            Platform: properties.platform,
          },
          "PqIWAUfii",
          "08870eca6fed1e4208dd7e9150af46a8bb0130d3796c2da7b3f71f7988e7f348"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams User List Downloaded", {
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        Platform: properties.platform,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Teams User List Downloaded", {
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        Platform: properties.platform,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams User List Downloaded", {
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        Platform: properties.platform,
      });
    } else {
      // do nothing
    }
  }

  /**
   * User Selected: Admin selects user(s) on the users setting page
   *
   * When to trigger this event:
   * 1. Click on any of the following selections. Bulk or individual. Select or unselect.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/34GIpshe5Z/trigger/QS3-4VA69
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} properties.page - The page or screen in app or on the web where the event sourced from.
   * @param {string} properties.userSelectionType - The selection type on the user page: bulk or individual.
   * @param {string} properties.userSelectionAction - Selection action on the user page: select or unselect.
   * @param {string} properties.platform - Platform the user was on at the time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/34GIpshe5Z}
   */
  function userSelected(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(assertPage(properties.page));
      messages = messages.concat(
        assertUserSelectionType(properties.userSelectionType)
      );
      messages = messages.concat(
        assertUserSelectionAction(properties.userSelectionAction)
      );
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "User Selected",
          Object.keys(properties),
          [
            "organizationGroupId",
            "organizationId",
            "page",
            "userSelectionType",
            "userSelectionAction",
            "platform",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "34GIpshe5Z",
          "f5fc4e8ad519a3f4770af521fcc59d412eb0bc8d23c447fd69228afb487623ff",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "User Selected",
        {
          "Organization Group ID": properties.organizationGroupId,
          "Organization ID": properties.organizationId,
          Page: properties.page,
          "User Selection Type": properties.userSelectionType,
          "User Selection Action": properties.userSelectionAction,
          Platform: properties.platform,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "34GIpshe5Z",
          "User Selected",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "1B4einUjHw",
              name: "User Selection Action",
              value: properties.userSelectionAction,
            },
            { id: "4j_Pu5zIMW", name: "Page", value: properties.page },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "SJgfdz28BI",
              name: "User Selection Type",
              value: properties.userSelectionType,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'User Selected': " + messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "User Selected",
          {
            "Organization Group ID": properties.organizationGroupId,
            "Organization ID": properties.organizationId,
            Page: properties.page,
            "User Selection Type": properties.userSelectionType,
            "User Selection Action": properties.userSelectionAction,
            Platform: properties.platform,
          },
          "34GIpshe5Z",
          "f5fc4e8ad519a3f4770af521fcc59d412eb0bc8d23c447fd69228afb487623ff"
        );
      }
      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("User Selected", {
        "Organization Group ID": properties.organizationGroupId,
        "Organization ID": properties.organizationId,
        Page: properties.page,
        "User Selection Type": properties.userSelectionType,
        "User Selection Action": properties.userSelectionAction,
        Platform: properties.platform,
      });

      // destination Mixpanel
      Mixpanel.logEvent("User Selected", {
        "Organization Group ID": properties.organizationGroupId,
        "Organization ID": properties.organizationId,
        Page: properties.page,
        "User Selection Type": properties.userSelectionType,
        "User Selection Action": properties.userSelectionAction,
        Platform: properties.platform,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Custom Rates Update Started: Admin started an interaction with a given custom rates
   *
   * When to trigger this event:
   * 1. "Change rate" buttons on top/bottom of custom rates page
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/SPxouI_zX/trigger/3HJg9-_Lm
   * 2. "Edit this rate" button on dropdown of upcoming custom rates list item
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/SPxouI_zX/trigger/q82h6IcOS
   * 3. "Remove this rate" button on dropdown of upcoming custom rates list item
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/SPxouI_zX/trigger/WonyOmyk6
   * 4. "Revert this rate" button on dropdown of past custom rates list item
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/SPxouI_zX/trigger/01Toh8UFH
   * 5. "Revert to default" buttons on top/bottom of custom rates page
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/SPxouI_zX/trigger/xar_T0YLp
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.customRatesUpdateType - Interaction type in custom rates
   * @param {string} [properties.customRatesSelection] - Type of custom rates selected
   * @param {string} properties.platform - Platform the user was on at the time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/SPxouI_zX}
   */
  function teamsCustomRatesUpdateStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(
        assertCustomRatesUpdateType(properties.customRatesUpdateType)
      );
      messages = messages.concat(
        assertOptionalCustomRatesSelection(properties.customRatesSelection)
      );
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Custom Rates Update Started",
          Object.keys(properties),
          ["customRatesUpdateType", "customRatesSelection", "platform"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "SPxouI_zX",
          "5cff9c4169d0a2b06ee6aaf69cbbf288504646a77c185ea4aeeaafaf1bb3dfb5",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Custom Rates Update Started",
        {
          "Custom Rates Update Type": properties.customRatesUpdateType,
          "Custom Rates Selection": properties.customRatesSelection,
          Platform: properties.platform,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "SPxouI_zX",
          "Teams Custom Rates Update Started",
          messages,
          [
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "p_aYbLlADo",
              name: "Custom Rates Update Type",
              value: properties.customRatesUpdateType,
            },
            {
              id: "sj8Oob-_yQ",
              name: "Custom Rates Selection",
              value: properties.customRatesSelection,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Custom Rates Update Started': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Custom Rates Update Started",
          {
            "Custom Rates Update Type": properties.customRatesUpdateType,
            "Custom Rates Selection": properties.customRatesSelection,
            Platform: properties.platform,
          },
          "SPxouI_zX",
          "5cff9c4169d0a2b06ee6aaf69cbbf288504646a77c185ea4aeeaafaf1bb3dfb5"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Custom Rates Update Started", {
        "Custom Rates Update Type": properties.customRatesUpdateType,
        "Custom Rates Selection": properties.customRatesSelection,
        Platform: properties.platform,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Teams Custom Rates Update Started", {
        "Custom Rates Update Type": properties.customRatesUpdateType,
        "Custom Rates Selection": properties.customRatesSelection,
        Platform: properties.platform,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Custom Rates Update Started", {
        "Custom Rates Update Type": properties.customRatesUpdateType,
        "Custom Rates Selection": properties.customRatesSelection,
        Platform: properties.platform,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Custom Rates Update Completed: Admin successfully finished an interaction with a given custom rates
   *
   * When to trigger this event:
   * 1. Delete rate confirmation modal
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/6SCDiTF7XL/trigger/8n7DZUXS0
   * 2. Edit upcoming rates modal
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/6SCDiTF7XL/trigger/Egjo2wioy
   * 3. Change rate modal
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/6SCDiTF7XL/trigger/vGhv3JCmp
   * 4. Revert to a previous rate modal
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/6SCDiTF7XL/trigger/wP8vRA-AG
   * 5. Reset to teams countries default rates confirmation modal
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/6SCDiTF7XL/trigger/-3K_2alcy
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.customRatesUpdateType - Interaction type in custom rates
   * @param {string} [properties.customRatesSelection] - Type of custom rates selected
   * @param {string} [properties.customRatesEffectiveDate] - Type of effective dates for created/updated custom rates
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/6SCDiTF7XL}
   */
  function teamsCustomRatesUpdateCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(
        assertCustomRatesUpdateType(properties.customRatesUpdateType)
      );
      messages = messages.concat(
        assertOptionalCustomRatesSelection(properties.customRatesSelection)
      );
      messages = messages.concat(
        assertOptionalCustomRatesEffectiveDate(
          properties.customRatesEffectiveDate
        )
      );
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Custom Rates Update Completed",
          Object.keys(properties),
          [
            "customRatesUpdateType",
            "customRatesSelection",
            "customRatesEffectiveDate",
            "platform",
            "organizationId",
            "organizationGroupId",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "6SCDiTF7XL",
          "4474518a3bf9e3372d24b44be5534dcee47bea995b2a211a457dd763bed1419c",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Custom Rates Update Completed",
        {
          "Custom Rates Update Type": properties.customRatesUpdateType,
          "Custom Rates Selection": properties.customRatesSelection,
          "Custom Rates Effective Date": properties.customRatesEffectiveDate,
          Platform: properties.platform,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "6SCDiTF7XL",
          "Teams Custom Rates Update Completed",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "pMIlytsFWc",
              name: "Custom Rates Effective Date",
              value: properties.customRatesEffectiveDate,
            },
            {
              id: "p_aYbLlADo",
              name: "Custom Rates Update Type",
              value: properties.customRatesUpdateType,
            },
            {
              id: "sj8Oob-_yQ",
              name: "Custom Rates Selection",
              value: properties.customRatesSelection,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Custom Rates Update Completed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Custom Rates Update Completed",
          {
            "Custom Rates Update Type": properties.customRatesUpdateType,
            "Custom Rates Selection": properties.customRatesSelection,
            "Custom Rates Effective Date": properties.customRatesEffectiveDate,
            Platform: properties.platform,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
          },
          "6SCDiTF7XL",
          "4474518a3bf9e3372d24b44be5534dcee47bea995b2a211a457dd763bed1419c"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Custom Rates Update Completed", {
        "Custom Rates Update Type": properties.customRatesUpdateType,
        "Custom Rates Selection": properties.customRatesSelection,
        "Custom Rates Effective Date": properties.customRatesEffectiveDate,
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Teams Custom Rates Update Completed", {
        "Custom Rates Update Type": properties.customRatesUpdateType,
        "Custom Rates Selection": properties.customRatesSelection,
        "Custom Rates Effective Date": properties.customRatesEffectiveDate,
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Custom Rates Update Completed", {
        "Custom Rates Update Type": properties.customRatesUpdateType,
        "Custom Rates Selection": properties.customRatesSelection,
        "Custom Rates Effective Date": properties.customRatesEffectiveDate,
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
      });

      // destination Braze
      Braze.logEvent("Teams Custom Rates Update Completed", {
        "Custom Rates Update Type": properties.customRatesUpdateType,
        "Custom Rates Selection": properties.customRatesSelection,
        "Custom Rates Effective Date": properties.customRatesEffectiveDate,
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Share MileIQ Selected: User select to Share MileIQ
   *
   * When to trigger this event:
   * 1. User clicks on any of the share options, including URL copy
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/aH1I8kVsA0/trigger/-V71r28UJ
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.shareSource - Share MileIQ Source
   * @param {string} properties.platform - Platform the user was on at the time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/aH1I8kVsA0}
   */
  function shareMileiqSelected(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertShareSource(properties.shareSource));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Share MileIQ Selected",
          Object.keys(properties),
          ["shareSource", "platform"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "aH1I8kVsA0",
          "42b95b3de6e66ddce6ac906cd9da398d93805f5484e1739e9e2caf4289ea5f0b",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Share MileIQ Selected",
        {
          "Share Source": properties.shareSource,
          Platform: properties.platform,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "aH1I8kVsA0",
          "Share MileIQ Selected",
          messages,
          [
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "_AOL0-p1J",
              name: "Share Source",
              value: properties.shareSource,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Share MileIQ Selected': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Share MileIQ Selected",
          {
            "Share Source": properties.shareSource,
            Platform: properties.platform,
          },
          "aH1I8kVsA0",
          "42b95b3de6e66ddce6ac906cd9da398d93805f5484e1739e9e2caf4289ea5f0b"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Share MileIQ Selected", {
        "Share Source": properties.shareSource,
        Platform: properties.platform,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Share MileIQ Selected", {
        "Share Source": properties.shareSource,
        Platform: properties.platform,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Share MileIQ Selected", {
        "Share Source": properties.shareSource,
        Platform: properties.platform,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Blog Selected: User selects the Blog modal
   *
   * When to trigger this event:
   * 1. User selects to access the Blog or a specific blog post
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/ogVctN7O0o/trigger/eim_o0T8c
   * 2. User clicks a blog link in the concur integration flow
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/ogVctN7O0o/trigger/TGr6UR6y3
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} properties.blogSource - Source of the redirect to the blog a specific blog post
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/ogVctN7O0o}
   */
  function blogSelected(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertBlogSource(properties.blogSource));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Blog Selected",
          Object.keys(properties),
          ["platform", "blogSource"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "ogVctN7O0o",
          "8216b2fc214635c99424de2809b27bd38fc54892142569ae4c4b3c6b14b24d4f",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Blog Selected",
        {
          Platform: properties.platform,
          "Blog Source": properties.blogSource,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "ogVctN7O0o",
          "Blog Selected",
          messages,
          [
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "UMJ3rLw2H",
              name: "Blog Source",
              value: properties.blogSource,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Blog Selected': " + messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Blog Selected",
          {
            Platform: properties.platform,
            "Blog Source": properties.blogSource,
          },
          "ogVctN7O0o",
          "8216b2fc214635c99424de2809b27bd38fc54892142569ae4c4b3c6b14b24d4f"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Blog Selected", {
        Platform: properties.platform,
        "Blog Source": properties.blogSource,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Blog Selected", {
        Platform: properties.platform,
        "Blog Source": properties.blogSource,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Blog Selected", {
        Platform: properties.platform,
        "Blog Source": properties.blogSource,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Vehicle Add Started: User starts the process to add a vehicle to their account
   *
   * When to trigger this event:
   * 1. User starts the add vehicle flow
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/iNIu5ze7ka/trigger/4V91uTEjD
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} properties.page - The page or screen in app or on the web where the event sourced from.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/iNIu5ze7ka}
   */
  function vehicleAddStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertPage(properties.page));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Vehicle Add Started",
          Object.keys(properties),
          ["platform", "page"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "iNIu5ze7ka",
          "6f2e01257e0b8ee99e98b52e461c89cb0b0113544ef92d8909a688e492c78cc6",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Vehicle Add Started",
        {
          Platform: properties.platform,
          Page: properties.page,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "iNIu5ze7ka",
          "Vehicle Add Started",
          messages,
          [
            { id: "4j_Pu5zIMW", name: "Page", value: properties.page },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Vehicle Add Started': " + messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Vehicle Add Started",
          {
            Platform: properties.platform,
            Page: properties.page,
          },
          "iNIu5ze7ka",
          "6f2e01257e0b8ee99e98b52e461c89cb0b0113544ef92d8909a688e492c78cc6"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Vehicle Add Started", {
        Platform: properties.platform,
        Page: properties.page,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Vehicle Add Started", {
        Platform: properties.platform,
        Page: properties.page,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Vehicle Updated: User makes an update to a vehicle on their account
   *
   * When to trigger this event:
   * 1. User completes an update on their vehicle: changes details, changes priority, changes visibility
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/QJ_yJ2heH/trigger/4bqMnOW6sT
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} properties.vehicleDetailsUpdate - Identifies if vehicle details were updated or kept the same
   * @param {string} properties.vehicleVisibilityUpdate - Identifies if vehicle visibility were updated or kept the same
   * @param {string} properties.vehiclePriorityUpdate - Identifies if vehicle priority was updated or kept the same
   * @param {string} properties.vehicleVisibility - Identifies vehicle visibility after update
   * @param {string} properties.vehiclePriority - Identifies the vehicle priority after update.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/QJ_yJ2heH}
   */
  function vehicleUpdated(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertVehicleDetailsUpdate(properties.vehicleDetailsUpdate)
      );
      messages = messages.concat(
        assertVehicleVisibilityUpdate(properties.vehicleVisibilityUpdate)
      );
      messages = messages.concat(
        assertVehiclePriorityUpdate(properties.vehiclePriorityUpdate)
      );
      messages = messages.concat(
        assertVehicleVisibility(properties.vehicleVisibility)
      );
      messages = messages.concat(
        assertVehiclePriority(properties.vehiclePriority)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Vehicle Updated",
          Object.keys(properties),
          [
            "platform",
            "vehicleDetailsUpdate",
            "vehicleVisibilityUpdate",
            "vehiclePriorityUpdate",
            "vehicleVisibility",
            "vehiclePriority",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "QJ_yJ2heH",
          "6aa4ae4323a3c11de3dc9cc0f0a0972e2f9ce47a3322d5e72ec13eb4c676618a",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Vehicle Updated",
        {
          Platform: properties.platform,
          "Vehicle Details Update": properties.vehicleDetailsUpdate,
          "Vehicle Visibility Update": properties.vehicleVisibilityUpdate,
          "Vehicle Priority Update": properties.vehiclePriorityUpdate,
          "Vehicle Visibility": properties.vehicleVisibility,
          "Vehicle Priority": properties.vehiclePriority,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "QJ_yJ2heH",
          "Vehicle Updated",
          messages,
          [
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "P7ky4xsaf",
              name: "Vehicle Priority",
              value: properties.vehiclePriority,
            },
            {
              id: "R2S4y5CHV",
              name: "Vehicle Priority Update",
              value: properties.vehiclePriorityUpdate,
            },
            {
              id: "_fPjNDD2Q",
              name: "Vehicle Details Update",
              value: properties.vehicleDetailsUpdate,
            },
            {
              id: "ahdn60zVz",
              name: "Vehicle Visibility",
              value: properties.vehicleVisibility,
            },
            {
              id: "ct3SJ5mAn",
              name: "Vehicle Visibility Update",
              value: properties.vehicleVisibilityUpdate,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Vehicle Updated': " + messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Vehicle Updated",
          {
            Platform: properties.platform,
            "Vehicle Details Update": properties.vehicleDetailsUpdate,
            "Vehicle Visibility Update": properties.vehicleVisibilityUpdate,
            "Vehicle Priority Update": properties.vehiclePriorityUpdate,
            "Vehicle Visibility": properties.vehicleVisibility,
            "Vehicle Priority": properties.vehiclePriority,
          },
          "QJ_yJ2heH",
          "6aa4ae4323a3c11de3dc9cc0f0a0972e2f9ce47a3322d5e72ec13eb4c676618a"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Vehicle Updated", {
        Platform: properties.platform,
        "Vehicle Details Update": properties.vehicleDetailsUpdate,
        "Vehicle Visibility Update": properties.vehicleVisibilityUpdate,
        "Vehicle Priority Update": properties.vehiclePriorityUpdate,
        "Vehicle Visibility": properties.vehicleVisibility,
        "Vehicle Priority": properties.vehiclePriority,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Vehicle Updated", {
        Platform: properties.platform,
        "Vehicle Details Update": properties.vehicleDetailsUpdate,
        "Vehicle Visibility Update": properties.vehicleVisibilityUpdate,
        "Vehicle Priority Update": properties.vehiclePriorityUpdate,
        "Vehicle Visibility": properties.vehicleVisibility,
        "Vehicle Priority": properties.vehiclePriority,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Vehicle Updated", {
        Platform: properties.platform,
        "Vehicle Details Update": properties.vehicleDetailsUpdate,
        "Vehicle Visibility Update": properties.vehicleVisibilityUpdate,
        "Vehicle Priority Update": properties.vehiclePriorityUpdate,
        "Vehicle Visibility": properties.vehicleVisibility,
        "Vehicle Priority": properties.vehiclePriority,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Vehicle Add Completed: User starts the process to add a vehicle to their account
   *
   * When to trigger this event:
   * 1. User completes the add vehicle flow
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/cDOGbr1EH/trigger/WxS0pR8dk2
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} properties.page - The page or screen in app or on the web where the event sourced from.
   * @param {string} properties.vehicleType - Options for vehicle types
   * @param {string} properties.addVehicleMethod - Methods of adding vehicles. If unavailable, set it to a null value.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/cDOGbr1EH}
   */
  function vehicleAddCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertPage(properties.page));
      messages = messages.concat(assertVehicleType(properties.vehicleType));
      messages = messages.concat(
        assertAddVehicleMethod(properties.addVehicleMethod)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Vehicle Add Completed",
          Object.keys(properties),
          ["platform", "page", "vehicleType", "addVehicleMethod"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "cDOGbr1EH",
          "70c206dca1c1424951611c55499351917809ad2817e76d873ec8558f0bcdf1ea",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Vehicle Add Completed",
        {
          Platform: properties.platform,
          Page: properties.page,
          "Vehicle Type": properties.vehicleType,
          "Add Vehicle Method": properties.addVehicleMethod,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "cDOGbr1EH",
          "Vehicle Add Completed",
          messages,
          [
            { id: "4j_Pu5zIMW", name: "Page", value: properties.page },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "kFeiOMZm8",
              name: "Add Vehicle Method",
              value: properties.addVehicleMethod,
            },
            {
              id: "yAUGC1YVE",
              name: "Vehicle Type",
              value: properties.vehicleType,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Vehicle Add Completed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Vehicle Add Completed",
          {
            Platform: properties.platform,
            Page: properties.page,
            "Vehicle Type": properties.vehicleType,
            "Add Vehicle Method": properties.addVehicleMethod,
          },
          "cDOGbr1EH",
          "70c206dca1c1424951611c55499351917809ad2817e76d873ec8558f0bcdf1ea"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Vehicle Add Completed", {
        Platform: properties.platform,
        Page: properties.page,
        "Vehicle Type": properties.vehicleType,
        "Add Vehicle Method": properties.addVehicleMethod,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Vehicle Add Completed", {
        Platform: properties.platform,
        Page: properties.page,
        "Vehicle Type": properties.vehicleType,
        "Add Vehicle Method": properties.addVehicleMethod,
      });
    } else {
      // do nothing
    }
  }

  /**
   * App Download Requested: User requests app download link

   *
   * When to trigger this event:
   * 1. User clicks download app from web dashboard get started page.

App Download Request Method: Text to Download
Page: Get Started
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/83fdI5c97m/trigger/yFEAkQy91
   * 2. User scans QR code to start the app download process from welcome page

App Download Request Method: QR Code
Page: Welcome Download
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/83fdI5c97m/trigger/QnK5qy8fX
   * 3. User clicks the link to start the app download process when on mobile web

App Download Request Method: Click to Download
Page: Welcome Download
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/83fdI5c97m/trigger/HUJesKFw1
   * 4. User requests text to download from Welcome Page
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/83fdI5c97m/trigger/hLiDUYrrJ
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} properties.page - The page or screen in app or on the web where the event sourced from.
   * @param {string} properties.appDownloadRequestMethod - Method for requesting the app download from web
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/83fdI5c97m}
   */
  function appDownloadRequested(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertPage(properties.page));
      messages = messages.concat(
        assertAppDownloadRequestMethod(properties.appDownloadRequestMethod)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "App Download Requested",
          Object.keys(properties),
          ["platform", "page", "appDownloadRequestMethod"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "83fdI5c97m",
          "9a0c558dfd84f0b2bcad5c97c5d54e6830ba7e8ae979011e3779b58f42799652",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "App Download Requested",
        {
          Platform: properties.platform,
          Page: properties.page,
          "App Download Request Method": properties.appDownloadRequestMethod,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "83fdI5c97m",
          "App Download Requested",
          messages,
          [
            { id: "4j_Pu5zIMW", name: "Page", value: properties.page },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "kCCdZER_S",
              name: "App Download Request Method",
              value: properties.appDownloadRequestMethod,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'App Download Requested': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "App Download Requested",
          {
            Platform: properties.platform,
            Page: properties.page,
            "App Download Request Method": properties.appDownloadRequestMethod,
          },
          "83fdI5c97m",
          "9a0c558dfd84f0b2bcad5c97c5d54e6830ba7e8ae979011e3779b58f42799652"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("App Download Requested", {
        Platform: properties.platform,
        Page: properties.page,
        "App Download Request Method": properties.appDownloadRequestMethod,
      });

      // destination Mixpanel
      Mixpanel.logEvent("App Download Requested", {
        Platform: properties.platform,
        Page: properties.page,
        "App Download Request Method": properties.appDownloadRequestMethod,
      });
    } else {
      // do nothing
    }
  }

  /**
   * App Download Request Failed: User runs into an error on the text to download request
   *
   * When to trigger this event:
   * 1. User clicks download app from web dashboard get started page and receives an error.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/_5o6PZj-M/trigger/T8c9dcRzJJ
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/_5o6PZj-M}
   */
  function appDownloadRequestFailed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "App Download Request Failed",
          Object.keys(properties),
          ["platform"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "_5o6PZj-M",
          "daeda88b3d5b911201a98db4c721231bbf211738a0a98ea9bcc6b93b39cd4684",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "App Download Request Failed",
        {
          Platform: properties.platform,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "_5o6PZj-M",
          "App Download Request Failed",
          messages,
          [{ id: "FfkzdkMHsZ", name: "Platform", value: properties.platform }],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'App Download Request Failed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "App Download Request Failed",
          {
            Platform: properties.platform,
          },
          "_5o6PZj-M",
          "daeda88b3d5b911201a98db4c721231bbf211738a0a98ea9bcc6b93b39cd4684"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("App Download Request Failed", {
        Platform: properties.platform,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("App Download Request Failed", {
        Platform: properties.platform,
      });

      // destination Mixpanel
      Mixpanel.logEvent("App Download Request Failed", {
        Platform: properties.platform,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Upgrade Completed: User completes the subscription upgrade process.
   *
   * When to trigger this event:
   * 1. User completes the upgrade flow from the subscription page on any of the CTAs.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/vz3y0dXnf/trigger/34KAXnNOmG
   * 2. User completes the upgrade on web from Onboarding flow of the Unlimited Plan
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/vz3y0dXnf/trigger/4y84tzeWf
   * 3. User completes the upgrade from Promotion
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/vz3y0dXnf/trigger/fZ9dYMWj7
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.subscriptionType] - Subscription interval type
   * @param {string} properties.upgradeSource - Describes the location of the upgrade screen.
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {float} [properties.revenue] - Revenue amount on payment
   * @param {string} [properties.currency] - Currency of purchase
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/vz3y0dXnf}
   */
  function upgradeCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(
        assertOptionalSubscriptionType(properties.subscriptionType)
      );
      messages = messages.concat(assertUpgradeSource(properties.upgradeSource));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertOptionalRevenue(properties.revenue));
      messages = messages.concat(assertOptionalCurrency(properties.currency));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Upgrade Completed",
          Object.keys(properties),
          [
            "subscriptionType",
            "upgradeSource",
            "platform",
            "revenue",
            "currency",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "vz3y0dXnf",
          "73c26827ac9e2dd5eae9af6d854a8dbe7fa33994e49a7847b76dc82f959570b9",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Upgrade Completed",
        {
          subscription_type: properties.subscriptionType,
          "Upgrade Source": properties.upgradeSource,
          Platform: properties.platform,
          revenue: properties.revenue,
          currency: properties.currency,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "vz3y0dXnf",
          "Upgrade Completed",
          messages,
          [
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "a2CcoRxZb0",
              name: "Upgrade Source",
              value: properties.upgradeSource,
            },
            { id: "dj1v6t5AJ", name: "revenue", value: properties.revenue },
            { id: "dnMIs8rIY", name: "currency", value: properties.currency },
            {
              id: "rN6HAJ5vu",
              name: "subscription_type",
              value: properties.subscriptionType,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Upgrade Completed': " + messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Upgrade Completed",
          {
            subscription_type: properties.subscriptionType,
            "Upgrade Source": properties.upgradeSource,
            Platform: properties.platform,
            revenue: properties.revenue,
            currency: properties.currency,
          },
          "vz3y0dXnf",
          "73c26827ac9e2dd5eae9af6d854a8dbe7fa33994e49a7847b76dc82f959570b9"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Upgrade Completed", {
        subscription_type: properties.subscriptionType,
        "Upgrade Source": properties.upgradeSource,
        Platform: properties.platform,
        revenue: properties.revenue,
        currency: properties.currency,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Upgrade Completed", {
        subscription_type: properties.subscriptionType,
        "Upgrade Source": properties.upgradeSource,
        Platform: properties.platform,
        revenue: properties.revenue,
        currency: properties.currency,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Upgrade Completed", {
        subscription_type: properties.subscriptionType,
        "Upgrade Source": properties.upgradeSource,
        Platform: properties.platform,
        revenue: properties.revenue,
        currency: properties.currency,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Subscription Update Started: User starts the flow to update their subscription
   *
   * When to trigger this event:
   * 1. User starts the flow to update their subscription from the subscription page.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/GG1r0LI_mE/trigger/ABNwFtIWf
   * 2.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/GG1r0LI_mE/trigger/RAve-ux5F
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} properties.subscriptionType - Subscription interval type
   * @param {string} properties.paymentService - payment service options
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/GG1r0LI_mE}
   */
  function subscriptionUpdateStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertSubscriptionType(properties.subscriptionType)
      );
      messages = messages.concat(
        assertPaymentService(properties.paymentService)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Subscription Update Started",
          Object.keys(properties),
          ["platform", "subscriptionType", "paymentService"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "GG1r0LI_mE",
          "050b5f2b273bff87978cbd162adeb10bc0c3bea48c300caa4c0953a55edd7602",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Subscription Update Started",
        {
          Platform: properties.platform,
          subscription_type: properties.subscriptionType,
          payment_service: properties.paymentService,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "GG1r0LI_mE",
          "Subscription Update Started",
          messages,
          [
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "PFrUGiD-O",
              name: "payment_service",
              value: properties.paymentService,
            },
            {
              id: "rN6HAJ5vu",
              name: "subscription_type",
              value: properties.subscriptionType,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Subscription Update Started': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Subscription Update Started",
          {
            Platform: properties.platform,
            subscription_type: properties.subscriptionType,
            payment_service: properties.paymentService,
          },
          "GG1r0LI_mE",
          "050b5f2b273bff87978cbd162adeb10bc0c3bea48c300caa4c0953a55edd7602"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Subscription Update Started", {
        Platform: properties.platform,
        subscription_type: properties.subscriptionType,
        payment_service: properties.paymentService,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Subscription Update Started", {
        Platform: properties.platform,
        subscription_type: properties.subscriptionType,
        payment_service: properties.paymentService,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Subscription Update Started", {
        Platform: properties.platform,
        subscription_type: properties.subscriptionType,
        payment_service: properties.paymentService,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Subscription Update Completed: User completes the flow to update their subscription
   *
   * When to trigger this event:
   * 1. User completes the flow to update their subscription from the subscription page.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/PVao87hVf/trigger/Rf646lZAh2
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} properties.subscriptionType - Subscription interval type
   * @param {string} properties.paymentService - payment service options
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/PVao87hVf}
   */
  function subscriptionUpdateCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertSubscriptionType(properties.subscriptionType)
      );
      messages = messages.concat(
        assertPaymentService(properties.paymentService)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Subscription Update Completed",
          Object.keys(properties),
          ["platform", "subscriptionType", "paymentService"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "PVao87hVf",
          "57e36dd482592b5cfe6b41f1c86fc58764811f26a9f2a15be0c27f821f6a322a",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Subscription Update Completed",
        {
          Platform: properties.platform,
          subscription_type: properties.subscriptionType,
          payment_service: properties.paymentService,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "PVao87hVf",
          "Subscription Update Completed",
          messages,
          [
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "PFrUGiD-O",
              name: "payment_service",
              value: properties.paymentService,
            },
            {
              id: "rN6HAJ5vu",
              name: "subscription_type",
              value: properties.subscriptionType,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Subscription Update Completed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Subscription Update Completed",
          {
            Platform: properties.platform,
            subscription_type: properties.subscriptionType,
            payment_service: properties.paymentService,
          },
          "PVao87hVf",
          "57e36dd482592b5cfe6b41f1c86fc58764811f26a9f2a15be0c27f821f6a322a"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Subscription Update Completed", {
        Platform: properties.platform,
        subscription_type: properties.subscriptionType,
        payment_service: properties.paymentService,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Subscription Update Completed", {
        Platform: properties.platform,
        subscription_type: properties.subscriptionType,
        payment_service: properties.paymentService,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Subscription Update Completed", {
        Platform: properties.platform,
        subscription_type: properties.subscriptionType,
        payment_service: properties.paymentService,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Frequent Drives Preference Changed: User changes their frequent drives preference
   *
   * When to trigger this event:
   * 1. User changes their frequent drive preference from the auto classification page.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/5bdGY57_t3/trigger/F-nm45j14
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.frequentDrivePreference - Preference options for frequent drive settings
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.page] - The page or screen in app or on the web where the event sourced from.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/5bdGY57_t3}
   */
  function frequentDrivesPreferenceChanged(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(
        assertFrequentDrivePreference(properties.frequentDrivePreference)
      );
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertOptionalPage(properties.page));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Frequent Drives Preference Changed",
          Object.keys(properties),
          ["frequentDrivePreference", "platform", "page"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "5bdGY57_t3",
          "f6deea1a1531074ed18696dd98ceb48b648cd0d670512ecf025207a2710ee89f",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Frequent Drives Preference Changed",
        {
          "Frequent Drive Preference": properties.frequentDrivePreference,
          Platform: properties.platform,
          Page: properties.page,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "5bdGY57_t3",
          "Frequent Drives Preference Changed",
          messages,
          [
            { id: "4j_Pu5zIMW", name: "Page", value: properties.page },
            {
              id: "BT7rdgeb-",
              name: "Frequent Drive Preference",
              value: properties.frequentDrivePreference,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Frequent Drives Preference Changed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Frequent Drives Preference Changed",
          {
            "Frequent Drive Preference": properties.frequentDrivePreference,
            Platform: properties.platform,
            Page: properties.page,
          },
          "5bdGY57_t3",
          "f6deea1a1531074ed18696dd98ceb48b648cd0d670512ecf025207a2710ee89f"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Frequent Drives Preference Changed", {
        "Frequent Drive Preference": properties.frequentDrivePreference,
        Platform: properties.platform,
        Page: properties.page,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Frequent Drives Preference Changed", {
        "Frequent Drive Preference": properties.frequentDrivePreference,
        Platform: properties.platform,
        Page: properties.page,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Frequent Drives Preference Changed", {
        "Frequent Drive Preference": properties.frequentDrivePreference,
        Platform: properties.platform,
        Page: properties.page,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Work Hours Update Started: User starts the flow to update their Work Hours settings. This should only trigger once when the  and the 'save' option is initialized.
   *
   * When to trigger this event:
   * 1. User triggers the start of an update to Work Hours settings on any of the following ways:
Enable / Disable `Auto Classify Drives During Work Hours`
Enable / Disable `Auto Classify Drives Outside Work Hours`
Change Work Hours Schedule (only on initial trigger)
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/u12pJuruhR/trigger/Qrxo0gugD
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.workHoursUpdateSource - Source of the Work hours update initialization
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} properties.autoClassifyDuringWorkHoursPreference - Preference options for Auto Classifying Drives During Work Hours setting
   * @param {string} properties.autoClassifyOutsideWorkHoursPreference - Preference options for Auto Classifying Drives Outside Work Hours setting
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/u12pJuruhR}
   */
  function workHoursUpdateStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(
        assertWorkHoursUpdateSource(properties.workHoursUpdateSource)
      );
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertAutoClassifyDuringWorkHoursPreference(
          properties.autoClassifyDuringWorkHoursPreference
        )
      );
      messages = messages.concat(
        assertAutoClassifyOutsideWorkHoursPreference(
          properties.autoClassifyOutsideWorkHoursPreference
        )
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Work Hours Update Started",
          Object.keys(properties),
          [
            "workHoursUpdateSource",
            "platform",
            "autoClassifyDuringWorkHoursPreference",
            "autoClassifyOutsideWorkHoursPreference",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "u12pJuruhR",
          "97191f1a5f90657d30b38cd3ee842d94c77f9da50e46f203e11ad60862154313",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Work Hours Update Started",
        {
          "Work Hours Update Source": properties.workHoursUpdateSource,
          Platform: properties.platform,
          "Auto Classify During Work Hours Preference":
            properties.autoClassifyDuringWorkHoursPreference,
          "Auto Classify Outside Work Hours Preference":
            properties.autoClassifyOutsideWorkHoursPreference,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "u12pJuruhR",
          "Work Hours Update Started",
          messages,
          [
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "Oh1Cp64hH",
              name: "Auto Classify Outside Work Hours Preference",
              value: properties.autoClassifyOutsideWorkHoursPreference,
            },
            {
              id: "OtNyEyNwj",
              name: "Work Hours Update Source",
              value: properties.workHoursUpdateSource,
            },
            {
              id: "xFeOzRR8i",
              name: "Auto Classify During Work Hours Preference",
              value: properties.autoClassifyDuringWorkHoursPreference,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Work Hours Update Started': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Work Hours Update Started",
          {
            "Work Hours Update Source": properties.workHoursUpdateSource,
            Platform: properties.platform,
            "Auto Classify During Work Hours Preference":
              properties.autoClassifyDuringWorkHoursPreference,
            "Auto Classify Outside Work Hours Preference":
              properties.autoClassifyOutsideWorkHoursPreference,
          },
          "u12pJuruhR",
          "97191f1a5f90657d30b38cd3ee842d94c77f9da50e46f203e11ad60862154313"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Work Hours Update Started", {
        "Work Hours Update Source": properties.workHoursUpdateSource,
        Platform: properties.platform,
        "Auto Classify During Work Hours Preference":
          properties.autoClassifyDuringWorkHoursPreference,
        "Auto Classify Outside Work Hours Preference":
          properties.autoClassifyOutsideWorkHoursPreference,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Work Hours Update Started", {
        "Work Hours Update Source": properties.workHoursUpdateSource,
        Platform: properties.platform,
        "Auto Classify During Work Hours Preference":
          properties.autoClassifyDuringWorkHoursPreference,
        "Auto Classify Outside Work Hours Preference":
          properties.autoClassifyOutsideWorkHoursPreference,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Work Hours Update Started", {
        "Work Hours Update Source": properties.workHoursUpdateSource,
        Platform: properties.platform,
        "Auto Classify During Work Hours Preference":
          properties.autoClassifyDuringWorkHoursPreference,
        "Auto Classify Outside Work Hours Preference":
          properties.autoClassifyOutsideWorkHoursPreference,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Work Hours Update Completed: User completes the flow update their business hours settings
   *
   * When to trigger this event:
   * 1. User clicks Save to update their Work Hours preferences. Trigger on success message.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/lk6dAMb1Q/trigger/XzsMAIp0qg
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} properties.autoClassifyOutsideWorkHoursPreference - Preference options for Auto Classifying Drives Outside Work Hours setting
   * @param {string} properties.autoClassifyDuringWorkHoursPreference - Preference options for Auto Classifying Drives During Work Hours setting
   * @param {string} properties.workHoursSchedule - Scheduling types for Work Hours
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/lk6dAMb1Q}
   */
  function workHoursUpdateCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertAutoClassifyOutsideWorkHoursPreference(
          properties.autoClassifyOutsideWorkHoursPreference
        )
      );
      messages = messages.concat(
        assertAutoClassifyDuringWorkHoursPreference(
          properties.autoClassifyDuringWorkHoursPreference
        )
      );
      messages = messages.concat(
        assertWorkHoursSchedule(properties.workHoursSchedule)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Work Hours Update Completed",
          Object.keys(properties),
          [
            "platform",
            "autoClassifyOutsideWorkHoursPreference",
            "autoClassifyDuringWorkHoursPreference",
            "workHoursSchedule",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "lk6dAMb1Q",
          "0905fe8a1839e29eb8c7b285c14cd552696f12cab193795a243bda82a0fc2610",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Work Hours Update Completed",
        {
          Platform: properties.platform,
          "Auto Classify Outside Work Hours Preference":
            properties.autoClassifyOutsideWorkHoursPreference,
          "Auto Classify During Work Hours Preference":
            properties.autoClassifyDuringWorkHoursPreference,
          "Work Hours Schedule": properties.workHoursSchedule,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "lk6dAMb1Q",
          "Work Hours Update Completed",
          messages,
          [
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "Oh1Cp64hH",
              name: "Auto Classify Outside Work Hours Preference",
              value: properties.autoClassifyOutsideWorkHoursPreference,
            },
            {
              id: "xFeOzRR8i",
              name: "Auto Classify During Work Hours Preference",
              value: properties.autoClassifyDuringWorkHoursPreference,
            },
            {
              id: "yQPukTxGs",
              name: "Work Hours Schedule",
              value: properties.workHoursSchedule,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Work Hours Update Completed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Work Hours Update Completed",
          {
            Platform: properties.platform,
            "Auto Classify Outside Work Hours Preference":
              properties.autoClassifyOutsideWorkHoursPreference,
            "Auto Classify During Work Hours Preference":
              properties.autoClassifyDuringWorkHoursPreference,
            "Work Hours Schedule": properties.workHoursSchedule,
          },
          "lk6dAMb1Q",
          "0905fe8a1839e29eb8c7b285c14cd552696f12cab193795a243bda82a0fc2610"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Work Hours Update Completed", {
        Platform: properties.platform,
        "Auto Classify Outside Work Hours Preference":
          properties.autoClassifyOutsideWorkHoursPreference,
        "Auto Classify During Work Hours Preference":
          properties.autoClassifyDuringWorkHoursPreference,
        "Work Hours Schedule": properties.workHoursSchedule,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Work Hours Update Completed", {
        Platform: properties.platform,
        "Auto Classify Outside Work Hours Preference":
          properties.autoClassifyOutsideWorkHoursPreference,
        "Auto Classify During Work Hours Preference":
          properties.autoClassifyDuringWorkHoursPreference,
        "Work Hours Schedule": properties.workHoursSchedule,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Work Hours Update Completed", {
        Platform: properties.platform,
        "Auto Classify Outside Work Hours Preference":
          properties.autoClassifyOutsideWorkHoursPreference,
        "Auto Classify During Work Hours Preference":
          properties.autoClassifyDuringWorkHoursPreference,
        "Work Hours Schedule": properties.workHoursSchedule,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Work Hours Update Failed: User received an error when saving Work Hours settings
   *
   * When to trigger this event:
   * 1. User receives an error in the Hours settings
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/CQawl0PnO_/trigger/cgbjHjff1
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} properties.workHourFailure - Failure types from Work Hours
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/CQawl0PnO_}
   */
  function workHoursUpdateFailed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertWorkHourFailure(properties.workHourFailure)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Work Hours Update Failed",
          Object.keys(properties),
          ["platform", "workHourFailure"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "CQawl0PnO_",
          "794f1ca04167410846d591c612212f5445f6757b0052dc2a07a51e1a7794b4ba",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Work Hours Update Failed",
        {
          Platform: properties.platform,
          "Work Hour Failure": properties.workHourFailure,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "CQawl0PnO_",
          "Work Hours Update Failed",
          messages,
          [
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "oJV7MaqyD",
              name: "Work Hour Failure",
              value: properties.workHourFailure,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Work Hours Update Failed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Work Hours Update Failed",
          {
            Platform: properties.platform,
            "Work Hour Failure": properties.workHourFailure,
          },
          "CQawl0PnO_",
          "794f1ca04167410846d591c612212f5445f6757b0052dc2a07a51e1a7794b4ba"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Work Hours Update Failed", {
        Platform: properties.platform,
        "Work Hour Failure": properties.workHourFailure,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Work Hours Update Failed", {
        Platform: properties.platform,
        "Work Hour Failure": properties.workHourFailure,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Work Hours Update Failed", {
        Platform: properties.platform,
        "Work Hour Failure": properties.workHourFailure,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Custom Purpose Add Started: User starts the flow to add a new custom purpose
   *
   * When to trigger this event:
   * 1. User selects to add a custom purpose.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/MW_dYjteZ4/trigger/MmohVeppj
   * 2. User starts to add a custom purpose from the Add Drive flow
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/MW_dYjteZ4/trigger/LIllhUoos
   * 3. User starts to add a custom purpose from the drives page
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/MW_dYjteZ4/trigger/RT5VrtbvR
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.driveClassificationType - Drive classification categories types.
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} properties.customPurposeSource - Custom purpose source
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/MW_dYjteZ4}
   */
  function customPurposeAddStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(
        assertDriveClassificationType(properties.driveClassificationType)
      );
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertCustomPurposeSource(properties.customPurposeSource)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Custom Purpose Add Started",
          Object.keys(properties),
          ["driveClassificationType", "platform", "customPurposeSource"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "MW_dYjteZ4",
          "88c877cb343df7622d9019de8cb8530e9b384d29c5a2f9d2730d789ce8597f65",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Custom Purpose Add Started",
        {
          "Drive Classification Type": properties.driveClassificationType,
          Platform: properties.platform,
          "Custom Purpose Source": properties.customPurposeSource,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "MW_dYjteZ4",
          "Custom Purpose Add Started",
          messages,
          [
            {
              id: "4Y4Sy8Xnx",
              name: "Custom Purpose Source",
              value: properties.customPurposeSource,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "oMiAPbzL8",
              name: "Drive Classification Type",
              value: properties.driveClassificationType,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Custom Purpose Add Started': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Custom Purpose Add Started",
          {
            "Drive Classification Type": properties.driveClassificationType,
            Platform: properties.platform,
            "Custom Purpose Source": properties.customPurposeSource,
          },
          "MW_dYjteZ4",
          "88c877cb343df7622d9019de8cb8530e9b384d29c5a2f9d2730d789ce8597f65"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Custom Purpose Add Started", {
        "Drive Classification Type": properties.driveClassificationType,
        Platform: properties.platform,
        "Custom Purpose Source": properties.customPurposeSource,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Custom Purpose Add Started", {
        "Drive Classification Type": properties.driveClassificationType,
        Platform: properties.platform,
        "Custom Purpose Source": properties.customPurposeSource,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Custom Purpose Add Started", {
        "Drive Classification Type": properties.driveClassificationType,
        Platform: properties.platform,
        "Custom Purpose Source": properties.customPurposeSource,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Custom Purpose Add Completed: User completes the flow to add a new custom purpose
   *
   * When to trigger this event:
   * 1. User saves a new custom purpose.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/BJNXSY9hA/trigger/pdZ1gXhJ4R
   * 2. User adds a custom purpose from the drives filter
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/BJNXSY9hA/trigger/caXb4Lzek
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.driveClassificationType - Drive classification categories types.
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} properties.customPurposeSource - Custom purpose source
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/BJNXSY9hA}
   */
  function customPurposeAddCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(
        assertDriveClassificationType(properties.driveClassificationType)
      );
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertCustomPurposeSource(properties.customPurposeSource)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Custom Purpose Add Completed",
          Object.keys(properties),
          ["driveClassificationType", "platform", "customPurposeSource"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "BJNXSY9hA",
          "78b5b3f3f57ce9d586eda7d0e1950d485c98ce895cb70f43b6fb0578d700ce26",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Custom Purpose Add Completed",
        {
          "Drive Classification Type": properties.driveClassificationType,
          Platform: properties.platform,
          "Custom Purpose Source": properties.customPurposeSource,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "BJNXSY9hA",
          "Custom Purpose Add Completed",
          messages,
          [
            {
              id: "4Y4Sy8Xnx",
              name: "Custom Purpose Source",
              value: properties.customPurposeSource,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "oMiAPbzL8",
              name: "Drive Classification Type",
              value: properties.driveClassificationType,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Custom Purpose Add Completed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Custom Purpose Add Completed",
          {
            "Drive Classification Type": properties.driveClassificationType,
            Platform: properties.platform,
            "Custom Purpose Source": properties.customPurposeSource,
          },
          "BJNXSY9hA",
          "78b5b3f3f57ce9d586eda7d0e1950d485c98ce895cb70f43b6fb0578d700ce26"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Custom Purpose Add Completed", {
        "Drive Classification Type": properties.driveClassificationType,
        Platform: properties.platform,
        "Custom Purpose Source": properties.customPurposeSource,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Custom Purpose Add Completed", {
        "Drive Classification Type": properties.driveClassificationType,
        Platform: properties.platform,
        "Custom Purpose Source": properties.customPurposeSource,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Custom Purpose Add Completed", {
        "Drive Classification Type": properties.driveClassificationType,
        Platform: properties.platform,
        "Custom Purpose Source": properties.customPurposeSource,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Custom Purpose Updated: User updates a custom purpose
   *
   * When to trigger this event:
   * 1. User updates a custom purpose in one of the following ways
Hide
Unhide
Order
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/fmY0tIs5e/trigger/mb4FrTzS37
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.driveClassificationType - Drive classification categories types.
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} properties.customPurposeUpdate - Update options on custom purpose
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/fmY0tIs5e}
   */
  function customPurposeUpdated(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(
        assertDriveClassificationType(properties.driveClassificationType)
      );
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertCustomPurposeUpdate(properties.customPurposeUpdate)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Custom Purpose Updated",
          Object.keys(properties),
          ["driveClassificationType", "platform", "customPurposeUpdate"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "fmY0tIs5e",
          "679c04625431b8d61559d2fd7c12747af7ef82db82ae96d42c1b7a690d440556",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Custom Purpose Updated",
        {
          "Drive Classification Type": properties.driveClassificationType,
          Platform: properties.platform,
          "Custom Purpose Update": properties.customPurposeUpdate,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "fmY0tIs5e",
          "Custom Purpose Updated",
          messages,
          [
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "Sul-LTTMY",
              name: "Custom Purpose Update",
              value: properties.customPurposeUpdate,
            },
            {
              id: "oMiAPbzL8",
              name: "Drive Classification Type",
              value: properties.driveClassificationType,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Custom Purpose Updated': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Custom Purpose Updated",
          {
            "Drive Classification Type": properties.driveClassificationType,
            Platform: properties.platform,
            "Custom Purpose Update": properties.customPurposeUpdate,
          },
          "fmY0tIs5e",
          "679c04625431b8d61559d2fd7c12747af7ef82db82ae96d42c1b7a690d440556"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Custom Purpose Updated", {
        "Drive Classification Type": properties.driveClassificationType,
        Platform: properties.platform,
        "Custom Purpose Update": properties.customPurposeUpdate,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Custom Purpose Updated", {
        "Drive Classification Type": properties.driveClassificationType,
        Platform: properties.platform,
        "Custom Purpose Update": properties.customPurposeUpdate,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Custom Purpose Updated", {
        "Drive Classification Type": properties.driveClassificationType,
        Platform: properties.platform,
        "Custom Purpose Update": properties.customPurposeUpdate,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Distance Unit Updated: User updates their distance unit prefence.
   *
   * When to trigger this event:
   * 1. User saves a new distance unit preference
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/G35p0gZeX/trigger/gQDHumAysd
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} properties.distanceUnit - Distance unit options
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/G35p0gZeX}
   */
  function distanceUnitUpdated(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertDistanceUnit(properties.distanceUnit));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Distance Unit Updated",
          Object.keys(properties),
          ["platform", "distanceUnit"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "G35p0gZeX",
          "0555dce9ddd4a9ae8a47c64e6444de45049df30133d63e124661ae97a0db551d",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Distance Unit Updated",
        {
          Platform: properties.platform,
          "Distance Unit": properties.distanceUnit,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "G35p0gZeX",
          "Distance Unit Updated",
          messages,
          [
            {
              id: "66VK90YPq",
              name: "Distance Unit",
              value: properties.distanceUnit,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Distance Unit Updated': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Distance Unit Updated",
          {
            Platform: properties.platform,
            "Distance Unit": properties.distanceUnit,
          },
          "G35p0gZeX",
          "0555dce9ddd4a9ae8a47c64e6444de45049df30133d63e124661ae97a0db551d"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Distance Unit Updated", {
        Platform: properties.platform,
        "Distance Unit": properties.distanceUnit,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Distance Unit Updated", {
        Platform: properties.platform,
        "Distance Unit": properties.distanceUnit,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Distance Unit Updated", {
        Platform: properties.platform,
        "Distance Unit": properties.distanceUnit,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Distance Rate Update Completed: User completes the flow to update a distance rate, which should only trigger once when the 'save' option becomes available
   *
   * When to trigger this event:
   * 1. User completes the flow to update a distance rate by clicking save
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/qaZIPmKsy/trigger/oSuhjUjgbT
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/qaZIPmKsy}
   */
  function distanceRateUpdateCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Distance Rate Update Completed",
          Object.keys(properties),
          ["platform"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "qaZIPmKsy",
          "8a521209852dbc9e90a933bce712cc81e56c84f9c0bbfdad01a1fe49e1758e1c",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Distance Rate Update Completed",
        {
          Platform: properties.platform,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "qaZIPmKsy",
          "Distance Rate Update Completed",
          messages,
          [{ id: "FfkzdkMHsZ", name: "Platform", value: properties.platform }],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Distance Rate Update Completed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Distance Rate Update Completed",
          {
            Platform: properties.platform,
          },
          "qaZIPmKsy",
          "8a521209852dbc9e90a933bce712cc81e56c84f9c0bbfdad01a1fe49e1758e1c"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Distance Rate Update Completed", {
        Platform: properties.platform,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Distance Rate Update Completed", {
        Platform: properties.platform,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Distance Rate Update Completed", {
        Platform: properties.platform,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Reports Filtered: Driver applies a filter to their reports view
   *
   * When to trigger this event:
   * 1. User applies any filter on the report page
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/vlx8uEiIYp/trigger/wyTpETvjz
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.reportsDateFilter - Selection options on the Reports Date Filter
   * @param {string} properties.reportsDriveFilter - Selection options for the Reports Drive Filter
   * @param {string} properties.reportsVehicleFilter - Selection options for Reports Vehicle Filter. This is an abstraction of options (all or select).
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {int} properties.subscriptionId - User's MileIQ Subscription ID at time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/vlx8uEiIYp}
   */
  function reportsFiltered(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(
        assertReportsDateFilter(properties.reportsDateFilter)
      );
      messages = messages.concat(
        assertReportsDriveFilter(properties.reportsDriveFilter)
      );
      messages = messages.concat(
        assertReportsVehicleFilter(properties.reportsVehicleFilter)
      );
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertSubscriptionId(properties.subscriptionId)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Reports Filtered",
          Object.keys(properties),
          [
            "reportsDateFilter",
            "reportsDriveFilter",
            "reportsVehicleFilter",
            "platform",
            "organizationGroupId",
            "organizationId",
            "subscriptionId",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "vlx8uEiIYp",
          "1ef30a72a0c07306d3f14c6601e3655e02c697c74fcaa888c35a094719e005c0",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Reports Filtered",
        {
          "Reports Date Filter": properties.reportsDateFilter,
          "Reports Drive Filter": properties.reportsDriveFilter,
          "Reports Vehicle Filter": properties.reportsVehicleFilter,
          Platform: properties.platform,
          "Organization Group ID": properties.organizationGroupId,
          "Organization ID": properties.organizationId,
          subscription_id: properties.subscriptionId,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "vlx8uEiIYp",
          "Reports Filtered",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            {
              id: "EPgAk6V-T",
              name: "Reports Drive Filter",
              value: properties.reportsDriveFilter,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "IrRajt9Rv",
              name: "Reports Date Filter",
              value: properties.reportsDateFilter,
            },
            {
              id: "TDTeQm2UP",
              name: "subscription_id",
              value: properties.subscriptionId,
            },
            {
              id: "kkaUYVCew",
              name: "Reports Vehicle Filter",
              value: properties.reportsVehicleFilter,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Reports Filtered': " + messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Reports Filtered",
          {
            "Reports Date Filter": properties.reportsDateFilter,
            "Reports Drive Filter": properties.reportsDriveFilter,
            "Reports Vehicle Filter": properties.reportsVehicleFilter,
            Platform: properties.platform,
            "Organization Group ID": properties.organizationGroupId,
            "Organization ID": properties.organizationId,
            subscription_id: properties.subscriptionId,
          },
          "vlx8uEiIYp",
          "1ef30a72a0c07306d3f14c6601e3655e02c697c74fcaa888c35a094719e005c0"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Reports Filtered", {
        "Reports Date Filter": properties.reportsDateFilter,
        "Reports Drive Filter": properties.reportsDriveFilter,
        "Reports Vehicle Filter": properties.reportsVehicleFilter,
        Platform: properties.platform,
        "Organization Group ID": properties.organizationGroupId,
        "Organization ID": properties.organizationId,
        subscription_id: properties.subscriptionId,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Reports Filtered", {
        "Reports Date Filter": properties.reportsDateFilter,
        "Reports Drive Filter": properties.reportsDriveFilter,
        "Reports Vehicle Filter": properties.reportsVehicleFilter,
        Platform: properties.platform,
        "Organization Group ID": properties.organizationGroupId,
        "Organization ID": properties.organizationId,
        subscription_id: properties.subscriptionId,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Reports Filtered", {
        "Reports Date Filter": properties.reportsDateFilter,
        "Reports Drive Filter": properties.reportsDriveFilter,
        "Reports Vehicle Filter": properties.reportsVehicleFilter,
        Platform: properties.platform,
        "Organization Group ID": properties.organizationGroupId,
        "Organization ID": properties.organizationId,
        subscription_id: properties.subscriptionId,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Report Creation Started: Driver starts the process to create a report. Note that there are multiple trigger points or ways a user can start the report submission process.
   *
   * When to trigger this event:
   * 1. User starts the process to create a report from the Reports Page on a driver's dashboard.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/F4oifNsH29/trigger/1N8ZipAxe
   * 2. Driver starts report from drives page
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/F4oifNsH29/trigger/omURVbJBX
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {int} properties.reportBusinessDrives - Number of business drive in report
   * @param {int} properties.reportPersonalDrives - Number of personal drives in report
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {int} properties.subscriptionId - User's MileIQ Subscription ID at time of event
   * @param {string} properties.page - The page or screen in app or on the web where the event sourced from.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/F4oifNsH29}
   */
  function reportCreationStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertReportBusinessDrives(properties.reportBusinessDrives)
      );
      messages = messages.concat(
        assertReportPersonalDrives(properties.reportPersonalDrives)
      );
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertSubscriptionId(properties.subscriptionId)
      );
      messages = messages.concat(assertPage(properties.page));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Report Creation Started",
          Object.keys(properties),
          [
            "platform",
            "reportBusinessDrives",
            "reportPersonalDrives",
            "organizationId",
            "organizationGroupId",
            "subscriptionId",
            "page",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "F4oifNsH29",
          "75d5d1e06d5463421f32d10bb90dc80f26d6bac99a58f2f673b32c5a143d563f",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Report Creation Started",
        {
          Platform: properties.platform,
          "Report Business Drives": properties.reportBusinessDrives,
          "Report Personal Drives": properties.reportPersonalDrives,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          subscription_id: properties.subscriptionId,
          Page: properties.page,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "F4oifNsH29",
          "Report Creation Started",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            { id: "4j_Pu5zIMW", name: "Page", value: properties.page },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "TDTeQm2UP",
              name: "subscription_id",
              value: properties.subscriptionId,
            },
            {
              id: "gtLqSg8tJ",
              name: "Report Business Drives",
              value: properties.reportBusinessDrives,
            },
            {
              id: "pIO_2RvM0",
              name: "Report Personal Drives",
              value: properties.reportPersonalDrives,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Report Creation Started': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Report Creation Started",
          {
            Platform: properties.platform,
            "Report Business Drives": properties.reportBusinessDrives,
            "Report Personal Drives": properties.reportPersonalDrives,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            subscription_id: properties.subscriptionId,
            Page: properties.page,
          },
          "F4oifNsH29",
          "75d5d1e06d5463421f32d10bb90dc80f26d6bac99a58f2f673b32c5a143d563f"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Report Creation Started", {
        Platform: properties.platform,
        "Report Business Drives": properties.reportBusinessDrives,
        "Report Personal Drives": properties.reportPersonalDrives,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        subscription_id: properties.subscriptionId,
        Page: properties.page,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Report Creation Started", {
        Platform: properties.platform,
        "Report Business Drives": properties.reportBusinessDrives,
        "Report Personal Drives": properties.reportPersonalDrives,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        subscription_id: properties.subscriptionId,
        Page: properties.page,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Report Creation Started", {
        Platform: properties.platform,
        "Report Business Drives": properties.reportBusinessDrives,
        "Report Personal Drives": properties.reportPersonalDrives,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        subscription_id: properties.subscriptionId,
        Page: properties.page,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Report Creation Completed: Driver completes the process to create a report. Note that there are multiple trigger points or ways a user can start the report submission process.
   *
   * When to trigger this event:
   * 1. User completes the process to create a report from the Reports Page on a driver's dashboard.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/WRbN0qP49/trigger/zSb9QAdUeM
   * 2. Triggers when user taps "Send report" on Share report screen of new two step report creation process
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/WRbN0qP49/trigger/ZNPPqHSk3
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {int} properties.reportBusinessDrives - Number of business drive in report
   * @param {int} properties.reportPersonalDrives - Number of personal drives in report
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {int} properties.subscriptionId - User's MileIQ Subscription ID at time of event
   * @param {string} properties.page - The page or screen in app or on the web where the event sourced from.
   * @param {string} properties.reportRecipientType - Type of recipient of the report: Team Admin, Email, Concur
   * @param {string} [properties.reportMarkDrives] - Selection options on marking drives (mark reported) on report recreation
   * @param {int} properties.reportUnclassifiedDrives - Number of unclassified drives in report
   * @param {string} [properties.contactRelationship] - User reported relationship between them and their saved contact. For example, Tax professional, Reimburser, Someone else.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/WRbN0qP49}
   */
  function reportCreationCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertReportBusinessDrives(properties.reportBusinessDrives)
      );
      messages = messages.concat(
        assertReportPersonalDrives(properties.reportPersonalDrives)
      );
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertSubscriptionId(properties.subscriptionId)
      );
      messages = messages.concat(assertPage(properties.page));
      messages = messages.concat(
        assertReportRecipientType(properties.reportRecipientType)
      );
      messages = messages.concat(
        assertOptionalReportMarkDrives(properties.reportMarkDrives)
      );
      messages = messages.concat(
        assertReportUnclassifiedDrives(properties.reportUnclassifiedDrives)
      );
      messages = messages.concat(
        assertOptionalContactRelationship(properties.contactRelationship)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Report Creation Completed",
          Object.keys(properties),
          [
            "platform",
            "reportBusinessDrives",
            "reportPersonalDrives",
            "organizationId",
            "organizationGroupId",
            "subscriptionId",
            "page",
            "reportRecipientType",
            "reportMarkDrives",
            "reportUnclassifiedDrives",
            "contactRelationship",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "WRbN0qP49",
          "03ae3cb725ad10262ff7bd46d74cd9dd44170eb715b12a41c87c55cd5a399e04",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Report Creation Completed",
        {
          Platform: properties.platform,
          "Report Business Drives": properties.reportBusinessDrives,
          "Report Personal Drives": properties.reportPersonalDrives,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          subscription_id: properties.subscriptionId,
          Page: properties.page,
          "Report Recipient Type": properties.reportRecipientType,
          "Report Mark Drives": properties.reportMarkDrives,
          "Report Unclassified Drives": properties.reportUnclassifiedDrives,
          "Contact Relationship": properties.contactRelationship,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "WRbN0qP49",
          "Report Creation Completed",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            { id: "4j_Pu5zIMW", name: "Page", value: properties.page },
            {
              id: "8BiIah0U4",
              name: "Contact Relationship",
              value: properties.contactRelationship,
            },
            {
              id: "AtIut9HHF",
              name: "Report Mark Drives",
              value: properties.reportMarkDrives,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "TDTeQm2UP",
              name: "subscription_id",
              value: properties.subscriptionId,
            },
            {
              id: "fgug2PGnqJ",
              name: "Report Recipient Type",
              value: properties.reportRecipientType,
            },
            {
              id: "gtLqSg8tJ",
              name: "Report Business Drives",
              value: properties.reportBusinessDrives,
            },
            {
              id: "nUhX3A1DT",
              name: "Report Unclassified Drives",
              value: properties.reportUnclassifiedDrives,
            },
            {
              id: "pIO_2RvM0",
              name: "Report Personal Drives",
              value: properties.reportPersonalDrives,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Report Creation Completed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Report Creation Completed",
          {
            Platform: properties.platform,
            "Report Business Drives": properties.reportBusinessDrives,
            "Report Personal Drives": properties.reportPersonalDrives,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            subscription_id: properties.subscriptionId,
            Page: properties.page,
            "Report Recipient Type": properties.reportRecipientType,
            "Report Mark Drives": properties.reportMarkDrives,
            "Report Unclassified Drives": properties.reportUnclassifiedDrives,
            "Contact Relationship": properties.contactRelationship,
          },
          "WRbN0qP49",
          "03ae3cb725ad10262ff7bd46d74cd9dd44170eb715b12a41c87c55cd5a399e04"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Report Creation Completed", {
        Platform: properties.platform,
        "Report Business Drives": properties.reportBusinessDrives,
        "Report Personal Drives": properties.reportPersonalDrives,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        subscription_id: properties.subscriptionId,
        Page: properties.page,
        "Report Recipient Type": properties.reportRecipientType,
        "Report Mark Drives": properties.reportMarkDrives,
        "Report Unclassified Drives": properties.reportUnclassifiedDrives,
        "Contact Relationship": properties.contactRelationship,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Report Creation Completed", {
        Platform: properties.platform,
        "Report Business Drives": properties.reportBusinessDrives,
        "Report Personal Drives": properties.reportPersonalDrives,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        subscription_id: properties.subscriptionId,
        Page: properties.page,
        "Report Recipient Type": properties.reportRecipientType,
        "Report Mark Drives": properties.reportMarkDrives,
        "Report Unclassified Drives": properties.reportUnclassifiedDrives,
        "Contact Relationship": properties.contactRelationship,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Report Creation Completed", {
        Platform: properties.platform,
        "Report Business Drives": properties.reportBusinessDrives,
        "Report Personal Drives": properties.reportPersonalDrives,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        subscription_id: properties.subscriptionId,
        Page: properties.page,
        "Report Recipient Type": properties.reportRecipientType,
        "Report Mark Drives": properties.reportMarkDrives,
        "Report Unclassified Drives": properties.reportUnclassifiedDrives,
        "Contact Relationship": properties.contactRelationship,
      });

      // destination Braze
      Braze.logEvent("Report Creation Completed", {
        Platform: properties.platform,
        "Report Business Drives": properties.reportBusinessDrives,
        "Report Personal Drives": properties.reportPersonalDrives,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Subscription Type": properties.subscriptionId,
        Page: properties.page,
        "Report Recipient Type": properties.reportRecipientType,
        "Report Mark Drives": properties.reportMarkDrives,
        "Report Unclassified Drives": properties.reportUnclassifiedDrives,
        "Contact Relationship": properties.contactRelationship,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Report Creation Failed: Driver receives an error in the report creation process
   *
   * When to trigger this event:
   * 1. User receives an error in the report creation flow
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/1cdrfpWxk/trigger/bsZ8Rb_POo
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {int} properties.subscriptionId - User's MileIQ Subscription ID at time of event
   * @param {string} properties.page - The page or screen in app or on the web where the event sourced from.
   * @param {string} properties.reportCreationFailure - Failure types
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/1cdrfpWxk}
   */
  function reportCreationFailed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertSubscriptionId(properties.subscriptionId)
      );
      messages = messages.concat(assertPage(properties.page));
      messages = messages.concat(
        assertReportCreationFailure(properties.reportCreationFailure)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Report Creation Failed",
          Object.keys(properties),
          [
            "platform",
            "organizationId",
            "organizationGroupId",
            "subscriptionId",
            "page",
            "reportCreationFailure",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "1cdrfpWxk",
          "f4e1bb5215f869db52f05cd09e9922576864cb3b0a824f6e049b56993883ffc6",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Report Creation Failed",
        {
          Platform: properties.platform,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          subscription_id: properties.subscriptionId,
          Page: properties.page,
          "Report Creation Failure": properties.reportCreationFailure,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "1cdrfpWxk",
          "Report Creation Failed",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "3ZA9BthdP",
              name: "Report Creation Failure",
              value: properties.reportCreationFailure,
            },
            { id: "4j_Pu5zIMW", name: "Page", value: properties.page },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "TDTeQm2UP",
              name: "subscription_id",
              value: properties.subscriptionId,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Report Creation Failed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Report Creation Failed",
          {
            Platform: properties.platform,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            subscription_id: properties.subscriptionId,
            Page: properties.page,
            "Report Creation Failure": properties.reportCreationFailure,
          },
          "1cdrfpWxk",
          "f4e1bb5215f869db52f05cd09e9922576864cb3b0a824f6e049b56993883ffc6"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Report Creation Failed", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        subscription_id: properties.subscriptionId,
        Page: properties.page,
        "Report Creation Failure": properties.reportCreationFailure,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Report Creation Failed", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        subscription_id: properties.subscriptionId,
        Page: properties.page,
        "Report Creation Failure": properties.reportCreationFailure,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Report Creation Failed", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        subscription_id: properties.subscriptionId,
        Page: properties.page,
        "Report Creation Failure": properties.reportCreationFailure,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Report Downloaded: Driver downloads an archived report
   *
   * When to trigger this event:
   * 1. User downloads an archived report
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/ANtneykaQ/trigger/gCuBVdr_Ol
   * 2. Report is downloaded from the shared with me page on the contacts lightweight dashboard
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/ANtneykaQ/trigger/t8xCSDS6k
   * 3. Report is downloaded from the shared reports section of the lightweight contacts dashboard
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/ANtneykaQ/trigger/1IDnWlZFH
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {int} properties.subscriptionId - User's MileIQ Subscription ID at time of event
   * @param {string} properties.page - The page or screen in app or on the web where the event sourced from.
   * @param {string} properties.downloadFormat - File format of a report download
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/ANtneykaQ}
   */
  function reportDownloaded(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertSubscriptionId(properties.subscriptionId)
      );
      messages = messages.concat(assertPage(properties.page));
      messages = messages.concat(
        assertDownloadFormat(properties.downloadFormat)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Report Downloaded",
          Object.keys(properties),
          [
            "platform",
            "organizationId",
            "organizationGroupId",
            "subscriptionId",
            "page",
            "downloadFormat",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "ANtneykaQ",
          "e05ac9f3655991455ec69d236932ff6130241f6a9d67de84c0b3323be50a3930",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Report Downloaded",
        {
          Platform: properties.platform,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          subscription_id: properties.subscriptionId,
          Page: properties.page,
          "Download Format": properties.downloadFormat,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "ANtneykaQ",
          "Report Downloaded",
          messages,
          [
            {
              id: "-PkiBW72m",
              name: "Download Format",
              value: properties.downloadFormat,
            },
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            { id: "4j_Pu5zIMW", name: "Page", value: properties.page },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "TDTeQm2UP",
              name: "subscription_id",
              value: properties.subscriptionId,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Report Downloaded': " + messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Report Downloaded",
          {
            Platform: properties.platform,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            subscription_id: properties.subscriptionId,
            Page: properties.page,
            "Download Format": properties.downloadFormat,
          },
          "ANtneykaQ",
          "e05ac9f3655991455ec69d236932ff6130241f6a9d67de84c0b3323be50a3930"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Report Downloaded", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        subscription_id: properties.subscriptionId,
        Page: properties.page,
        "Download Format": properties.downloadFormat,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Report Downloaded", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        subscription_id: properties.subscriptionId,
        Page: properties.page,
        "Download Format": properties.downloadFormat,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Report Downloaded", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        subscription_id: properties.subscriptionId,
        Page: properties.page,
        "Download Format": properties.downloadFormat,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Report Deleted: Driver deletes a report
   *
   * When to trigger this event:
   * 1. User deletes a report
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/96c6wvnUI/trigger/gZDKkEgcex
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {int} properties.subscriptionId - User's MileIQ Subscription ID at time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/96c6wvnUI}
   */
  function reportDeleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertSubscriptionId(properties.subscriptionId)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Report Deleted",
          Object.keys(properties),
          [
            "platform",
            "organizationId",
            "organizationGroupId",
            "subscriptionId",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "96c6wvnUI",
          "58ff53381e4da4217c4889f0e2f2a32d0f89e08ebe680a6c5d603b09b1ec5529",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Report Deleted",
        {
          Platform: properties.platform,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          subscription_id: properties.subscriptionId,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "96c6wvnUI",
          "Report Deleted",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "TDTeQm2UP",
              name: "subscription_id",
              value: properties.subscriptionId,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Report Deleted': " + messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Report Deleted",
          {
            Platform: properties.platform,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            subscription_id: properties.subscriptionId,
          },
          "96c6wvnUI",
          "58ff53381e4da4217c4889f0e2f2a32d0f89e08ebe680a6c5d603b09b1ec5529"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Report Deleted", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        subscription_id: properties.subscriptionId,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Report Deleted", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        subscription_id: properties.subscriptionId,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Report Deleted", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        subscription_id: properties.subscriptionId,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Integration Started: Driver starts the process to connect an integration
   *
   * When to trigger this event:
   * 1. User starts the process to add an integration from any start point
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/fplJefRYYf/trigger/hUwZW1_Lw
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {int} properties.subscriptionId - User's MileIQ Subscription ID at time of event
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {string} properties.integration - Integration options
   * @param {string} properties.integrationProcess - Process type of integration setup
   * @param {string} properties.page - The page or screen in app or on the web where the event sourced from.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/fplJefRYYf}
   */
  function integrationStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertSubscriptionId(properties.subscriptionId)
      );
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(assertIntegration(properties.integration));
      messages = messages.concat(
        assertIntegrationProcess(properties.integrationProcess)
      );
      messages = messages.concat(assertPage(properties.page));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Integration Started",
          Object.keys(properties),
          [
            "platform",
            "subscriptionId",
            "organizationId",
            "organizationGroupId",
            "integration",
            "integrationProcess",
            "page",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "fplJefRYYf",
          "d663817deef174fcf81b3006bebbf65210e2cdabdae76ca36cd43f3a0dd2f6df",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Integration Started",
        {
          Platform: properties.platform,
          subscription_id: properties.subscriptionId,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          Integration: properties.integration,
          "Integration Process": properties.integrationProcess,
          Page: properties.page,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "fplJefRYYf",
          "Integration Started",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            { id: "4j_Pu5zIMW", name: "Page", value: properties.page },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "MPoe6Hqy5",
              name: "Integration",
              value: properties.integration,
            },
            {
              id: "TDTeQm2UP",
              name: "subscription_id",
              value: properties.subscriptionId,
            },
            {
              id: "kIO9IcVmz",
              name: "Integration Process",
              value: properties.integrationProcess,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Integration Started': " + messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Integration Started",
          {
            Platform: properties.platform,
            subscription_id: properties.subscriptionId,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            Integration: properties.integration,
            "Integration Process": properties.integrationProcess,
            Page: properties.page,
          },
          "fplJefRYYf",
          "d663817deef174fcf81b3006bebbf65210e2cdabdae76ca36cd43f3a0dd2f6df"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Integration Started", {
        Platform: properties.platform,
        subscription_id: properties.subscriptionId,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        Integration: properties.integration,
        "Integration Process": properties.integrationProcess,
        Page: properties.page,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Integration Started", {
        Platform: properties.platform,
        subscription_id: properties.subscriptionId,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        Integration: properties.integration,
        "Integration Process": properties.integrationProcess,
        Page: properties.page,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Integration Started", {
        Platform: properties.platform,
        subscription_id: properties.subscriptionId,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        Integration: properties.integration,
        "Integration Process": properties.integrationProcess,
        Page: properties.page,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Integration Step Completed: Driver completes a step in the integration flow
   *
   * When to trigger this event:
   * 1. User adds employee ID
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/ENtIw7JB9/trigger/mRwQiHdb-y
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {int} properties.subscriptionId - User's MileIQ Subscription ID at time of event
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {string} properties.integration - Integration options
   * @param {string} properties.integrationProcess - Process type of integration setup
   * @param {string} properties.page - The page or screen in app or on the web where the event sourced from.
   * @param {string} properties.integrationStepName - Step name of the integration flow
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/ENtIw7JB9}
   */
  function integrationStepCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertSubscriptionId(properties.subscriptionId)
      );
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(assertIntegration(properties.integration));
      messages = messages.concat(
        assertIntegrationProcess(properties.integrationProcess)
      );
      messages = messages.concat(assertPage(properties.page));
      messages = messages.concat(
        assertIntegrationStepName(properties.integrationStepName)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Integration Step Completed",
          Object.keys(properties),
          [
            "platform",
            "subscriptionId",
            "organizationId",
            "organizationGroupId",
            "integration",
            "integrationProcess",
            "page",
            "integrationStepName",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "ENtIw7JB9",
          "bb22cfb2f41c4ad842d08b9da20aaf586ce4907f0210b6b66a502e0f89c35a59",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Integration Step Completed",
        {
          Platform: properties.platform,
          subscription_id: properties.subscriptionId,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          Integration: properties.integration,
          "Integration Process": properties.integrationProcess,
          Page: properties.page,
          "Integration Step Name": properties.integrationStepName,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "ENtIw7JB9",
          "Integration Step Completed",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "0oLcCLWo-",
              name: "Integration Step Name",
              value: properties.integrationStepName,
            },
            { id: "4j_Pu5zIMW", name: "Page", value: properties.page },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "MPoe6Hqy5",
              name: "Integration",
              value: properties.integration,
            },
            {
              id: "TDTeQm2UP",
              name: "subscription_id",
              value: properties.subscriptionId,
            },
            {
              id: "kIO9IcVmz",
              name: "Integration Process",
              value: properties.integrationProcess,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Integration Step Completed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Integration Step Completed",
          {
            Platform: properties.platform,
            subscription_id: properties.subscriptionId,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            Integration: properties.integration,
            "Integration Process": properties.integrationProcess,
            Page: properties.page,
            "Integration Step Name": properties.integrationStepName,
          },
          "ENtIw7JB9",
          "bb22cfb2f41c4ad842d08b9da20aaf586ce4907f0210b6b66a502e0f89c35a59"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Integration Step Completed", {
        Platform: properties.platform,
        subscription_id: properties.subscriptionId,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        Integration: properties.integration,
        "Integration Process": properties.integrationProcess,
        Page: properties.page,
        "Integration Step Name": properties.integrationStepName,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Integration Step Completed", {
        Platform: properties.platform,
        subscription_id: properties.subscriptionId,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        Integration: properties.integration,
        "Integration Process": properties.integrationProcess,
        Page: properties.page,
        "Integration Step Name": properties.integrationStepName,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Integration Step Completed", {
        Platform: properties.platform,
        subscription_id: properties.subscriptionId,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        Integration: properties.integration,
        "Integration Process": properties.integrationProcess,
        Page: properties.page,
        "Integration Step Name": properties.integrationStepName,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Integration Completed: Driver completes the process to connect an integration
   *
   * When to trigger this event:
   * 1. User completes the process to add an integration from any start point
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/3G4GIqFnY/trigger/_verKBHdlw
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {int} properties.subscriptionId - User's MileIQ Subscription ID at time of event
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {string} properties.integration - Integration options
   * @param {string} properties.integrationProcess - Process type of integration setup
   * @param {string} properties.page - The page or screen in app or on the web where the event sourced from.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/3G4GIqFnY}
   */
  function integrationCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertSubscriptionId(properties.subscriptionId)
      );
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(assertIntegration(properties.integration));
      messages = messages.concat(
        assertIntegrationProcess(properties.integrationProcess)
      );
      messages = messages.concat(assertPage(properties.page));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Integration Completed",
          Object.keys(properties),
          [
            "platform",
            "subscriptionId",
            "organizationId",
            "organizationGroupId",
            "integration",
            "integrationProcess",
            "page",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "3G4GIqFnY",
          "0a49e89f9cbe7d36617db525f71a3ed3ed8f0097e0ff14b9879f62d977535928",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Integration Completed",
        {
          Platform: properties.platform,
          subscription_id: properties.subscriptionId,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          Integration: properties.integration,
          "Integration Process": properties.integrationProcess,
          Page: properties.page,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "3G4GIqFnY",
          "Integration Completed",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            { id: "4j_Pu5zIMW", name: "Page", value: properties.page },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "MPoe6Hqy5",
              name: "Integration",
              value: properties.integration,
            },
            {
              id: "TDTeQm2UP",
              name: "subscription_id",
              value: properties.subscriptionId,
            },
            {
              id: "kIO9IcVmz",
              name: "Integration Process",
              value: properties.integrationProcess,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Integration Completed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Integration Completed",
          {
            Platform: properties.platform,
            subscription_id: properties.subscriptionId,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            Integration: properties.integration,
            "Integration Process": properties.integrationProcess,
            Page: properties.page,
          },
          "3G4GIqFnY",
          "0a49e89f9cbe7d36617db525f71a3ed3ed8f0097e0ff14b9879f62d977535928"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Integration Completed", {
        Platform: properties.platform,
        subscription_id: properties.subscriptionId,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        Integration: properties.integration,
        "Integration Process": properties.integrationProcess,
        Page: properties.page,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Integration Completed", {
        Platform: properties.platform,
        subscription_id: properties.subscriptionId,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        Integration: properties.integration,
        "Integration Process": properties.integrationProcess,
        Page: properties.page,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Integration Completed", {
        Platform: properties.platform,
        subscription_id: properties.subscriptionId,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        Integration: properties.integration,
        "Integration Process": properties.integrationProcess,
        Page: properties.page,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Integration Failed: Driver receives an error in the integration flow
   *
   * When to trigger this event:
   * 1. User receives an error
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/GyGK9xbV9/trigger/_SRE5TfVnV
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {int} properties.subscriptionId - User's MileIQ Subscription ID at time of event
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {string} properties.integration - Integration options
   * @param {string} properties.integrationProcess - Process type of integration setup
   * @param {string} properties.page - The page or screen in app or on the web where the event sourced from.
   * @param {string} properties.integrationFailure - Integration Failure Types
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/GyGK9xbV9}
   */
  function integrationFailed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertSubscriptionId(properties.subscriptionId)
      );
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(assertIntegration(properties.integration));
      messages = messages.concat(
        assertIntegrationProcess(properties.integrationProcess)
      );
      messages = messages.concat(assertPage(properties.page));
      messages = messages.concat(
        assertIntegrationFailure(properties.integrationFailure)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Integration Failed",
          Object.keys(properties),
          [
            "platform",
            "subscriptionId",
            "organizationId",
            "organizationGroupId",
            "integration",
            "integrationProcess",
            "page",
            "integrationFailure",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "GyGK9xbV9",
          "8be32c83e184cde9c81a08ec6f626faed5a6524f7dfb8b8dfaf779adcda27c7a",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Integration Failed",
        {
          Platform: properties.platform,
          subscription_id: properties.subscriptionId,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          Integration: properties.integration,
          "Integration Process": properties.integrationProcess,
          Page: properties.page,
          "Integration Failure": properties.integrationFailure,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "GyGK9xbV9",
          "Integration Failed",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            { id: "4j_Pu5zIMW", name: "Page", value: properties.page },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "MPoe6Hqy5",
              name: "Integration",
              value: properties.integration,
            },
            {
              id: "NYO6CRT6w",
              name: "Integration Failure",
              value: properties.integrationFailure,
            },
            {
              id: "TDTeQm2UP",
              name: "subscription_id",
              value: properties.subscriptionId,
            },
            {
              id: "kIO9IcVmz",
              name: "Integration Process",
              value: properties.integrationProcess,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Integration Failed': " + messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Integration Failed",
          {
            Platform: properties.platform,
            subscription_id: properties.subscriptionId,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            Integration: properties.integration,
            "Integration Process": properties.integrationProcess,
            Page: properties.page,
            "Integration Failure": properties.integrationFailure,
          },
          "GyGK9xbV9",
          "8be32c83e184cde9c81a08ec6f626faed5a6524f7dfb8b8dfaf779adcda27c7a"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Integration Failed", {
        Platform: properties.platform,
        subscription_id: properties.subscriptionId,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        Integration: properties.integration,
        "Integration Process": properties.integrationProcess,
        Page: properties.page,
        "Integration Failure": properties.integrationFailure,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Integration Failed", {
        Platform: properties.platform,
        subscription_id: properties.subscriptionId,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        Integration: properties.integration,
        "Integration Process": properties.integrationProcess,
        Page: properties.page,
        "Integration Failure": properties.integrationFailure,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Integration Failed", {
        Platform: properties.platform,
        subscription_id: properties.subscriptionId,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        Integration: properties.integration,
        "Integration Process": properties.integrationProcess,
        Page: properties.page,
        "Integration Failure": properties.integrationFailure,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Integration Enable Started: Admin starts the process to enable an integation
   *
   * When to trigger this event:
   * 1. Admin clicks enable integration
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/hF14UQWQ9p/trigger/0zG_t7gJn
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {int} properties.subscriptionId - User's MileIQ Subscription ID at time of event
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {string} properties.integration - Integration options
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/hF14UQWQ9p}
   */
  function integrationEnableStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertSubscriptionId(properties.subscriptionId)
      );
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(assertIntegration(properties.integration));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Integration Enable Started",
          Object.keys(properties),
          [
            "platform",
            "subscriptionId",
            "organizationId",
            "organizationGroupId",
            "integration",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "hF14UQWQ9p",
          "a487457df89955f44783d8a4f2965c196fca8708b635972f5ad76f95f0bba137",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Integration Enable Started",
        {
          Platform: properties.platform,
          subscription_id: properties.subscriptionId,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          Integration: properties.integration,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "hF14UQWQ9p",
          "Integration Enable Started",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "MPoe6Hqy5",
              name: "Integration",
              value: properties.integration,
            },
            {
              id: "TDTeQm2UP",
              name: "subscription_id",
              value: properties.subscriptionId,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Integration Enable Started': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Integration Enable Started",
          {
            Platform: properties.platform,
            subscription_id: properties.subscriptionId,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            Integration: properties.integration,
          },
          "hF14UQWQ9p",
          "a487457df89955f44783d8a4f2965c196fca8708b635972f5ad76f95f0bba137"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Integration Enable Started", {
        Platform: properties.platform,
        subscription_id: properties.subscriptionId,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        Integration: properties.integration,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Integration Enable Started", {
        Platform: properties.platform,
        subscription_id: properties.subscriptionId,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        Integration: properties.integration,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Integration Enable Started", {
        Platform: properties.platform,
        subscription_id: properties.subscriptionId,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        Integration: properties.integration,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Integration Enable Completed: Admin completes the process to enable an integration
   *
   * When to trigger this event:
   * 1. Admin completes enable integration
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/8DBaKLtFU/trigger/AZ1yGpO91u
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {int} properties.subscriptionId - User's MileIQ Subscription ID at time of event
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {string} properties.integration - Integration options
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/8DBaKLtFU}
   */
  function integrationEnableCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertSubscriptionId(properties.subscriptionId)
      );
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(assertIntegration(properties.integration));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Integration Enable Completed",
          Object.keys(properties),
          [
            "platform",
            "subscriptionId",
            "organizationId",
            "organizationGroupId",
            "integration",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "8DBaKLtFU",
          "58a86b02ebd49a01a841623a3fda6ce9729e5641cac14b54a1027c14bfdfd32e",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Integration Enable Completed",
        {
          Platform: properties.platform,
          subscription_id: properties.subscriptionId,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          Integration: properties.integration,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "8DBaKLtFU",
          "Integration Enable Completed",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "MPoe6Hqy5",
              name: "Integration",
              value: properties.integration,
            },
            {
              id: "TDTeQm2UP",
              name: "subscription_id",
              value: properties.subscriptionId,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Integration Enable Completed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Integration Enable Completed",
          {
            Platform: properties.platform,
            subscription_id: properties.subscriptionId,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            Integration: properties.integration,
          },
          "8DBaKLtFU",
          "58a86b02ebd49a01a841623a3fda6ce9729e5641cac14b54a1027c14bfdfd32e"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Integration Enable Completed", {
        Platform: properties.platform,
        subscription_id: properties.subscriptionId,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        Integration: properties.integration,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Integration Enable Completed", {
        Platform: properties.platform,
        subscription_id: properties.subscriptionId,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        Integration: properties.integration,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Integration Enable Completed", {
        Platform: properties.platform,
        subscription_id: properties.subscriptionId,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        Integration: properties.integration,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Integration Edit Started: Admin starts the process to enable an integation
   *
   * When to trigger this event:
   * 1. Admin clicks edit integration
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/gw43zZLJW/trigger/1ObJ3BTma5
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {int} properties.subscriptionId - User's MileIQ Subscription ID at time of event
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {string} properties.integration - Integration options
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/gw43zZLJW}
   */
  function integrationEditStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertSubscriptionId(properties.subscriptionId)
      );
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(assertIntegration(properties.integration));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Integration Edit Started",
          Object.keys(properties),
          [
            "platform",
            "subscriptionId",
            "organizationId",
            "organizationGroupId",
            "integration",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "gw43zZLJW",
          "11bb96c239704026f38b295add8763929bd97fc00c3d882ca5e0c44f284024dd",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Integration Edit Started",
        {
          Platform: properties.platform,
          subscription_id: properties.subscriptionId,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          Integration: properties.integration,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "gw43zZLJW",
          "Integration Edit Started",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "MPoe6Hqy5",
              name: "Integration",
              value: properties.integration,
            },
            {
              id: "TDTeQm2UP",
              name: "subscription_id",
              value: properties.subscriptionId,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Integration Edit Started': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Integration Edit Started",
          {
            Platform: properties.platform,
            subscription_id: properties.subscriptionId,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            Integration: properties.integration,
          },
          "gw43zZLJW",
          "11bb96c239704026f38b295add8763929bd97fc00c3d882ca5e0c44f284024dd"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Integration Edit Started", {
        Platform: properties.platform,
        subscription_id: properties.subscriptionId,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        Integration: properties.integration,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Integration Edit Started", {
        Platform: properties.platform,
        subscription_id: properties.subscriptionId,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        Integration: properties.integration,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Integration Edit Started", {
        Platform: properties.platform,
        subscription_id: properties.subscriptionId,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        Integration: properties.integration,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Integration Edit Completed: Admin completes the process to enable an integration
   *
   * When to trigger this event:
   * 1. Admin clicks save
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/Fo194CxSJ/trigger/t_6ABa2378
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {int} properties.subscriptionId - User's MileIQ Subscription ID at time of event
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {string} properties.integration - Integration options
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/Fo194CxSJ}
   */
  function integrationEditCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertSubscriptionId(properties.subscriptionId)
      );
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(assertIntegration(properties.integration));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Integration Edit Completed",
          Object.keys(properties),
          [
            "platform",
            "subscriptionId",
            "organizationId",
            "organizationGroupId",
            "integration",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "Fo194CxSJ",
          "81cdfcccfcbe4b6cdbf02ee166cd0a2b8f2474e342196a04b929118a0ec35534",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Integration Edit Completed",
        {
          Platform: properties.platform,
          subscription_id: properties.subscriptionId,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          Integration: properties.integration,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "Fo194CxSJ",
          "Integration Edit Completed",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "MPoe6Hqy5",
              name: "Integration",
              value: properties.integration,
            },
            {
              id: "TDTeQm2UP",
              name: "subscription_id",
              value: properties.subscriptionId,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Integration Edit Completed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Integration Edit Completed",
          {
            Platform: properties.platform,
            subscription_id: properties.subscriptionId,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            Integration: properties.integration,
          },
          "Fo194CxSJ",
          "81cdfcccfcbe4b6cdbf02ee166cd0a2b8f2474e342196a04b929118a0ec35534"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Integration Edit Completed", {
        Platform: properties.platform,
        subscription_id: properties.subscriptionId,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        Integration: properties.integration,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Integration Edit Completed", {
        Platform: properties.platform,
        subscription_id: properties.subscriptionId,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        Integration: properties.integration,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Integration Edit Completed", {
        Platform: properties.platform,
        subscription_id: properties.subscriptionId,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        Integration: properties.integration,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Integration Edit Failed: Admin completes the process to enable an integration
   *
   * When to trigger this event:
   * 1. Admin receives a failure in the
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/PMWu26Y8K/trigger/VxFm1Oq4W7
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {int} properties.subscriptionId - User's MileIQ Subscription ID at time of event
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {string} properties.integration - Integration options
   * @param {string} properties.integrationFailure - Integration Failure Types
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/PMWu26Y8K}
   */
  function integrationEditFailed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertSubscriptionId(properties.subscriptionId)
      );
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(assertIntegration(properties.integration));
      messages = messages.concat(
        assertIntegrationFailure(properties.integrationFailure)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Integration Edit Failed",
          Object.keys(properties),
          [
            "platform",
            "subscriptionId",
            "organizationId",
            "organizationGroupId",
            "integration",
            "integrationFailure",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "PMWu26Y8K",
          "156379ae24db016d44d4a6be46b182466cdfc5795d046d70bc17f49ea5c144cb",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Integration Edit Failed",
        {
          Platform: properties.platform,
          subscription_id: properties.subscriptionId,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          Integration: properties.integration,
          "Integration Failure": properties.integrationFailure,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "PMWu26Y8K",
          "Integration Edit Failed",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "MPoe6Hqy5",
              name: "Integration",
              value: properties.integration,
            },
            {
              id: "NYO6CRT6w",
              name: "Integration Failure",
              value: properties.integrationFailure,
            },
            {
              id: "TDTeQm2UP",
              name: "subscription_id",
              value: properties.subscriptionId,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Integration Edit Failed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Integration Edit Failed",
          {
            Platform: properties.platform,
            subscription_id: properties.subscriptionId,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            Integration: properties.integration,
            "Integration Failure": properties.integrationFailure,
          },
          "PMWu26Y8K",
          "156379ae24db016d44d4a6be46b182466cdfc5795d046d70bc17f49ea5c144cb"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Integration Edit Failed", {
        Platform: properties.platform,
        subscription_id: properties.subscriptionId,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        Integration: properties.integration,
        "Integration Failure": properties.integrationFailure,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Integration Edit Failed", {
        Platform: properties.platform,
        subscription_id: properties.subscriptionId,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        Integration: properties.integration,
        "Integration Failure": properties.integrationFailure,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Integration Edit Failed", {
        Platform: properties.platform,
        subscription_id: properties.subscriptionId,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        Integration: properties.integration,
        "Integration Failure": properties.integrationFailure,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Integration Removed: Admin removes an integration
   *
   * When to trigger this event:
   * 1. Admin removes an integration
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/SEUKFaUp6/trigger/57QOhe52Jo
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {int} properties.subscriptionId - User's MileIQ Subscription ID at time of event
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {string} properties.integration - Integration options
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/SEUKFaUp6}
   */
  function integrationRemoved(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertSubscriptionId(properties.subscriptionId)
      );
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(assertIntegration(properties.integration));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Integration Removed",
          Object.keys(properties),
          [
            "platform",
            "subscriptionId",
            "organizationId",
            "organizationGroupId",
            "integration",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "SEUKFaUp6",
          "d306837a4002eb072ce869f2a12bedb2d9c603d92ef5427ecbab8aedc3479ea8",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Integration Removed",
        {
          Platform: properties.platform,
          subscription_id: properties.subscriptionId,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          Integration: properties.integration,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "SEUKFaUp6",
          "Integration Removed",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "MPoe6Hqy5",
              name: "Integration",
              value: properties.integration,
            },
            {
              id: "TDTeQm2UP",
              name: "subscription_id",
              value: properties.subscriptionId,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Integration Removed': " + messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Integration Removed",
          {
            Platform: properties.platform,
            subscription_id: properties.subscriptionId,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            Integration: properties.integration,
          },
          "SEUKFaUp6",
          "d306837a4002eb072ce869f2a12bedb2d9c603d92ef5427ecbab8aedc3479ea8"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Integration Removed", {
        Platform: properties.platform,
        subscription_id: properties.subscriptionId,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        Integration: properties.integration,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Integration Removed", {
        Platform: properties.platform,
        subscription_id: properties.subscriptionId,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        Integration: properties.integration,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Integration Removed", {
        Platform: properties.platform,
        subscription_id: properties.subscriptionId,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        Integration: properties.integration,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Integration Checked: Admin starts the process to enable an integration
   *
   * When to trigger this event:
   * 1. Admin checks the integration status
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/8_JlVP-EG/trigger/qwl9T92jnj
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {int} properties.subscriptionId - User's MileIQ Subscription ID at time of event
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {string} properties.integration - Integration options
   * @param {string} properties.integrationStatus - Integration status options
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/8_JlVP-EG}
   */
  function integrationChecked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertSubscriptionId(properties.subscriptionId)
      );
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(assertIntegration(properties.integration));
      messages = messages.concat(
        assertIntegrationStatus(properties.integrationStatus)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Integration Checked",
          Object.keys(properties),
          [
            "platform",
            "subscriptionId",
            "organizationId",
            "organizationGroupId",
            "integration",
            "integrationStatus",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "8_JlVP-EG",
          "cabc02227216922f118494d1975b2964b37ce77b94b6b3111c6bce6bb61e629f",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Integration Checked",
        {
          Platform: properties.platform,
          subscription_id: properties.subscriptionId,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          Integration: properties.integration,
          "Integration Status": properties.integrationStatus,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "8_JlVP-EG",
          "Integration Checked",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "MPoe6Hqy5",
              name: "Integration",
              value: properties.integration,
            },
            {
              id: "Q46D2yJ9r",
              name: "Integration Status",
              value: properties.integrationStatus,
            },
            {
              id: "TDTeQm2UP",
              name: "subscription_id",
              value: properties.subscriptionId,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Integration Checked': " + messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Integration Checked",
          {
            Platform: properties.platform,
            subscription_id: properties.subscriptionId,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            Integration: properties.integration,
            "Integration Status": properties.integrationStatus,
          },
          "8_JlVP-EG",
          "cabc02227216922f118494d1975b2964b37ce77b94b6b3111c6bce6bb61e629f"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Integration Checked", {
        Platform: properties.platform,
        subscription_id: properties.subscriptionId,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        Integration: properties.integration,
        "Integration Status": properties.integrationStatus,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Integration Checked", {
        Platform: properties.platform,
        subscription_id: properties.subscriptionId,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        Integration: properties.integration,
        "Integration Status": properties.integrationStatus,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Integration Checked", {
        Platform: properties.platform,
        subscription_id: properties.subscriptionId,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        Integration: properties.integration,
        "Integration Status": properties.integrationStatus,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Frequent Drive Prompted: User is prompted to auto-classify a frequent drive
   *
   * When to trigger this event:
   * 1. User takes any action on the prompt
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/VkSKtdT84/trigger/ByI5dZWMg
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} properties.page - The page or screen in app or on the web where the event sourced from.
   * @param {string} properties.frequentDrivePromptAction - User actions available from frequent drive prompt
   * @param {string} properties.frequentUnclassifiedDrivesAction - User selection on unclassified drives in the auto classify prompt
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/VkSKtdT84}
   */
  function frequentDrivePrompted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertPage(properties.page));
      messages = messages.concat(
        assertFrequentDrivePromptAction(properties.frequentDrivePromptAction)
      );
      messages = messages.concat(
        assertFrequentUnclassifiedDrivesAction(
          properties.frequentUnclassifiedDrivesAction
        )
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Frequent Drive Prompted",
          Object.keys(properties),
          [
            "platform",
            "page",
            "frequentDrivePromptAction",
            "frequentUnclassifiedDrivesAction",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "VkSKtdT84",
          "9ef549048b8d5cd3074bc7c6e89b33a77099fcc3209c8c0d81e300a906f71315",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Frequent Drive Prompted",
        {
          Platform: properties.platform,
          Page: properties.page,
          "Frequent Drive Prompt Action": properties.frequentDrivePromptAction,
          "Frequent Unclassified Drives Action":
            properties.frequentUnclassifiedDrivesAction,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "VkSKtdT84",
          "Frequent Drive Prompted",
          messages,
          [
            {
              id: "42qU5Rs27",
              name: "Frequent Drive Prompt Action",
              value: properties.frequentDrivePromptAction,
            },
            { id: "4j_Pu5zIMW", name: "Page", value: properties.page },
            {
              id: "Ac-lsPbaP",
              name: "Frequent Unclassified Drives Action",
              value: properties.frequentUnclassifiedDrivesAction,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Frequent Drive Prompted': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Frequent Drive Prompted",
          {
            Platform: properties.platform,
            Page: properties.page,
            "Frequent Drive Prompt Action":
              properties.frequentDrivePromptAction,
            "Frequent Unclassified Drives Action":
              properties.frequentUnclassifiedDrivesAction,
          },
          "VkSKtdT84",
          "9ef549048b8d5cd3074bc7c6e89b33a77099fcc3209c8c0d81e300a906f71315"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Frequent Drive Prompted", {
        Platform: properties.platform,
        Page: properties.page,
        "Frequent Drive Prompt Action": properties.frequentDrivePromptAction,
        "Frequent Unclassified Drives Action":
          properties.frequentUnclassifiedDrivesAction,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Frequent Drive Prompted", {
        Platform: properties.platform,
        Page: properties.page,
        "Frequent Drive Prompt Action": properties.frequentDrivePromptAction,
        "Frequent Unclassified Drives Action":
          properties.frequentUnclassifiedDrivesAction,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Frequent Drive Prompted", {
        Platform: properties.platform,
        Page: properties.page,
        "Frequent Drive Prompt Action": properties.frequentDrivePromptAction,
        "Frequent Unclassified Drives Action":
          properties.frequentUnclassifiedDrivesAction,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Frequent Drive Edited: User edits their preference on a specific frequent drive
   *
   * When to trigger this event:
   * 1. User takes an action from the edit page
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/q1hBCjzV_7/trigger/tnG83XFg6
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} properties.page - The page or screen in app or on the web where the event sourced from.
   * @param {string} properties.frequentDriveEditAction - Action taken by user from the edit pop-up for a specific frequent drive
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/q1hBCjzV_7}
   */
  function frequentDriveEdited(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertPage(properties.page));
      messages = messages.concat(
        assertFrequentDriveEditAction(properties.frequentDriveEditAction)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Frequent Drive Edited",
          Object.keys(properties),
          ["platform", "page", "frequentDriveEditAction"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "q1hBCjzV_7",
          "bd18615deeb49a4219349cccdcec898136275721ea3614106b202e9b4aa9fe57",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Frequent Drive Edited",
        {
          Platform: properties.platform,
          Page: properties.page,
          "Frequent Drive Edit Action": properties.frequentDriveEditAction,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "q1hBCjzV_7",
          "Frequent Drive Edited",
          messages,
          [
            { id: "4j_Pu5zIMW", name: "Page", value: properties.page },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "n6k_-xtwc",
              name: "Frequent Drive Edit Action",
              value: properties.frequentDriveEditAction,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Frequent Drive Edited': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Frequent Drive Edited",
          {
            Platform: properties.platform,
            Page: properties.page,
            "Frequent Drive Edit Action": properties.frequentDriveEditAction,
          },
          "q1hBCjzV_7",
          "bd18615deeb49a4219349cccdcec898136275721ea3614106b202e9b4aa9fe57"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Frequent Drive Edited", {
        Platform: properties.platform,
        Page: properties.page,
        "Frequent Drive Edit Action": properties.frequentDriveEditAction,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Frequent Drive Edited", {
        Platform: properties.platform,
        Page: properties.page,
        "Frequent Drive Edit Action": properties.frequentDriveEditAction,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Frequent Drive Edited", {
        Platform: properties.platform,
        Page: properties.page,
        "Frequent Drive Edit Action": properties.frequentDriveEditAction,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Drive Map Enlarged: User enlarges the map of a drive
   *
   * When to trigger this event:
   * 1. User clicks on the map in the drive details
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/flAmMJL52m/trigger/yBVqW0Ckg
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/flAmMJL52m}
   */
  function driveMapEnlarged(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Drive Map Enlarged",
          Object.keys(properties),
          ["platform"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "flAmMJL52m",
          "e5cb5f55c6ea4796a73c60b7d118e88c1a911f6362ca7c5cc61cd35537f24240",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Drive Map Enlarged",
        {
          Platform: properties.platform,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "flAmMJL52m",
          "Drive Map Enlarged",
          messages,
          [{ id: "FfkzdkMHsZ", name: "Platform", value: properties.platform }],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Drive Map Enlarged': " + messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Drive Map Enlarged",
          {
            Platform: properties.platform,
          },
          "flAmMJL52m",
          "e5cb5f55c6ea4796a73c60b7d118e88c1a911f6362ca7c5cc61cd35537f24240"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Drive Map Enlarged", {
        Platform: properties.platform,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Drive Map Enlarged", {
        Platform: properties.platform,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Drive Add Started: User starts the flow to add a manual drive
   *
   * When to trigger this event:
   * 1. User selects Add Drive
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/Zq8TsguSBU/trigger/gDPaqpOJWk
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} properties.page - The page or screen in app or on the web where the event sourced from.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/Zq8TsguSBU}
   */
  function driveAddStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertPage(properties.page));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Drive Add Started",
          Object.keys(properties),
          ["platform", "page"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "Zq8TsguSBU",
          "8dfb75ef09adeab0191a2bd3760bf62f2333be714f0a3ef5d87c2ecc922bad7d",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Drive Add Started",
        {
          Platform: properties.platform,
          Page: properties.page,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "Zq8TsguSBU",
          "Drive Add Started",
          messages,
          [
            { id: "4j_Pu5zIMW", name: "Page", value: properties.page },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Drive Add Started': " + messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Drive Add Started",
          {
            Platform: properties.platform,
            Page: properties.page,
          },
          "Zq8TsguSBU",
          "8dfb75ef09adeab0191a2bd3760bf62f2333be714f0a3ef5d87c2ecc922bad7d"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Drive Add Started", {
        Platform: properties.platform,
        Page: properties.page,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Drive Add Started", {
        Platform: properties.platform,
        Page: properties.page,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Drive Add Completed: User completes the flow to add a manual drive
   *
   * When to trigger this event:
   * 1. User selects Add Drive
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/HtjivmG6Y/trigger/DlKRr0bEj2
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} properties.page - The page or screen in app or on the web where the event sourced from.
   * @param {string} properties.driveClassificationType - Drive classification categories types.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/HtjivmG6Y}
   */
  function driveAddCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertPage(properties.page));
      messages = messages.concat(
        assertDriveClassificationType(properties.driveClassificationType)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Drive Add Completed",
          Object.keys(properties),
          ["platform", "page", "driveClassificationType"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "HtjivmG6Y",
          "4cefed05de41f3ef67a7d31d6e6ce185a715b5520f3128d60816ac92569b7953",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Drive Add Completed",
        {
          Platform: properties.platform,
          Page: properties.page,
          "Drive Classification Type": properties.driveClassificationType,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "HtjivmG6Y",
          "Drive Add Completed",
          messages,
          [
            { id: "4j_Pu5zIMW", name: "Page", value: properties.page },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "oMiAPbzL8",
              name: "Drive Classification Type",
              value: properties.driveClassificationType,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Drive Add Completed': " + messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Drive Add Completed",
          {
            Platform: properties.platform,
            Page: properties.page,
            "Drive Classification Type": properties.driveClassificationType,
          },
          "HtjivmG6Y",
          "4cefed05de41f3ef67a7d31d6e6ce185a715b5520f3128d60816ac92569b7953"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Drive Add Completed", {
        Platform: properties.platform,
        Page: properties.page,
        "Drive Classification Type": properties.driveClassificationType,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Drive Add Completed", {
        Platform: properties.platform,
        Page: properties.page,
        "Drive Classification Type": properties.driveClassificationType,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Named Location Created: User creates a named location
   *
   * When to trigger this event:
   * 1. User creates a named location from a drive edit
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/TFVAm7nsH_/trigger/m9DDOLkpJ
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.page - The page or screen in app or on the web where the event sourced from.
   * @param {string} properties.platform - Platform the user was on at the time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/TFVAm7nsH_}
   */
  function namedLocationCreated(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPage(properties.page));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Named Location Created",
          Object.keys(properties),
          ["page", "platform"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "TFVAm7nsH_",
          "51c8eef114f999b4d042a9e91693302471c99f730337a426a9cf421ea17a7dc7",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Named Location Created",
        {
          Page: properties.page,
          Platform: properties.platform,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "TFVAm7nsH_",
          "Named Location Created",
          messages,
          [
            { id: "4j_Pu5zIMW", name: "Page", value: properties.page },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Named Location Created': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Named Location Created",
          {
            Page: properties.page,
            Platform: properties.platform,
          },
          "TFVAm7nsH_",
          "51c8eef114f999b4d042a9e91693302471c99f730337a426a9cf421ea17a7dc7"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Named Location Created", {
        Page: properties.page,
        Platform: properties.platform,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Named Location Created", {
        Page: properties.page,
        Platform: properties.platform,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Named Location Edited: User edits a named location
   *
   * When to trigger this event:
   * 1. User edits a named location from a drive edit
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/Xe2_dgQjr/trigger/7sk8qPYiZw
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.page - The page or screen in app or on the web where the event sourced from.
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} properties.namedLocationEdit - Type of edit applied to named location
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/Xe2_dgQjr}
   */
  function namedLocationEdited(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPage(properties.page));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertNamedLocationEdit(properties.namedLocationEdit)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Named Location Edited",
          Object.keys(properties),
          ["page", "platform", "namedLocationEdit"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "Xe2_dgQjr",
          "b13c640e32db2f27b34ff674e10675c9154ff2bddc110b6817f3fdefbbf1dd11",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Named Location Edited",
        {
          Page: properties.page,
          Platform: properties.platform,
          "Named Location Edit": properties.namedLocationEdit,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "Xe2_dgQjr",
          "Named Location Edited",
          messages,
          [
            { id: "4j_Pu5zIMW", name: "Page", value: properties.page },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "qsH2osMFv",
              name: "Named Location Edit",
              value: properties.namedLocationEdit,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Named Location Edited': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Named Location Edited",
          {
            Page: properties.page,
            Platform: properties.platform,
            "Named Location Edit": properties.namedLocationEdit,
          },
          "Xe2_dgQjr",
          "b13c640e32db2f27b34ff674e10675c9154ff2bddc110b6817f3fdefbbf1dd11"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Named Location Edited", {
        Page: properties.page,
        Platform: properties.platform,
        "Named Location Edit": properties.namedLocationEdit,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Named Location Edited", {
        Page: properties.page,
        Platform: properties.platform,
        "Named Location Edit": properties.namedLocationEdit,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Drive Duplicate Started: User starts the flow to duplicate a drive
   *
   * When to trigger this event:
   * 1. User selects duplicate in the drive details
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/0Aj2P5pah1/trigger/Y0KJb_6qy
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.page - The page or screen in app or on the web where the event sourced from.
   * @param {string} properties.platform - Platform the user was on at the time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/0Aj2P5pah1}
   */
  function driveDuplicateStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPage(properties.page));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Drive Duplicate Started",
          Object.keys(properties),
          ["page", "platform"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "0Aj2P5pah1",
          "d8c0e560d2a0744bcd7a09ad5d79c629bebc972eac6d0244443a038936de6d84",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Drive Duplicate Started",
        {
          Page: properties.page,
          Platform: properties.platform,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "0Aj2P5pah1",
          "Drive Duplicate Started",
          messages,
          [
            { id: "4j_Pu5zIMW", name: "Page", value: properties.page },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Drive Duplicate Started': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Drive Duplicate Started",
          {
            Page: properties.page,
            Platform: properties.platform,
          },
          "0Aj2P5pah1",
          "d8c0e560d2a0744bcd7a09ad5d79c629bebc972eac6d0244443a038936de6d84"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Drive Duplicate Started", {
        Page: properties.page,
        Platform: properties.platform,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Drive Duplicate Started", {
        Page: properties.page,
        Platform: properties.platform,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Drive Duplicate Started", {
        Page: properties.page,
        Platform: properties.platform,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Drive Duplicate Completed: User completes the flow to duplicate a drive
   *
   * When to trigger this event:
   * 1. User selects duplicate drive at the end of the flow
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/yul517oSQ/trigger/C9eyZ9iaPB
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.page - The page or screen in app or on the web where the event sourced from.
   * @param {string} properties.platform - Platform the user was on at the time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/yul517oSQ}
   */
  function driveDuplicateCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPage(properties.page));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Drive Duplicate Completed",
          Object.keys(properties),
          ["page", "platform"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "yul517oSQ",
          "a35200ee2acd826e786c095de3123bd8615c3bc10d8aacd938884a11160a02ab",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Drive Duplicate Completed",
        {
          Page: properties.page,
          Platform: properties.platform,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "yul517oSQ",
          "Drive Duplicate Completed",
          messages,
          [
            { id: "4j_Pu5zIMW", name: "Page", value: properties.page },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Drive Duplicate Completed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Drive Duplicate Completed",
          {
            Page: properties.page,
            Platform: properties.platform,
          },
          "yul517oSQ",
          "a35200ee2acd826e786c095de3123bd8615c3bc10d8aacd938884a11160a02ab"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Drive Duplicate Completed", {
        Page: properties.page,
        Platform: properties.platform,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Drive Duplicate Completed", {
        Page: properties.page,
        Platform: properties.platform,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Drive Duplicate Completed", {
        Page: properties.page,
        Platform: properties.platform,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Drive Join Started: User starts the flow to join drives
   *
   * When to trigger this event:
   * 1. User selects join in the drive details
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/ftWMATucT/trigger/Qy9QXHU8DJ
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.page - The page or screen in app or on the web where the event sourced from.
   * @param {string} properties.platform - Platform the user was on at the time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/ftWMATucT}
   */
  function driveJoinStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPage(properties.page));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Drive Join Started",
          Object.keys(properties),
          ["page", "platform"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "ftWMATucT",
          "8d87fb05a9f0d35d4aa5a378d6db15f247d5d4555a9e8624bf457fa88e5835a5",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Drive Join Started",
        {
          Page: properties.page,
          Platform: properties.platform,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "ftWMATucT",
          "Drive Join Started",
          messages,
          [
            { id: "4j_Pu5zIMW", name: "Page", value: properties.page },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Drive Join Started': " + messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Drive Join Started",
          {
            Page: properties.page,
            Platform: properties.platform,
          },
          "ftWMATucT",
          "8d87fb05a9f0d35d4aa5a378d6db15f247d5d4555a9e8624bf457fa88e5835a5"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Drive Join Started", {
        Page: properties.page,
        Platform: properties.platform,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Drive Join Started", {
        Page: properties.page,
        Platform: properties.platform,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Drive Join Completed: User completes the flow to join drives
   *
   * When to trigger this event:
   * 1. User completes join in the drive details
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/bFSmoGtjm/trigger/Gqo0qL0Q_L
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.page - The page or screen in app or on the web where the event sourced from.
   * @param {string} properties.platform - Platform the user was on at the time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/bFSmoGtjm}
   */
  function driveJoinCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPage(properties.page));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Drive Join Completed",
          Object.keys(properties),
          ["page", "platform"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "bFSmoGtjm",
          "7441eda067375b90e2976cf05671eb082e58077451f51c98f96e4288ce1b2853",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Drive Join Completed",
        {
          Page: properties.page,
          Platform: properties.platform,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "bFSmoGtjm",
          "Drive Join Completed",
          messages,
          [
            { id: "4j_Pu5zIMW", name: "Page", value: properties.page },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Drive Join Completed': " + messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Drive Join Completed",
          {
            Page: properties.page,
            Platform: properties.platform,
          },
          "bFSmoGtjm",
          "7441eda067375b90e2976cf05671eb082e58077451f51c98f96e4288ce1b2853"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Drive Join Completed", {
        Page: properties.page,
        Platform: properties.platform,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Drive Join Completed", {
        Page: properties.page,
        Platform: properties.platform,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Drive Delete Started: User starts the flow to delete drive(s), Drive Count property denotes the number of drives to be deleted
   *
   * When to trigger this event:
   * 1. User selects delete
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/yplh4jmuJ/trigger/17B6p1OSf3
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} properties.page - The page or screen in app or on the web where the event sourced from.
   * @param {int} properties.driveCount - Number of drives
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/yplh4jmuJ}
   */
  function driveDeleteStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertPage(properties.page));
      messages = messages.concat(assertDriveCount(properties.driveCount));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Drive Delete Started",
          Object.keys(properties),
          ["platform", "page", "driveCount"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "yplh4jmuJ",
          "b011c864b63b19aeab9c863243a2476ee692d4f9f5cf37e4be83f531c2597757",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Drive Delete Started",
        {
          Platform: properties.platform,
          Page: properties.page,
          "Drive Count": properties.driveCount,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "yplh4jmuJ",
          "Drive Delete Started",
          messages,
          [
            { id: "4j_Pu5zIMW", name: "Page", value: properties.page },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "JDI2RsZke",
              name: "Drive Count",
              value: properties.driveCount,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Drive Delete Started': " + messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Drive Delete Started",
          {
            Platform: properties.platform,
            Page: properties.page,
            "Drive Count": properties.driveCount,
          },
          "yplh4jmuJ",
          "b011c864b63b19aeab9c863243a2476ee692d4f9f5cf37e4be83f531c2597757"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Drive Delete Started", {
        Platform: properties.platform,
        Page: properties.page,
        "Drive Count": properties.driveCount,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Drive Delete Started", {
        Platform: properties.platform,
        Page: properties.page,
        "Drive Count": properties.driveCount,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Drive Delete Completed: User completes the flow to delete drive(s), Drive Count property denotes the number of drives to be deleted
   *
   * When to trigger this event:
   * 1. User selects delete
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/Yqa1VufsO/trigger/CG2mEWLIvp
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} properties.page - The page or screen in app or on the web where the event sourced from.
   * @param {int} properties.driveCount - Number of drives
   * @param {string} [properties.driveDeletionReason] - Reason selected for deleting the drive. Event should not trigger on cancellation of deletion.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/Yqa1VufsO}
   */
  function driveDeleteCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertPage(properties.page));
      messages = messages.concat(assertDriveCount(properties.driveCount));
      messages = messages.concat(
        assertOptionalDriveDeletionReason(properties.driveDeletionReason)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Drive Delete Completed",
          Object.keys(properties),
          ["platform", "page", "driveCount", "driveDeletionReason"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "Yqa1VufsO",
          "51a115837d2f6df3dd835208f939b0c8bf2dfc89213f11e9f8088cf88c05b5de",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Drive Delete Completed",
        {
          Platform: properties.platform,
          Page: properties.page,
          "Drive Count": properties.driveCount,
          "Drive Deletion Reason": properties.driveDeletionReason,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "Yqa1VufsO",
          "Drive Delete Completed",
          messages,
          [
            { id: "4j_Pu5zIMW", name: "Page", value: properties.page },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "JDI2RsZke",
              name: "Drive Count",
              value: properties.driveCount,
            },
            {
              id: "YZSO71UQCu",
              name: "Drive Deletion Reason",
              value: properties.driveDeletionReason,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Drive Delete Completed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Drive Delete Completed",
          {
            Platform: properties.platform,
            Page: properties.page,
            "Drive Count": properties.driveCount,
            "Drive Deletion Reason": properties.driveDeletionReason,
          },
          "Yqa1VufsO",
          "51a115837d2f6df3dd835208f939b0c8bf2dfc89213f11e9f8088cf88c05b5de"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Drive Delete Completed", {
        Platform: properties.platform,
        Page: properties.page,
        "Drive Count": properties.driveCount,
        "Drive Deletion Reason": properties.driveDeletionReason,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Drive Delete Completed", {
        Platform: properties.platform,
        Page: properties.page,
        "Drive Count": properties.driveCount,
        "Drive Deletion Reason": properties.driveDeletionReason,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Drive Classify Started: Driver starts to classify a drive(s)
   *
   * When to trigger this event:
   * 1. Start classify from Drives page
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/5OtwbMCzbj/trigger/mTmCn77Pm
   * 2. Start classify from Drive Details
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/5OtwbMCzbj/trigger/Nf-X3cyRJ
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} properties.page - The page or screen in app or on the web where the event sourced from.
   * @param {string} properties.driveClassificationType - Drive classification categories types.
   * @param {int} properties.driveCount - Number of drives
   * @param {Array<string>} properties.existingDriveClassificationType - Drive classification category of drive(s) selected. Potentially multiple classifications, which can be added as a list. Note that 3 Business drives should just result in 1 Business in the list.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/5OtwbMCzbj}
   */
  function driveClassifyStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertPage(properties.page));
      messages = messages.concat(
        assertDriveClassificationType(properties.driveClassificationType)
      );
      messages = messages.concat(assertDriveCount(properties.driveCount));
      messages = messages.concat(
        assertExistingDriveClassificationType(
          properties.existingDriveClassificationType
        )
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Drive Classify Started",
          Object.keys(properties),
          [
            "platform",
            "page",
            "driveClassificationType",
            "driveCount",
            "existingDriveClassificationType",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "5OtwbMCzbj",
          "437fca1c32b915dda6df13aad0f586d29f4dfb8eedb441a4dd5af77fa328c8bf",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Drive Classify Started",
        {
          Platform: properties.platform,
          Page: properties.page,
          "Drive Classification Type": properties.driveClassificationType,
          "Drive Count": properties.driveCount,
          "Existing Drive Classification Type":
            properties.existingDriveClassificationType,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "5OtwbMCzbj",
          "Drive Classify Started",
          messages,
          [
            { id: "4j_Pu5zIMW", name: "Page", value: properties.page },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "JDI2RsZke",
              name: "Drive Count",
              value: properties.driveCount,
            },
            {
              id: "VlHqlX93L",
              name: "Existing Drive Classification Type",
              value: properties.existingDriveClassificationType,
            },
            {
              id: "oMiAPbzL8",
              name: "Drive Classification Type",
              value: properties.driveClassificationType,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Drive Classify Started': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Drive Classify Started",
          {
            Platform: properties.platform,
            Page: properties.page,
            "Drive Classification Type": properties.driveClassificationType,
            "Drive Count": properties.driveCount,
            "Existing Drive Classification Type":
              properties.existingDriveClassificationType,
          },
          "5OtwbMCzbj",
          "437fca1c32b915dda6df13aad0f586d29f4dfb8eedb441a4dd5af77fa328c8bf"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Drive Classify Started", {
        Platform: properties.platform,
        Page: properties.page,
        "Drive Classification Type": properties.driveClassificationType,
        "Drive Count": properties.driveCount,
        "Existing Drive Classification Type":
          properties.existingDriveClassificationType,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Drive Classify Started", {
        Platform: properties.platform,
        Page: properties.page,
        "Drive Classification Type": properties.driveClassificationType,
        "Drive Count": properties.driveCount,
        "Existing Drive Classification Type":
          properties.existingDriveClassificationType,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Drive Classify Completed: Driver completes classifying a drive(s)
   *
   * When to trigger this event:
   * 1. Complete classify from Drives page
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/my_3uAsxH/trigger/Cw6AZaxpM4
   * 2. Complete classify from Drive Details
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/my_3uAsxH/trigger/ZT9rMYvIBA
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} properties.page - The page or screen in app or on the web where the event sourced from.
   * @param {string} properties.driveClassificationType - Drive classification categories types.
   * @param {int} properties.driveCount - Number of drives
   * @param {Array<string>} properties.existingDriveClassificationType - Drive classification category of drive(s) selected. Potentially multiple classifications, which can be added as a list. Note that 3 Business drives should just result in 1 Business in the list.
   * @param {string} properties.driveClassificationPurpose - Drive classification purpose options, both Business and Personal. If a custom purpose, then just custom.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/my_3uAsxH}
   */
  function driveClassifyCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertPage(properties.page));
      messages = messages.concat(
        assertDriveClassificationType(properties.driveClassificationType)
      );
      messages = messages.concat(assertDriveCount(properties.driveCount));
      messages = messages.concat(
        assertExistingDriveClassificationType(
          properties.existingDriveClassificationType
        )
      );
      messages = messages.concat(
        assertDriveClassificationPurpose(properties.driveClassificationPurpose)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Drive Classify Completed",
          Object.keys(properties),
          [
            "platform",
            "page",
            "driveClassificationType",
            "driveCount",
            "existingDriveClassificationType",
            "driveClassificationPurpose",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "my_3uAsxH",
          "45437822f0de90ddb923f409e0d6afe983ece7aec6c35e2d70d6aeed2c71c6d0",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Drive Classify Completed",
        {
          Platform: properties.platform,
          Page: properties.page,
          "Drive Classification Type": properties.driveClassificationType,
          "Drive Count": properties.driveCount,
          "Existing Drive Classification Type":
            properties.existingDriveClassificationType,
          "Drive Classification Purpose": properties.driveClassificationPurpose,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "my_3uAsxH",
          "Drive Classify Completed",
          messages,
          [
            { id: "4j_Pu5zIMW", name: "Page", value: properties.page },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "JDI2RsZke",
              name: "Drive Count",
              value: properties.driveCount,
            },
            {
              id: "NXh-hfXZ-",
              name: "Drive Classification Purpose",
              value: properties.driveClassificationPurpose,
            },
            {
              id: "VlHqlX93L",
              name: "Existing Drive Classification Type",
              value: properties.existingDriveClassificationType,
            },
            {
              id: "oMiAPbzL8",
              name: "Drive Classification Type",
              value: properties.driveClassificationType,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Drive Classify Completed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Drive Classify Completed",
          {
            Platform: properties.platform,
            Page: properties.page,
            "Drive Classification Type": properties.driveClassificationType,
            "Drive Count": properties.driveCount,
            "Existing Drive Classification Type":
              properties.existingDriveClassificationType,
            "Drive Classification Purpose":
              properties.driveClassificationPurpose,
          },
          "my_3uAsxH",
          "45437822f0de90ddb923f409e0d6afe983ece7aec6c35e2d70d6aeed2c71c6d0"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Drive Classify Completed", {
        Platform: properties.platform,
        Page: properties.page,
        "Drive Classification Type": properties.driveClassificationType,
        "Drive Count": properties.driveCount,
        "Existing Drive Classification Type":
          properties.existingDriveClassificationType,
        "Drive Classification Purpose": properties.driveClassificationPurpose,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Drive Classify Completed", {
        Platform: properties.platform,
        Page: properties.page,
        "Drive Classification Type": properties.driveClassificationType,
        "Drive Count": properties.driveCount,
        "Existing Drive Classification Type":
          properties.existingDriveClassificationType,
        "Drive Classification Purpose": properties.driveClassificationPurpose,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Drive Edited: Driver edits the details of a drive
   *
   * When to trigger this event:
   * 1. User edits drive details from the Drive Details page
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/raTRq_3Kv/trigger/7pJu8g_LL
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.page - The page or screen in app or on the web where the event sourced from.
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {int} properties.driveCount - Number of drives
   * @param {string} properties.driveDetail - Drive detail options
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/raTRq_3Kv}
   */
  function driveEdited(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPage(properties.page));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertDriveCount(properties.driveCount));
      messages = messages.concat(assertDriveDetail(properties.driveDetail));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Drive Edited",
          Object.keys(properties),
          ["page", "platform", "driveCount", "driveDetail"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "raTRq_3Kv",
          "3ba272796c53eed3756de3b5d9785307eea124f7f414dcf169353540fbcdc82b",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Drive Edited",
        {
          Page: properties.page,
          Platform: properties.platform,
          "Drive Count": properties.driveCount,
          "Drive Detail": properties.driveDetail,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "raTRq_3Kv",
          "Drive Edited",
          messages,
          [
            { id: "4j_Pu5zIMW", name: "Page", value: properties.page },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "JDI2RsZke",
              name: "Drive Count",
              value: properties.driveCount,
            },
            {
              id: "_MdrmlLsf",
              name: "Drive Detail",
              value: properties.driveDetail,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Drive Edited': " + messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Drive Edited",
          {
            Page: properties.page,
            Platform: properties.platform,
            "Drive Count": properties.driveCount,
            "Drive Detail": properties.driveDetail,
          },
          "raTRq_3Kv",
          "3ba272796c53eed3756de3b5d9785307eea124f7f414dcf169353540fbcdc82b"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Drive Edited", {
        Page: properties.page,
        Platform: properties.platform,
        "Drive Count": properties.driveCount,
        "Drive Detail": properties.driveDetail,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Drive Edited", {
        Page: properties.page,
        Platform: properties.platform,
        "Drive Count": properties.driveCount,
        "Drive Detail": properties.driveDetail,
      });

      // destination Braze
      Braze.logEvent("Drive Edited", {
        Page: properties.page,
        Platform: properties.platform,
        "Drive Count": properties.driveCount,
        "Drive Detail": properties.driveDetail,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Drives Filtered: Driver filters the drives view
   *
   * When to trigger this event:
   * 1. Filter the drive classification type
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/t3Vm8xdfmJ/trigger/1qZXZk3p2
   * 2. Filter the date range
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/t3Vm8xdfmJ/trigger/_KXLjKa-L
   * 3. Apply advanced filters
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/t3Vm8xdfmJ/trigger/X7X_j_tz_
   * 4. Filter by drive reporting status
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/t3Vm8xdfmJ/trigger/ukczT1i_E
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} properties.page - The page or screen in app or on the web where the event sourced from.
   * @param {string} properties.driveDateFilter - Date filter options
   * @param {string} properties.driveReportedFilter - Options for reported drives filter
   * @param {string} properties.driveClassificationFilter - Drive classification filter options
   * @param {int} properties.driveAdvancedFilterCount - Count of advanced filters applied
   * @param {string} properties.driveSearch - Property to describe whether a search as been applied on drives
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/t3Vm8xdfmJ}
   */
  function drivesFiltered(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertPage(properties.page));
      messages = messages.concat(
        assertDriveDateFilter(properties.driveDateFilter)
      );
      messages = messages.concat(
        assertDriveReportedFilter(properties.driveReportedFilter)
      );
      messages = messages.concat(
        assertDriveClassificationFilter(properties.driveClassificationFilter)
      );
      messages = messages.concat(
        assertDriveAdvancedFilterCount(properties.driveAdvancedFilterCount)
      );
      messages = messages.concat(assertDriveSearch(properties.driveSearch));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Drives Filtered",
          Object.keys(properties),
          [
            "platform",
            "page",
            "driveDateFilter",
            "driveReportedFilter",
            "driveClassificationFilter",
            "driveAdvancedFilterCount",
            "driveSearch",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "t3Vm8xdfmJ",
          "dab5857b8c5916261f824864f6bcc07b3dda2b339d357a851d00fc279a973528",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Drives Filtered",
        {
          Platform: properties.platform,
          Page: properties.page,
          "Drive Date Filter": properties.driveDateFilter,
          "Drive Reported Filter": properties.driveReportedFilter,
          "Drive Classification Filter": properties.driveClassificationFilter,
          "Drive Advanced Filter Count": properties.driveAdvancedFilterCount,
          "Drive Search": properties.driveSearch,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "t3Vm8xdfmJ",
          "Drives Filtered",
          messages,
          [
            {
              id: "32VoH_Ayk",
              name: "Drive Advanced Filter Count",
              value: properties.driveAdvancedFilterCount,
            },
            { id: "4j_Pu5zIMW", name: "Page", value: properties.page },
            {
              id: "D4Tul0Xys",
              name: "Drive Reported Filter",
              value: properties.driveReportedFilter,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "PkUfqXS21",
              name: "Drive Search",
              value: properties.driveSearch,
            },
            {
              id: "mUalaEu4z",
              name: "Drive Date Filter",
              value: properties.driveDateFilter,
            },
            {
              id: "uRQ78ipPA",
              name: "Drive Classification Filter",
              value: properties.driveClassificationFilter,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Drives Filtered': " + messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Drives Filtered",
          {
            Platform: properties.platform,
            Page: properties.page,
            "Drive Date Filter": properties.driveDateFilter,
            "Drive Reported Filter": properties.driveReportedFilter,
            "Drive Classification Filter": properties.driveClassificationFilter,
            "Drive Advanced Filter Count": properties.driveAdvancedFilterCount,
            "Drive Search": properties.driveSearch,
          },
          "t3Vm8xdfmJ",
          "dab5857b8c5916261f824864f6bcc07b3dda2b339d357a851d00fc279a973528"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Drives Filtered", {
        Platform: properties.platform,
        Page: properties.page,
        "Drive Date Filter": properties.driveDateFilter,
        "Drive Reported Filter": properties.driveReportedFilter,
        "Drive Classification Filter": properties.driveClassificationFilter,
        "Drive Advanced Filter Count": properties.driveAdvancedFilterCount,
        "Drive Search": properties.driveSearch,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Drives Filtered", {
        Platform: properties.platform,
        Page: properties.page,
        "Drive Date Filter": properties.driveDateFilter,
        "Drive Reported Filter": properties.driveReportedFilter,
        "Drive Classification Filter": properties.driveClassificationFilter,
        "Drive Advanced Filter Count": properties.driveAdvancedFilterCount,
        "Drive Search": properties.driveSearch,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Drives Advance Filtered: Driver adds advanced filters to the drives page
   *
   * When to trigger this event:
   * 1. Select done in advanced filters
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/1DPrHeRfJE/trigger/8e42-9m8ha
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.page - The page or screen in app or on the web where the event sourced from.
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} properties.filterDriveFrequentDrives - Selection options for frequent drive filter
   * @param {string} properties.filterDriveWorkHours - Selection options for work hours filter
   * @param {string} properties.filterDriveManuallyClassified - Selection options for frequent drive filter
   * @param {string} properties.filterDriveWithoutNotes - Selection options for frequent drive filter
   * @param {int} properties.businessPurposeCount - Count of business purposes applied
   * @param {int} properties.personalPurposeCount - Count of personal purposes applied
   * @param {int} properties.vehicleCount - Count of vehicles applied
   * @param {string} properties.driveSearch - Property to describe whether a search as been applied on drives
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/1DPrHeRfJE}
   */
  function drivesAdvanceFiltered(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPage(properties.page));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertFilterDriveFrequentDrives(properties.filterDriveFrequentDrives)
      );
      messages = messages.concat(
        assertFilterDriveWorkHours(properties.filterDriveWorkHours)
      );
      messages = messages.concat(
        assertFilterDriveManuallyClassified(
          properties.filterDriveManuallyClassified
        )
      );
      messages = messages.concat(
        assertFilterDriveWithoutNotes(properties.filterDriveWithoutNotes)
      );
      messages = messages.concat(
        assertBusinessPurposeCount(properties.businessPurposeCount)
      );
      messages = messages.concat(
        assertPersonalPurposeCount(properties.personalPurposeCount)
      );
      messages = messages.concat(assertVehicleCount(properties.vehicleCount));
      messages = messages.concat(assertDriveSearch(properties.driveSearch));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Drives Advance Filtered",
          Object.keys(properties),
          [
            "page",
            "platform",
            "filterDriveFrequentDrives",
            "filterDriveWorkHours",
            "filterDriveManuallyClassified",
            "filterDriveWithoutNotes",
            "businessPurposeCount",
            "personalPurposeCount",
            "vehicleCount",
            "driveSearch",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "1DPrHeRfJE",
          "eaa674b67ea679a0542cd3574ba6b92a3a95a570dc98bc202c01b5dd742e9432",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Drives Advance Filtered",
        {
          Page: properties.page,
          Platform: properties.platform,
          "Filter Drive Frequent Drives": properties.filterDriveFrequentDrives,
          "Filter Drive Work Hours": properties.filterDriveWorkHours,
          "Filter Drive Manually Classified":
            properties.filterDriveManuallyClassified,
          "Filter Drive Without Notes": properties.filterDriveWithoutNotes,
          "Business Purpose Count": properties.businessPurposeCount,
          "Personal Purpose Count": properties.personalPurposeCount,
          "Vehicle Count": properties.vehicleCount,
          "Drive Search": properties.driveSearch,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "1DPrHeRfJE",
          "Drives Advance Filtered",
          messages,
          [
            { id: "4j_Pu5zIMW", name: "Page", value: properties.page },
            {
              id: "Et8FL0ioR",
              name: "Filter Drive Frequent Drives",
              value: properties.filterDriveFrequentDrives,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "Fg3Z-uxvl",
              name: "Filter Drive Without Notes",
              value: properties.filterDriveWithoutNotes,
            },
            {
              id: "JQ3AfPhRR",
              name: "Filter Drive Work Hours",
              value: properties.filterDriveWorkHours,
            },
            {
              id: "M68_gGgjq",
              name: "Business Purpose Count",
              value: properties.businessPurposeCount,
            },
            {
              id: "MF1NUk3Ox",
              name: "Personal Purpose Count",
              value: properties.personalPurposeCount,
            },
            {
              id: "PkUfqXS21",
              name: "Drive Search",
              value: properties.driveSearch,
            },
            {
              id: "ss43OmmE_",
              name: "Filter Drive Manually Classified",
              value: properties.filterDriveManuallyClassified,
            },
            {
              id: "v4aPRYQeW",
              name: "Vehicle Count",
              value: properties.vehicleCount,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Drives Advance Filtered': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Drives Advance Filtered",
          {
            Page: properties.page,
            Platform: properties.platform,
            "Filter Drive Frequent Drives":
              properties.filterDriveFrequentDrives,
            "Filter Drive Work Hours": properties.filterDriveWorkHours,
            "Filter Drive Manually Classified":
              properties.filterDriveManuallyClassified,
            "Filter Drive Without Notes": properties.filterDriveWithoutNotes,
            "Business Purpose Count": properties.businessPurposeCount,
            "Personal Purpose Count": properties.personalPurposeCount,
            "Vehicle Count": properties.vehicleCount,
            "Drive Search": properties.driveSearch,
          },
          "1DPrHeRfJE",
          "eaa674b67ea679a0542cd3574ba6b92a3a95a570dc98bc202c01b5dd742e9432"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Drives Advance Filtered", {
        Page: properties.page,
        Platform: properties.platform,
        "Filter Drive Frequent Drives": properties.filterDriveFrequentDrives,
        "Filter Drive Work Hours": properties.filterDriveWorkHours,
        "Filter Drive Manually Classified":
          properties.filterDriveManuallyClassified,
        "Filter Drive Without Notes": properties.filterDriveWithoutNotes,
        "Business Purpose Count": properties.businessPurposeCount,
        "Personal Purpose Count": properties.personalPurposeCount,
        "Vehicle Count": properties.vehicleCount,
        "Drive Search": properties.driveSearch,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Drives Advance Filtered", {
        Page: properties.page,
        Platform: properties.platform,
        "Filter Drive Frequent Drives": properties.filterDriveFrequentDrives,
        "Filter Drive Work Hours": properties.filterDriveWorkHours,
        "Filter Drive Manually Classified":
          properties.filterDriveManuallyClassified,
        "Filter Drive Without Notes": properties.filterDriveWithoutNotes,
        "Business Purpose Count": properties.businessPurposeCount,
        "Personal Purpose Count": properties.personalPurposeCount,
        "Vehicle Count": properties.vehicleCount,
        "Drive Search": properties.driveSearch,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Drives Advance Filtered", {
        Page: properties.page,
        Platform: properties.platform,
        "Filter Drive Frequent Drives": properties.filterDriveFrequentDrives,
        "Filter Drive Work Hours": properties.filterDriveWorkHours,
        "Filter Drive Manually Classified":
          properties.filterDriveManuallyClassified,
        "Filter Drive Without Notes": properties.filterDriveWithoutNotes,
        "Business Purpose Count": properties.businessPurposeCount,
        "Personal Purpose Count": properties.personalPurposeCount,
        "Vehicle Count": properties.vehicleCount,
        "Drive Search": properties.driveSearch,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Drive Selected: User selects drive(s)
   *
   * When to trigger this event:
   * 1. Select all matching
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/W7q9qFN61P/trigger/mp1d6ftXv
   * 2. Select Day
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/W7q9qFN61P/trigger/aLwdzI_Qe
   * 3. Select individual drive
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/W7q9qFN61P/trigger/AE2IzXjiZ
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} properties.page - The page or screen in app or on the web where the event sourced from.
   * @param {string} properties.driveSelectionMethod - Method options to select drive(s)
   * @param {int} properties.driveCount - Number of drives
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/W7q9qFN61P}
   */
  function driveSelected(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertPage(properties.page));
      messages = messages.concat(
        assertDriveSelectionMethod(properties.driveSelectionMethod)
      );
      messages = messages.concat(assertDriveCount(properties.driveCount));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Drive Selected",
          Object.keys(properties),
          ["platform", "page", "driveSelectionMethod", "driveCount"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "W7q9qFN61P",
          "e8014a02fa8450585141cbcd7cf7473ef1102e38ec26bf1111576cd8d9efecc3",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Drive Selected",
        {
          Platform: properties.platform,
          Page: properties.page,
          "Drive Selection Method": properties.driveSelectionMethod,
          "Drive Count": properties.driveCount,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "W7q9qFN61P",
          "Drive Selected",
          messages,
          [
            { id: "4j_Pu5zIMW", name: "Page", value: properties.page },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "JDI2RsZke",
              name: "Drive Count",
              value: properties.driveCount,
            },
            {
              id: "JcKYzo7cC",
              name: "Drive Selection Method",
              value: properties.driveSelectionMethod,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Drive Selected': " + messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Drive Selected",
          {
            Platform: properties.platform,
            Page: properties.page,
            "Drive Selection Method": properties.driveSelectionMethod,
            "Drive Count": properties.driveCount,
          },
          "W7q9qFN61P",
          "e8014a02fa8450585141cbcd7cf7473ef1102e38ec26bf1111576cd8d9efecc3"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Drive Selected", {
        Platform: properties.platform,
        Page: properties.page,
        "Drive Selection Method": properties.driveSelectionMethod,
        "Drive Count": properties.driveCount,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Drive Selected", {
        Platform: properties.platform,
        Page: properties.page,
        "Drive Selection Method": properties.driveSelectionMethod,
        "Drive Count": properties.driveCount,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Account Dropdown Selected: User selects the dropdown on their account bar
   *
   * When to trigger this event:
   * 1. Select account bar
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/slBPVG6KON/trigger/3culaFOQM
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.page - The page or screen in app or on the web where the event sourced from.
   * @param {string} properties.platform - Platform the user was on at the time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/slBPVG6KON}
   */
  function accountDropdownSelected(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPage(properties.page));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Account Dropdown Selected",
          Object.keys(properties),
          ["page", "platform"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "slBPVG6KON",
          "0d4bd3309322463802672c825f09aef0aebdacffb3985fbcbe46061330862c1b",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Account Dropdown Selected",
        {
          Page: properties.page,
          Platform: properties.platform,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "slBPVG6KON",
          "Account Dropdown Selected",
          messages,
          [
            { id: "4j_Pu5zIMW", name: "Page", value: properties.page },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Account Dropdown Selected': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Account Dropdown Selected",
          {
            Page: properties.page,
            Platform: properties.platform,
          },
          "slBPVG6KON",
          "0d4bd3309322463802672c825f09aef0aebdacffb3985fbcbe46061330862c1b"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Account Dropdown Selected", {
        Page: properties.page,
        Platform: properties.platform,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Account Dropdown Selected", {
        Page: properties.page,
        Platform: properties.platform,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Account Dropdown Selected", {
        Page: properties.page,
        Platform: properties.platform,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Account Signed Out: User signs out
   *
   * When to trigger this event:
   * 1. User selects sign out
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/BCLe15Aagr/trigger/3MJKtCDAY
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/BCLe15Aagr}
   */
  function accountSignedOut(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Account Signed Out",
          Object.keys(properties),
          ["platform"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "BCLe15Aagr",
          "0e81ed090e39704368a0d21f3f5dcea7840b41cd0138d09ea6361c3579957f55",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Account Signed Out",
        {
          Platform: properties.platform,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "BCLe15Aagr",
          "Account Signed Out",
          messages,
          [{ id: "FfkzdkMHsZ", name: "Platform", value: properties.platform }],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Account Signed Out': " + messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Account Signed Out",
          {
            Platform: properties.platform,
          },
          "BCLe15Aagr",
          "0e81ed090e39704368a0d21f3f5dcea7840b41cd0138d09ea6361c3579957f55"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Account Signed Out", {
        Platform: properties.platform,
      });
      RudderStackWebDashboard.unidentify();

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Account Signed Out", {
        Platform: properties.platform,
      });
      SegmentWebDashboard.unidentify();

      // destination Mixpanel
      Mixpanel.logEvent("Account Signed Out", {
        Platform: properties.platform,
      });
      Mixpanel.unidentify();
    } else {
      // do nothing
    }
  }

  /**
   * Dashboard Switched: User switches to another dashboard
   *
   * When to trigger this event:
   * 1. From Teams dashboard, user clicks on Driver Dashboard in the sidebar
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/VBQOu0CmSs/trigger/vzN9y1NgV
   * 2. From Driver dashboard, user clicks on Teams Dashboard in sidebar
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/VBQOu0CmSs/trigger/X7fN6W5lF
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.page - The page or screen in app or on the web where the event sourced from.
   * @param {string} properties.dashboardSwitchedTo - The kind of dashboard that the user switched to
   * @param {string} properties.dashboardSwitchFrom - Source of the dashboard switch
   * @param {string} properties.platform - Platform the user was on at the time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/VBQOu0CmSs}
   */
  function dashboardSwitched(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPage(properties.page));
      messages = messages.concat(
        assertDashboardSwitchedTo(properties.dashboardSwitchedTo)
      );
      messages = messages.concat(
        assertDashboardSwitchFrom(properties.dashboardSwitchFrom)
      );
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Dashboard Switched",
          Object.keys(properties),
          ["page", "dashboardSwitchedTo", "dashboardSwitchFrom", "platform"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "VBQOu0CmSs",
          "eeef867ba0ed277e2511ffe32f117045e3271768420d9279f06d273455264b9b",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Dashboard Switched",
        {
          Page: properties.page,
          "Dashboard Switched To": properties.dashboardSwitchedTo,
          "Dashboard Switch From": properties.dashboardSwitchFrom,
          Platform: properties.platform,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "VBQOu0CmSs",
          "Dashboard Switched",
          messages,
          [
            { id: "4j_Pu5zIMW", name: "Page", value: properties.page },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "KtZI6fuaf",
              name: "Dashboard Switched To",
              value: properties.dashboardSwitchedTo,
            },
            {
              id: "SzhpD2tNX",
              name: "Dashboard Switch From",
              value: properties.dashboardSwitchFrom,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Dashboard Switched': " + messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Dashboard Switched",
          {
            Page: properties.page,
            "Dashboard Switched To": properties.dashboardSwitchedTo,
            "Dashboard Switch From": properties.dashboardSwitchFrom,
            Platform: properties.platform,
          },
          "VBQOu0CmSs",
          "eeef867ba0ed277e2511ffe32f117045e3271768420d9279f06d273455264b9b"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Dashboard Switched", {
        Page: properties.page,
        "Dashboard Switched To": properties.dashboardSwitchedTo,
        "Dashboard Switch From": properties.dashboardSwitchFrom,
        Platform: properties.platform,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Dashboard Switched", {
        Page: properties.page,
        "Dashboard Switched To": properties.dashboardSwitchedTo,
        "Dashboard Switch From": properties.dashboardSwitchFrom,
        Platform: properties.platform,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Dashboard Switched", {
        Page: properties.page,
        "Dashboard Switched To": properties.dashboardSwitchedTo,
        "Dashboard Switch From": properties.dashboardSwitchFrom,
        Platform: properties.platform,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Email Setting Updated: User updates an email preference
   *
   * When to trigger this event:
   * 1. Update from braze email link
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/QFobNcxrkP/trigger/kyTJTrPJh
   * 2. Trigger from the notifications settings page
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/QFobNcxrkP/trigger/tVXAJJULe
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.weeklyEmailPreferenceChange] - Change applied to weekly email preference. Empty if no change.
   * @param {string} [properties.monthlyEmailPreferenceChange] - Change applied to monthly email preference. Empty if no change.
   * @param {string} [properties.otherEmailPreferenceChange] - Change applied to other email preference. Empty if no change.
   * @param {string} [properties.emailPreferenceChangeMethod] - User's method to change email preference. Primarily used to identify when Unsubscribe All is used.
   * @param {string} properties.page - The page or screen in app or on the web where the event sourced from.
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.promotionalEmailPreferenceChange] - Change applied to other email preference. Empty if no change.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/QFobNcxrkP}
   */
  function emailSettingUpdated(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(
        assertOptionalWeeklyEmailPreferenceChange(
          properties.weeklyEmailPreferenceChange
        )
      );
      messages = messages.concat(
        assertOptionalMonthlyEmailPreferenceChange(
          properties.monthlyEmailPreferenceChange
        )
      );
      messages = messages.concat(
        assertOptionalOtherEmailPreferenceChange(
          properties.otherEmailPreferenceChange
        )
      );
      messages = messages.concat(
        assertOptionalEmailPreferenceChangeMethod(
          properties.emailPreferenceChangeMethod
        )
      );
      messages = messages.concat(assertPage(properties.page));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalPromotionalEmailPreferenceChange(
          properties.promotionalEmailPreferenceChange
        )
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Email Setting Updated",
          Object.keys(properties),
          [
            "weeklyEmailPreferenceChange",
            "monthlyEmailPreferenceChange",
            "otherEmailPreferenceChange",
            "emailPreferenceChangeMethod",
            "page",
            "platform",
            "promotionalEmailPreferenceChange",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "QFobNcxrkP",
          "a411f1d55936ac4c4211967ffc535e4b58e3ed8fb393ffe6e75901adb77f9ca6",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Email Setting Updated",
        {
          "Weekly Email Preference Change":
            properties.weeklyEmailPreferenceChange,
          "Monthly Email Preference Change":
            properties.monthlyEmailPreferenceChange,
          "Other Email Preference Change":
            properties.otherEmailPreferenceChange,
          "Email Preference Change Method":
            properties.emailPreferenceChangeMethod,
          Page: properties.page,
          Platform: properties.platform,
          "Promotional Email Preference Change":
            properties.promotionalEmailPreferenceChange,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "QFobNcxrkP",
          "Email Setting Updated",
          messages,
          [
            { id: "4j_Pu5zIMW", name: "Page", value: properties.page },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "UNTR59L6v",
              name: "Other Email Preference Change",
              value: properties.otherEmailPreferenceChange,
            },
            {
              id: "hPXdy4ttZ",
              name: "Promotional Email Preference Change",
              value: properties.promotionalEmailPreferenceChange,
            },
            {
              id: "hpNqFkv7e",
              name: "Weekly Email Preference Change",
              value: properties.weeklyEmailPreferenceChange,
            },
            {
              id: "iqd98lcTV",
              name: "Email Preference Change Method",
              value: properties.emailPreferenceChangeMethod,
            },
            {
              id: "t-gDmCpz8",
              name: "Monthly Email Preference Change",
              value: properties.monthlyEmailPreferenceChange,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Email Setting Updated': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Email Setting Updated",
          {
            "Weekly Email Preference Change":
              properties.weeklyEmailPreferenceChange,
            "Monthly Email Preference Change":
              properties.monthlyEmailPreferenceChange,
            "Other Email Preference Change":
              properties.otherEmailPreferenceChange,
            "Email Preference Change Method":
              properties.emailPreferenceChangeMethod,
            Page: properties.page,
            Platform: properties.platform,
            "Promotional Email Preference Change":
              properties.promotionalEmailPreferenceChange,
          },
          "QFobNcxrkP",
          "a411f1d55936ac4c4211967ffc535e4b58e3ed8fb393ffe6e75901adb77f9ca6"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Email Setting Updated", {
        "Weekly Email Preference Change":
          properties.weeklyEmailPreferenceChange,
        "Monthly Email Preference Change":
          properties.monthlyEmailPreferenceChange,
        "Other Email Preference Change": properties.otherEmailPreferenceChange,
        "Email Preference Change Method":
          properties.emailPreferenceChangeMethod,
        Page: properties.page,
        Platform: properties.platform,
        "Promotional Email Preference Change":
          properties.promotionalEmailPreferenceChange,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Email Setting Updated", {
        "Weekly Email Preference Change":
          properties.weeklyEmailPreferenceChange,
        "Monthly Email Preference Change":
          properties.monthlyEmailPreferenceChange,
        "Other Email Preference Change": properties.otherEmailPreferenceChange,
        "Email Preference Change Method":
          properties.emailPreferenceChangeMethod,
        Page: properties.page,
        Platform: properties.platform,
        "Promotional Email Preference Change":
          properties.promotionalEmailPreferenceChange,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Email Setting Updated", {
        "Weekly Email Preference Change":
          properties.weeklyEmailPreferenceChange,
        "Monthly Email Preference Change":
          properties.monthlyEmailPreferenceChange,
        "Other Email Preference Change": properties.otherEmailPreferenceChange,
        "Email Preference Change Method":
          properties.emailPreferenceChangeMethod,
        Page: properties.page,
        Platform: properties.platform,
        "Promotional Email Preference Change":
          properties.promotionalEmailPreferenceChange,
      });

      // destination Braze
      Braze.logEvent("Email Setting Updated", {
        "Weekly Email Preference Change":
          properties.weeklyEmailPreferenceChange,
        "Monthly Email Preference Change":
          properties.monthlyEmailPreferenceChange,
        "Other Email Preference Change": properties.otherEmailPreferenceChange,
        "Email Preference Change Method":
          properties.emailPreferenceChangeMethod,
        Page: properties.page,
        Platform: properties.platform,
        "Promotional Email Preference Change":
          properties.promotionalEmailPreferenceChange,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Distance Rate Update Started: User starts the flow to update a distance rate
   *
   * When to trigger this event:
   * 1. User completes the flow to update a distance rate by clicking save
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/8yhhptbCf/trigger/v7TjKp8Jh5
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/8yhhptbCf}
   */
  function distanceRateUpdateStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Distance Rate Update Started",
          Object.keys(properties),
          ["platform"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "8yhhptbCf",
          "c71c8c61a640cb55b0a1fbdc6ee1e78638d4f7d5193410bfa72071b7a6906de8",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Distance Rate Update Started",
        {
          Platform: properties.platform,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "8yhhptbCf",
          "Distance Rate Update Started",
          messages,
          [{ id: "FfkzdkMHsZ", name: "Platform", value: properties.platform }],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Distance Rate Update Started': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Distance Rate Update Started",
          {
            Platform: properties.platform,
          },
          "8yhhptbCf",
          "c71c8c61a640cb55b0a1fbdc6ee1e78638d4f7d5193410bfa72071b7a6906de8"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Distance Rate Update Started", {
        Platform: properties.platform,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Distance Rate Update Started", {
        Platform: properties.platform,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Distance Rate Update Started", {
        Platform: properties.platform,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Product Preference Selected: User chooses (clicks on) on an option in the "How are you planning to use MileIQ?" page
   *
   * When to trigger this event:
   * 1. user clicks on "for myself", "create a team", or "Join a team"
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/XI9oZRsZE5/trigger/Y89lUcYYC
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.intent - User's intent for the product they want to use.  "use personal" or "create team" or "join team"
   * @param {string} properties.utmSource - Source of the ad
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} properties.utmContent - Content of the advertisement
   * @param {string} properties.utmCampaign - Ad campaign from the UTM
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/XI9oZRsZE5}
   */
  function productPreferenceSelected(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertIntent(properties.intent));
      messages = messages.concat(assertUTMSource(properties.utmSource));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUTMContent(properties.utmContent));
      messages = messages.concat(assertUTMCampaign(properties.utmCampaign));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Product Preference Selected",
          Object.keys(properties),
          ["intent", "utmSource", "platform", "utmContent", "utmCampaign"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "XI9oZRsZE5",
          "6fdab7c0faabb116a5393e175e0ca4a258a75a38bed74bf8d4c1757784a4c7b9",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Product Preference Selected",
        {
          Intent: properties.intent,
          "UTM Source": properties.utmSource,
          Platform: properties.platform,
          "UTM Content": properties.utmContent,
          "UTM Campaign": properties.utmCampaign,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "XI9oZRsZE5",
          "Product Preference Selected",
          messages,
          [
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "X0Bc-NE2Dt",
              name: "UTM Campaign",
              value: properties.utmCampaign,
            },
            {
              id: "uFzvwV4V4V",
              name: "UTM Content",
              value: properties.utmContent,
            },
            {
              id: "yRYklsveXX",
              name: "UTM Source",
              value: properties.utmSource,
            },
            { id: "zv_WuIxy3", name: "Intent", value: properties.intent },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Product Preference Selected': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Product Preference Selected",
          {
            Intent: properties.intent,
            "UTM Source": properties.utmSource,
            Platform: properties.platform,
            "UTM Content": properties.utmContent,
            "UTM Campaign": properties.utmCampaign,
          },
          "XI9oZRsZE5",
          "6fdab7c0faabb116a5393e175e0ca4a258a75a38bed74bf8d4c1757784a4c7b9"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Product Preference Selected", {
        Intent: properties.intent,
        "UTM Source": properties.utmSource,
        Platform: properties.platform,
        "UTM Content": properties.utmContent,
        "UTM Campaign": properties.utmCampaign,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Product Preference Selected", {
        Intent: properties.intent,
        "UTM Source": properties.utmSource,
        Platform: properties.platform,
        "UTM Content": properties.utmContent,
        "UTM Campaign": properties.utmCampaign,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Product Preference Selected", {
        Intent: properties.intent,
        "UTM Source": properties.utmSource,
        Platform: properties.platform,
        "UTM Content": properties.utmContent,
        "UTM Campaign": properties.utmCampaign,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Invite Admin Started: User clicks on "Send to admin" from the Create Team flow
   *
   * When to trigger this event:
   * 1. User clicks on "Send to Admin"
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/1f6ATb-sxC/trigger/N1IuPASqK
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/1f6ATb-sxC}
   */
  function inviteAdminStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Invite Admin Started",
          Object.keys(properties),
          ["platform"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "1f6ATb-sxC",
          "86e49314541a05217d1678979c71ef2526c59b95aee5934c8fd5f9d3c1360951",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Invite Admin Started",
        {
          Platform: properties.platform,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "1f6ATb-sxC",
          "Invite Admin Started",
          messages,
          [{ id: "FfkzdkMHsZ", name: "Platform", value: properties.platform }],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Invite Admin Started': " + messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Invite Admin Started",
          {
            Platform: properties.platform,
          },
          "1f6ATb-sxC",
          "86e49314541a05217d1678979c71ef2526c59b95aee5934c8fd5f9d3c1360951"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Invite Admin Started", {
        Platform: properties.platform,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Invite Admin Started", {
        Platform: properties.platform,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Invite Admin Started", {
        Platform: properties.platform,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Invite Admin Step Completed: User completes any step of the  "send to admin" process in the Create Team flow
   *
   * @param {object} properties - the properties associatied with this event
   * @param {int} properties.inviteAdminStep - step number in the flow for inviting an admin to create a team

   * @param {string} properties.inviteAdminStepName - Step Name in the flow for inviting an admin to create a team
   * @param {string} [properties.name] - Name input by user during event
   * @param {string} [properties.email] - Email address captured during event
   * @param {string} properties.platform - Platform the user was on at the time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/eWLdXNlHn3}
   */
  function inviteAdminStepCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(
        assertInviteAdminStep(properties.inviteAdminStep)
      );
      messages = messages.concat(
        assertInviteAdminStepName(properties.inviteAdminStepName)
      );
      messages = messages.concat(assertOptionalName(properties.name));
      messages = messages.concat(assertOptionalEmail(properties.email));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Invite Admin Step Completed",
          Object.keys(properties),
          [
            "inviteAdminStep",
            "inviteAdminStepName",
            "name",
            "email",
            "platform",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "eWLdXNlHn3",
          "675f4c9c2abe1f67b1d6dc71f86a383fe0735e905cd4a8f52b71692eea40d2dd",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Invite Admin Step Completed",
        {
          "Invite Admin Step": properties.inviteAdminStep,
          "Invite Admin Step Name": properties.inviteAdminStepName,
          Name: properties.name,
          Email: properties.email,
          Platform: properties.platform,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "eWLdXNlHn3",
          "Invite Admin Step Completed",
          messages,
          [
            { id: "-GjIYlnhA", name: "Name", value: properties.name },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            { id: "KwJDoiNGCh", name: "Email", value: properties.email },
            {
              id: "hUOJ4Vm6Y",
              name: "Invite Admin Step Name",
              value: properties.inviteAdminStepName,
            },
            {
              id: "n-fLdMdct",
              name: "Invite Admin Step",
              value: properties.inviteAdminStep,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Invite Admin Step Completed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Invite Admin Step Completed",
          {
            "Invite Admin Step": properties.inviteAdminStep,
            "Invite Admin Step Name": properties.inviteAdminStepName,
            Name: properties.name,
            Email: properties.email,
            Platform: properties.platform,
          },
          "eWLdXNlHn3",
          "675f4c9c2abe1f67b1d6dc71f86a383fe0735e905cd4a8f52b71692eea40d2dd"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Invite Admin Step Completed", {
        "Invite Admin Step": properties.inviteAdminStep,
        "Invite Admin Step Name": properties.inviteAdminStepName,
        Name: properties.name,
        Email: properties.email,
        Platform: properties.platform,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Invite Admin Step Completed", {
        "Invite Admin Step": properties.inviteAdminStep,
        "Invite Admin Step Name": properties.inviteAdminStepName,
        Name: properties.name,
        Email: properties.email,
        Platform: properties.platform,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Invite Admin Step Completed", {
        "Invite Admin Step": properties.inviteAdminStep,
        "Invite Admin Step Name": properties.inviteAdminStepName,
        Name: properties.name,
        Email: properties.email,
        Platform: properties.platform,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Invite Admin Completed: User completes the invite admin flow, successfully sending an invite to their admin.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.name - Name input by user during event
   * @param {string} properties.email - Email address captured during event
   * @param {string} properties.platform - Platform the user was on at the time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/y1zXgvgoz}
   */
  function inviteAdminCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertName(properties.name));
      messages = messages.concat(assertEmail(properties.email));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Invite Admin Completed",
          Object.keys(properties),
          ["name", "email", "platform"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "y1zXgvgoz",
          "7dc37a23483cc13442eab40c64691e9947d4358abeed4e1852188a85271bfc2a",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Invite Admin Completed",
        {
          Name: properties.name,
          Email: properties.email,
          Platform: properties.platform,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "y1zXgvgoz",
          "Invite Admin Completed",
          messages,
          [
            { id: "-GjIYlnhA", name: "Name", value: properties.name },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            { id: "KwJDoiNGCh", name: "Email", value: properties.email },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Invite Admin Completed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Invite Admin Completed",
          {
            Name: properties.name,
            Email: properties.email,
            Platform: properties.platform,
          },
          "y1zXgvgoz",
          "7dc37a23483cc13442eab40c64691e9947d4358abeed4e1852188a85271bfc2a"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Invite Admin Completed", {
        Name: properties.name,
        Email: properties.email,
        Platform: properties.platform,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Invite Admin Completed", {
        Name: properties.name,
        Email: properties.email,
        Platform: properties.platform,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Invite Admin Completed", {
        Name: properties.name,
        Email: properties.email,
        Platform: properties.platform,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Feature Detail Selected: User clicks "Learn More" from the plan selection page.  The "Learn More" link appears on when a user hovers over a feature in one of the plan bubbles.
   *
   * When to trigger this event:
   * 1. User clicks "learn more" from the popup that appears when hovering over a feature name
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/Wm8hEPYV6b/trigger/0zWTyatho
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.featureName - Feature selected from the teams plan selector page.
   * @param {string} [properties.teamsPlanName] - Name of the Team's plan at time of event. If a team is not on a plan, do not send property.
   * @param {string} properties.platform - Platform the user was on at the time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/Wm8hEPYV6b}
   */
  function featureDetailSelected(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertFeatureName(properties.featureName));
      messages = messages.concat(
        assertOptionalTeamsPlanName(properties.teamsPlanName)
      );
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Feature Detail Selected",
          Object.keys(properties),
          ["featureName", "teamsPlanName", "platform"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "Wm8hEPYV6b",
          "8c90e05ad6c9eb82a92d1b718459cedbecf1caa1d5b44c46b8c3a159ae817e47",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Feature Detail Selected",
        {
          "Feature Name": properties.featureName,
          "Teams Plan Name": properties.teamsPlanName,
          Platform: properties.platform,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "Wm8hEPYV6b",
          "Feature Detail Selected",
          messages,
          [
            {
              id: "125AY5RLNY",
              name: "Teams Plan Name",
              value: properties.teamsPlanName,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "ugJQWcfws",
              name: "Feature Name",
              value: properties.featureName,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Feature Detail Selected': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Feature Detail Selected",
          {
            "Feature Name": properties.featureName,
            "Teams Plan Name": properties.teamsPlanName,
            Platform: properties.platform,
          },
          "Wm8hEPYV6b",
          "8c90e05ad6c9eb82a92d1b718459cedbecf1caa1d5b44c46b8c3a159ae817e47"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Feature Detail Selected", {
        "Feature Name": properties.featureName,
        "Teams Plan Name": properties.teamsPlanName,
        Platform: properties.platform,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Feature Detail Selected", {
        "Feature Name": properties.featureName,
        "Teams Plan Name": properties.teamsPlanName,
        Platform: properties.platform,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Feature Detail Selected", {
        "Feature Name": properties.featureName,
        "Teams Plan Name": properties.teamsPlanName,
        Platform: properties.platform,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Reports Filtered: Admin applies a filter to the reports view
   *
   * When to trigger this event:
   * 1. Admin applies any filter on the teams report page
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/GlhdYMnKP/trigger/_6SmJVjhB3
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {int} properties.subscriptionId - User's MileIQ Subscription ID at time of event
   * @param {string} [properties.teamsReportsSubmissionFilter] - Teams Reports Submission Filter Options
   * @param {string} [properties.teamsReportsDriversFilter] - Teams Reports Drivers Filter Options (multiple or individual)
   * @param {string} [properties.teamsReportsMonthOfDrivesFilter] - Teams Reports Month of Drives Filter Options
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/GlhdYMnKP}
   */
  function teamsReportsFiltered(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertSubscriptionId(properties.subscriptionId)
      );
      messages = messages.concat(
        assertOptionalTeamsReportsSubmissionFilter(
          properties.teamsReportsSubmissionFilter
        )
      );
      messages = messages.concat(
        assertOptionalTeamsReportsDriversFilter(
          properties.teamsReportsDriversFilter
        )
      );
      messages = messages.concat(
        assertOptionalTeamsReportsMonthOfDrivesFilter(
          properties.teamsReportsMonthOfDrivesFilter
        )
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Reports Filtered",
          Object.keys(properties),
          [
            "platform",
            "organizationGroupId",
            "organizationId",
            "subscriptionId",
            "teamsReportsSubmissionFilter",
            "teamsReportsDriversFilter",
            "teamsReportsMonthOfDrivesFilter",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "GlhdYMnKP",
          "f1eee28bab2cc003f6ee7822713cb44a6f5785b45f98ee29d53d8871f1982a37",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Reports Filtered",
        {
          Platform: properties.platform,
          "Organization Group ID": properties.organizationGroupId,
          "Organization ID": properties.organizationId,
          subscription_id: properties.subscriptionId,
          "Teams Reports Submission Filter":
            properties.teamsReportsSubmissionFilter,
          "Teams Reports Drivers Filter": properties.teamsReportsDriversFilter,
          "Teams Reports Month of Drives Filter":
            properties.teamsReportsMonthOfDrivesFilter,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "GlhdYMnKP",
          "Teams Reports Filtered",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "90lHtUV6D",
              name: "Teams Reports Month of Drives Filter",
              value: properties.teamsReportsMonthOfDrivesFilter,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "TDTeQm2UP",
              name: "subscription_id",
              value: properties.subscriptionId,
            },
            {
              id: "la6RYKAJ9",
              name: "Teams Reports Submission Filter",
              value: properties.teamsReportsSubmissionFilter,
            },
            {
              id: "vtg1sPIz-",
              name: "Teams Reports Drivers Filter",
              value: properties.teamsReportsDriversFilter,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Reports Filtered': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Reports Filtered",
          {
            Platform: properties.platform,
            "Organization Group ID": properties.organizationGroupId,
            "Organization ID": properties.organizationId,
            subscription_id: properties.subscriptionId,
            "Teams Reports Submission Filter":
              properties.teamsReportsSubmissionFilter,
            "Teams Reports Drivers Filter":
              properties.teamsReportsDriversFilter,
            "Teams Reports Month of Drives Filter":
              properties.teamsReportsMonthOfDrivesFilter,
          },
          "GlhdYMnKP",
          "f1eee28bab2cc003f6ee7822713cb44a6f5785b45f98ee29d53d8871f1982a37"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Reports Filtered", {
        Platform: properties.platform,
        "Organization Group ID": properties.organizationGroupId,
        "Organization ID": properties.organizationId,
        subscription_id: properties.subscriptionId,
        "Teams Reports Submission Filter":
          properties.teamsReportsSubmissionFilter,
        "Teams Reports Drivers Filter": properties.teamsReportsDriversFilter,
        "Teams Reports Month of Drives Filter":
          properties.teamsReportsMonthOfDrivesFilter,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Reports Filtered", {
        Platform: properties.platform,
        "Organization Group ID": properties.organizationGroupId,
        "Organization ID": properties.organizationId,
        subscription_id: properties.subscriptionId,
        "Teams Reports Submission Filter":
          properties.teamsReportsSubmissionFilter,
        "Teams Reports Drivers Filter": properties.teamsReportsDriversFilter,
        "Teams Reports Month of Drives Filter":
          properties.teamsReportsMonthOfDrivesFilter,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Driver Report Selected: Admin selects a report in the report view
   *
   * When to trigger this event:
   * 1. Admin selects a report in the reports view
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/4sE9esFD5/trigger/p0dVE938QX
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {int} properties.subscriptionId - User's MileIQ Subscription ID at time of event
   * @param {string} properties.driverReportSelectionType - Type of selection made
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/4sE9esFD5}
   */
  function driverReportSelected(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertSubscriptionId(properties.subscriptionId)
      );
      messages = messages.concat(
        assertDriverReportSelectionType(properties.driverReportSelectionType)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Driver Report Selected",
          Object.keys(properties),
          [
            "platform",
            "organizationGroupId",
            "organizationId",
            "subscriptionId",
            "driverReportSelectionType",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "4sE9esFD5",
          "314164cf84453f63fad54bcb79b983c3911b311e6f6480f98d6e87e4e69e9c49",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Driver Report Selected",
        {
          Platform: properties.platform,
          "Organization Group ID": properties.organizationGroupId,
          "Organization ID": properties.organizationId,
          subscription_id: properties.subscriptionId,
          "Driver Report Selection Type": properties.driverReportSelectionType,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "4sE9esFD5",
          "Driver Report Selected",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "TDTeQm2UP",
              name: "subscription_id",
              value: properties.subscriptionId,
            },
            {
              id: "x9ydpXsb6",
              name: "Driver Report Selection Type",
              value: properties.driverReportSelectionType,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Driver Report Selected': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Driver Report Selected",
          {
            Platform: properties.platform,
            "Organization Group ID": properties.organizationGroupId,
            "Organization ID": properties.organizationId,
            subscription_id: properties.subscriptionId,
            "Driver Report Selection Type":
              properties.driverReportSelectionType,
          },
          "4sE9esFD5",
          "314164cf84453f63fad54bcb79b983c3911b311e6f6480f98d6e87e4e69e9c49"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Driver Report Selected", {
        Platform: properties.platform,
        "Organization Group ID": properties.organizationGroupId,
        "Organization ID": properties.organizationId,
        subscription_id: properties.subscriptionId,
        "Driver Report Selection Type": properties.driverReportSelectionType,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Driver Report Selected", {
        Platform: properties.platform,
        "Organization Group ID": properties.organizationGroupId,
        "Organization ID": properties.organizationId,
        subscription_id: properties.subscriptionId,
        "Driver Report Selection Type": properties.driverReportSelectionType,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Driver Report Opened: Admin opens a driver's report
   *
   * When to trigger this event:
   * 1. Admin opens a report from the report row
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/fhD4cojuh/trigger/OUJHHleDAk
   * 2. Admin opens a report from the eye icon
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/fhD4cojuh/trigger/0szet0qlk
   * 3. Admin opens a report from the sidebar
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/fhD4cojuh/trigger/ZUcHsUWCW
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {int} properties.subscriptionId - User's MileIQ Subscription ID at time of event
   * @param {string} properties.reportOpenSource - Sources to open a report
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/fhD4cojuh}
   */
  function driverReportOpened(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertSubscriptionId(properties.subscriptionId)
      );
      messages = messages.concat(
        assertReportOpenSource(properties.reportOpenSource)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Driver Report Opened",
          Object.keys(properties),
          [
            "platform",
            "organizationGroupId",
            "organizationId",
            "subscriptionId",
            "reportOpenSource",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "fhD4cojuh",
          "d938fbbdea3cf5720c7ecddfbf1b274043628fe8ad7875892abb3e96fe8f2de2",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Driver Report Opened",
        {
          Platform: properties.platform,
          "Organization Group ID": properties.organizationGroupId,
          "Organization ID": properties.organizationId,
          subscription_id: properties.subscriptionId,
          "Report Open Source": properties.reportOpenSource,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "fhD4cojuh",
          "Driver Report Opened",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "TDTeQm2UP",
              name: "subscription_id",
              value: properties.subscriptionId,
            },
            {
              id: "sDjxHAr4i",
              name: "Report Open Source",
              value: properties.reportOpenSource,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Driver Report Opened': " + messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Driver Report Opened",
          {
            Platform: properties.platform,
            "Organization Group ID": properties.organizationGroupId,
            "Organization ID": properties.organizationId,
            subscription_id: properties.subscriptionId,
            "Report Open Source": properties.reportOpenSource,
          },
          "fhD4cojuh",
          "d938fbbdea3cf5720c7ecddfbf1b274043628fe8ad7875892abb3e96fe8f2de2"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Driver Report Opened", {
        Platform: properties.platform,
        "Organization Group ID": properties.organizationGroupId,
        "Organization ID": properties.organizationId,
        subscription_id: properties.subscriptionId,
        "Report Open Source": properties.reportOpenSource,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Driver Report Opened", {
        Platform: properties.platform,
        "Organization Group ID": properties.organizationGroupId,
        "Organization ID": properties.organizationId,
        subscription_id: properties.subscriptionId,
        "Report Open Source": properties.reportOpenSource,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Driver Report Drive Selected: Admin selects a drive within a report
   *
   * When to trigger this event:
   * 1. Admin selects a drive from the report
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/rnVBo7b-f/trigger/HeAZ8IMUrX
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {int} properties.subscriptionId - User's MileIQ Subscription ID at time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/rnVBo7b-f}
   */
  function driverReportDriveSelected(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertSubscriptionId(properties.subscriptionId)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Driver Report Drive Selected",
          Object.keys(properties),
          [
            "platform",
            "organizationGroupId",
            "organizationId",
            "subscriptionId",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "rnVBo7b-f",
          "331efec494f6228ee5a788098d2ced26a1260e4e7903c32e77fb548021c707f6",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Driver Report Drive Selected",
        {
          Platform: properties.platform,
          "Organization Group ID": properties.organizationGroupId,
          "Organization ID": properties.organizationId,
          subscription_id: properties.subscriptionId,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "rnVBo7b-f",
          "Driver Report Drive Selected",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "TDTeQm2UP",
              name: "subscription_id",
              value: properties.subscriptionId,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Driver Report Drive Selected': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Driver Report Drive Selected",
          {
            Platform: properties.platform,
            "Organization Group ID": properties.organizationGroupId,
            "Organization ID": properties.organizationId,
            subscription_id: properties.subscriptionId,
          },
          "rnVBo7b-f",
          "331efec494f6228ee5a788098d2ced26a1260e4e7903c32e77fb548021c707f6"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Driver Report Drive Selected", {
        Platform: properties.platform,
        "Organization Group ID": properties.organizationGroupId,
        "Organization ID": properties.organizationId,
        subscription_id: properties.subscriptionId,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Driver Report Drive Selected", {
        Platform: properties.platform,
        "Organization Group ID": properties.organizationGroupId,
        "Organization ID": properties.organizationId,
        subscription_id: properties.subscriptionId,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Driver Report Details Filtered: Admin filters the report details view
   *
   * When to trigger this event:
   * 1. Admin filters the report detail view by toggling drive type
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/--Il4Md26/trigger/05coGVAv8q
   * 2. Admin filters the report detail view by filtering
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/--Il4Md26/trigger/NzWDu--wA
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {int} properties.subscriptionId - User's MileIQ Subscription ID at time of event
   * @param {string} [properties.reportDetailsDriveFilter] - The drive type options in report details view
   * @param {string} properties.reportDetailsSearchFilter - Search filter application options
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/--Il4Md26}
   */
  function driverReportDetailsFiltered(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertSubscriptionId(properties.subscriptionId)
      );
      messages = messages.concat(
        assertOptionalReportDetailsDriveFilter(
          properties.reportDetailsDriveFilter
        )
      );
      messages = messages.concat(
        assertReportDetailsSearchFilter(properties.reportDetailsSearchFilter)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Driver Report Details Filtered",
          Object.keys(properties),
          [
            "platform",
            "organizationGroupId",
            "organizationId",
            "subscriptionId",
            "reportDetailsDriveFilter",
            "reportDetailsSearchFilter",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "--Il4Md26",
          "cfd97a7645b9ee805ac6c7663d02b6eed41bb3c73c5f94756852c5ed22b7c8be",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Driver Report Details Filtered",
        {
          Platform: properties.platform,
          "Organization Group ID": properties.organizationGroupId,
          "Organization ID": properties.organizationId,
          subscription_id: properties.subscriptionId,
          "Report Details Drive Filter": properties.reportDetailsDriveFilter,
          "Report Details Search Filter": properties.reportDetailsSearchFilter,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "--Il4Md26",
          "Driver Report Details Filtered",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "LudSgovtA",
              name: "Report Details Drive Filter",
              value: properties.reportDetailsDriveFilter,
            },
            {
              id: "TDTeQm2UP",
              name: "subscription_id",
              value: properties.subscriptionId,
            },
            {
              id: "pM-3_WWOM",
              name: "Report Details Search Filter",
              value: properties.reportDetailsSearchFilter,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Driver Report Details Filtered': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Driver Report Details Filtered",
          {
            Platform: properties.platform,
            "Organization Group ID": properties.organizationGroupId,
            "Organization ID": properties.organizationId,
            subscription_id: properties.subscriptionId,
            "Report Details Drive Filter": properties.reportDetailsDriveFilter,
            "Report Details Search Filter":
              properties.reportDetailsSearchFilter,
          },
          "--Il4Md26",
          "cfd97a7645b9ee805ac6c7663d02b6eed41bb3c73c5f94756852c5ed22b7c8be"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Driver Report Details Filtered", {
        Platform: properties.platform,
        "Organization Group ID": properties.organizationGroupId,
        "Organization ID": properties.organizationId,
        subscription_id: properties.subscriptionId,
        "Report Details Drive Filter": properties.reportDetailsDriveFilter,
        "Report Details Search Filter": properties.reportDetailsSearchFilter,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Driver Report Details Filtered", {
        Platform: properties.platform,
        "Organization Group ID": properties.organizationGroupId,
        "Organization ID": properties.organizationId,
        subscription_id: properties.subscriptionId,
        "Report Details Drive Filter": properties.reportDetailsDriveFilter,
        "Report Details Search Filter": properties.reportDetailsSearchFilter,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Consolidated Report Started: Admin starts the process to create a consolidated report
   *
   * When to trigger this event:
   * 1. Admin selects to create a consolidated report
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/RYPXt7hm-/trigger/upsksyCpFD
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {int} properties.subscriptionId - User's MileIQ Subscription ID at time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/RYPXt7hm-}
   */
  function teamsConsolidatedReportStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertSubscriptionId(properties.subscriptionId)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Consolidated Report Started",
          Object.keys(properties),
          [
            "platform",
            "organizationGroupId",
            "organizationId",
            "subscriptionId",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "RYPXt7hm-",
          "67d08bef6aa5797033c70bea9b3e350175d1cfa1bc3b8c0381dc961389f7412b",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Consolidated Report Started",
        {
          Platform: properties.platform,
          "Organization Group ID": properties.organizationGroupId,
          "Organization ID": properties.organizationId,
          subscription_id: properties.subscriptionId,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "RYPXt7hm-",
          "Teams Consolidated Report Started",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "TDTeQm2UP",
              name: "subscription_id",
              value: properties.subscriptionId,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Consolidated Report Started': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Consolidated Report Started",
          {
            Platform: properties.platform,
            "Organization Group ID": properties.organizationGroupId,
            "Organization ID": properties.organizationId,
            subscription_id: properties.subscriptionId,
          },
          "RYPXt7hm-",
          "67d08bef6aa5797033c70bea9b3e350175d1cfa1bc3b8c0381dc961389f7412b"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Consolidated Report Started", {
        Platform: properties.platform,
        "Organization Group ID": properties.organizationGroupId,
        "Organization ID": properties.organizationId,
        subscription_id: properties.subscriptionId,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Consolidated Report Started", {
        Platform: properties.platform,
        "Organization Group ID": properties.organizationGroupId,
        "Organization ID": properties.organizationId,
        subscription_id: properties.subscriptionId,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Consolidated Report Completed: Admin completes the process to create a consolidated report
   *
   * When to trigger this event:
   * 1. Admin completes a consolidated report
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/pQCVH4aF-/trigger/0qeBtiF22P
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {int} properties.subscriptionId - User's MileIQ Subscription ID at time of event
   * @param {string} properties.consolidatedReportTimeframe - Timeframe selection options for consolidated reports
   * @param {string} properties.consolidatedReportFormat - Consolidated Report Format Options
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/pQCVH4aF-}
   */
  function teamsConsolidatedReportCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertSubscriptionId(properties.subscriptionId)
      );
      messages = messages.concat(
        assertConsolidatedReportTimeframe(
          properties.consolidatedReportTimeframe
        )
      );
      messages = messages.concat(
        assertConsolidatedReportFormat(properties.consolidatedReportFormat)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Consolidated Report Completed",
          Object.keys(properties),
          [
            "platform",
            "organizationGroupId",
            "organizationId",
            "subscriptionId",
            "consolidatedReportTimeframe",
            "consolidatedReportFormat",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "pQCVH4aF-",
          "3e7541c8128cf467c9ea49134975bf3092f48846bdbe133a4802350a8fccb7af",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Consolidated Report Completed",
        {
          Platform: properties.platform,
          "Organization Group ID": properties.organizationGroupId,
          "Organization ID": properties.organizationId,
          subscription_id: properties.subscriptionId,
          "Consolidated Report Timeframe":
            properties.consolidatedReportTimeframe,
          "Consolidated Report Format": properties.consolidatedReportFormat,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "pQCVH4aF-",
          "Teams Consolidated Report Completed",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "1Qs7wUeGe",
              name: "Consolidated Report Timeframe",
              value: properties.consolidatedReportTimeframe,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "Owm1CLq9u",
              name: "Consolidated Report Format",
              value: properties.consolidatedReportFormat,
            },
            {
              id: "TDTeQm2UP",
              name: "subscription_id",
              value: properties.subscriptionId,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Consolidated Report Completed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Consolidated Report Completed",
          {
            Platform: properties.platform,
            "Organization Group ID": properties.organizationGroupId,
            "Organization ID": properties.organizationId,
            subscription_id: properties.subscriptionId,
            "Consolidated Report Timeframe":
              properties.consolidatedReportTimeframe,
            "Consolidated Report Format": properties.consolidatedReportFormat,
          },
          "pQCVH4aF-",
          "3e7541c8128cf467c9ea49134975bf3092f48846bdbe133a4802350a8fccb7af"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Consolidated Report Completed", {
        Platform: properties.platform,
        "Organization Group ID": properties.organizationGroupId,
        "Organization ID": properties.organizationId,
        subscription_id: properties.subscriptionId,
        "Consolidated Report Timeframe": properties.consolidatedReportTimeframe,
        "Consolidated Report Format": properties.consolidatedReportFormat,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Consolidated Report Completed", {
        Platform: properties.platform,
        "Organization Group ID": properties.organizationGroupId,
        "Organization ID": properties.organizationId,
        subscription_id: properties.subscriptionId,
        "Consolidated Report Timeframe": properties.consolidatedReportTimeframe,
        "Consolidated Report Format": properties.consolidatedReportFormat,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Product Preference Submitted: user clicks "submit" from the how would you like to use MileIQ page
   *
   * When to trigger this event:
   * 1. user clicks "continue" on the how would you like to use MileIQ page
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/amZD1ygcWF/trigger/p5a00CjO-
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.intent - User's intent for the product they want to use.  "use personal" or "create team" or "join team"
   * @param {string} properties.utmSource - Source of the ad
   * @param {string} properties.utmCampaign - Ad campaign from the UTM
   * @param {string} properties.utmContent - Content of the advertisement
   * @param {string} properties.platform - Platform the user was on at the time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/amZD1ygcWF}
   */
  function productPreferenceSubmitted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertIntent(properties.intent));
      messages = messages.concat(assertUTMSource(properties.utmSource));
      messages = messages.concat(assertUTMCampaign(properties.utmCampaign));
      messages = messages.concat(assertUTMContent(properties.utmContent));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Product Preference Submitted",
          Object.keys(properties),
          ["intent", "utmSource", "utmCampaign", "utmContent", "platform"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "amZD1ygcWF",
          "35bce1e2a730dec5ee94a604aff2cf9e20afc20000f389661f771c0ea8c06525",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Product Preference Submitted",
        {
          Intent: properties.intent,
          "UTM Source": properties.utmSource,
          "UTM Campaign": properties.utmCampaign,
          "UTM Content": properties.utmContent,
          Platform: properties.platform,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "amZD1ygcWF",
          "Product Preference Submitted",
          messages,
          [
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "X0Bc-NE2Dt",
              name: "UTM Campaign",
              value: properties.utmCampaign,
            },
            {
              id: "uFzvwV4V4V",
              name: "UTM Content",
              value: properties.utmContent,
            },
            {
              id: "yRYklsveXX",
              name: "UTM Source",
              value: properties.utmSource,
            },
            { id: "zv_WuIxy3", name: "Intent", value: properties.intent },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Product Preference Submitted': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Product Preference Submitted",
          {
            Intent: properties.intent,
            "UTM Source": properties.utmSource,
            "UTM Campaign": properties.utmCampaign,
            "UTM Content": properties.utmContent,
            Platform: properties.platform,
          },
          "amZD1ygcWF",
          "35bce1e2a730dec5ee94a604aff2cf9e20afc20000f389661f771c0ea8c06525"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Product Preference Submitted", {
        Intent: properties.intent,
        "UTM Source": properties.utmSource,
        "UTM Campaign": properties.utmCampaign,
        "UTM Content": properties.utmContent,
        Platform: properties.platform,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Product Preference Submitted", {
        Intent: properties.intent,
        "UTM Source": properties.utmSource,
        "UTM Campaign": properties.utmCampaign,
        "UTM Content": properties.utmContent,
        Platform: properties.platform,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Username Edit Started: User starts the process to edit their username
   *
   * When to trigger this event:
   * 1. User clicks into email textbox.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/stLnhw_E9/trigger/2qa9GMYnJ
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {int} properties.subscriptionId - User's MileIQ Subscription ID at time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/stLnhw_E9}
   */
  function usernameEditStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertSubscriptionId(properties.subscriptionId)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Username Edit Started",
          Object.keys(properties),
          ["platform", "subscriptionId"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "stLnhw_E9",
          "eea34c6b62727c169ba6cf87965c410663f531bb891717af1ce8b850d62da76d",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Username Edit Started",
        {
          Platform: properties.platform,
          subscription_id: properties.subscriptionId,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "stLnhw_E9",
          "Username Edit Started",
          messages,
          [
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "TDTeQm2UP",
              name: "subscription_id",
              value: properties.subscriptionId,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Username Edit Started': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Username Edit Started",
          {
            Platform: properties.platform,
            subscription_id: properties.subscriptionId,
          },
          "stLnhw_E9",
          "eea34c6b62727c169ba6cf87965c410663f531bb891717af1ce8b850d62da76d"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Username Edit Started", {
        Platform: properties.platform,
        subscription_id: properties.subscriptionId,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Username Edit Started", {
        Platform: properties.platform,
        subscription_id: properties.subscriptionId,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Username Edit Step Completed: User completes a step in the edit username flow
   *
   * When to trigger this event:
   * 1. User selects change email in the edit username flow on the web
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/oVi0GVTcD/trigger/bc5vTzIPm
   * 2. User starts to enter a new password in the edit username flow
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/oVi0GVTcD/trigger/zpy4u_Goq
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} properties.editUsernameStepName - Step names in the edit username flow
   * @param {int} properties.subscriptionId - User's MileIQ Subscription ID at time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/oVi0GVTcD}
   */
  function usernameEditStepCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertEditUsernameStepName(properties.editUsernameStepName)
      );
      messages = messages.concat(
        assertSubscriptionId(properties.subscriptionId)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Username Edit Step Completed",
          Object.keys(properties),
          ["platform", "editUsernameStepName", "subscriptionId"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "oVi0GVTcD",
          "6f5013b49e0c4de2d87a13ba326c1a44330952a4351da2adac6c174ed3d737f4",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Username Edit Step Completed",
        {
          Platform: properties.platform,
          "Edit Username Step Name": properties.editUsernameStepName,
          subscription_id: properties.subscriptionId,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "oVi0GVTcD",
          "Username Edit Step Completed",
          messages,
          [
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "OqLN7y296",
              name: "Edit Username Step Name",
              value: properties.editUsernameStepName,
            },
            {
              id: "TDTeQm2UP",
              name: "subscription_id",
              value: properties.subscriptionId,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Username Edit Step Completed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Username Edit Step Completed",
          {
            Platform: properties.platform,
            "Edit Username Step Name": properties.editUsernameStepName,
            subscription_id: properties.subscriptionId,
          },
          "oVi0GVTcD",
          "6f5013b49e0c4de2d87a13ba326c1a44330952a4351da2adac6c174ed3d737f4"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Username Edit Step Completed", {
        Platform: properties.platform,
        "Edit Username Step Name": properties.editUsernameStepName,
        subscription_id: properties.subscriptionId,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Username Edit Step Completed", {
        Platform: properties.platform,
        "Edit Username Step Name": properties.editUsernameStepName,
        subscription_id: properties.subscriptionId,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Username Edit Completed: User completes the process to edit their username
   *
   * When to trigger this event:
   * 1. User completes the edit username flow and successfully submits done
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/p1cvsqOb5/trigger/qAOygcdLaq
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {int} properties.subscriptionId - User's MileIQ Subscription ID at time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/p1cvsqOb5}
   */
  function usernameEditCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertSubscriptionId(properties.subscriptionId)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Username Edit Completed",
          Object.keys(properties),
          ["platform", "subscriptionId"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "p1cvsqOb5",
          "4df6c094b8509e8985baa0d10ebbaba32632f93e79dcc7e01bc4d71b56ab6aaf",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Username Edit Completed",
        {
          Platform: properties.platform,
          subscription_id: properties.subscriptionId,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "p1cvsqOb5",
          "Username Edit Completed",
          messages,
          [
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "TDTeQm2UP",
              name: "subscription_id",
              value: properties.subscriptionId,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Username Edit Completed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Username Edit Completed",
          {
            Platform: properties.platform,
            subscription_id: properties.subscriptionId,
          },
          "p1cvsqOb5",
          "4df6c094b8509e8985baa0d10ebbaba32632f93e79dcc7e01bc4d71b56ab6aaf"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Username Edit Completed", {
        Platform: properties.platform,
        subscription_id: properties.subscriptionId,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Username Edit Completed", {
        Platform: properties.platform,
        subscription_id: properties.subscriptionId,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Page Viewed: User navigates to a new screen
   *
   * When to trigger this event:
   * 1. Report recipient who is not a standalone user opens a report email and viewed the shared reports page
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/HKPNAsenWk/trigger/0SqW4-qmM
   * 2. Report recipient who is logged in as a standalone driver clicks on a report link in an email and views reports on the "Shared with me" page
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/HKPNAsenWk/trigger/7j0T1vluk
   * 3. A contact has converted to a teams admin and is viewing previously shared reported on the shared with me tab from the teams dashboard
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/HKPNAsenWk/trigger/I-GlGeZ_B
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.customDestinationPageName_ - Name of the page or screen
   * @param {string} properties.page - The page or screen in app or on the web where the event sourced from.
   * @param {string} properties.platform - Platform the user was on at the time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/HKPNAsenWk}
   */
  function pageViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(
        assertCustomDestinationPageName_(properties.customDestinationPageName_)
      );
      messages = messages.concat(assertPage(properties.page));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Page Viewed",
          Object.keys(properties),
          ["customDestinationPageName_", "page", "platform"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "HKPNAsenWk",
          "4db157187a0421e7752b95baa07dfd94a7d115caa862592c6c7babb9a7f5b0d0",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Page Viewed",
        {
          Page: properties.page,
          Platform: properties.platform,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "HKPNAsenWk",
          "Page Viewed",
          messages,
          [
            { id: "4j_Pu5zIMW", name: "Page", value: properties.page },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Page Viewed': " + messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Page Viewed",
          {
            Page: properties.page,
            Platform: properties.platform,
          },
          "HKPNAsenWk",
          "4db157187a0421e7752b95baa07dfd94a7d115caa862592c6c7babb9a7f5b0d0"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.page
        ? RudderStackWebDashboard.page(properties.customDestinationPageName_, {
            Page: properties.page,
            Platform: properties.platform,
          })
        : InternalAvoLogger.error(
            "Page method is not implemented in the destination",
            ""
          );
      RudderStackWebDashboard.logEvent("Page Viewed", {
        Page: properties.page,
        Platform: properties.platform,
      });

      // destination Mixpanel
      Mixpanel.page
        ? Mixpanel.page(properties.customDestinationPageName_, {
            Page: properties.page,
            Platform: properties.platform,
          })
        : InternalAvoLogger.error(
            "Page method is not implemented in the destination",
            ""
          );
      Mixpanel.logEvent("Page Viewed", {
        Page: properties.page,
        Platform: properties.platform,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Add Shared Named Location Started: Admin starts the Add Shared Named Location Flow
   *
   * When to trigger this event:
   * 1. Admin starts the Add Shared Named Location flow from Teams Locations Page
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/Wg2QPynqor/trigger/EzhRVo31u
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} properties.page - The page or screen in app or on the web where the event sourced from.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/Wg2QPynqor}
   */
  function addSharedNamedLocationStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(assertPage(properties.page));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Add Shared Named Location Started",
          Object.keys(properties),
          ["platform", "organizationGroupId", "organizationId", "page"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "Wg2QPynqor",
          "1ac71dfa9e2ec478adbcd9de98748593a14ee8b4b103ec8ced23f9565068fa1a",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Add Shared Named Location Started",
        {
          Platform: properties.platform,
          "Organization Group ID": properties.organizationGroupId,
          "Organization ID": properties.organizationId,
          Page: properties.page,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "Wg2QPynqor",
          "Add Shared Named Location Started",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            { id: "4j_Pu5zIMW", name: "Page", value: properties.page },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Add Shared Named Location Started': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Add Shared Named Location Started",
          {
            Platform: properties.platform,
            "Organization Group ID": properties.organizationGroupId,
            "Organization ID": properties.organizationId,
            Page: properties.page,
          },
          "Wg2QPynqor",
          "1ac71dfa9e2ec478adbcd9de98748593a14ee8b4b103ec8ced23f9565068fa1a"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Add Shared Named Location Started", {
        Platform: properties.platform,
        "Organization Group ID": properties.organizationGroupId,
        "Organization ID": properties.organizationId,
        Page: properties.page,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Add Shared Named Location Started", {
        Platform: properties.platform,
        "Organization Group ID": properties.organizationGroupId,
        "Organization ID": properties.organizationId,
        Page: properties.page,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Add Shared Named Location Step: Admin starts a step in the Add Shared Named Location flow
   *
   * When to trigger this event:
   * 1. Admin starts Address
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/drCetmC9Y/trigger/G1aq_5ERiO
   * 2. Admin starts to Add Location Name
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/drCetmC9Y/trigger/71EQrvKUp
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} properties.page - The page or screen in app or on the web where the event sourced from.
   * @param {string} properties.sharedNamedLocationStepName - Name of the step in the Shared Named Location Flow
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/drCetmC9Y}
   */
  function addSharedNamedLocationStep(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(assertPage(properties.page));
      messages = messages.concat(
        assertSharedNamedLocationStepName(
          properties.sharedNamedLocationStepName
        )
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Add Shared Named Location Step",
          Object.keys(properties),
          [
            "platform",
            "organizationGroupId",
            "organizationId",
            "page",
            "sharedNamedLocationStepName",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "drCetmC9Y",
          "ab6c14e40581b2756021084fd18f6cb48ec22d6ca6d2086c84767add588283d5",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Add Shared Named Location Step",
        {
          Platform: properties.platform,
          "Organization Group ID": properties.organizationGroupId,
          "Organization ID": properties.organizationId,
          Page: properties.page,
          "Shared Named Location Step Name":
            properties.sharedNamedLocationStepName,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "drCetmC9Y",
          "Add Shared Named Location Step",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            { id: "4j_Pu5zIMW", name: "Page", value: properties.page },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "VcM7896xn",
              name: "Shared Named Location Step Name",
              value: properties.sharedNamedLocationStepName,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Add Shared Named Location Step': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Add Shared Named Location Step",
          {
            Platform: properties.platform,
            "Organization Group ID": properties.organizationGroupId,
            "Organization ID": properties.organizationId,
            Page: properties.page,
            "Shared Named Location Step Name":
              properties.sharedNamedLocationStepName,
          },
          "drCetmC9Y",
          "ab6c14e40581b2756021084fd18f6cb48ec22d6ca6d2086c84767add588283d5"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Add Shared Named Location Step", {
        Platform: properties.platform,
        "Organization Group ID": properties.organizationGroupId,
        "Organization ID": properties.organizationId,
        Page: properties.page,
        "Shared Named Location Step Name":
          properties.sharedNamedLocationStepName,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Add Shared Named Location Step", {
        Platform: properties.platform,
        "Organization Group ID": properties.organizationGroupId,
        "Organization ID": properties.organizationId,
        Page: properties.page,
        "Shared Named Location Step Name":
          properties.sharedNamedLocationStepName,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Add Shared Named Location Completed: Admin completes the Add Shared Named Location Flow
   *
   * When to trigger this event:
   * 1. Admin completes the Add Shared Named Location flow.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/O40OrHHax/trigger/uNGYMGWsku
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} properties.page - The page or screen in app or on the web where the event sourced from.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/O40OrHHax}
   */
  function addSharedNamedLocationCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(assertPage(properties.page));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Add Shared Named Location Completed",
          Object.keys(properties),
          ["platform", "organizationGroupId", "organizationId", "page"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "O40OrHHax",
          "5cc64135315087183cab5e979fd7bdfadc2d92f4557c1d06284219df98ca58b3",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Add Shared Named Location Completed",
        {
          Platform: properties.platform,
          "Organization Group ID": properties.organizationGroupId,
          "Organization ID": properties.organizationId,
          Page: properties.page,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "O40OrHHax",
          "Add Shared Named Location Completed",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            { id: "4j_Pu5zIMW", name: "Page", value: properties.page },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Add Shared Named Location Completed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Add Shared Named Location Completed",
          {
            Platform: properties.platform,
            "Organization Group ID": properties.organizationGroupId,
            "Organization ID": properties.organizationId,
            Page: properties.page,
          },
          "O40OrHHax",
          "5cc64135315087183cab5e979fd7bdfadc2d92f4557c1d06284219df98ca58b3"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Add Shared Named Location Completed", {
        Platform: properties.platform,
        "Organization Group ID": properties.organizationGroupId,
        "Organization ID": properties.organizationId,
        Page: properties.page,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Add Shared Named Location Completed", {
        Platform: properties.platform,
        "Organization Group ID": properties.organizationGroupId,
        "Organization ID": properties.organizationId,
        Page: properties.page,
      });

      // destination Braze
      Braze.logEvent("Add Shared Named Location Completed", {
        Platform: properties.platform,
        "Organization Group ID": properties.organizationGroupId,
        "Organization ID": properties.organizationId,
        Page: properties.page,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Rename Shared Named Location Started: Admin starts the Rename Shared Named Location Flow
   *
   * When to trigger this event:
   * 1. Admin starts the Rename shared Named Location flow from Teams Locations Page
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/mdtdT122d/trigger/Ot1m53Q8Hp
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} properties.page - The page or screen in app or on the web where the event sourced from.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/mdtdT122d}
   */
  function renameSharedNamedLocationStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(assertPage(properties.page));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Rename Shared Named Location Started",
          Object.keys(properties),
          ["platform", "organizationGroupId", "organizationId", "page"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "mdtdT122d",
          "0975e294da0985b2a53be36818d24e7f240fb7b16131ccc84d7e0ff615c06d6a",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Rename Shared Named Location Started",
        {
          Platform: properties.platform,
          "Organization Group ID": properties.organizationGroupId,
          "Organization ID": properties.organizationId,
          Page: properties.page,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "mdtdT122d",
          "Rename Shared Named Location Started",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            { id: "4j_Pu5zIMW", name: "Page", value: properties.page },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Rename Shared Named Location Started': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Rename Shared Named Location Started",
          {
            Platform: properties.platform,
            "Organization Group ID": properties.organizationGroupId,
            "Organization ID": properties.organizationId,
            Page: properties.page,
          },
          "mdtdT122d",
          "0975e294da0985b2a53be36818d24e7f240fb7b16131ccc84d7e0ff615c06d6a"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Rename Shared Named Location Started", {
        Platform: properties.platform,
        "Organization Group ID": properties.organizationGroupId,
        "Organization ID": properties.organizationId,
        Page: properties.page,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Rename Shared Named Location Started", {
        Platform: properties.platform,
        "Organization Group ID": properties.organizationGroupId,
        "Organization ID": properties.organizationId,
        Page: properties.page,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Rename Shared Named Location Completed: Admin completes the Rename Shared Named Location Flow
   *
   * When to trigger this event:
   * 1. Admin completes the Rename shared Named Location flow
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/L8KWy7Nes/trigger/SSm62od1UJ
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} properties.page - The page or screen in app or on the web where the event sourced from.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/L8KWy7Nes}
   */
  function renameSharedNamedLocationCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(assertPage(properties.page));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Rename Shared Named Location Completed",
          Object.keys(properties),
          ["platform", "organizationGroupId", "organizationId", "page"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "L8KWy7Nes",
          "b201744012d1abd98eb702a8424d044e922b6d946ef3055e7d6591044408c574",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Rename Shared Named Location Completed",
        {
          Platform: properties.platform,
          "Organization Group ID": properties.organizationGroupId,
          "Organization ID": properties.organizationId,
          Page: properties.page,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "L8KWy7Nes",
          "Rename Shared Named Location Completed",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            { id: "4j_Pu5zIMW", name: "Page", value: properties.page },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Rename Shared Named Location Completed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Rename Shared Named Location Completed",
          {
            Platform: properties.platform,
            "Organization Group ID": properties.organizationGroupId,
            "Organization ID": properties.organizationId,
            Page: properties.page,
          },
          "L8KWy7Nes",
          "b201744012d1abd98eb702a8424d044e922b6d946ef3055e7d6591044408c574"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent(
        "Rename Shared Named Location Completed",
        {
          Platform: properties.platform,
          "Organization Group ID": properties.organizationGroupId,
          "Organization ID": properties.organizationId,
          Page: properties.page,
        }
      );

      // destination Mixpanel
      Mixpanel.logEvent("Rename Shared Named Location Completed", {
        Platform: properties.platform,
        "Organization Group ID": properties.organizationGroupId,
        "Organization ID": properties.organizationId,
        Page: properties.page,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Delete Shared Named Location Started: Admin starts the Delete Shared Named Location Flow
   *
   * When to trigger this event:
   * 1. Admin starts the Delete shared Named Location flow from Teams Locations Page
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/tS-KMQh22/trigger/BgNiNnHIJi
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} properties.page - The page or screen in app or on the web where the event sourced from.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/tS-KMQh22}
   */
  function deleteSharedNamedLocationStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(assertPage(properties.page));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Delete Shared Named Location Started",
          Object.keys(properties),
          ["platform", "organizationGroupId", "organizationId", "page"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "tS-KMQh22",
          "d7d79d7a7981776d8a05fa740eab33ec21ae65d275a5b256c7d5115458d8a006",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Delete Shared Named Location Started",
        {
          Platform: properties.platform,
          "Organization Group ID": properties.organizationGroupId,
          "Organization ID": properties.organizationId,
          Page: properties.page,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "tS-KMQh22",
          "Delete Shared Named Location Started",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            { id: "4j_Pu5zIMW", name: "Page", value: properties.page },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Delete Shared Named Location Started': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Delete Shared Named Location Started",
          {
            Platform: properties.platform,
            "Organization Group ID": properties.organizationGroupId,
            "Organization ID": properties.organizationId,
            Page: properties.page,
          },
          "tS-KMQh22",
          "d7d79d7a7981776d8a05fa740eab33ec21ae65d275a5b256c7d5115458d8a006"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Delete Shared Named Location Started", {
        Platform: properties.platform,
        "Organization Group ID": properties.organizationGroupId,
        "Organization ID": properties.organizationId,
        Page: properties.page,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Delete Shared Named Location Started", {
        Platform: properties.platform,
        "Organization Group ID": properties.organizationGroupId,
        "Organization ID": properties.organizationId,
        Page: properties.page,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Delete Shared Named Location Completed: Admin completes the Delete Shared Named Location Flow
   *
   * When to trigger this event:
   * 1. Admin completes the Delete shared Named Location flow
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/Gj0JUSmQA/trigger/U64tjzEkpC
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} properties.page - The page or screen in app or on the web where the event sourced from.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/Gj0JUSmQA}
   */
  function deleteSharedNamedLocationCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(assertPage(properties.page));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Delete Shared Named Location Completed",
          Object.keys(properties),
          ["platform", "organizationGroupId", "organizationId", "page"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "Gj0JUSmQA",
          "1a7330537dd4280ba9b8b1ce0a586c8b41c7dbe255a6241ca5860dfc41e5ecf1",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Delete Shared Named Location Completed",
        {
          Platform: properties.platform,
          "Organization Group ID": properties.organizationGroupId,
          "Organization ID": properties.organizationId,
          Page: properties.page,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "Gj0JUSmQA",
          "Delete Shared Named Location Completed",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            { id: "4j_Pu5zIMW", name: "Page", value: properties.page },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Delete Shared Named Location Completed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Delete Shared Named Location Completed",
          {
            Platform: properties.platform,
            "Organization Group ID": properties.organizationGroupId,
            "Organization ID": properties.organizationId,
            Page: properties.page,
          },
          "Gj0JUSmQA",
          "1a7330537dd4280ba9b8b1ce0a586c8b41c7dbe255a6241ca5860dfc41e5ecf1"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent(
        "Delete Shared Named Location Completed",
        {
          Platform: properties.platform,
          "Organization Group ID": properties.organizationGroupId,
          "Organization ID": properties.organizationId,
          Page: properties.page,
        }
      );

      // destination Mixpanel
      Mixpanel.logEvent("Delete Shared Named Location Completed", {
        Platform: properties.platform,
        "Organization Group ID": properties.organizationGroupId,
        "Organization ID": properties.organizationId,
        Page: properties.page,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Shared Named Location Failed: Admin completes the Delete Shared Named Location Flow
   *
   * When to trigger this event:
   * 1. Area is already a location
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/o2Fu78mMp/trigger/V8rhBujJIX
   * 2. Address is already a location
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/o2Fu78mMp/trigger/H9RxL0efn
   * 3. Name is already a location
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/o2Fu78mMp/trigger/i8iA-uE9M
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} properties.page - The page or screen in app or on the web where the event sourced from.
   * @param {string} properties.sharedNamedLocationFailure - Name of the failure in shared name location
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/o2Fu78mMp}
   */
  function sharedNamedLocationFailed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(assertPage(properties.page));
      messages = messages.concat(
        assertSharedNamedLocationFailure(properties.sharedNamedLocationFailure)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Shared Named Location Failed",
          Object.keys(properties),
          [
            "platform",
            "organizationGroupId",
            "organizationId",
            "page",
            "sharedNamedLocationFailure",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "o2Fu78mMp",
          "f543dba8738a1f19e88832cd0ac0e42c5122ae2df29b6e3c21b3b68db35ba524",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Shared Named Location Failed",
        {
          Platform: properties.platform,
          "Organization Group ID": properties.organizationGroupId,
          "Organization ID": properties.organizationId,
          Page: properties.page,
          "Shared Named Location Failure":
            properties.sharedNamedLocationFailure,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "o2Fu78mMp",
          "Shared Named Location Failed",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            { id: "4j_Pu5zIMW", name: "Page", value: properties.page },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "pjut28haR",
              name: "Shared Named Location Failure",
              value: properties.sharedNamedLocationFailure,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Shared Named Location Failed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Shared Named Location Failed",
          {
            Platform: properties.platform,
            "Organization Group ID": properties.organizationGroupId,
            "Organization ID": properties.organizationId,
            Page: properties.page,
            "Shared Named Location Failure":
              properties.sharedNamedLocationFailure,
          },
          "o2Fu78mMp",
          "f543dba8738a1f19e88832cd0ac0e42c5122ae2df29b6e3c21b3b68db35ba524"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Shared Named Location Failed", {
        Platform: properties.platform,
        "Organization Group ID": properties.organizationGroupId,
        "Organization ID": properties.organizationId,
        Page: properties.page,
        "Shared Named Location Failure": properties.sharedNamedLocationFailure,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Shared Named Location Failed", {
        Platform: properties.platform,
        "Organization Group ID": properties.organizationGroupId,
        "Organization ID": properties.organizationId,
        Page: properties.page,
        "Shared Named Location Failure": properties.sharedNamedLocationFailure,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Subscription Cancelation Started: Admin begins the teams subscription cancelation flow
   *
   * When to trigger this event:
   * 1. Admin selects "Cancel subscription" from the Manage Subscription menu on the teams dashboard
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/UypJ2gtoYw/trigger/zSNo3cMhd
   *
   * @param {object} properties - the properties associatied with this event
   * @param {int} properties.teamId - Team unique identifier
   * @param {int} properties.teamsDriverCount - Count of drivers in Team at time of event.
   * @param {int} [properties.teamsPlanId] - Plan Type ID of the Team at time of event. If a team is not on a plan, do not send property.
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {bool} [properties.freeTrial] - Indicates whether the event is associated with a free trial plan.
   * @param {string} [properties.teamsPlanInterval] - Describes the Teams plan interval at the time of the event.
   * @param {bool} [properties.eligibleToDiscounts] - Indicates whether the team is eligible to be offered discounts.

   * @param {string} [properties.teamsPlanName] - Name of the Team's plan at time of event. If a team is not on a plan, do not send property.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/UypJ2gtoYw}
   */
  function teamsSubscriptionCancelationStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertTeamId(properties.teamId));
      messages = messages.concat(
        assertTeamsDriverCount(properties.teamsDriverCount)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanID(properties.teamsPlanId)
      );
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertOptionalFreeTrial(properties.freeTrial));
      messages = messages.concat(
        assertOptionalTeamsPlanInterval(properties.teamsPlanInterval)
      );
      messages = messages.concat(
        assertOptionalEligibleToDiscounts(properties.eligibleToDiscounts)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanName(properties.teamsPlanName)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Subscription Cancelation Started",
          Object.keys(properties),
          [
            "teamId",
            "teamsDriverCount",
            "teamsPlanId",
            "platform",
            "freeTrial",
            "teamsPlanInterval",
            "eligibleToDiscounts",
            "teamsPlanName",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "UypJ2gtoYw",
          "1c55068438d348a13705005ecb04cc8f2c569d826af1b2eeb8431735b030908d",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Subscription Cancelation Started",
        {
          team_id: properties.teamId,
          "Teams Driver Count": properties.teamsDriverCount,
          "Teams Plan ID": properties.teamsPlanId,
          Platform: properties.platform,
          "Free Trial": properties.freeTrial,
          "Teams Plan Interval": properties.teamsPlanInterval,
          "Eligible to Discounts": properties.eligibleToDiscounts,
          "Teams Plan Name": properties.teamsPlanName,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "UypJ2gtoYw",
          "Teams Subscription Cancelation Started",
          messages,
          [
            {
              id: "125AY5RLNY",
              name: "Teams Plan Name",
              value: properties.teamsPlanName,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "IaqLx6O9U",
              name: "Eligible to Discounts",
              value: properties.eligibleToDiscounts,
            },
            {
              id: "TbSVW_o_GH",
              name: "Teams Plan ID",
              value: properties.teamsPlanId,
            },
            {
              id: "XcK728z2q",
              name: "Teams Plan Interval",
              value: properties.teamsPlanInterval,
            },
            {
              id: "dVaX1T1uG",
              name: "Free Trial",
              value: properties.freeTrial,
            },
            {
              id: "h2UcigKyW",
              name: "Teams Driver Count",
              value: properties.teamsDriverCount,
            },
            { id: "oeDBOcvZ5e", name: "team_id", value: properties.teamId },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Subscription Cancelation Started': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Subscription Cancelation Started",
          {
            team_id: properties.teamId,
            "Teams Driver Count": properties.teamsDriverCount,
            "Teams Plan ID": properties.teamsPlanId,
            Platform: properties.platform,
            "Free Trial": properties.freeTrial,
            "Teams Plan Interval": properties.teamsPlanInterval,
            "Eligible to Discounts": properties.eligibleToDiscounts,
            "Teams Plan Name": properties.teamsPlanName,
          },
          "UypJ2gtoYw",
          "1c55068438d348a13705005ecb04cc8f2c569d826af1b2eeb8431735b030908d"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent(
        "Teams Subscription Cancelation Started",
        {
          team_id: properties.teamId,
          "Teams Driver Count": properties.teamsDriverCount,
          "Teams Plan ID": properties.teamsPlanId,
          Platform: properties.platform,
          "Free Trial": properties.freeTrial,
          "Teams Plan Interval": properties.teamsPlanInterval,
          "Eligible to Discounts": properties.eligibleToDiscounts,
          "Teams Plan Name": properties.teamsPlanName,
        }
      );

      // destination Mixpanel
      Mixpanel.logEvent("Teams Subscription Cancelation Started", {
        team_id: properties.teamId,
        "Teams Driver Count": properties.teamsDriverCount,
        "Teams Plan ID": properties.teamsPlanId,
        Platform: properties.platform,
        "Free Trial": properties.freeTrial,
        "Teams Plan Interval": properties.teamsPlanInterval,
        "Eligible to Discounts": properties.eligibleToDiscounts,
        "Teams Plan Name": properties.teamsPlanName,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Subscription Cancelation Completed: Admin completes the subscription cancelation flow
   *
   * When to trigger this event:
   * 1. Admin clicks on "Cancel Subscription" on Cancelation Reason step and successfully cancel their subscription
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/VVluXHR1Tj/trigger/lyn9Lzs6o
   * 2. Admin clicks on "Cancel Subscription" on Team All Time Stats step and successfully cancel their subscription
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/VVluXHR1Tj/trigger/DhJtmM7gk
   * 3. Admin clicks on "Cancel Subscription" on Downgrade Subscription step and successfully cancel their subscription
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/VVluXHR1Tj/trigger/KkDvLyiyi
   * 4. Admin clicks on "Cancel Subscription" on Claim Discount step and successfully cancel their subscription
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/VVluXHR1Tj/trigger/vsFKkuBmQ
   *
   * @param {object} properties - the properties associatied with this event
   * @param {int} properties.teamId - Team unique identifier
   * @param {int} [properties.teamsPlanId] - Plan Type ID of the Team at time of event. If a team is not on a plan, do not send property.
   * @param {int} properties.teamsDriverCount - Count of drivers in Team at time of event.
   * @param {string} properties.cancelationReason - Subscription cancelation reason entered by the user during the subscription cancelation flow
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {bool} properties.freeTrial - Indicates whether the event is associated with a free trial plan.
   * @param {string} [properties.teamsPlanInterval] - Describes the Teams plan interval at the time of the event.
   * @param {string} [properties.teamsSubscriptionCancellationStep] - Indicate the step of the Teams subscription cancellation flow.
   * @param {bool} [properties.eligibleToDiscounts] - Indicates whether the team is eligible to be offered discounts.

   * @param {string} [properties.teamsPlanName] - Name of the Team's plan at time of event. If a team is not on a plan, do not send property.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/VVluXHR1Tj}
   */
  function teamsSubscriptionCancelationCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertTeamId(properties.teamId));
      messages = messages.concat(
        assertOptionalTeamsPlanID(properties.teamsPlanId)
      );
      messages = messages.concat(
        assertTeamsDriverCount(properties.teamsDriverCount)
      );
      messages = messages.concat(
        assertCancelationReason(properties.cancelationReason)
      );
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertFreeTrial(properties.freeTrial));
      messages = messages.concat(
        assertOptionalTeamsPlanInterval(properties.teamsPlanInterval)
      );
      messages = messages.concat(
        assertOptionalTeamsSubscriptionCancellationStep(
          properties.teamsSubscriptionCancellationStep
        )
      );
      messages = messages.concat(
        assertOptionalEligibleToDiscounts(properties.eligibleToDiscounts)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanName(properties.teamsPlanName)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Subscription Cancelation Completed",
          Object.keys(properties),
          [
            "teamId",
            "teamsPlanId",
            "teamsDriverCount",
            "cancelationReason",
            "platform",
            "freeTrial",
            "teamsPlanInterval",
            "teamsSubscriptionCancellationStep",
            "eligibleToDiscounts",
            "teamsPlanName",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "VVluXHR1Tj",
          "4329d665503c838f8a8f5c7aecb0cafb6d3e44fe2cc572296e507c517bb49af4",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Subscription Cancelation Completed",
        {
          team_id: properties.teamId,
          "Teams Plan ID": properties.teamsPlanId,
          "Teams Driver Count": properties.teamsDriverCount,
          "Cancelation Reason": properties.cancelationReason,
          Platform: properties.platform,
          "Free Trial": properties.freeTrial,
          "Teams Plan Interval": properties.teamsPlanInterval,
          "Teams Subscription Cancellation Step":
            properties.teamsSubscriptionCancellationStep,
          "Eligible to Discounts": properties.eligibleToDiscounts,
          "Teams Plan Name": properties.teamsPlanName,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "VVluXHR1Tj",
          "Teams Subscription Cancelation Completed",
          messages,
          [
            {
              id: "125AY5RLNY",
              name: "Teams Plan Name",
              value: properties.teamsPlanName,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "IaqLx6O9U",
              name: "Eligible to Discounts",
              value: properties.eligibleToDiscounts,
            },
            {
              id: "TbSVW_o_GH",
              name: "Teams Plan ID",
              value: properties.teamsPlanId,
            },
            {
              id: "VfvB5TTnB",
              name: "Cancelation Reason",
              value: properties.cancelationReason,
            },
            {
              id: "XcK728z2q",
              name: "Teams Plan Interval",
              value: properties.teamsPlanInterval,
            },
            {
              id: "dVaX1T1uG",
              name: "Free Trial",
              value: properties.freeTrial,
            },
            {
              id: "h2UcigKyW",
              name: "Teams Driver Count",
              value: properties.teamsDriverCount,
            },
            { id: "oeDBOcvZ5e", name: "team_id", value: properties.teamId },
            {
              id: "ps4aByRzM",
              name: "Teams Subscription Cancellation Step",
              value: properties.teamsSubscriptionCancellationStep,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Subscription Cancelation Completed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Subscription Cancelation Completed",
          {
            team_id: properties.teamId,
            "Teams Plan ID": properties.teamsPlanId,
            "Teams Driver Count": properties.teamsDriverCount,
            "Cancelation Reason": properties.cancelationReason,
            Platform: properties.platform,
            "Free Trial": properties.freeTrial,
            "Teams Plan Interval": properties.teamsPlanInterval,
            "Teams Subscription Cancellation Step":
              properties.teamsSubscriptionCancellationStep,
            "Eligible to Discounts": properties.eligibleToDiscounts,
            "Teams Plan Name": properties.teamsPlanName,
          },
          "VVluXHR1Tj",
          "4329d665503c838f8a8f5c7aecb0cafb6d3e44fe2cc572296e507c517bb49af4"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent(
        "Teams Subscription Cancelation Completed",
        {
          team_id: properties.teamId,
          "Teams Plan ID": properties.teamsPlanId,
          "Teams Driver Count": properties.teamsDriverCount,
          "Cancelation Reason": properties.cancelationReason,
          Platform: properties.platform,
          "Free Trial": properties.freeTrial,
          "Teams Plan Interval": properties.teamsPlanInterval,
          "Teams Subscription Cancellation Step":
            properties.teamsSubscriptionCancellationStep,
          "Eligible to Discounts": properties.eligibleToDiscounts,
          "Teams Plan Name": properties.teamsPlanName,
        }
      );

      // destination Mixpanel
      Mixpanel.logEvent("Teams Subscription Cancelation Completed", {
        team_id: properties.teamId,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Driver Count": properties.teamsDriverCount,
        "Cancelation Reason": properties.cancelationReason,
        Platform: properties.platform,
        "Free Trial": properties.freeTrial,
        "Teams Plan Interval": properties.teamsPlanInterval,
        "Teams Subscription Cancellation Step":
          properties.teamsSubscriptionCancellationStep,
        "Eligible to Discounts": properties.eligibleToDiscounts,
        "Teams Plan Name": properties.teamsPlanName,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Action Undone: User reverts an action (UNDO)
   *
   * When to trigger this event:
   * 1. User selects undo in the blue toast pop-up
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/n11ZHfF01a/trigger/zP5pn7N-T
   * 2. Undo drive classify
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/n11ZHfF01a/trigger/A_dr53ppF
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.userAction - Action taken by the user, which can be undone with an 'undo' button.
   * @param {int} properties.subscriptionId - User's MileIQ Subscription ID at time of event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} properties.page - The page or screen in app or on the web where the event sourced from.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/n11ZHfF01a}
   */
  function actionUndone(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertUserAction(properties.userAction));
      messages = messages.concat(
        assertSubscriptionId(properties.subscriptionId)
      );
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertPage(properties.page));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Action Undone",
          Object.keys(properties),
          ["userAction", "subscriptionId", "platform", "page"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "n11ZHfF01a",
          "d8b6c29fc258514cbbd914922cc7e329bd6bdfa4fa802a48772b37f129768462",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Action Undone",
        {
          "User Action": properties.userAction,
          subscription_id: properties.subscriptionId,
          Platform: properties.platform,
          Page: properties.page,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "n11ZHfF01a",
          "Action Undone",
          messages,
          [
            { id: "4j_Pu5zIMW", name: "Page", value: properties.page },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "QOk1tKWD6",
              name: "User Action",
              value: properties.userAction,
            },
            {
              id: "TDTeQm2UP",
              name: "subscription_id",
              value: properties.subscriptionId,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Action Undone': " + messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Action Undone",
          {
            "User Action": properties.userAction,
            subscription_id: properties.subscriptionId,
            Platform: properties.platform,
            Page: properties.page,
          },
          "n11ZHfF01a",
          "d8b6c29fc258514cbbd914922cc7e329bd6bdfa4fa802a48772b37f129768462"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Action Undone", {
        "User Action": properties.userAction,
        subscription_id: properties.subscriptionId,
        Platform: properties.platform,
        Page: properties.page,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Action Undone", {
        "User Action": properties.userAction,
        subscription_id: properties.subscriptionId,
        Platform: properties.platform,
        Page: properties.page,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Search Started: Driver starts a search on Drives page.
   *
   * When to trigger this event:
   * 1. Driver starts to type into the search box on Drive Page Search
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/exPCVuUJSe/trigger/e3q9a8uTR
   *
   * @param {object} properties - the properties associatied with this event
   * @param {int} properties.subscriptionId - User's MileIQ Subscription ID at time of event
   * @param {string} properties.page - The page or screen in app or on the web where the event sourced from.
   * @param {string} properties.platform - Platform the user was on at the time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/exPCVuUJSe}
   */
  function searchStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(
        assertSubscriptionId(properties.subscriptionId)
      );
      messages = messages.concat(assertPage(properties.page));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Search Started",
          Object.keys(properties),
          ["subscriptionId", "page", "platform"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "exPCVuUJSe",
          "c465ac0b743a84791c0f21b5d554bfb4d66c4832728857725adf4374967087a9",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Search Started",
        {
          subscription_id: properties.subscriptionId,
          Page: properties.page,
          Platform: properties.platform,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "exPCVuUJSe",
          "Search Started",
          messages,
          [
            { id: "4j_Pu5zIMW", name: "Page", value: properties.page },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "TDTeQm2UP",
              name: "subscription_id",
              value: properties.subscriptionId,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Search Started': " + messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Search Started",
          {
            subscription_id: properties.subscriptionId,
            Page: properties.page,
            Platform: properties.platform,
          },
          "exPCVuUJSe",
          "c465ac0b743a84791c0f21b5d554bfb4d66c4832728857725adf4374967087a9"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Search Started", {
        subscription_id: properties.subscriptionId,
        Page: properties.page,
        Platform: properties.platform,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Search Started", {
        subscription_id: properties.subscriptionId,
        Page: properties.page,
        Platform: properties.platform,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Search Completed: Driver completes a search on Drives page.
   *
   * When to trigger this event:
   * 1. Driver hits 'enter' or selects a drop down from the search box on Drive Page Search
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/XvYBfObuj/trigger/BVW3ciRSrp
   *
   * @param {object} properties - the properties associatied with this event
   * @param {int} properties.subscriptionId - User's MileIQ Subscription ID at time of event
   * @param {string} properties.page - The page or screen in app or on the web where the event sourced from.
   * @param {string} properties.searchSelectionType - Type of search detail applied
   * @param {string} properties.platform - Platform the user was on at the time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/XvYBfObuj}
   */
  function searchCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(
        assertSubscriptionId(properties.subscriptionId)
      );
      messages = messages.concat(assertPage(properties.page));
      messages = messages.concat(
        assertSearchSelectionType(properties.searchSelectionType)
      );
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Search Completed",
          Object.keys(properties),
          ["subscriptionId", "page", "searchSelectionType", "platform"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "XvYBfObuj",
          "83bc08be9638f41651e1d9b007a0acdfcc977ac915cbbfb5b6af2f7181e14a8b",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Search Completed",
        {
          subscription_id: properties.subscriptionId,
          Page: properties.page,
          "Search Selection Type": properties.searchSelectionType,
          Platform: properties.platform,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "XvYBfObuj",
          "Search Completed",
          messages,
          [
            { id: "4j_Pu5zIMW", name: "Page", value: properties.page },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "FqbzTAJB2",
              name: "Search Selection Type",
              value: properties.searchSelectionType,
            },
            {
              id: "TDTeQm2UP",
              name: "subscription_id",
              value: properties.subscriptionId,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Search Completed': " + messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Search Completed",
          {
            subscription_id: properties.subscriptionId,
            Page: properties.page,
            "Search Selection Type": properties.searchSelectionType,
            Platform: properties.platform,
          },
          "XvYBfObuj",
          "83bc08be9638f41651e1d9b007a0acdfcc977ac915cbbfb5b6af2f7181e14a8b"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Search Completed", {
        subscription_id: properties.subscriptionId,
        Page: properties.page,
        "Search Selection Type": properties.searchSelectionType,
        Platform: properties.platform,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Search Completed", {
        subscription_id: properties.subscriptionId,
        Page: properties.page,
        "Search Selection Type": properties.searchSelectionType,
        Platform: properties.platform,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Free Trial Selected: User clicks "Start your N-day free trial of Teams Pro" from the Create Team flow.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/ssXxNfv226/trigger/J_X79z2Dm
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.teamName - Team name for Teams service events
   * @param {string} [properties.industry] - Industry in which the team's company operates, as selected by the admin creating the team.
   * @param {string} properties.discountCouponCode - The Discount Coupon Code used at Stripe Checkout.
   * @param {string} properties.platform - Platform the user was on at the time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/ssXxNfv226}
   */
  function teamsFreeTrialSelected(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertTeamName(properties.teamName));
      messages = messages.concat(assertOptionalIndustry(properties.industry));
      messages = messages.concat(
        assertDiscountCouponCode(properties.discountCouponCode)
      );
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Free Trial Selected",
          Object.keys(properties),
          ["teamName", "industry", "discountCouponCode", "platform"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "ssXxNfv226",
          "597147f8ec3a4bf84da7aef63e038e6897c27c64ad15d05c75b231cfb80d6647",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Free Trial Selected",
        {
          "Team Name": properties.teamName,
          Industry: properties.industry,
          "Discount Coupon Code": properties.discountCouponCode,
          Platform: properties.platform,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "ssXxNfv226",
          "Teams Free Trial Selected",
          messages,
          [
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            { id: "fU92KYufq", name: "Industry", value: properties.industry },
            {
              id: "ma7AAeRIY",
              name: "Discount Coupon Code",
              value: properties.discountCouponCode,
            },
            { id: "zEyW0825ou", name: "Team Name", value: properties.teamName },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Free Trial Selected': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Free Trial Selected",
          {
            "Team Name": properties.teamName,
            Industry: properties.industry,
            "Discount Coupon Code": properties.discountCouponCode,
            Platform: properties.platform,
          },
          "ssXxNfv226",
          "597147f8ec3a4bf84da7aef63e038e6897c27c64ad15d05c75b231cfb80d6647"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Free Trial Selected", {
        "Team Name": properties.teamName,
        Industry: properties.industry,
        "Discount Coupon Code": properties.discountCouponCode,
        Platform: properties.platform,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Free Trial Selected", {
        "Team Name": properties.teamName,
        Industry: properties.industry,
        "Discount Coupon Code": properties.discountCouponCode,
        Platform: properties.platform,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Free Trial Rejected: User clicks "No thanks, I prefer to pay full price for a different plan" from the Create Team flow.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/uOyphDWQ4/trigger/uUZdBH6hhN
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.teamName - Team name for Teams service events
   * @param {string} [properties.industry] - Industry in which the team's company operates, as selected by the admin creating the team.
   * @param {string} properties.discountCouponCode - The Discount Coupon Code used at Stripe Checkout.
   * @param {string} properties.platform - Platform the user was on at the time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/uOyphDWQ4}
   */
  function teamsFreeTrialRejected(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertTeamName(properties.teamName));
      messages = messages.concat(assertOptionalIndustry(properties.industry));
      messages = messages.concat(
        assertDiscountCouponCode(properties.discountCouponCode)
      );
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Free Trial Rejected",
          Object.keys(properties),
          ["teamName", "industry", "discountCouponCode", "platform"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "uOyphDWQ4",
          "f4585d68696a8417c9bd7a3f5c4573cdb79656f68c7bb0e051191db025488370",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Free Trial Rejected",
        {
          "Team Name": properties.teamName,
          Industry: properties.industry,
          "Discount Coupon Code": properties.discountCouponCode,
          Platform: properties.platform,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "uOyphDWQ4",
          "Teams Free Trial Rejected",
          messages,
          [
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            { id: "fU92KYufq", name: "Industry", value: properties.industry },
            {
              id: "ma7AAeRIY",
              name: "Discount Coupon Code",
              value: properties.discountCouponCode,
            },
            { id: "zEyW0825ou", name: "Team Name", value: properties.teamName },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Free Trial Rejected': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Free Trial Rejected",
          {
            "Team Name": properties.teamName,
            Industry: properties.industry,
            "Discount Coupon Code": properties.discountCouponCode,
            Platform: properties.platform,
          },
          "uOyphDWQ4",
          "f4585d68696a8417c9bd7a3f5c4573cdb79656f68c7bb0e051191db025488370"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Free Trial Rejected", {
        "Team Name": properties.teamName,
        Industry: properties.industry,
        "Discount Coupon Code": properties.discountCouponCode,
        Platform: properties.platform,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Free Trial Rejected", {
        "Team Name": properties.teamName,
        Industry: properties.industry,
        "Discount Coupon Code": properties.discountCouponCode,
        Platform: properties.platform,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Upgrade Abandoned: User abandons the purchase/upgrade flow for Teams product
   *
   * When to trigger this event:
   * 1. When user goes back from the Stripe payment page
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/tBZ_mYSxq/trigger/R45JMStD1
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {int} [properties.teamsPlanId] - Plan Type ID of the Team at time of event. If a team is not on a plan, do not send property.
   * @param {string} [properties.teamsPlanName] - Name of the Team's plan at time of event. If a team is not on a plan, do not send property.
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {int} properties.teamsSeatsPurchaseCount - Number of teams seats purchased at time of event.
   * @param {int} properties.teamsPlanSelectionId - ID of teams plan selected for upgrade
   * @param {string} properties.teamsPlanSelectionName - Plan selected for upgrade.
   * @param {int} properties.teamsDriverCount - Count of drivers in Team at time of event.
   * @param {bool} properties.freeTrial - Indicates whether the event is associated with a free trial plan.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/tBZ_mYSxq}
   */
  function teamsUpgradeAbandoned(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalTeamsPlanID(properties.teamsPlanId)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanName(properties.teamsPlanName)
      );
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertTeamsSeatsPurchaseCount(properties.teamsSeatsPurchaseCount)
      );
      messages = messages.concat(
        assertTeamsPlanSelectionID(properties.teamsPlanSelectionId)
      );
      messages = messages.concat(
        assertTeamsPlanSelectionName(properties.teamsPlanSelectionName)
      );
      messages = messages.concat(
        assertTeamsDriverCount(properties.teamsDriverCount)
      );
      messages = messages.concat(assertFreeTrial(properties.freeTrial));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Upgrade Abandoned",
          Object.keys(properties),
          [
            "platform",
            "teamsPlanId",
            "teamsPlanName",
            "organizationId",
            "organizationGroupId",
            "teamsSeatsPurchaseCount",
            "teamsPlanSelectionId",
            "teamsPlanSelectionName",
            "teamsDriverCount",
            "freeTrial",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "tBZ_mYSxq",
          "d52541743057718700e443184e00efb829d39f36404557b5d003fb4006e5658c",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Upgrade Abandoned",
        {
          Platform: properties.platform,
          "Teams Plan ID": properties.teamsPlanId,
          "Teams Plan Name": properties.teamsPlanName,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          "Teams Seats Purchase Count": properties.teamsSeatsPurchaseCount,
          "Teams Plan Selection ID": properties.teamsPlanSelectionId,
          "Teams Plan Selection Name": properties.teamsPlanSelectionName,
          "Teams Driver Count": properties.teamsDriverCount,
          "Free Trial": properties.freeTrial,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "tBZ_mYSxq",
          "Teams Upgrade Abandoned",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "125AY5RLNY",
              name: "Teams Plan Name",
              value: properties.teamsPlanName,
            },
            {
              id: "6pTFwqFl49",
              name: "Teams Plan Selection ID",
              value: properties.teamsPlanSelectionId,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "T9hGL4ArX7",
              name: "Teams Plan Selection Name",
              value: properties.teamsPlanSelectionName,
            },
            {
              id: "TbSVW_o_GH",
              name: "Teams Plan ID",
              value: properties.teamsPlanId,
            },
            {
              id: "dVaX1T1uG",
              name: "Free Trial",
              value: properties.freeTrial,
            },
            {
              id: "h2UcigKyW",
              name: "Teams Driver Count",
              value: properties.teamsDriverCount,
            },
            {
              id: "o2HIGOy0wz",
              name: "Teams Seats Purchase Count",
              value: properties.teamsSeatsPurchaseCount,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Upgrade Abandoned': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Upgrade Abandoned",
          {
            Platform: properties.platform,
            "Teams Plan ID": properties.teamsPlanId,
            "Teams Plan Name": properties.teamsPlanName,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            "Teams Seats Purchase Count": properties.teamsSeatsPurchaseCount,
            "Teams Plan Selection ID": properties.teamsPlanSelectionId,
            "Teams Plan Selection Name": properties.teamsPlanSelectionName,
            "Teams Driver Count": properties.teamsDriverCount,
            "Free Trial": properties.freeTrial,
          },
          "tBZ_mYSxq",
          "d52541743057718700e443184e00efb829d39f36404557b5d003fb4006e5658c"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Upgrade Abandoned", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Seats Purchase Count": properties.teamsSeatsPurchaseCount,
        "Teams Plan Selection ID": properties.teamsPlanSelectionId,
        "Teams Plan Selection Name": properties.teamsPlanSelectionName,
        "Teams Driver Count": properties.teamsDriverCount,
        "Free Trial": properties.freeTrial,
      });

      // destination SegmentWebDashboard
      SegmentWebDashboard.logEvent("Teams Upgrade Abandoned", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Seats Purchase Count": properties.teamsSeatsPurchaseCount,
        "Teams Plan Selection ID": properties.teamsPlanSelectionId,
        "Teams Plan Selection Name": properties.teamsPlanSelectionName,
        "Teams Driver Count": properties.teamsDriverCount,
        "Free Trial": properties.freeTrial,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Upgrade Abandoned", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Seats Purchase Count": properties.teamsSeatsPurchaseCount,
        "Teams Plan Selection ID": properties.teamsPlanSelectionId,
        "Teams Plan Selection Name": properties.teamsPlanSelectionName,
        "Teams Driver Count": properties.teamsDriverCount,
        "Free Trial": properties.freeTrial,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Report Reminders Enabled: Report Reminders feature turned on
   *
   * When to trigger this event:
   * 1. Admin toggles on Report Reminders from the Teams Admin dashboard
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/EizRbVNMr5/trigger/hVLXwwPMp
   *
   * @param {object} properties - the properties associatied with this event
   * @param {bool} properties.freeTrial - Indicates whether the event is associated with a free trial plan.
   * @param {string} properties.platform - Platform the user was on at the time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/EizRbVNMr5}
   */
  function reportRemindersEnabled(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertFreeTrial(properties.freeTrial));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Report Reminders Enabled",
          Object.keys(properties),
          ["freeTrial", "platform"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "EizRbVNMr5",
          "edaace8c2296ee286c200452ad9de75ddcef2b6d36767be7b3080b0d1dd26613",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Report Reminders Enabled",
        {
          "Free Trial": properties.freeTrial,
          Platform: properties.platform,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "EizRbVNMr5",
          "Report Reminders Enabled",
          messages,
          [
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "dVaX1T1uG",
              name: "Free Trial",
              value: properties.freeTrial,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Report Reminders Enabled': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Report Reminders Enabled",
          {
            "Free Trial": properties.freeTrial,
            Platform: properties.platform,
          },
          "EizRbVNMr5",
          "edaace8c2296ee286c200452ad9de75ddcef2b6d36767be7b3080b0d1dd26613"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Report Reminders Enabled", {
        "Free Trial": properties.freeTrial,
        Platform: properties.platform,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Report Reminders Enabled", {
        "Free Trial": properties.freeTrial,
        Platform: properties.platform,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Report Reminders Schedule Updated: Admin updates the schedule for drivers' report reminders
   *
   * When to trigger this event:
   * 1. In the Teams Admin Dashboard, Admin updates the "First Reminder" date, the "Repeats" schedule, or both; then clicks "Save"
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/OIY4YvR4VA/trigger/76DBGHlqD
   *
   * @param {object} properties - the properties associatied with this event
   * @param {bool} properties.freeTrial - Indicates whether the event is associated with a free trial plan.
   * @param {string} properties.firstReportReminderDateSetting - The new "first reminder" date being set by the admin for the Teams Report Reminders feature.
   * @param {string} properties.reportReminderRepeatsScheduleSetting - The new "Repeats" schedule being set by the admin, for the Teams Report Reminders feature.
   * @param {string} properties.reportReminderRepeatsScheduleSettingType - Type of schedule being set by the admin for the Teams Report Reminder feature. Can be
"weekly", "monthly" or "custom"
   * @param {string} properties.platform - Platform the user was on at the time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/OIY4YvR4VA}
   */
  function reportRemindersScheduleUpdated(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertFreeTrial(properties.freeTrial));
      messages = messages.concat(
        assertFirstReportReminderDateSetting(
          properties.firstReportReminderDateSetting
        )
      );
      messages = messages.concat(
        assertReportReminderRepeatsScheduleSetting(
          properties.reportReminderRepeatsScheduleSetting
        )
      );
      messages = messages.concat(
        assertReportReminderRepeatsScheduleSettingType(
          properties.reportReminderRepeatsScheduleSettingType
        )
      );
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Report Reminders Schedule Updated",
          Object.keys(properties),
          [
            "freeTrial",
            "firstReportReminderDateSetting",
            "reportReminderRepeatsScheduleSetting",
            "reportReminderRepeatsScheduleSettingType",
            "platform",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "OIY4YvR4VA",
          "92565965d6db743a8919223f1483f3c9f68fb5f816a8b96f0a2be6767c37a6e1",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Report Reminders Schedule Updated",
        {
          "Free Trial": properties.freeTrial,
          "First Report Reminder Date Setting":
            properties.firstReportReminderDateSetting,
          "Report Reminder Repeats Schedule Setting":
            properties.reportReminderRepeatsScheduleSetting,
          "Report Reminder Repeats Schedule Setting Type":
            properties.reportReminderRepeatsScheduleSettingType,
          Platform: properties.platform,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "OIY4YvR4VA",
          "Report Reminders Schedule Updated",
          messages,
          [
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "GT-hcInJ8",
              name: "Report Reminder Repeats Schedule Setting",
              value: properties.reportReminderRepeatsScheduleSetting,
            },
            {
              id: "I95-6spf_",
              name: "First Report Reminder Date Setting",
              value: properties.firstReportReminderDateSetting,
            },
            {
              id: "Vx3Lv-Etq",
              name: "Report Reminder Repeats Schedule Setting Type",
              value: properties.reportReminderRepeatsScheduleSettingType,
            },
            {
              id: "dVaX1T1uG",
              name: "Free Trial",
              value: properties.freeTrial,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Report Reminders Schedule Updated': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Report Reminders Schedule Updated",
          {
            "Free Trial": properties.freeTrial,
            "First Report Reminder Date Setting":
              properties.firstReportReminderDateSetting,
            "Report Reminder Repeats Schedule Setting":
              properties.reportReminderRepeatsScheduleSetting,
            "Report Reminder Repeats Schedule Setting Type":
              properties.reportReminderRepeatsScheduleSettingType,
            Platform: properties.platform,
          },
          "OIY4YvR4VA",
          "92565965d6db743a8919223f1483f3c9f68fb5f816a8b96f0a2be6767c37a6e1"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Report Reminders Schedule Updated", {
        "Free Trial": properties.freeTrial,
        "First Report Reminder Date Setting":
          properties.firstReportReminderDateSetting,
        "Report Reminder Repeats Schedule Setting":
          properties.reportReminderRepeatsScheduleSetting,
        "Report Reminder Repeats Schedule Setting Type":
          properties.reportReminderRepeatsScheduleSettingType,
        Platform: properties.platform,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Report Reminders Schedule Updated", {
        "Free Trial": properties.freeTrial,
        "First Report Reminder Date Setting":
          properties.firstReportReminderDateSetting,
        "Report Reminder Repeats Schedule Setting":
          properties.reportReminderRepeatsScheduleSetting,
        "Report Reminder Repeats Schedule Setting Type":
          properties.reportReminderRepeatsScheduleSettingType,
        Platform: properties.platform,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Report Reminders Disabled: Report Reminders feature turned off
   *
   * When to trigger this event:
   * 1. Admin toggles off Report Reminders from the Teams Admin dashboard
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/YLNspQVgx/trigger/Y5yhfXpRRY
   *
   * @param {object} properties - the properties associatied with this event
   * @param {bool} properties.freeTrial - Indicates whether the event is associated with a free trial plan.
   * @param {string} properties.platform - Platform the user was on at the time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/YLNspQVgx}
   */
  function reportRemindersDisabled(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertFreeTrial(properties.freeTrial));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Report Reminders Disabled",
          Object.keys(properties),
          ["freeTrial", "platform"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "YLNspQVgx",
          "32b45eb3513f2184cf893893ca599ee44223986821362a6d54150806617fa1bb",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Report Reminders Disabled",
        {
          "Free Trial": properties.freeTrial,
          Platform: properties.platform,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "YLNspQVgx",
          "Report Reminders Disabled",
          messages,
          [
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "dVaX1T1uG",
              name: "Free Trial",
              value: properties.freeTrial,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Report Reminders Disabled': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Report Reminders Disabled",
          {
            "Free Trial": properties.freeTrial,
            Platform: properties.platform,
          },
          "YLNspQVgx",
          "32b45eb3513f2184cf893893ca599ee44223986821362a6d54150806617fa1bb"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Report Reminders Disabled", {
        "Free Trial": properties.freeTrial,
        Platform: properties.platform,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Report Reminders Disabled", {
        "Free Trial": properties.freeTrial,
        Platform: properties.platform,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Signup Failed: User's signup attempt fails. Signup failure point is detailed in the properties.
   *
   * When to trigger this event:
   * 1. Invalid email
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/eCLz90u4b/trigger/xiyd1Pg2Q
   * 2. Account with email already exists
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/eCLz90u4b/trigger/Nzuw7GV2p
   * 3. Invalid password
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/eCLz90u4b/trigger/HSHNhtjDB
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} properties.email - Email address captured during event
   * @param {string} properties.signupFailure - Failure reason during signup
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/eCLz90u4b}
   */
  function signupFailed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertEmail(properties.email));
      messages = messages.concat(assertSignupFailure(properties.signupFailure));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Signup Failed",
          Object.keys(properties),
          ["platform", "email", "signupFailure"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "eCLz90u4b",
          "334b71fabd4c9f98677428a2e1ff25a3449a26fd36792b088045d788b4f08298",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Signup Failed",
        {
          Platform: properties.platform,
          Email: properties.email,
          "Signup Failure": properties.signupFailure,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "eCLz90u4b",
          "Signup Failed",
          messages,
          [
            {
              id: "FQMnEG9KE",
              name: "Signup Failure",
              value: properties.signupFailure,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            { id: "KwJDoiNGCh", name: "Email", value: properties.email },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Signup Failed': " + messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Signup Failed",
          {
            Platform: properties.platform,
            Email: properties.email,
            "Signup Failure": properties.signupFailure,
          },
          "eCLz90u4b",
          "334b71fabd4c9f98677428a2e1ff25a3449a26fd36792b088045d788b4f08298"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Signup Failed", {
        Platform: properties.platform,
        Email: properties.email,
        "Signup Failure": properties.signupFailure,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Signup Failed", {
        Platform: properties.platform,
        Email: properties.email,
        "Signup Failure": properties.signupFailure,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Automatic Report Submission Enabled: Team Member enables the Automatic Report Submission feature
   *
   * When to trigger this event:
   * 1. Team member toggles on Automatic Report Submission from the Drivers Dashboard - Settings page
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/4LTQHXcSUl/trigger/VOubFm__Q
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.automaticReportsRecurrence] - The recurrence schedule set by team member for automatic reports.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/4LTQHXcSUl}
   */
  function automaticReportSubmissionEnabled(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalAutomaticReportsRecurrence(
          properties.automaticReportsRecurrence
        )
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Automatic Report Submission Enabled",
          Object.keys(properties),
          ["platform", "automaticReportsRecurrence"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "4LTQHXcSUl",
          "e1e6c5bb8c6746162f42cb5ac00fe3ad506532c9d7d25cc8de83b582cc649434",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Automatic Report Submission Enabled",
        {
          Platform: properties.platform,
          "Automatic Reports Recurrence": properties.automaticReportsRecurrence,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "4LTQHXcSUl",
          "Automatic Report Submission Enabled",
          messages,
          [
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "Zr7LvUpVN",
              name: "Automatic Reports Recurrence",
              value: properties.automaticReportsRecurrence,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Automatic Report Submission Enabled': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Automatic Report Submission Enabled",
          {
            Platform: properties.platform,
            "Automatic Reports Recurrence":
              properties.automaticReportsRecurrence,
          },
          "4LTQHXcSUl",
          "e1e6c5bb8c6746162f42cb5ac00fe3ad506532c9d7d25cc8de83b582cc649434"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Automatic Report Submission Enabled", {
        Platform: properties.platform,
        "Automatic Reports Recurrence": properties.automaticReportsRecurrence,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Automatic Report Submission Enabled", {
        Platform: properties.platform,
        "Automatic Reports Recurrence": properties.automaticReportsRecurrence,
      });

      // destination Braze
      Braze.logEvent("Automatic Report Submission Enabled", {
        Platform: properties.platform,
        "Automatic Reports Recurrence": properties.automaticReportsRecurrence,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Automatic Report Submission Disabled: Team Member disables the Automatic Report Submission feature
   *
   * When to trigger this event:
   * 1. Team member toggles off Automatic Report Submission from the Drivers Dashboard - Settings page
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/inZTh0rca/trigger/Kwnp_GEL_
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/inZTh0rca}
   */
  function automaticReportSubmissionDisabled(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Automatic Report Submission Disabled",
          Object.keys(properties),
          ["platform"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "inZTh0rca",
          "5d67d86e37d305ebf9337210b86cfb84e55dcd461972e934160c213ebb0abfe9",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Automatic Report Submission Disabled",
        {
          Platform: properties.platform,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "inZTh0rca",
          "Automatic Report Submission Disabled",
          messages,
          [{ id: "FfkzdkMHsZ", name: "Platform", value: properties.platform }],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Automatic Report Submission Disabled': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Automatic Report Submission Disabled",
          {
            Platform: properties.platform,
          },
          "inZTh0rca",
          "5d67d86e37d305ebf9337210b86cfb84e55dcd461972e934160c213ebb0abfe9"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Automatic Report Submission Disabled", {
        Platform: properties.platform,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Automatic Report Submission Disabled", {
        Platform: properties.platform,
      });

      // destination Braze
      Braze.logEvent("Automatic Report Submission Disabled", {
        Platform: properties.platform,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Subscription Cancel Started: User starts the flow to cancel their subscription
   *
   * When to trigger this event:
   * 1. User starts the cancel flow
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/wJontZgG_C/trigger/gqA-KjUeW
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} properties.subscriptionType - Subscription interval type
   * @param {string} properties.paymentService - payment service options
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/wJontZgG_C}
   */
  function subscriptionCancelStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertSubscriptionType(properties.subscriptionType)
      );
      messages = messages.concat(
        assertPaymentService(properties.paymentService)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Subscription Cancel Started",
          Object.keys(properties),
          ["platform", "subscriptionType", "paymentService"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "wJontZgG_C",
          "34dcf0a0a751d5bca20f470844b60486e5b80333e4bef3625e766d2b775ee495",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Subscription Cancel Started",
        {
          Platform: properties.platform,
          subscription_type: properties.subscriptionType,
          payment_service: properties.paymentService,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "wJontZgG_C",
          "Subscription Cancel Started",
          messages,
          [
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "PFrUGiD-O",
              name: "payment_service",
              value: properties.paymentService,
            },
            {
              id: "rN6HAJ5vu",
              name: "subscription_type",
              value: properties.subscriptionType,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Subscription Cancel Started': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Subscription Cancel Started",
          {
            Platform: properties.platform,
            subscription_type: properties.subscriptionType,
            payment_service: properties.paymentService,
          },
          "wJontZgG_C",
          "34dcf0a0a751d5bca20f470844b60486e5b80333e4bef3625e766d2b775ee495"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Subscription Cancel Started", {
        Platform: properties.platform,
        subscription_type: properties.subscriptionType,
        payment_service: properties.paymentService,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Subscription Cancel Started", {
        Platform: properties.platform,
        subscription_type: properties.subscriptionType,
        payment_service: properties.paymentService,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Subscription Cancel Reason Selected: User selects a cancellation reason
   *
   * When to trigger this event:
   * 1. User selects cancellation reason
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/vsmDutG4Y/trigger/_m76Rs4dPa
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} properties.subscriptionType - Subscription interval type
   * @param {string} properties.paymentService - payment service options
   * @param {string} properties.subscriptionCancelReason - Reason selected to cancel subscription
   * @param {string} [properties.subscriptionCancelReasonFeedback] - Details in the 'other' free text
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/vsmDutG4Y}
   */
  function subscriptionCancelReasonSelected(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertSubscriptionType(properties.subscriptionType)
      );
      messages = messages.concat(
        assertPaymentService(properties.paymentService)
      );
      messages = messages.concat(
        assertSubscriptionCancelReason(properties.subscriptionCancelReason)
      );
      messages = messages.concat(
        assertOptionalSubscriptionCancelReasonFeedback(
          properties.subscriptionCancelReasonFeedback
        )
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Subscription Cancel Reason Selected",
          Object.keys(properties),
          [
            "platform",
            "subscriptionType",
            "paymentService",
            "subscriptionCancelReason",
            "subscriptionCancelReasonFeedback",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "vsmDutG4Y",
          "e105cd2f773c7b19694fc4ba8152847757a2317c7631f0e56e3cc06dcb95441c",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Subscription Cancel Reason Selected",
        {
          Platform: properties.platform,
          subscription_type: properties.subscriptionType,
          payment_service: properties.paymentService,
          "Subscription Cancel Reason": properties.subscriptionCancelReason,
          "Subscription Cancel Reason Feedback":
            properties.subscriptionCancelReasonFeedback,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "vsmDutG4Y",
          "Subscription Cancel Reason Selected",
          messages,
          [
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "Nt3_iEQ7e",
              name: "Subscription Cancel Reason Feedback",
              value: properties.subscriptionCancelReasonFeedback,
            },
            {
              id: "PFrUGiD-O",
              name: "payment_service",
              value: properties.paymentService,
            },
            {
              id: "rN6HAJ5vu",
              name: "subscription_type",
              value: properties.subscriptionType,
            },
            {
              id: "vluEV5X6S",
              name: "Subscription Cancel Reason",
              value: properties.subscriptionCancelReason,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Subscription Cancel Reason Selected': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Subscription Cancel Reason Selected",
          {
            Platform: properties.platform,
            subscription_type: properties.subscriptionType,
            payment_service: properties.paymentService,
            "Subscription Cancel Reason": properties.subscriptionCancelReason,
            "Subscription Cancel Reason Feedback":
              properties.subscriptionCancelReasonFeedback,
          },
          "vsmDutG4Y",
          "e105cd2f773c7b19694fc4ba8152847757a2317c7631f0e56e3cc06dcb95441c"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Subscription Cancel Reason Selected", {
        Platform: properties.platform,
        subscription_type: properties.subscriptionType,
        payment_service: properties.paymentService,
        "Subscription Cancel Reason": properties.subscriptionCancelReason,
        "Subscription Cancel Reason Feedback":
          properties.subscriptionCancelReasonFeedback,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Subscription Cancel Reason Selected", {
        Platform: properties.platform,
        subscription_type: properties.subscriptionType,
        payment_service: properties.paymentService,
        "Subscription Cancel Reason": properties.subscriptionCancelReason,
        "Subscription Cancel Reason Feedback":
          properties.subscriptionCancelReasonFeedback,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Subscription Cancel Completed: User completes the cancellation process
   *
   * When to trigger this event:
   * 1. User completes the subscription cancellation flow
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/Oe5OUkNnh/trigger/PNZOmOnATv
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} properties.subscriptionType - Subscription interval type
   * @param {string} properties.paymentService - payment service options
   * @param {string} properties.subscriptionCancelReason - Reason selected to cancel subscription
   * @param {string} [properties.subscriptionCancelReasonFeedback] - Details in the 'other' free text
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/Oe5OUkNnh}
   */
  function subscriptionCancelCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertSubscriptionType(properties.subscriptionType)
      );
      messages = messages.concat(
        assertPaymentService(properties.paymentService)
      );
      messages = messages.concat(
        assertSubscriptionCancelReason(properties.subscriptionCancelReason)
      );
      messages = messages.concat(
        assertOptionalSubscriptionCancelReasonFeedback(
          properties.subscriptionCancelReasonFeedback
        )
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Subscription Cancel Completed",
          Object.keys(properties),
          [
            "platform",
            "subscriptionType",
            "paymentService",
            "subscriptionCancelReason",
            "subscriptionCancelReasonFeedback",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "Oe5OUkNnh",
          "776340fd60ba020faf2079434c5dc7fb0c35093af26b51acda571504e605285e",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Subscription Cancel Completed",
        {
          Platform: properties.platform,
          subscription_type: properties.subscriptionType,
          payment_service: properties.paymentService,
          "Subscription Cancel Reason": properties.subscriptionCancelReason,
          "Subscription Cancel Reason Feedback":
            properties.subscriptionCancelReasonFeedback,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "Oe5OUkNnh",
          "Subscription Cancel Completed",
          messages,
          [
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "Nt3_iEQ7e",
              name: "Subscription Cancel Reason Feedback",
              value: properties.subscriptionCancelReasonFeedback,
            },
            {
              id: "PFrUGiD-O",
              name: "payment_service",
              value: properties.paymentService,
            },
            {
              id: "rN6HAJ5vu",
              name: "subscription_type",
              value: properties.subscriptionType,
            },
            {
              id: "vluEV5X6S",
              name: "Subscription Cancel Reason",
              value: properties.subscriptionCancelReason,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Subscription Cancel Completed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Subscription Cancel Completed",
          {
            Platform: properties.platform,
            subscription_type: properties.subscriptionType,
            payment_service: properties.paymentService,
            "Subscription Cancel Reason": properties.subscriptionCancelReason,
            "Subscription Cancel Reason Feedback":
              properties.subscriptionCancelReasonFeedback,
          },
          "Oe5OUkNnh",
          "776340fd60ba020faf2079434c5dc7fb0c35093af26b51acda571504e605285e"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Subscription Cancel Completed", {
        Platform: properties.platform,
        subscription_type: properties.subscriptionType,
        payment_service: properties.paymentService,
        "Subscription Cancel Reason": properties.subscriptionCancelReason,
        "Subscription Cancel Reason Feedback":
          properties.subscriptionCancelReasonFeedback,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Subscription Cancel Completed", {
        Platform: properties.platform,
        subscription_type: properties.subscriptionType,
        payment_service: properties.paymentService,
        "Subscription Cancel Reason": properties.subscriptionCancelReason,
        "Subscription Cancel Reason Feedback":
          properties.subscriptionCancelReasonFeedback,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Downgrade Started: Admin starts the process to downgrade Team's plan.
   *
   * When to trigger this event:
   * 1. Admin land on the Downgrade Subscription step of the Teams Subscription Cancellation flow
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/KvuNG_MM05/trigger/VpXAeYbuu
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} properties.teamsDowngradeSource - Source of the CTA to start the downgrade flow.

   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {int} [properties.teamsPlanId] - Plan Type ID of the Team at time of event. If a team is not on a plan, do not send property.
   * @param {string} [properties.teamsPlanName] - Name of the Team's plan at time of event. If a team is not on a plan, do not send property.
   * @param {int} [properties.teamsDriverCount] - Count of drivers in Team at time of event.
   * @param {bool} properties.freeTrial - Indicates whether the event is associated with a free trial plan.
   * @param {bool} properties.eligibleToDiscounts - Indicates whether the team is eligible to be offered discounts.

   * @param {string} [properties.teamsPlanInterval] - Describes the Teams plan interval at the time of the event.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/KvuNG_MM05}
   */
  function teamsDowngradeStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertTeamsDowngradeSource(properties.teamsDowngradeSource)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanID(properties.teamsPlanId)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanName(properties.teamsPlanName)
      );
      messages = messages.concat(
        assertOptionalTeamsDriverCount(properties.teamsDriverCount)
      );
      messages = messages.concat(assertFreeTrial(properties.freeTrial));
      messages = messages.concat(
        assertEligibleToDiscounts(properties.eligibleToDiscounts)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanInterval(properties.teamsPlanInterval)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Downgrade Started",
          Object.keys(properties),
          [
            "platform",
            "teamsDowngradeSource",
            "organizationGroupId",
            "organizationId",
            "teamsPlanId",
            "teamsPlanName",
            "teamsDriverCount",
            "freeTrial",
            "eligibleToDiscounts",
            "teamsPlanInterval",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "KvuNG_MM05",
          "21fd54d80cfc3d67ada378530a5a568dfc46d61ba9de4402586fcdf5c00a1ebe",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Downgrade Started",
        {
          Platform: properties.platform,
          "Teams Downgrade Source": properties.teamsDowngradeSource,
          "Organization Group ID": properties.organizationGroupId,
          "Organization ID": properties.organizationId,
          "Teams Plan ID": properties.teamsPlanId,
          "Teams Plan Name": properties.teamsPlanName,
          "Teams Driver Count": properties.teamsDriverCount,
          "Free Trial": properties.freeTrial,
          "Eligible to Discounts": properties.eligibleToDiscounts,
          "Teams Plan Interval": properties.teamsPlanInterval,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "KvuNG_MM05",
          "Teams Downgrade Started",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "125AY5RLNY",
              name: "Teams Plan Name",
              value: properties.teamsPlanName,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            {
              id: "EL_wSUVYa",
              name: "Teams Downgrade Source",
              value: properties.teamsDowngradeSource,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "IaqLx6O9U",
              name: "Eligible to Discounts",
              value: properties.eligibleToDiscounts,
            },
            {
              id: "TbSVW_o_GH",
              name: "Teams Plan ID",
              value: properties.teamsPlanId,
            },
            {
              id: "XcK728z2q",
              name: "Teams Plan Interval",
              value: properties.teamsPlanInterval,
            },
            {
              id: "dVaX1T1uG",
              name: "Free Trial",
              value: properties.freeTrial,
            },
            {
              id: "h2UcigKyW",
              name: "Teams Driver Count",
              value: properties.teamsDriverCount,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Downgrade Started': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Downgrade Started",
          {
            Platform: properties.platform,
            "Teams Downgrade Source": properties.teamsDowngradeSource,
            "Organization Group ID": properties.organizationGroupId,
            "Organization ID": properties.organizationId,
            "Teams Plan ID": properties.teamsPlanId,
            "Teams Plan Name": properties.teamsPlanName,
            "Teams Driver Count": properties.teamsDriverCount,
            "Free Trial": properties.freeTrial,
            "Eligible to Discounts": properties.eligibleToDiscounts,
            "Teams Plan Interval": properties.teamsPlanInterval,
          },
          "KvuNG_MM05",
          "21fd54d80cfc3d67ada378530a5a568dfc46d61ba9de4402586fcdf5c00a1ebe"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Downgrade Started", {
        Platform: properties.platform,
        "Teams Downgrade Source": properties.teamsDowngradeSource,
        "Organization Group ID": properties.organizationGroupId,
        "Organization ID": properties.organizationId,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Driver Count": properties.teamsDriverCount,
        "Free Trial": properties.freeTrial,
        "Eligible to Discounts": properties.eligibleToDiscounts,
        "Teams Plan Interval": properties.teamsPlanInterval,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Downgrade Started", {
        Platform: properties.platform,
        "Teams Downgrade Source": properties.teamsDowngradeSource,
        "Organization Group ID": properties.organizationGroupId,
        "Organization ID": properties.organizationId,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Driver Count": properties.teamsDriverCount,
        "Free Trial": properties.freeTrial,
        "Eligible to Discounts": properties.eligibleToDiscounts,
        "Teams Plan Interval": properties.teamsPlanInterval,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Downgrade Completed: Admin completes the downgrade flow for Teams product
   *
   * When to trigger this event:
   * 1. Admin successfully downgrades their subscription after clicking on "Switch Plans"
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/C5ovVgwHgG/trigger/BVEL98vK9
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {int} [properties.teamsPlanId] - Plan Type ID of the Team at time of event. If a team is not on a plan, do not send property.
   * @param {string} [properties.teamsPlanName] - Name of the Team's plan at time of event. If a team is not on a plan, do not send property.
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {int} properties.teamsPlanSelectionId - ID of teams plan selected for upgrade
   * @param {string} properties.teamsPlanSelectionName - Plan selected for upgrade.
   * @param {int} [properties.teamsDriverCount] - Count of drivers in Team at time of event.
   * @param {bool} properties.freeTrial - Indicates whether the event is associated with a free trial plan.
   * @param {bool} properties.eligibleToDiscounts - Indicates whether the team is eligible to be offered discounts.

   * @param {string} [properties.teamsPlanInterval] - Describes the Teams plan interval at the time of the event.
   * @param {string} properties.teamsPlanSelectionInterval - Interval selected for upgrade/downgrade.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/C5ovVgwHgG}
   */
  function teamsDowngradeCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalTeamsPlanID(properties.teamsPlanId)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanName(properties.teamsPlanName)
      );
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertTeamsPlanSelectionID(properties.teamsPlanSelectionId)
      );
      messages = messages.concat(
        assertTeamsPlanSelectionName(properties.teamsPlanSelectionName)
      );
      messages = messages.concat(
        assertOptionalTeamsDriverCount(properties.teamsDriverCount)
      );
      messages = messages.concat(assertFreeTrial(properties.freeTrial));
      messages = messages.concat(
        assertEligibleToDiscounts(properties.eligibleToDiscounts)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanInterval(properties.teamsPlanInterval)
      );
      messages = messages.concat(
        assertTeamsPlanSelectionInterval(properties.teamsPlanSelectionInterval)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Downgrade Completed",
          Object.keys(properties),
          [
            "platform",
            "teamsPlanId",
            "teamsPlanName",
            "organizationId",
            "organizationGroupId",
            "teamsPlanSelectionId",
            "teamsPlanSelectionName",
            "teamsDriverCount",
            "freeTrial",
            "eligibleToDiscounts",
            "teamsPlanInterval",
            "teamsPlanSelectionInterval",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "C5ovVgwHgG",
          "484b57549283b014e5ac2d1e7647d5b65c1813f19f90d6ddbb879c953e63984c",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Downgrade Completed",
        {
          Platform: properties.platform,
          "Teams Plan ID": properties.teamsPlanId,
          "Teams Plan Name": properties.teamsPlanName,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          "Teams Plan Selection ID": properties.teamsPlanSelectionId,
          "Teams Plan Selection Name": properties.teamsPlanSelectionName,
          "Teams Driver Count": properties.teamsDriverCount,
          "Free Trial": properties.freeTrial,
          "Eligible to Discounts": properties.eligibleToDiscounts,
          "Teams Plan Interval": properties.teamsPlanInterval,
          "Teams Plan Selection Interval":
            properties.teamsPlanSelectionInterval,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "C5ovVgwHgG",
          "Teams Downgrade Completed",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "125AY5RLNY",
              name: "Teams Plan Name",
              value: properties.teamsPlanName,
            },
            {
              id: "6pTFwqFl49",
              name: "Teams Plan Selection ID",
              value: properties.teamsPlanSelectionId,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "IaqLx6O9U",
              name: "Eligible to Discounts",
              value: properties.eligibleToDiscounts,
            },
            {
              id: "T9hGL4ArX7",
              name: "Teams Plan Selection Name",
              value: properties.teamsPlanSelectionName,
            },
            {
              id: "TbSVW_o_GH",
              name: "Teams Plan ID",
              value: properties.teamsPlanId,
            },
            {
              id: "XcK728z2q",
              name: "Teams Plan Interval",
              value: properties.teamsPlanInterval,
            },
            {
              id: "ZcBOdB-fW",
              name: "Teams Plan Selection Interval",
              value: properties.teamsPlanSelectionInterval,
            },
            {
              id: "dVaX1T1uG",
              name: "Free Trial",
              value: properties.freeTrial,
            },
            {
              id: "h2UcigKyW",
              name: "Teams Driver Count",
              value: properties.teamsDriverCount,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Downgrade Completed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Downgrade Completed",
          {
            Platform: properties.platform,
            "Teams Plan ID": properties.teamsPlanId,
            "Teams Plan Name": properties.teamsPlanName,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            "Teams Plan Selection ID": properties.teamsPlanSelectionId,
            "Teams Plan Selection Name": properties.teamsPlanSelectionName,
            "Teams Driver Count": properties.teamsDriverCount,
            "Free Trial": properties.freeTrial,
            "Eligible to Discounts": properties.eligibleToDiscounts,
            "Teams Plan Interval": properties.teamsPlanInterval,
            "Teams Plan Selection Interval":
              properties.teamsPlanSelectionInterval,
          },
          "C5ovVgwHgG",
          "484b57549283b014e5ac2d1e7647d5b65c1813f19f90d6ddbb879c953e63984c"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Downgrade Completed", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan Selection ID": properties.teamsPlanSelectionId,
        "Teams Plan Selection Name": properties.teamsPlanSelectionName,
        "Teams Driver Count": properties.teamsDriverCount,
        "Free Trial": properties.freeTrial,
        "Eligible to Discounts": properties.eligibleToDiscounts,
        "Teams Plan Interval": properties.teamsPlanInterval,
        "Teams Plan Selection Interval": properties.teamsPlanSelectionInterval,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Downgrade Completed", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan Selection ID": properties.teamsPlanSelectionId,
        "Teams Plan Selection Name": properties.teamsPlanSelectionName,
        "Teams Driver Count": properties.teamsDriverCount,
        "Free Trial": properties.freeTrial,
        "Eligible to Discounts": properties.eligibleToDiscounts,
        "Teams Plan Interval": properties.teamsPlanInterval,
        "Teams Plan Selection Interval": properties.teamsPlanSelectionInterval,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Discount Claimed: Admin claims a discount offer at the end of the Teams subscription cancellation flow.
   *
   * When to trigger this event:
   * 1. Admin successfully claims a discount offer after clicking on "Claim offer"
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/5801UBMGn63/trigger/YCku8QLaR
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {int} [properties.teamsPlanId] - Plan Type ID of the Team at time of event. If a team is not on a plan, do not send property.
   * @param {string} [properties.teamsPlanName] - Name of the Team's plan at time of event. If a team is not on a plan, do not send property.
   * @param {string} [properties.teamsPlanInterval] - Describes the Teams plan interval at the time of the event.
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {int} [properties.teamsDriverCount] - Count of drivers in Team at time of event.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/5801UBMGn63}
   */
  function teamsDiscountClaimed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalTeamsPlanID(properties.teamsPlanId)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanName(properties.teamsPlanName)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanInterval(properties.teamsPlanInterval)
      );
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalTeamsDriverCount(properties.teamsDriverCount)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Discount Claimed",
          Object.keys(properties),
          [
            "platform",
            "teamsPlanId",
            "teamsPlanName",
            "teamsPlanInterval",
            "organizationId",
            "organizationGroupId",
            "teamsDriverCount",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "5801UBMGn63",
          "8993ce22f650e39459afa122c0f95935f642393f05b7820f7eb89177e441bec2",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Discount Claimed",
        {
          Platform: properties.platform,
          "Teams Plan ID": properties.teamsPlanId,
          "Teams Plan Name": properties.teamsPlanName,
          "Teams Plan Interval": properties.teamsPlanInterval,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          "Teams Driver Count": properties.teamsDriverCount,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "5801UBMGn63",
          "Teams Discount Claimed",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "125AY5RLNY",
              name: "Teams Plan Name",
              value: properties.teamsPlanName,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "TbSVW_o_GH",
              name: "Teams Plan ID",
              value: properties.teamsPlanId,
            },
            {
              id: "XcK728z2q",
              name: "Teams Plan Interval",
              value: properties.teamsPlanInterval,
            },
            {
              id: "h2UcigKyW",
              name: "Teams Driver Count",
              value: properties.teamsDriverCount,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Discount Claimed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Discount Claimed",
          {
            Platform: properties.platform,
            "Teams Plan ID": properties.teamsPlanId,
            "Teams Plan Name": properties.teamsPlanName,
            "Teams Plan Interval": properties.teamsPlanInterval,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            "Teams Driver Count": properties.teamsDriverCount,
          },
          "5801UBMGn63",
          "8993ce22f650e39459afa122c0f95935f642393f05b7820f7eb89177e441bec2"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Discount Claimed", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan Interval": properties.teamsPlanInterval,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Driver Count": properties.teamsDriverCount,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Discount Claimed", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan Interval": properties.teamsPlanInterval,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Driver Count": properties.teamsDriverCount,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams All Time Stats Viewed: Admin has viewed the all-time stats screen of the Teams subscription cancellation flow.
   *
   * When to trigger this event:
   * 1. Admin lands on the All Time Stats step of the Teams Subscription Cancellation flow
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/Uht4eOEBY-/trigger/oxRBQ45Es
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {int} [properties.teamsPlanId] - Plan Type ID of the Team at time of event. If a team is not on a plan, do not send property.
   * @param {string} [properties.teamsPlanName] - Name of the Team's plan at time of event. If a team is not on a plan, do not send property.
   * @param {string} [properties.teamsPlanInterval] - Describes the Teams plan interval at the time of the event.
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {int} [properties.teamsDriverCount] - Count of drivers in Team at time of event.
   * @param {bool} properties.eligibleToDiscounts - Indicates whether the team is eligible to be offered discounts.

   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/Uht4eOEBY-}
   */
  function teamsAllTimeStatsViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalTeamsPlanID(properties.teamsPlanId)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanName(properties.teamsPlanName)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanInterval(properties.teamsPlanInterval)
      );
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalTeamsDriverCount(properties.teamsDriverCount)
      );
      messages = messages.concat(
        assertEligibleToDiscounts(properties.eligibleToDiscounts)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams All Time Stats Viewed",
          Object.keys(properties),
          [
            "platform",
            "teamsPlanId",
            "teamsPlanName",
            "teamsPlanInterval",
            "organizationId",
            "organizationGroupId",
            "teamsDriverCount",
            "eligibleToDiscounts",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "Uht4eOEBY-",
          "26645b388b9b277294cdcfbc8b9fbb9ddf4b190ce066d7949488ca62c99319be",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams All Time Stats Viewed",
        {
          Platform: properties.platform,
          "Teams Plan ID": properties.teamsPlanId,
          "Teams Plan Name": properties.teamsPlanName,
          "Teams Plan Interval": properties.teamsPlanInterval,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          "Teams Driver Count": properties.teamsDriverCount,
          "Eligible to Discounts": properties.eligibleToDiscounts,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "Uht4eOEBY-",
          "Teams All Time Stats Viewed",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "125AY5RLNY",
              name: "Teams Plan Name",
              value: properties.teamsPlanName,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "IaqLx6O9U",
              name: "Eligible to Discounts",
              value: properties.eligibleToDiscounts,
            },
            {
              id: "TbSVW_o_GH",
              name: "Teams Plan ID",
              value: properties.teamsPlanId,
            },
            {
              id: "XcK728z2q",
              name: "Teams Plan Interval",
              value: properties.teamsPlanInterval,
            },
            {
              id: "h2UcigKyW",
              name: "Teams Driver Count",
              value: properties.teamsDriverCount,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams All Time Stats Viewed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams All Time Stats Viewed",
          {
            Platform: properties.platform,
            "Teams Plan ID": properties.teamsPlanId,
            "Teams Plan Name": properties.teamsPlanName,
            "Teams Plan Interval": properties.teamsPlanInterval,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            "Teams Driver Count": properties.teamsDriverCount,
            "Eligible to Discounts": properties.eligibleToDiscounts,
          },
          "Uht4eOEBY-",
          "26645b388b9b277294cdcfbc8b9fbb9ddf4b190ce066d7949488ca62c99319be"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams All Time Stats Viewed", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan Interval": properties.teamsPlanInterval,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Driver Count": properties.teamsDriverCount,
        "Eligible to Discounts": properties.eligibleToDiscounts,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams All Time Stats Viewed", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan Interval": properties.teamsPlanInterval,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Driver Count": properties.teamsDriverCount,
        "Eligible to Discounts": properties.eligibleToDiscounts,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Subscription Cancellation Abandoned: Admin abandons the teams subscription cancellation flow.
   *
   * When to trigger this event:
   * 1. Admin clicks on the X button to close the modal or press the "Esc" key on their keyboard.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/oGR6Zcs_IV/trigger/omyjrx4ke
   * 2. Admin clicks on "Keep my plan" CTA on Cancellation Reason step
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/oGR6Zcs_IV/trigger/-AR49yMwi
   * 3. Admin clicks on "Keep my plan" CTA on Team All Time Stats step
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/oGR6Zcs_IV/trigger/ZM7TKWvtB
   *
   * @param {object} properties - the properties associatied with this event
   * @param {int} properties.teamId - Team unique identifier
   * @param {int} properties.teamsDriverCount - Count of drivers in Team at time of event.
   * @param {int} [properties.teamsPlanId] - Plan Type ID of the Team at time of event. If a team is not on a plan, do not send property.
   * @param {string} properties.teamsPlanInterval - Describes the Teams plan interval at the time of the event.
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {bool} properties.freeTrial - Indicates whether the event is associated with a free trial plan.
   * @param {bool} properties.eligibleToDiscounts - Indicates whether the team is eligible to be offered discounts.

   * @param {string} properties.teamsSubscriptionCancellationStep - Indicate the step of the Teams subscription cancellation flow.
   * @param {string} properties.cancellationAbandonedMethod - Method that admin used to abandon the Teams Subscription Cancellation flow.
   * @param {string} [properties.teamsPlanName] - Name of the Team's plan at time of event. If a team is not on a plan, do not send property.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/oGR6Zcs_IV}
   */
  function teamsSubscriptionCancellationAbandoned(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertTeamId(properties.teamId));
      messages = messages.concat(
        assertTeamsDriverCount(properties.teamsDriverCount)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanID(properties.teamsPlanId)
      );
      messages = messages.concat(
        assertTeamsPlanInterval(properties.teamsPlanInterval)
      );
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertFreeTrial(properties.freeTrial));
      messages = messages.concat(
        assertEligibleToDiscounts(properties.eligibleToDiscounts)
      );
      messages = messages.concat(
        assertTeamsSubscriptionCancellationStep(
          properties.teamsSubscriptionCancellationStep
        )
      );
      messages = messages.concat(
        assertCancellationAbandonedMethod(
          properties.cancellationAbandonedMethod
        )
      );
      messages = messages.concat(
        assertOptionalTeamsPlanName(properties.teamsPlanName)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Subscription Cancellation Abandoned",
          Object.keys(properties),
          [
            "teamId",
            "teamsDriverCount",
            "teamsPlanId",
            "teamsPlanInterval",
            "platform",
            "freeTrial",
            "eligibleToDiscounts",
            "teamsSubscriptionCancellationStep",
            "cancellationAbandonedMethod",
            "teamsPlanName",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "oGR6Zcs_IV",
          "3510fc90acb4f9b568a86c9a55ee78ca1a450b7d4372234335b8f19bfdb0c06d",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Subscription Cancellation Abandoned",
        {
          team_id: properties.teamId,
          "Teams Driver Count": properties.teamsDriverCount,
          "Teams Plan ID": properties.teamsPlanId,
          "Teams Plan Interval": properties.teamsPlanInterval,
          Platform: properties.platform,
          "Free Trial": properties.freeTrial,
          "Eligible to Discounts": properties.eligibleToDiscounts,
          "Teams Subscription Cancellation Step":
            properties.teamsSubscriptionCancellationStep,
          "Cancellation Abandoned Method":
            properties.cancellationAbandonedMethod,
          "Teams Plan Name": properties.teamsPlanName,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "oGR6Zcs_IV",
          "Teams Subscription Cancellation Abandoned",
          messages,
          [
            {
              id: "125AY5RLNY",
              name: "Teams Plan Name",
              value: properties.teamsPlanName,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "IaqLx6O9U",
              name: "Eligible to Discounts",
              value: properties.eligibleToDiscounts,
            },
            {
              id: "O3VMtWs8j",
              name: "Cancellation Abandoned Method",
              value: properties.cancellationAbandonedMethod,
            },
            {
              id: "TbSVW_o_GH",
              name: "Teams Plan ID",
              value: properties.teamsPlanId,
            },
            {
              id: "XcK728z2q",
              name: "Teams Plan Interval",
              value: properties.teamsPlanInterval,
            },
            {
              id: "dVaX1T1uG",
              name: "Free Trial",
              value: properties.freeTrial,
            },
            {
              id: "h2UcigKyW",
              name: "Teams Driver Count",
              value: properties.teamsDriverCount,
            },
            { id: "oeDBOcvZ5e", name: "team_id", value: properties.teamId },
            {
              id: "ps4aByRzM",
              name: "Teams Subscription Cancellation Step",
              value: properties.teamsSubscriptionCancellationStep,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Subscription Cancellation Abandoned': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Subscription Cancellation Abandoned",
          {
            team_id: properties.teamId,
            "Teams Driver Count": properties.teamsDriverCount,
            "Teams Plan ID": properties.teamsPlanId,
            "Teams Plan Interval": properties.teamsPlanInterval,
            Platform: properties.platform,
            "Free Trial": properties.freeTrial,
            "Eligible to Discounts": properties.eligibleToDiscounts,
            "Teams Subscription Cancellation Step":
              properties.teamsSubscriptionCancellationStep,
            "Cancellation Abandoned Method":
              properties.cancellationAbandonedMethod,
            "Teams Plan Name": properties.teamsPlanName,
          },
          "oGR6Zcs_IV",
          "3510fc90acb4f9b568a86c9a55ee78ca1a450b7d4372234335b8f19bfdb0c06d"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent(
        "Teams Subscription Cancellation Abandoned",
        {
          team_id: properties.teamId,
          "Teams Driver Count": properties.teamsDriverCount,
          "Teams Plan ID": properties.teamsPlanId,
          "Teams Plan Interval": properties.teamsPlanInterval,
          Platform: properties.platform,
          "Free Trial": properties.freeTrial,
          "Eligible to Discounts": properties.eligibleToDiscounts,
          "Teams Subscription Cancellation Step":
            properties.teamsSubscriptionCancellationStep,
          "Cancellation Abandoned Method":
            properties.cancellationAbandonedMethod,
          "Teams Plan Name": properties.teamsPlanName,
        }
      );

      // destination Mixpanel
      Mixpanel.logEvent("Teams Subscription Cancellation Abandoned", {
        team_id: properties.teamId,
        "Teams Driver Count": properties.teamsDriverCount,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Interval": properties.teamsPlanInterval,
        Platform: properties.platform,
        "Free Trial": properties.freeTrial,
        "Eligible to Discounts": properties.eligibleToDiscounts,
        "Teams Subscription Cancellation Step":
          properties.teamsSubscriptionCancellationStep,
        "Cancellation Abandoned Method": properties.cancellationAbandonedMethod,
        "Teams Plan Name": properties.teamsPlanName,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Web Page Viewed: User navigates to a web screen
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} properties.webPage - The page or screen on the web where the event sourced from
   * @param {string} [properties.previousWebPage] - The page or screen on the web where the user was before landing on the page that the event sources from
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/vtReMrP-AX}
   */
  function webPageViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertWebPage(properties.webPage));
      messages = messages.concat(
        assertOptionalPreviousWebPage(properties.previousWebPage)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Web Page Viewed",
          Object.keys(properties),
          ["platform", "webPage", "previousWebPage"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "vtReMrP-AX",
          "0e7285a37d42c356246fce6977f2af827756553f04bdfd3e665aa366bff2d43e",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Web Page Viewed",
        {
          Platform: properties.platform,
          "Web Page": properties.webPage,
          "Previous Web Page": properties.previousWebPage,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "vtReMrP-AX",
          "Web Page Viewed",
          messages,
          [
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            { id: "MZLkJ3Cmi", name: "Web Page", value: properties.webPage },
            {
              id: "erhYEd3eU",
              name: "Previous Web Page",
              value: properties.previousWebPage,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Web Page Viewed': " + messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Web Page Viewed",
          {
            Platform: properties.platform,
            "Web Page": properties.webPage,
            "Previous Web Page": properties.previousWebPage,
          },
          "vtReMrP-AX",
          "0e7285a37d42c356246fce6977f2af827756553f04bdfd3e665aa366bff2d43e"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Web Page Viewed", {
        Platform: properties.platform,
        "Web Page": properties.webPage,
        "Previous Web Page": properties.previousWebPage,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Web Page Viewed", {
        Platform: properties.platform,
        "Web Page": properties.webPage,
        "Previous Web Page": properties.previousWebPage,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Overview Metrics Failed: User lands on the Teams Overview page and sees an error banner because the metrics couldn't be properly loaded.
   *
   * When to trigger this event:
   * 1. User landing on the page with the error state shown.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/cpny8pnc7Z/trigger/2C2_j1K7o
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {int} [properties.teamsPlanId] - Plan Type ID of the Team at time of event. If a team is not on a plan, do not send property.
   * @param {string} [properties.teamsPlanName] - Name of the Team's plan at time of event. If a team is not on a plan, do not send property.
   * @param {string} properties.teamsPlanInterval - Describes the Teams plan interval at the time of the event.
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/cpny8pnc7Z}
   */
  function teamsOverviewMetricsFailed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalTeamsPlanID(properties.teamsPlanId)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanName(properties.teamsPlanName)
      );
      messages = messages.concat(
        assertTeamsPlanInterval(properties.teamsPlanInterval)
      );
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Overview Metrics Failed",
          Object.keys(properties),
          [
            "platform",
            "teamsPlanId",
            "teamsPlanName",
            "teamsPlanInterval",
            "organizationId",
            "organizationGroupId",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "cpny8pnc7Z",
          "47797a1991aff6360e381b21b733a72df73999b0abcf0d71c11b4e549b91a5be",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Overview Metrics Failed",
        {
          Platform: properties.platform,
          "Teams Plan ID": properties.teamsPlanId,
          "Teams Plan Name": properties.teamsPlanName,
          "Teams Plan Interval": properties.teamsPlanInterval,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "cpny8pnc7Z",
          "Teams Overview Metrics Failed",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "125AY5RLNY",
              name: "Teams Plan Name",
              value: properties.teamsPlanName,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "TbSVW_o_GH",
              name: "Teams Plan ID",
              value: properties.teamsPlanId,
            },
            {
              id: "XcK728z2q",
              name: "Teams Plan Interval",
              value: properties.teamsPlanInterval,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Overview Metrics Failed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Overview Metrics Failed",
          {
            Platform: properties.platform,
            "Teams Plan ID": properties.teamsPlanId,
            "Teams Plan Name": properties.teamsPlanName,
            "Teams Plan Interval": properties.teamsPlanInterval,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
          },
          "cpny8pnc7Z",
          "47797a1991aff6360e381b21b733a72df73999b0abcf0d71c11b4e549b91a5be"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Overview Metrics Failed", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan Interval": properties.teamsPlanInterval,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Overview Metrics Failed", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan Interval": properties.teamsPlanInterval,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Profile Name Add Started: User starts to add first and last name to profile.
   *
   * When to trigger this event:
   * 1. Add name for users when the user voluntarily clicks to add name
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/0w3YnwNrCO/trigger/-V8YgkRR7
   * 2. When user lands on add name from route (like through engagement efforts)
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/0w3YnwNrCO/trigger/nmayVbqGG
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {int} properties.subscriptionId - User's MileIQ Subscription ID at time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/0w3YnwNrCO}
   */
  function profileNameAddStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertSubscriptionId(properties.subscriptionId)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Profile Name Add Started",
          Object.keys(properties),
          ["platform", "subscriptionId"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "0w3YnwNrCO",
          "bd4f9b0685a2d4f05deee8c7fca9ffb9740186221275b23bd654b2d2586f73f4",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Profile Name Add Started",
        {
          Platform: properties.platform,
          subscription_id: properties.subscriptionId,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "0w3YnwNrCO",
          "Profile Name Add Started",
          messages,
          [
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "TDTeQm2UP",
              name: "subscription_id",
              value: properties.subscriptionId,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Profile Name Add Started': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Profile Name Add Started",
          {
            Platform: properties.platform,
            subscription_id: properties.subscriptionId,
          },
          "0w3YnwNrCO",
          "bd4f9b0685a2d4f05deee8c7fca9ffb9740186221275b23bd654b2d2586f73f4"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Profile Name Add Started", {
        Platform: properties.platform,
        subscription_id: properties.subscriptionId,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Profile Name Add Started", {
        Platform: properties.platform,
        subscription_id: properties.subscriptionId,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Profile Name Add Completed: User completes adding first and last name to profile.
   *
   * When to trigger this event:
   * 1. User clicks 'Save name' after entering first and last names
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/hTyCBoIqh/trigger/z2KWxKdy_
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {int} properties.subscriptionId - User's MileIQ Subscription ID at time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/hTyCBoIqh}
   */
  function profileNameAddCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertSubscriptionId(properties.subscriptionId)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Profile Name Add Completed",
          Object.keys(properties),
          ["platform", "subscriptionId"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "hTyCBoIqh",
          "869da38cc6089085e264ad8ee6d4eb4ca3827b1714ce4a4376b70b1c6723246d",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Profile Name Add Completed",
        {
          Platform: properties.platform,
          subscription_id: properties.subscriptionId,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "hTyCBoIqh",
          "Profile Name Add Completed",
          messages,
          [
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "TDTeQm2UP",
              name: "subscription_id",
              value: properties.subscriptionId,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Profile Name Add Completed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Profile Name Add Completed",
          {
            Platform: properties.platform,
            subscription_id: properties.subscriptionId,
          },
          "hTyCBoIqh",
          "869da38cc6089085e264ad8ee6d4eb4ca3827b1714ce4a4376b70b1c6723246d"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Profile Name Add Completed", {
        Platform: properties.platform,
        subscription_id: properties.subscriptionId,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Profile Name Add Completed", {
        Platform: properties.platform,
        subscription_id: properties.subscriptionId,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Profile Name Update Started: User starts to update first and last name to profile.
   *
   * When to trigger this event:
   * 1. When the user clicks to "Edit" name
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/PMmUkm8RE/trigger/QpYAW1E2t-
   * 2. When user lands on edit name from route (like through engagement efforts)
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/PMmUkm8RE/trigger/K5yxH_GDhy
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {int} properties.subscriptionId - User's MileIQ Subscription ID at time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/PMmUkm8RE}
   */
  function profileNameUpdateStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertSubscriptionId(properties.subscriptionId)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Profile Name Update Started",
          Object.keys(properties),
          ["platform", "subscriptionId"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "PMmUkm8RE",
          "45de57061c14e44b5d80f049f071fb4ebd27b077ffd65cdc2d5b26fb5fcf2f52",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Profile Name Update Started",
        {
          Platform: properties.platform,
          subscription_id: properties.subscriptionId,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "PMmUkm8RE",
          "Profile Name Update Started",
          messages,
          [
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "TDTeQm2UP",
              name: "subscription_id",
              value: properties.subscriptionId,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Profile Name Update Started': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Profile Name Update Started",
          {
            Platform: properties.platform,
            subscription_id: properties.subscriptionId,
          },
          "PMmUkm8RE",
          "45de57061c14e44b5d80f049f071fb4ebd27b077ffd65cdc2d5b26fb5fcf2f52"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Profile Name Update Started", {
        Platform: properties.platform,
        subscription_id: properties.subscriptionId,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Profile Name Update Started", {
        Platform: properties.platform,
        subscription_id: properties.subscriptionId,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Profile Name Update Completed: User completes updating first and last name in profile.
   *
   * When to trigger this event:
   * 1. User clicks 'Save name' after updating first and last names
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/X5QQaEGqA/trigger/C8hT-qiTrS
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {int} properties.subscriptionId - User's MileIQ Subscription ID at time of event
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/X5QQaEGqA}
   */
  function profileNameUpdateCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertSubscriptionId(properties.subscriptionId)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Profile Name Update Completed",
          Object.keys(properties),
          ["platform", "subscriptionId"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "X5QQaEGqA",
          "fdb6be7c84bb51d43d8ea9629b72557948608e02e670dbd313ba97cf48ab0558",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Profile Name Update Completed",
        {
          Platform: properties.platform,
          subscription_id: properties.subscriptionId,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "X5QQaEGqA",
          "Profile Name Update Completed",
          messages,
          [
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "TDTeQm2UP",
              name: "subscription_id",
              value: properties.subscriptionId,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Profile Name Update Completed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Profile Name Update Completed",
          {
            Platform: properties.platform,
            subscription_id: properties.subscriptionId,
          },
          "X5QQaEGqA",
          "fdb6be7c84bb51d43d8ea9629b72557948608e02e670dbd313ba97cf48ab0558"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Profile Name Update Completed", {
        Platform: properties.platform,
        subscription_id: properties.subscriptionId,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Profile Name Update Completed", {
        Platform: properties.platform,
        subscription_id: properties.subscriptionId,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Dunning Warning Modal Started: Modal that warns teams admins their team is either expired or in the grace period. This modal is triggered once a day, when the user lands on any Teams dashboard page.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/wyddv9iWal/trigger/85kEQ0-5T
   * 2.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/wyddv9iWal/trigger/3QV33hnfZ
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {int} [properties.teamsPlanId] - Plan Type ID of the Team at time of event. If a team is not on a plan, do not send property.
   * @param {string} [properties.teamsPlanName] - Name of the Team's plan at time of event. If a team is not on a plan, do not send property.
   * @param {string} [properties.teamsPlanInterval] - Describes the Teams plan interval at the time of the event.
   * @param {int} [properties.daysUntilGracePeriodEnds] - Represents how many days until a Teams Subscription expires.
   * @param {int} [properties.teamsDriverCount] - Count of drivers in Team at time of event.
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {bool} [properties.subscriptionExpired] - Represents whether a subscription is expired or not.
   * @param {string} [properties.webPage] - The page or screen on the web where the event sourced from
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/wyddv9iWal}
   */
  function teamsDunningWarningModalStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalTeamsPlanID(properties.teamsPlanId)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanName(properties.teamsPlanName)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanInterval(properties.teamsPlanInterval)
      );
      messages = messages.concat(
        assertOptionalDaysUntilGracePeriodEnds(
          properties.daysUntilGracePeriodEnds
        )
      );
      messages = messages.concat(
        assertOptionalTeamsDriverCount(properties.teamsDriverCount)
      );
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalSubscriptionExpired(properties.subscriptionExpired)
      );
      messages = messages.concat(assertOptionalWebPage(properties.webPage));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Dunning Warning Modal Started",
          Object.keys(properties),
          [
            "platform",
            "teamsPlanId",
            "teamsPlanName",
            "teamsPlanInterval",
            "daysUntilGracePeriodEnds",
            "teamsDriverCount",
            "organizationId",
            "organizationGroupId",
            "subscriptionExpired",
            "webPage",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "wyddv9iWal",
          "6c14add2959174ad878ac4130ce55117394706fdbe71002e9fa5d6b841990115",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Dunning Warning Modal Started",
        {
          Platform: properties.platform,
          "Teams Plan ID": properties.teamsPlanId,
          "Teams Plan Name": properties.teamsPlanName,
          "Teams Plan Interval": properties.teamsPlanInterval,
          "Days Until Grace Period Ends": properties.daysUntilGracePeriodEnds,
          "Teams Driver Count": properties.teamsDriverCount,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          "Subscription Expired": properties.subscriptionExpired,
          "Web Page": properties.webPage,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "wyddv9iWal",
          "Teams Dunning Warning Modal Started",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "125AY5RLNY",
              name: "Teams Plan Name",
              value: properties.teamsPlanName,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            { id: "MZLkJ3Cmi", name: "Web Page", value: properties.webPage },
            {
              id: "TbSVW_o_GH",
              name: "Teams Plan ID",
              value: properties.teamsPlanId,
            },
            {
              id: "XcK728z2q",
              name: "Teams Plan Interval",
              value: properties.teamsPlanInterval,
            },
            {
              id: "dKx5VI1W7",
              name: "Subscription Expired",
              value: properties.subscriptionExpired,
            },
            {
              id: "h2UcigKyW",
              name: "Teams Driver Count",
              value: properties.teamsDriverCount,
            },
            {
              id: "tll649ar0",
              name: "Days Until Grace Period Ends",
              value: properties.daysUntilGracePeriodEnds,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Dunning Warning Modal Started': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Dunning Warning Modal Started",
          {
            Platform: properties.platform,
            "Teams Plan ID": properties.teamsPlanId,
            "Teams Plan Name": properties.teamsPlanName,
            "Teams Plan Interval": properties.teamsPlanInterval,
            "Days Until Grace Period Ends": properties.daysUntilGracePeriodEnds,
            "Teams Driver Count": properties.teamsDriverCount,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            "Subscription Expired": properties.subscriptionExpired,
            "Web Page": properties.webPage,
          },
          "wyddv9iWal",
          "6c14add2959174ad878ac4130ce55117394706fdbe71002e9fa5d6b841990115"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Dunning Warning Modal Started", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan Interval": properties.teamsPlanInterval,
        "Days Until Grace Period Ends": properties.daysUntilGracePeriodEnds,
        "Teams Driver Count": properties.teamsDriverCount,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Subscription Expired": properties.subscriptionExpired,
        "Web Page": properties.webPage,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Dunning Warning Modal Started", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan Interval": properties.teamsPlanInterval,
        "Days Until Grace Period Ends": properties.daysUntilGracePeriodEnds,
        "Teams Driver Count": properties.teamsDriverCount,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Subscription Expired": properties.subscriptionExpired,
        "Web Page": properties.webPage,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Dunning Warning Modal Abandoned: Teams admin abandoned the modal that warns them their team is either expired or in the grace period.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/5-pblQxNSn/trigger/yWh5UMABM
   * 2.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/5-pblQxNSn/trigger/7TMEPfI7x
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {int} [properties.teamsPlanId] - Plan Type ID of the Team at time of event. If a team is not on a plan, do not send property.
   * @param {string} [properties.teamsPlanName] - Name of the Team's plan at time of event. If a team is not on a plan, do not send property.
   * @param {string} [properties.teamsPlanInterval] - Describes the Teams plan interval at the time of the event.
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {int} [properties.daysUntilGracePeriodEnds] - Represents how many days until a Teams Subscription expires.
   * @param {int} [properties.teamsDriverCount] - Count of drivers in Team at time of event.
   * @param {string} [properties.modalAbandonMethod] - Represents the method used to close modals across the dashboard.
   * @param {bool} [properties.subscriptionExpired] - Represents whether a subscription is expired or not.
   * @param {string} [properties.webPage] - The page or screen on the web where the event sourced from
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/5-pblQxNSn}
   */
  function teamsDunningWarningModalAbandoned(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalTeamsPlanID(properties.teamsPlanId)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanName(properties.teamsPlanName)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanInterval(properties.teamsPlanInterval)
      );
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalDaysUntilGracePeriodEnds(
          properties.daysUntilGracePeriodEnds
        )
      );
      messages = messages.concat(
        assertOptionalTeamsDriverCount(properties.teamsDriverCount)
      );
      messages = messages.concat(
        assertOptionalModalAbandonMethod(properties.modalAbandonMethod)
      );
      messages = messages.concat(
        assertOptionalSubscriptionExpired(properties.subscriptionExpired)
      );
      messages = messages.concat(assertOptionalWebPage(properties.webPage));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Dunning Warning Modal Abandoned",
          Object.keys(properties),
          [
            "platform",
            "teamsPlanId",
            "teamsPlanName",
            "teamsPlanInterval",
            "organizationId",
            "organizationGroupId",
            "daysUntilGracePeriodEnds",
            "teamsDriverCount",
            "modalAbandonMethod",
            "subscriptionExpired",
            "webPage",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "5-pblQxNSn",
          "cbb30b6af87b377acce230ab8f077c69a3ec9d881230b32e6da11c35b928c64a",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Dunning Warning Modal Abandoned",
        {
          Platform: properties.platform,
          "Teams Plan ID": properties.teamsPlanId,
          "Teams Plan Name": properties.teamsPlanName,
          "Teams Plan Interval": properties.teamsPlanInterval,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          "Days Until Grace Period Ends": properties.daysUntilGracePeriodEnds,
          "Teams Driver Count": properties.teamsDriverCount,
          "Modal Abandon Method": properties.modalAbandonMethod,
          "Subscription Expired": properties.subscriptionExpired,
          "Web Page": properties.webPage,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "5-pblQxNSn",
          "Teams Dunning Warning Modal Abandoned",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "125AY5RLNY",
              name: "Teams Plan Name",
              value: properties.teamsPlanName,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            { id: "MZLkJ3Cmi", name: "Web Page", value: properties.webPage },
            {
              id: "TbSVW_o_GH",
              name: "Teams Plan ID",
              value: properties.teamsPlanId,
            },
            {
              id: "XcK728z2q",
              name: "Teams Plan Interval",
              value: properties.teamsPlanInterval,
            },
            {
              id: "dKx5VI1W7",
              name: "Subscription Expired",
              value: properties.subscriptionExpired,
            },
            {
              id: "h2UcigKyW",
              name: "Teams Driver Count",
              value: properties.teamsDriverCount,
            },
            {
              id: "tll649ar0",
              name: "Days Until Grace Period Ends",
              value: properties.daysUntilGracePeriodEnds,
            },
            {
              id: "vb2dwipxd",
              name: "Modal Abandon Method",
              value: properties.modalAbandonMethod,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Dunning Warning Modal Abandoned': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Dunning Warning Modal Abandoned",
          {
            Platform: properties.platform,
            "Teams Plan ID": properties.teamsPlanId,
            "Teams Plan Name": properties.teamsPlanName,
            "Teams Plan Interval": properties.teamsPlanInterval,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            "Days Until Grace Period Ends": properties.daysUntilGracePeriodEnds,
            "Teams Driver Count": properties.teamsDriverCount,
            "Modal Abandon Method": properties.modalAbandonMethod,
            "Subscription Expired": properties.subscriptionExpired,
            "Web Page": properties.webPage,
          },
          "5-pblQxNSn",
          "cbb30b6af87b377acce230ab8f077c69a3ec9d881230b32e6da11c35b928c64a"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent(
        "Teams Dunning Warning Modal Abandoned",
        {
          Platform: properties.platform,
          "Teams Plan ID": properties.teamsPlanId,
          "Teams Plan Name": properties.teamsPlanName,
          "Teams Plan Interval": properties.teamsPlanInterval,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          "Days Until Grace Period Ends": properties.daysUntilGracePeriodEnds,
          "Teams Driver Count": properties.teamsDriverCount,
          "Modal Abandon Method": properties.modalAbandonMethod,
          "Subscription Expired": properties.subscriptionExpired,
          "Web Page": properties.webPage,
        }
      );

      // destination Mixpanel
      Mixpanel.logEvent("Teams Dunning Warning Modal Abandoned", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan Interval": properties.teamsPlanInterval,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Days Until Grace Period Ends": properties.daysUntilGracePeriodEnds,
        "Teams Driver Count": properties.teamsDriverCount,
        "Modal Abandon Method": properties.modalAbandonMethod,
        "Subscription Expired": properties.subscriptionExpired,
        "Web Page": properties.webPage,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Update Payment Started: Indicates the update payment process has started, either from an expired subscription or a subscription in grace period.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/SY_f7S0fYm/trigger/glrIVwPTj
   * 2.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/SY_f7S0fYm/trigger/8RvkGmV76
   * 3.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/SY_f7S0fYm/trigger/lZKQ3bYS1
   * 4.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/SY_f7S0fYm/trigger/x-Xo1d_h-
   * 5.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/SY_f7S0fYm/trigger/RkTB0AenI
   * 6.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/SY_f7S0fYm/trigger/DrGdK1-Pb
   * 7.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/SY_f7S0fYm/trigger/JYmp_gpII
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {int} [properties.teamsPlanId] - Plan Type ID of the Team at time of event. If a team is not on a plan, do not send property.
   * @param {string} [properties.teamsPlanName] - Name of the Team's plan at time of event. If a team is not on a plan, do not send property.
   * @param {string} [properties.teamsPlanInterval] - Describes the Teams plan interval at the time of the event.
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {int} [properties.daysUntilGracePeriodEnds] - Represents how many days until a Teams Subscription expires.
   * @param {int} [properties.teamsDriverCount] - Count of drivers in Team at time of event.
   * @param {bool} [properties.subscriptionExpired] - Represents whether a subscription is expired or not.
   * @param {string} [properties.teamsUpdatePaymentSource] - Represents entry points for the Teams Update Payment process.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/SY_f7S0fYm}
   */
  function teamsUpdatePaymentStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalTeamsPlanID(properties.teamsPlanId)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanName(properties.teamsPlanName)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanInterval(properties.teamsPlanInterval)
      );
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalDaysUntilGracePeriodEnds(
          properties.daysUntilGracePeriodEnds
        )
      );
      messages = messages.concat(
        assertOptionalTeamsDriverCount(properties.teamsDriverCount)
      );
      messages = messages.concat(
        assertOptionalSubscriptionExpired(properties.subscriptionExpired)
      );
      messages = messages.concat(
        assertOptionalTeamsUpdatePaymentSource(
          properties.teamsUpdatePaymentSource
        )
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Update Payment Started",
          Object.keys(properties),
          [
            "platform",
            "teamsPlanId",
            "teamsPlanName",
            "teamsPlanInterval",
            "organizationId",
            "organizationGroupId",
            "daysUntilGracePeriodEnds",
            "teamsDriverCount",
            "subscriptionExpired",
            "teamsUpdatePaymentSource",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "SY_f7S0fYm",
          "0a615012209875228f38081554f547d4171af4bb6e1c4f4b0f0fc177fca12dad",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Update Payment Started",
        {
          Platform: properties.platform,
          "Teams Plan ID": properties.teamsPlanId,
          "Teams Plan Name": properties.teamsPlanName,
          "Teams Plan Interval": properties.teamsPlanInterval,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          "Days Until Grace Period Ends": properties.daysUntilGracePeriodEnds,
          "Teams Driver Count": properties.teamsDriverCount,
          "Subscription Expired": properties.subscriptionExpired,
          "Teams Update Payment Source": properties.teamsUpdatePaymentSource,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "SY_f7S0fYm",
          "Teams Update Payment Started",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "125AY5RLNY",
              name: "Teams Plan Name",
              value: properties.teamsPlanName,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "QemLemsma",
              name: "Teams Update Payment Source",
              value: properties.teamsUpdatePaymentSource,
            },
            {
              id: "TbSVW_o_GH",
              name: "Teams Plan ID",
              value: properties.teamsPlanId,
            },
            {
              id: "XcK728z2q",
              name: "Teams Plan Interval",
              value: properties.teamsPlanInterval,
            },
            {
              id: "dKx5VI1W7",
              name: "Subscription Expired",
              value: properties.subscriptionExpired,
            },
            {
              id: "h2UcigKyW",
              name: "Teams Driver Count",
              value: properties.teamsDriverCount,
            },
            {
              id: "tll649ar0",
              name: "Days Until Grace Period Ends",
              value: properties.daysUntilGracePeriodEnds,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Update Payment Started': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Update Payment Started",
          {
            Platform: properties.platform,
            "Teams Plan ID": properties.teamsPlanId,
            "Teams Plan Name": properties.teamsPlanName,
            "Teams Plan Interval": properties.teamsPlanInterval,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            "Days Until Grace Period Ends": properties.daysUntilGracePeriodEnds,
            "Teams Driver Count": properties.teamsDriverCount,
            "Subscription Expired": properties.subscriptionExpired,
            "Teams Update Payment Source": properties.teamsUpdatePaymentSource,
          },
          "SY_f7S0fYm",
          "0a615012209875228f38081554f547d4171af4bb6e1c4f4b0f0fc177fca12dad"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Update Payment Started", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan Interval": properties.teamsPlanInterval,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Days Until Grace Period Ends": properties.daysUntilGracePeriodEnds,
        "Teams Driver Count": properties.teamsDriverCount,
        "Subscription Expired": properties.subscriptionExpired,
        "Teams Update Payment Source": properties.teamsUpdatePaymentSource,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Update Payment Started", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan Interval": properties.teamsPlanInterval,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Days Until Grace Period Ends": properties.daysUntilGracePeriodEnds,
        "Teams Driver Count": properties.teamsDriverCount,
        "Subscription Expired": properties.subscriptionExpired,
        "Teams Update Payment Source": properties.teamsUpdatePaymentSource,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Update Payment Completed: Indicates the update payment process has succeeded, and the team subscription was completely recovered.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/1bfZJoYBf/trigger/IQP9Dt0UM
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {int} [properties.teamsPlanId] - Plan Type ID of the Team at time of event. If a team is not on a plan, do not send property.
   * @param {string} [properties.teamsPlanName] - Name of the Team's plan at time of event. If a team is not on a plan, do not send property.
   * @param {string} [properties.teamsPlanInterval] - Describes the Teams plan interval at the time of the event.
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {int} [properties.daysUntilGracePeriodEnds] - Represents how many days until a Teams Subscription expires.
   * @param {int} [properties.teamsDriverCount] - Count of drivers in Team at time of event.
   * @param {bool} [properties.subscriptionExpired] - Represents whether a subscription is expired or not.
   * @param {float} [properties.paymentAmountDue] - Represents the amount due of payment processes.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/1bfZJoYBf}
   */
  function teamsUpdatePaymentCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalTeamsPlanID(properties.teamsPlanId)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanName(properties.teamsPlanName)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanInterval(properties.teamsPlanInterval)
      );
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalDaysUntilGracePeriodEnds(
          properties.daysUntilGracePeriodEnds
        )
      );
      messages = messages.concat(
        assertOptionalTeamsDriverCount(properties.teamsDriverCount)
      );
      messages = messages.concat(
        assertOptionalSubscriptionExpired(properties.subscriptionExpired)
      );
      messages = messages.concat(
        assertOptionalPaymentAmountDue(properties.paymentAmountDue)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Update Payment Completed",
          Object.keys(properties),
          [
            "platform",
            "teamsPlanId",
            "teamsPlanName",
            "teamsPlanInterval",
            "organizationId",
            "organizationGroupId",
            "daysUntilGracePeriodEnds",
            "teamsDriverCount",
            "subscriptionExpired",
            "paymentAmountDue",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "1bfZJoYBf",
          "ceeafec1a1731f28dabe8b3cdc003de363c2815540388f44eaedf55cbc1a0150",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Update Payment Completed",
        {
          Platform: properties.platform,
          "Teams Plan ID": properties.teamsPlanId,
          "Teams Plan Name": properties.teamsPlanName,
          "Teams Plan Interval": properties.teamsPlanInterval,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          "Days Until Grace Period Ends": properties.daysUntilGracePeriodEnds,
          "Teams Driver Count": properties.teamsDriverCount,
          "Subscription Expired": properties.subscriptionExpired,
          "Payment Amount Due": properties.paymentAmountDue,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "1bfZJoYBf",
          "Teams Update Payment Completed",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "125AY5RLNY",
              name: "Teams Plan Name",
              value: properties.teamsPlanName,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "TbSVW_o_GH",
              name: "Teams Plan ID",
              value: properties.teamsPlanId,
            },
            {
              id: "XcK728z2q",
              name: "Teams Plan Interval",
              value: properties.teamsPlanInterval,
            },
            {
              id: "dKx5VI1W7",
              name: "Subscription Expired",
              value: properties.subscriptionExpired,
            },
            {
              id: "h2UcigKyW",
              name: "Teams Driver Count",
              value: properties.teamsDriverCount,
            },
            {
              id: "qP671jcZS",
              name: "Payment Amount Due",
              value: properties.paymentAmountDue,
            },
            {
              id: "tll649ar0",
              name: "Days Until Grace Period Ends",
              value: properties.daysUntilGracePeriodEnds,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Update Payment Completed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Update Payment Completed",
          {
            Platform: properties.platform,
            "Teams Plan ID": properties.teamsPlanId,
            "Teams Plan Name": properties.teamsPlanName,
            "Teams Plan Interval": properties.teamsPlanInterval,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            "Days Until Grace Period Ends": properties.daysUntilGracePeriodEnds,
            "Teams Driver Count": properties.teamsDriverCount,
            "Subscription Expired": properties.subscriptionExpired,
            "Payment Amount Due": properties.paymentAmountDue,
          },
          "1bfZJoYBf",
          "ceeafec1a1731f28dabe8b3cdc003de363c2815540388f44eaedf55cbc1a0150"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Update Payment Completed", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan Interval": properties.teamsPlanInterval,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Days Until Grace Period Ends": properties.daysUntilGracePeriodEnds,
        "Teams Driver Count": properties.teamsDriverCount,
        "Subscription Expired": properties.subscriptionExpired,
        "Payment Amount Due": properties.paymentAmountDue,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Update Payment Completed", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan Interval": properties.teamsPlanInterval,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Days Until Grace Period Ends": properties.daysUntilGracePeriodEnds,
        "Teams Driver Count": properties.teamsDriverCount,
        "Subscription Expired": properties.subscriptionExpired,
        "Payment Amount Due": properties.paymentAmountDue,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Resubscribe Modal Started: Modal that tells teams admins what they're missing by having an expired subscription, with a CTA to push them to update their payment. Can be opened from any dashboard CTA or from engagement campaigns (leveraging URL parameters).
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/5Ol9HSwQA/trigger/T9OyHuWY8
   * 2. Any dashboard CTA
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/5Ol9HSwQA/trigger/vV4As1va4
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {int} [properties.teamsPlanId] - Plan Type ID of the Team at time of event. If a team is not on a plan, do not send property.
   * @param {string} [properties.teamsPlanName] - Name of the Team's plan at time of event. If a team is not on a plan, do not send property.
   * @param {string} [properties.teamsPlanInterval] - Describes the Teams plan interval at the time of the event.
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {int} [properties.teamsDriverCount] - Count of drivers in Team at time of event.
   * @param {string} [properties.webPage] - The page or screen on the web where the event sourced from
   * @param {string} [properties.teamsResubscribeModalSource] - Represents entry points for the Teams Resubscribe Modal.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/5Ol9HSwQA}
   */
  function teamsResubscribeModalStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalTeamsPlanID(properties.teamsPlanId)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanName(properties.teamsPlanName)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanInterval(properties.teamsPlanInterval)
      );
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalTeamsDriverCount(properties.teamsDriverCount)
      );
      messages = messages.concat(assertOptionalWebPage(properties.webPage));
      messages = messages.concat(
        assertOptionalTeamsResubscribeModalSource(
          properties.teamsResubscribeModalSource
        )
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Resubscribe Modal Started",
          Object.keys(properties),
          [
            "platform",
            "teamsPlanId",
            "teamsPlanName",
            "teamsPlanInterval",
            "organizationId",
            "organizationGroupId",
            "teamsDriverCount",
            "webPage",
            "teamsResubscribeModalSource",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "5Ol9HSwQA",
          "42bca6a9fc86de8604aec4769e4c593349a5b494a392d84a336969c4cac50dad",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Resubscribe Modal Started",
        {
          Platform: properties.platform,
          "Teams Plan ID": properties.teamsPlanId,
          "Teams Plan Name": properties.teamsPlanName,
          "Teams Plan Interval": properties.teamsPlanInterval,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          "Teams Driver Count": properties.teamsDriverCount,
          "Web Page": properties.webPage,
          "Teams Resubscribe Modal Source":
            properties.teamsResubscribeModalSource,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "5Ol9HSwQA",
          "Teams Resubscribe Modal Started",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "125AY5RLNY",
              name: "Teams Plan Name",
              value: properties.teamsPlanName,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            { id: "MZLkJ3Cmi", name: "Web Page", value: properties.webPage },
            {
              id: "Rgnqsm5P5",
              name: "Teams Resubscribe Modal Source",
              value: properties.teamsResubscribeModalSource,
            },
            {
              id: "TbSVW_o_GH",
              name: "Teams Plan ID",
              value: properties.teamsPlanId,
            },
            {
              id: "XcK728z2q",
              name: "Teams Plan Interval",
              value: properties.teamsPlanInterval,
            },
            {
              id: "h2UcigKyW",
              name: "Teams Driver Count",
              value: properties.teamsDriverCount,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Resubscribe Modal Started': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Resubscribe Modal Started",
          {
            Platform: properties.platform,
            "Teams Plan ID": properties.teamsPlanId,
            "Teams Plan Name": properties.teamsPlanName,
            "Teams Plan Interval": properties.teamsPlanInterval,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            "Teams Driver Count": properties.teamsDriverCount,
            "Web Page": properties.webPage,
            "Teams Resubscribe Modal Source":
              properties.teamsResubscribeModalSource,
          },
          "5Ol9HSwQA",
          "42bca6a9fc86de8604aec4769e4c593349a5b494a392d84a336969c4cac50dad"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Resubscribe Modal Started", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan Interval": properties.teamsPlanInterval,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Driver Count": properties.teamsDriverCount,
        "Web Page": properties.webPage,
        "Teams Resubscribe Modal Source":
          properties.teamsResubscribeModalSource,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Resubscribe Modal Started", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan Interval": properties.teamsPlanInterval,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Driver Count": properties.teamsDriverCount,
        "Web Page": properties.webPage,
        "Teams Resubscribe Modal Source":
          properties.teamsResubscribeModalSource,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Resubscribe Modal Abandoned: Teams admin abandoned the modal that tells them what they're missing by having an expired subscription.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/7e-PtLmBs/trigger/lvXUtcY6B
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {int} [properties.teamsPlanId] - Plan Type ID of the Team at time of event. If a team is not on a plan, do not send property.
   * @param {string} [properties.teamsPlanName] - Name of the Team's plan at time of event. If a team is not on a plan, do not send property.
   * @param {string} [properties.teamsPlanInterval] - Describes the Teams plan interval at the time of the event.
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {int} [properties.teamsDriverCount] - Count of drivers in Team at time of event.
   * @param {string} [properties.modalAbandonMethod] - Represents the method used to close modals across the dashboard.
   * @param {string} [properties.webPage] - The page or screen on the web where the event sourced from
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/7e-PtLmBs}
   */
  function teamsResubscribeModalAbandoned(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalTeamsPlanID(properties.teamsPlanId)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanName(properties.teamsPlanName)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanInterval(properties.teamsPlanInterval)
      );
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalTeamsDriverCount(properties.teamsDriverCount)
      );
      messages = messages.concat(
        assertOptionalModalAbandonMethod(properties.modalAbandonMethod)
      );
      messages = messages.concat(assertOptionalWebPage(properties.webPage));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Resubscribe Modal Abandoned",
          Object.keys(properties),
          [
            "platform",
            "teamsPlanId",
            "teamsPlanName",
            "teamsPlanInterval",
            "organizationId",
            "organizationGroupId",
            "teamsDriverCount",
            "modalAbandonMethod",
            "webPage",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "7e-PtLmBs",
          "6a277da4bc1e933ac5a071bd1034ede4e78bb4a86578d0b9091fd240a440fead",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Resubscribe Modal Abandoned",
        {
          Platform: properties.platform,
          "Teams Plan ID": properties.teamsPlanId,
          "Teams Plan Name": properties.teamsPlanName,
          "Teams Plan Interval": properties.teamsPlanInterval,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          "Teams Driver Count": properties.teamsDriverCount,
          "Modal Abandon Method": properties.modalAbandonMethod,
          "Web Page": properties.webPage,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "7e-PtLmBs",
          "Teams Resubscribe Modal Abandoned",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "125AY5RLNY",
              name: "Teams Plan Name",
              value: properties.teamsPlanName,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            { id: "MZLkJ3Cmi", name: "Web Page", value: properties.webPage },
            {
              id: "TbSVW_o_GH",
              name: "Teams Plan ID",
              value: properties.teamsPlanId,
            },
            {
              id: "XcK728z2q",
              name: "Teams Plan Interval",
              value: properties.teamsPlanInterval,
            },
            {
              id: "h2UcigKyW",
              name: "Teams Driver Count",
              value: properties.teamsDriverCount,
            },
            {
              id: "vb2dwipxd",
              name: "Modal Abandon Method",
              value: properties.modalAbandonMethod,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Resubscribe Modal Abandoned': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Resubscribe Modal Abandoned",
          {
            Platform: properties.platform,
            "Teams Plan ID": properties.teamsPlanId,
            "Teams Plan Name": properties.teamsPlanName,
            "Teams Plan Interval": properties.teamsPlanInterval,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            "Teams Driver Count": properties.teamsDriverCount,
            "Modal Abandon Method": properties.modalAbandonMethod,
            "Web Page": properties.webPage,
          },
          "7e-PtLmBs",
          "6a277da4bc1e933ac5a071bd1034ede4e78bb4a86578d0b9091fd240a440fead"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Resubscribe Modal Abandoned", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan Interval": properties.teamsPlanInterval,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Driver Count": properties.teamsDriverCount,
        "Modal Abandon Method": properties.modalAbandonMethod,
        "Web Page": properties.webPage,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Resubscribe Modal Abandoned", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan Interval": properties.teamsPlanInterval,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Driver Count": properties.teamsDriverCount,
        "Modal Abandon Method": properties.modalAbandonMethod,
        "Web Page": properties.webPage,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Update Payment Failed: Indicates the update payment process has failed, either from a payment method validation error, or an unexpected error.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/HJVi7E_1t/trigger/zmkvzwKEx
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {int} [properties.teamsPlanId] - Plan Type ID of the Team at time of event. If a team is not on a plan, do not send property.
   * @param {string} [properties.teamsPlanName] - Name of the Team's plan at time of event. If a team is not on a plan, do not send property.
   * @param {string} [properties.teamsPlanInterval] - Describes the Teams plan interval at the time of the event.
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {int} [properties.daysUntilGracePeriodEnds] - Represents how many days until a Teams Subscription expires.
   * @param {int} [properties.teamsDriverCount] - Count of drivers in Team at time of event.
   * @param {bool} [properties.subscriptionExpired] - Represents whether a subscription is expired or not.
   * @param {string} [properties.teamsUpdatePaymentFailReason] - Detailed information about errors during the Teams Update Payment process.
   * @param {float} [properties.paymentAmountDue] - Represents the amount due of payment processes.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/HJVi7E_1t}
   */
  function teamsUpdatePaymentFailed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalTeamsPlanID(properties.teamsPlanId)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanName(properties.teamsPlanName)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanInterval(properties.teamsPlanInterval)
      );
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalDaysUntilGracePeriodEnds(
          properties.daysUntilGracePeriodEnds
        )
      );
      messages = messages.concat(
        assertOptionalTeamsDriverCount(properties.teamsDriverCount)
      );
      messages = messages.concat(
        assertOptionalSubscriptionExpired(properties.subscriptionExpired)
      );
      messages = messages.concat(
        assertOptionalTeamsUpdatePaymentFailReason(
          properties.teamsUpdatePaymentFailReason
        )
      );
      messages = messages.concat(
        assertOptionalPaymentAmountDue(properties.paymentAmountDue)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Update Payment Failed",
          Object.keys(properties),
          [
            "platform",
            "teamsPlanId",
            "teamsPlanName",
            "teamsPlanInterval",
            "organizationId",
            "organizationGroupId",
            "daysUntilGracePeriodEnds",
            "teamsDriverCount",
            "subscriptionExpired",
            "teamsUpdatePaymentFailReason",
            "paymentAmountDue",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "HJVi7E_1t",
          "144ad98a620cb88670cacbbbe19550bc56f95d23f13214965bd07d123113952d",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Update Payment Failed",
        {
          Platform: properties.platform,
          "Teams Plan ID": properties.teamsPlanId,
          "Teams Plan Name": properties.teamsPlanName,
          "Teams Plan Interval": properties.teamsPlanInterval,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          "Days Until Grace Period Ends": properties.daysUntilGracePeriodEnds,
          "Teams Driver Count": properties.teamsDriverCount,
          "Subscription Expired": properties.subscriptionExpired,
          "Teams Update Payment Fail Reason":
            properties.teamsUpdatePaymentFailReason,
          "Payment Amount Due": properties.paymentAmountDue,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "HJVi7E_1t",
          "Teams Update Payment Failed",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "125AY5RLNY",
              name: "Teams Plan Name",
              value: properties.teamsPlanName,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "TbSVW_o_GH",
              name: "Teams Plan ID",
              value: properties.teamsPlanId,
            },
            {
              id: "XcK728z2q",
              name: "Teams Plan Interval",
              value: properties.teamsPlanInterval,
            },
            {
              id: "dKx5VI1W7",
              name: "Subscription Expired",
              value: properties.subscriptionExpired,
            },
            {
              id: "h2UcigKyW",
              name: "Teams Driver Count",
              value: properties.teamsDriverCount,
            },
            {
              id: "ol0C1rRCB",
              name: "Teams Update Payment Fail Reason",
              value: properties.teamsUpdatePaymentFailReason,
            },
            {
              id: "qP671jcZS",
              name: "Payment Amount Due",
              value: properties.paymentAmountDue,
            },
            {
              id: "tll649ar0",
              name: "Days Until Grace Period Ends",
              value: properties.daysUntilGracePeriodEnds,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Update Payment Failed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Update Payment Failed",
          {
            Platform: properties.platform,
            "Teams Plan ID": properties.teamsPlanId,
            "Teams Plan Name": properties.teamsPlanName,
            "Teams Plan Interval": properties.teamsPlanInterval,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            "Days Until Grace Period Ends": properties.daysUntilGracePeriodEnds,
            "Teams Driver Count": properties.teamsDriverCount,
            "Subscription Expired": properties.subscriptionExpired,
            "Teams Update Payment Fail Reason":
              properties.teamsUpdatePaymentFailReason,
            "Payment Amount Due": properties.paymentAmountDue,
          },
          "HJVi7E_1t",
          "144ad98a620cb88670cacbbbe19550bc56f95d23f13214965bd07d123113952d"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Update Payment Failed", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan Interval": properties.teamsPlanInterval,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Days Until Grace Period Ends": properties.daysUntilGracePeriodEnds,
        "Teams Driver Count": properties.teamsDriverCount,
        "Subscription Expired": properties.subscriptionExpired,
        "Teams Update Payment Fail Reason":
          properties.teamsUpdatePaymentFailReason,
        "Payment Amount Due": properties.paymentAmountDue,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Update Payment Failed", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan Interval": properties.teamsPlanInterval,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Days Until Grace Period Ends": properties.daysUntilGracePeriodEnds,
        "Teams Driver Count": properties.teamsDriverCount,
        "Subscription Expired": properties.subscriptionExpired,
        "Teams Update Payment Fail Reason":
          properties.teamsUpdatePaymentFailReason,
        "Payment Amount Due": properties.paymentAmountDue,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Update Payment Abandoned: Indicates the update payment process has been abandoned.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/oa6zy1Duf/trigger/T7QdtDb6v
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {int} [properties.teamsPlanId] - Plan Type ID of the Team at time of event. If a team is not on a plan, do not send property.
   * @param {string} [properties.teamsPlanName] - Name of the Team's plan at time of event. If a team is not on a plan, do not send property.
   * @param {string} [properties.teamsPlanInterval] - Describes the Teams plan interval at the time of the event.
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {int} [properties.daysUntilGracePeriodEnds] - Represents how many days until a Teams Subscription expires.
   * @param {int} [properties.teamsDriverCount] - Count of drivers in Team at time of event.
   * @param {bool} [properties.subscriptionExpired] - Represents whether a subscription is expired or not.
   * @param {string} [properties.modalAbandonMethod] - Represents the method used to close modals across the dashboard.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/oa6zy1Duf}
   */
  function teamsUpdatePaymentAbandoned(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalTeamsPlanID(properties.teamsPlanId)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanName(properties.teamsPlanName)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanInterval(properties.teamsPlanInterval)
      );
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalDaysUntilGracePeriodEnds(
          properties.daysUntilGracePeriodEnds
        )
      );
      messages = messages.concat(
        assertOptionalTeamsDriverCount(properties.teamsDriverCount)
      );
      messages = messages.concat(
        assertOptionalSubscriptionExpired(properties.subscriptionExpired)
      );
      messages = messages.concat(
        assertOptionalModalAbandonMethod(properties.modalAbandonMethod)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Update Payment Abandoned",
          Object.keys(properties),
          [
            "platform",
            "teamsPlanId",
            "teamsPlanName",
            "teamsPlanInterval",
            "organizationId",
            "organizationGroupId",
            "daysUntilGracePeriodEnds",
            "teamsDriverCount",
            "subscriptionExpired",
            "modalAbandonMethod",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "oa6zy1Duf",
          "2eb384429635844a8d276b1c9c66d65feaa10e08366b3df756322a65fb07b548",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Update Payment Abandoned",
        {
          Platform: properties.platform,
          "Teams Plan ID": properties.teamsPlanId,
          "Teams Plan Name": properties.teamsPlanName,
          "Teams Plan Interval": properties.teamsPlanInterval,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          "Days Until Grace Period Ends": properties.daysUntilGracePeriodEnds,
          "Teams Driver Count": properties.teamsDriverCount,
          "Subscription Expired": properties.subscriptionExpired,
          "Modal Abandon Method": properties.modalAbandonMethod,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "oa6zy1Duf",
          "Teams Update Payment Abandoned",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "125AY5RLNY",
              name: "Teams Plan Name",
              value: properties.teamsPlanName,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "TbSVW_o_GH",
              name: "Teams Plan ID",
              value: properties.teamsPlanId,
            },
            {
              id: "XcK728z2q",
              name: "Teams Plan Interval",
              value: properties.teamsPlanInterval,
            },
            {
              id: "dKx5VI1W7",
              name: "Subscription Expired",
              value: properties.subscriptionExpired,
            },
            {
              id: "h2UcigKyW",
              name: "Teams Driver Count",
              value: properties.teamsDriverCount,
            },
            {
              id: "tll649ar0",
              name: "Days Until Grace Period Ends",
              value: properties.daysUntilGracePeriodEnds,
            },
            {
              id: "vb2dwipxd",
              name: "Modal Abandon Method",
              value: properties.modalAbandonMethod,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Update Payment Abandoned': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Update Payment Abandoned",
          {
            Platform: properties.platform,
            "Teams Plan ID": properties.teamsPlanId,
            "Teams Plan Name": properties.teamsPlanName,
            "Teams Plan Interval": properties.teamsPlanInterval,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            "Days Until Grace Period Ends": properties.daysUntilGracePeriodEnds,
            "Teams Driver Count": properties.teamsDriverCount,
            "Subscription Expired": properties.subscriptionExpired,
            "Modal Abandon Method": properties.modalAbandonMethod,
          },
          "oa6zy1Duf",
          "2eb384429635844a8d276b1c9c66d65feaa10e08366b3df756322a65fb07b548"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Update Payment Abandoned", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan Interval": properties.teamsPlanInterval,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Days Until Grace Period Ends": properties.daysUntilGracePeriodEnds,
        "Teams Driver Count": properties.teamsDriverCount,
        "Subscription Expired": properties.subscriptionExpired,
        "Modal Abandon Method": properties.modalAbandonMethod,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Update Payment Abandoned", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan Interval": properties.teamsPlanInterval,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Days Until Grace Period Ends": properties.daysUntilGracePeriodEnds,
        "Teams Driver Count": properties.teamsDriverCount,
        "Subscription Expired": properties.subscriptionExpired,
        "Modal Abandon Method": properties.modalAbandonMethod,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Report Creation Step Completed: Intermediary steps between start and completion of the report creation flow. Triggers when a driver selects a report time period and when a driver selects a contact to send a report to.
   *
   * When to trigger this event:
   * 1. Triggers when user taps "next" on the Add Details page of the new two page report creation process
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/FY_aCaJPD/trigger/aQFmWAAlS
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {int} properties.subscriptionId - User's MileIQ Subscription ID at time of event
   * @param {string} properties.page - The page or screen in app or on the web where the event sourced from.
   * @param {string} properties.reportCreationStepName - Specific report step name
   * @param {string} [properties.reportRecipientType] - Type of recipient of the report: Team Admin, Email, Concur
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/FY_aCaJPD}
   */
  function reportCreationStepCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertSubscriptionId(properties.subscriptionId)
      );
      messages = messages.concat(assertPage(properties.page));
      messages = messages.concat(
        assertReportCreationStepName(properties.reportCreationStepName)
      );
      messages = messages.concat(
        assertOptionalReportRecipientType(properties.reportRecipientType)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Report Creation Step Completed",
          Object.keys(properties),
          [
            "platform",
            "organizationId",
            "organizationGroupId",
            "subscriptionId",
            "page",
            "reportCreationStepName",
            "reportRecipientType",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "FY_aCaJPD",
          "e978cfcb744a9ed58f618773c986bcd32ed69cb0309916e282c525edd1b78f37",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Report Creation Step Completed",
        {
          Platform: properties.platform,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          subscription_id: properties.subscriptionId,
          Page: properties.page,
          "Report Creation Step Name": properties.reportCreationStepName,
          "Report Recipient Type": properties.reportRecipientType,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "FY_aCaJPD",
          "Report Creation Step Completed",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            { id: "4j_Pu5zIMW", name: "Page", value: properties.page },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "Gk0YhZ6oD",
              name: "Report Creation Step Name",
              value: properties.reportCreationStepName,
            },
            {
              id: "TDTeQm2UP",
              name: "subscription_id",
              value: properties.subscriptionId,
            },
            {
              id: "fgug2PGnqJ",
              name: "Report Recipient Type",
              value: properties.reportRecipientType,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Report Creation Step Completed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Report Creation Step Completed",
          {
            Platform: properties.platform,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            subscription_id: properties.subscriptionId,
            Page: properties.page,
            "Report Creation Step Name": properties.reportCreationStepName,
            "Report Recipient Type": properties.reportRecipientType,
          },
          "FY_aCaJPD",
          "e978cfcb744a9ed58f618773c986bcd32ed69cb0309916e282c525edd1b78f37"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Report Creation Step Completed", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        subscription_id: properties.subscriptionId,
        Page: properties.page,
        "Report Creation Step Name": properties.reportCreationStepName,
        "Report Recipient Type": properties.reportRecipientType,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Report Creation Step Completed", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        subscription_id: properties.subscriptionId,
        Page: properties.page,
        "Report Creation Step Name": properties.reportCreationStepName,
        "Report Recipient Type": properties.reportRecipientType,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Contact Add Started: Driver taps "Add a contact" in either the create a report flow or from the contacts section of account settings.
   *
   * When to trigger this event:
   * 1. Triggers when "Add a contact" is tapped from the Share report screen
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/eTpvFjcqe/trigger/yWBxQgxCt
   * 2. Triggered when "Add new contact" is tapped from the contacts page under reports in Settings on the Web Dashboard
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/eTpvFjcqe/trigger/z9-uo7Ujr
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {int} properties.subscriptionId - User's MileIQ Subscription ID at time of event
   * @param {string} properties.page - The page or screen in app or on the web where the event sourced from.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/eTpvFjcqe}
   */
  function contactAddStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertSubscriptionId(properties.subscriptionId)
      );
      messages = messages.concat(assertPage(properties.page));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Contact Add Started",
          Object.keys(properties),
          [
            "platform",
            "organizationId",
            "organizationGroupId",
            "subscriptionId",
            "page",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "eTpvFjcqe",
          "904fd24d1f1240e15c78f3f092153b9bbe515279ef02b8f78c84a12765cc7490",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Contact Add Started",
        {
          Platform: properties.platform,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          subscription_id: properties.subscriptionId,
          Page: properties.page,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "eTpvFjcqe",
          "Contact Add Started",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            { id: "4j_Pu5zIMW", name: "Page", value: properties.page },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "TDTeQm2UP",
              name: "subscription_id",
              value: properties.subscriptionId,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Contact Add Started': " + messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Contact Add Started",
          {
            Platform: properties.platform,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            subscription_id: properties.subscriptionId,
            Page: properties.page,
          },
          "eTpvFjcqe",
          "904fd24d1f1240e15c78f3f092153b9bbe515279ef02b8f78c84a12765cc7490"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Contact Add Started", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        subscription_id: properties.subscriptionId,
        Page: properties.page,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Contact Add Started", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        subscription_id: properties.subscriptionId,
        Page: properties.page,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Contact Add Completed: Driver taps save checkmark to add their new contact from either the settings add a contact flow or when they are adding a contact from report creation.
   *
   * When to trigger this event:
   * 1. Triggers when "Add" is tapped on Add a contact modal after contact details have been filled out
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/WVljlsL7f/trigger/NR8dM7BR6
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {int} properties.subscriptionId - User's MileIQ Subscription ID at time of event
   * @param {string} properties.page - The page or screen in app or on the web where the event sourced from.
   * @param {string} properties.contactRelationship - User reported relationship between them and their saved contact. For example, Tax professional, Reimburser, Someone else.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/WVljlsL7f}
   */
  function contactAddCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertSubscriptionId(properties.subscriptionId)
      );
      messages = messages.concat(assertPage(properties.page));
      messages = messages.concat(
        assertContactRelationship(properties.contactRelationship)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Contact Add Completed",
          Object.keys(properties),
          [
            "platform",
            "organizationId",
            "organizationGroupId",
            "subscriptionId",
            "page",
            "contactRelationship",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "WVljlsL7f",
          "3ebe762fcffa1eb87f7ebb9e8d721f6db4fdee1db7615ce7e32ae57eafc5ee9e",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Contact Add Completed",
        {
          Platform: properties.platform,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          subscription_id: properties.subscriptionId,
          Page: properties.page,
          "Contact Relationship": properties.contactRelationship,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "WVljlsL7f",
          "Contact Add Completed",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            { id: "4j_Pu5zIMW", name: "Page", value: properties.page },
            {
              id: "8BiIah0U4",
              name: "Contact Relationship",
              value: properties.contactRelationship,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "TDTeQm2UP",
              name: "subscription_id",
              value: properties.subscriptionId,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Contact Add Completed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Contact Add Completed",
          {
            Platform: properties.platform,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            subscription_id: properties.subscriptionId,
            Page: properties.page,
            "Contact Relationship": properties.contactRelationship,
          },
          "WVljlsL7f",
          "3ebe762fcffa1eb87f7ebb9e8d721f6db4fdee1db7615ce7e32ae57eafc5ee9e"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Contact Add Completed", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        subscription_id: properties.subscriptionId,
        Page: properties.page,
        "Contact Relationship": properties.contactRelationship,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Contact Add Completed", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        subscription_id: properties.subscriptionId,
        Page: properties.page,
        "Contact Relationship": properties.contactRelationship,
      });

      // destination Braze
      Braze.logEvent("Contact Add Completed", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Subscription Type": properties.subscriptionId,
        Page: properties.page,
        "Contact Relationship": properties.contactRelationship,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Drives Summary Filtered: This event is sent when a user applies filters to narrow down the list of displayed Summary of Team Drives.
This may be triggered from the 'All drives' summary page or 'Drives to Approve' summary page, as well as their subpages.

   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/jcUD3xqmo7/trigger/nf9znu97j
   * 2.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/jcUD3xqmo7/trigger/moDJ3NGdA
   * 3.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/jcUD3xqmo7/trigger/l33KOvzQw
   * 4.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/jcUD3xqmo7/trigger/vCkeEBT6P
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {string} [properties.teamsPlanName] - Name of the Team's plan at time of event. If a team is not on a plan, do not send property.
   * @param {int} [properties.teamsPlanId] - Plan Type ID of the Team at time of event. If a team is not on a plan, do not send property.
   * @param {string} [properties.teamDrivesDateFilter] - Selected date filter for Team Drives.
   * @param {string} [properties.teamDrivesDriversFilter] - Selected driver(s) filter for Team Drives.



   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/jcUD3xqmo7}
   */
  function teamsDrivesSummaryFiltered(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanName(properties.teamsPlanName)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanID(properties.teamsPlanId)
      );
      messages = messages.concat(
        assertOptionalTeamDrivesDateFilter(properties.teamDrivesDateFilter)
      );
      messages = messages.concat(
        assertOptionalTeamDrivesDriversFilter(
          properties.teamDrivesDriversFilter
        )
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Drives Summary Filtered",
          Object.keys(properties),
          [
            "platform",
            "organizationId",
            "organizationGroupId",
            "teamsPlanName",
            "teamsPlanId",
            "teamDrivesDateFilter",
            "teamDrivesDriversFilter",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "jcUD3xqmo7",
          "5ea895919748c718289c9c66d68c042d298c16f4a9e41beea05b6a193a3280fa",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Drives Summary Filtered",
        {
          Platform: properties.platform,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          "Teams Plan Name": properties.teamsPlanName,
          "Teams Plan ID": properties.teamsPlanId,
          "Team Drives Date Filter": properties.teamDrivesDateFilter,
          "Team Drives Drivers Filter": properties.teamDrivesDriversFilter,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "jcUD3xqmo7",
          "Teams Drives Summary Filtered",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "125AY5RLNY",
              name: "Teams Plan Name",
              value: properties.teamsPlanName,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "Rx2HKmjkp",
              name: "Team Drives Drivers Filter",
              value: properties.teamDrivesDriversFilter,
            },
            {
              id: "TbSVW_o_GH",
              name: "Teams Plan ID",
              value: properties.teamsPlanId,
            },
            {
              id: "jv44-OJMO",
              name: "Team Drives Date Filter",
              value: properties.teamDrivesDateFilter,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Drives Summary Filtered': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Drives Summary Filtered",
          {
            Platform: properties.platform,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            "Teams Plan Name": properties.teamsPlanName,
            "Teams Plan ID": properties.teamsPlanId,
            "Team Drives Date Filter": properties.teamDrivesDateFilter,
            "Team Drives Drivers Filter": properties.teamDrivesDriversFilter,
          },
          "jcUD3xqmo7",
          "5ea895919748c718289c9c66d68c042d298c16f4a9e41beea05b6a193a3280fa"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Drives Summary Filtered", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan ID": properties.teamsPlanId,
        "Team Drives Date Filter": properties.teamDrivesDateFilter,
        "Team Drives Drivers Filter": properties.teamDrivesDriversFilter,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Drives Summary Filtered", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan ID": properties.teamsPlanId,
        "Team Drives Date Filter": properties.teamDrivesDateFilter,
        "Team Drives Drivers Filter": properties.teamDrivesDriversFilter,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Drives List Filtered: This event is sent when a user applies filters to narrow down the list of displayed Team Drives.
This may be triggered from the 'All drives' List page or 'Drives to Approve' List page.

   *
   * When to trigger this event:
   * 1. Date Filter
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/CWcP59hFJZ/trigger/hChrjUAO5
   * 2. Review Status Filter
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/CWcP59hFJZ/trigger/5QJZG_WAa
   * 3. Drive Type Filter
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/CWcP59hFJZ/trigger/8Rbq2XTYa
   * 4. Drives to approve page
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/CWcP59hFJZ/trigger/y6lu9p12t
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {string} [properties.teamsPlanName] - Name of the Team's plan at time of event. If a team is not on a plan, do not send property.
   * @param {int} [properties.teamsPlanId] - Plan Type ID of the Team at time of event. If a team is not on a plan, do not send property.
   * @param {string} [properties.teamDrivesDateFilter] - Selected date filter for Team Drives.
   * @param {string} properties.webPage - The page or screen on the web where the event sourced from
   * @param {string} [properties.reviewStatusFilter] - This is used to filter drives based on their current review status in the All Drives or Drive to approve pages.
   * @param {string} [properties.reviewDriveTypeFilter] - This is used to filter drives based on whether they were manually added or auto-detected in the All Drives or Drive to approve pages.
   * @param {string} [properties.teamDrivesDriversFilter] - Selected driver(s) filter for Team Drives.



   * @param {string} [properties.teamDrivesPurposeFilter] - This is used to filter drives based on purposes in the All Drives or Drive to approve pages.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/CWcP59hFJZ}
   */
  function teamsDrivesListFiltered(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanName(properties.teamsPlanName)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanID(properties.teamsPlanId)
      );
      messages = messages.concat(
        assertOptionalTeamDrivesDateFilter(properties.teamDrivesDateFilter)
      );
      messages = messages.concat(assertWebPage(properties.webPage));
      messages = messages.concat(
        assertOptionalReviewStatusFilter(properties.reviewStatusFilter)
      );
      messages = messages.concat(
        assertOptionalReviewDriveTypeFilter(properties.reviewDriveTypeFilter)
      );
      messages = messages.concat(
        assertOptionalTeamDrivesDriversFilter(
          properties.teamDrivesDriversFilter
        )
      );
      messages = messages.concat(
        assertOptionalTeamDrivesPurposeFilter(
          properties.teamDrivesPurposeFilter
        )
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Drives List Filtered",
          Object.keys(properties),
          [
            "platform",
            "organizationId",
            "organizationGroupId",
            "teamsPlanName",
            "teamsPlanId",
            "teamDrivesDateFilter",
            "webPage",
            "reviewStatusFilter",
            "reviewDriveTypeFilter",
            "teamDrivesDriversFilter",
            "teamDrivesPurposeFilter",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "CWcP59hFJZ",
          "ef498115c2b6d49e7d772ab466d703f3a77559676304ee91066b3bff853881e3",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Drives List Filtered",
        {
          Platform: properties.platform,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          "Teams Plan Name": properties.teamsPlanName,
          "Teams Plan ID": properties.teamsPlanId,
          "Team Drives Date Filter": properties.teamDrivesDateFilter,
          "Web Page": properties.webPage,
          "Review Status Filter": properties.reviewStatusFilter,
          "Review Drive Type Filter": properties.reviewDriveTypeFilter,
          "Team Drives Drivers Filter": properties.teamDrivesDriversFilter,
          "Team Drives Purpose Filter": properties.teamDrivesPurposeFilter,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "CWcP59hFJZ",
          "Teams Drives List Filtered",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "125AY5RLNY",
              name: "Teams Plan Name",
              value: properties.teamsPlanName,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            { id: "MZLkJ3Cmi", name: "Web Page", value: properties.webPage },
            {
              id: "Rx2HKmjkp",
              name: "Team Drives Drivers Filter",
              value: properties.teamDrivesDriversFilter,
            },
            {
              id: "TbSVW_o_GH",
              name: "Teams Plan ID",
              value: properties.teamsPlanId,
            },
            {
              id: "Vz1F0wsyf",
              name: "Review Drive Type Filter",
              value: properties.reviewDriveTypeFilter,
            },
            {
              id: "bcKD803TJ",
              name: "Review Status Filter",
              value: properties.reviewStatusFilter,
            },
            {
              id: "jv44-OJMO",
              name: "Team Drives Date Filter",
              value: properties.teamDrivesDateFilter,
            },
            {
              id: "rEaF8yiKv",
              name: "Team Drives Purpose Filter",
              value: properties.teamDrivesPurposeFilter,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Drives List Filtered': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Drives List Filtered",
          {
            Platform: properties.platform,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            "Teams Plan Name": properties.teamsPlanName,
            "Teams Plan ID": properties.teamsPlanId,
            "Team Drives Date Filter": properties.teamDrivesDateFilter,
            "Web Page": properties.webPage,
            "Review Status Filter": properties.reviewStatusFilter,
            "Review Drive Type Filter": properties.reviewDriveTypeFilter,
            "Team Drives Drivers Filter": properties.teamDrivesDriversFilter,
            "Team Drives Purpose Filter": properties.teamDrivesPurposeFilter,
          },
          "CWcP59hFJZ",
          "ef498115c2b6d49e7d772ab466d703f3a77559676304ee91066b3bff853881e3"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Drives List Filtered", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan ID": properties.teamsPlanId,
        "Team Drives Date Filter": properties.teamDrivesDateFilter,
        "Web Page": properties.webPage,
        "Review Status Filter": properties.reviewStatusFilter,
        "Review Drive Type Filter": properties.reviewDriveTypeFilter,
        "Team Drives Drivers Filter": properties.teamDrivesDriversFilter,
        "Team Drives Purpose Filter": properties.teamDrivesPurposeFilter,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Drives List Filtered", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan ID": properties.teamsPlanId,
        "Team Drives Date Filter": properties.teamDrivesDateFilter,
        "Web Page": properties.webPage,
        "Review Status Filter": properties.reviewStatusFilter,
        "Review Drive Type Filter": properties.reviewDriveTypeFilter,
        "Team Drives Drivers Filter": properties.teamDrivesDriversFilter,
        "Team Drives Purpose Filter": properties.teamDrivesPurposeFilter,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Drives List Opened: This event is triggered when a user accesses the list of Team Drives. It can be either a list of all drivers' drives, or a specific driver's drives.
This may be triggered from the 'All drives' page as well as 'Drives to approve' page.
   *
   * When to trigger this event:
   * 1. All drives - All members
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/Aqe0EwkFyw/trigger/_tzp-W2bQ
   * 2. All drives
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/Aqe0EwkFyw/trigger/JxnlITTTP
   * 3. Drive to approve
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/Aqe0EwkFyw/trigger/4DBbrCmgx
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {int} [properties.teamsPlanId] - Plan Type ID of the Team at time of event. If a team is not on a plan, do not send property.
   * @param {string} [properties.teamsPlanName] - Name of the Team's plan at time of event. If a team is not on a plan, do not send property.
   * @param {bool} properties.allDrivers - Specify if all drivers were selected, or a specific one.
   * @param {string} properties.webPage - The page or screen on the web where the event sourced from
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/Aqe0EwkFyw}
   */
  function teamsDrivesListOpened(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanID(properties.teamsPlanId)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanName(properties.teamsPlanName)
      );
      messages = messages.concat(assertAllDrivers(properties.allDrivers));
      messages = messages.concat(assertWebPage(properties.webPage));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Drives List Opened",
          Object.keys(properties),
          [
            "platform",
            "organizationId",
            "organizationGroupId",
            "teamsPlanId",
            "teamsPlanName",
            "allDrivers",
            "webPage",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "Aqe0EwkFyw",
          "aab65fc6db85d1e857dc9e5c89d3fb70a6edfe99fa5ed7a456250f11f4d887fb",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Drives List Opened",
        {
          Platform: properties.platform,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          "Teams Plan ID": properties.teamsPlanId,
          "Teams Plan Name": properties.teamsPlanName,
          "All Drivers": properties.allDrivers,
          "Web Page": properties.webPage,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "Aqe0EwkFyw",
          "Teams Drives List Opened",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "125AY5RLNY",
              name: "Teams Plan Name",
              value: properties.teamsPlanName,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            {
              id: "EdylnfTLU",
              name: "All Drivers",
              value: properties.allDrivers,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            { id: "MZLkJ3Cmi", name: "Web Page", value: properties.webPage },
            {
              id: "TbSVW_o_GH",
              name: "Teams Plan ID",
              value: properties.teamsPlanId,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Drives List Opened': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Drives List Opened",
          {
            Platform: properties.platform,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            "Teams Plan ID": properties.teamsPlanId,
            "Teams Plan Name": properties.teamsPlanName,
            "All Drivers": properties.allDrivers,
            "Web Page": properties.webPage,
          },
          "Aqe0EwkFyw",
          "aab65fc6db85d1e857dc9e5c89d3fb70a6edfe99fa5ed7a456250f11f4d887fb"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Drives List Opened", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        "All Drivers": properties.allDrivers,
        "Web Page": properties.webPage,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Drives List Opened", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan ID": properties.teamsPlanId,
        "Teams Plan Name": properties.teamsPlanName,
        "All Drivers": properties.allDrivers,
        "Web Page": properties.webPage,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Drive Selected: This event occurs when a user selects a specific Team Drive from a list. It captures the moment of selection, signaling interest or intent to interact with the content of a particular Team Drive.
This action may be taken from either the All drives page or the Drives to approve page.

   *
   * When to trigger this event:
   * 1. From All drives page
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/lJHIXXr6Mr/trigger/6ZTnlr8BW
   * 2. From Drives to Approve page
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/lJHIXXr6Mr/trigger/fCxKLHFWn
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {string} [properties.teamsPlanName] - Name of the Team's plan at time of event. If a team is not on a plan, do not send property.
   * @param {int} [properties.teamsPlanId] - Plan Type ID of the Team at time of event. If a team is not on a plan, do not send property.
   * @param {string} properties.webPage - The page or screen on the web where the event sourced from
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/lJHIXXr6Mr}
   */
  function teamsDriveSelected(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanName(properties.teamsPlanName)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanID(properties.teamsPlanId)
      );
      messages = messages.concat(assertWebPage(properties.webPage));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Drive Selected",
          Object.keys(properties),
          [
            "platform",
            "organizationId",
            "organizationGroupId",
            "teamsPlanName",
            "teamsPlanId",
            "webPage",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "lJHIXXr6Mr",
          "27b319df1bd80cdaae76a8aa89418904561fa0a4b423678b79e02679d3838100",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Drive Selected",
        {
          Platform: properties.platform,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          "Teams Plan Name": properties.teamsPlanName,
          "Teams Plan ID": properties.teamsPlanId,
          "Web Page": properties.webPage,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "lJHIXXr6Mr",
          "Teams Drive Selected",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "125AY5RLNY",
              name: "Teams Plan Name",
              value: properties.teamsPlanName,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            { id: "MZLkJ3Cmi", name: "Web Page", value: properties.webPage },
            {
              id: "TbSVW_o_GH",
              name: "Teams Plan ID",
              value: properties.teamsPlanId,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Drive Selected': " + messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Drive Selected",
          {
            Platform: properties.platform,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            "Teams Plan Name": properties.teamsPlanName,
            "Teams Plan ID": properties.teamsPlanId,
            "Web Page": properties.webPage,
          },
          "lJHIXXr6Mr",
          "27b319df1bd80cdaae76a8aa89418904561fa0a4b423678b79e02679d3838100"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Drive Selected", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan ID": properties.teamsPlanId,
        "Web Page": properties.webPage,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Drive Selected", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan ID": properties.teamsPlanId,
        "Web Page": properties.webPage,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Drives Export Started: This event is initiated when a user starts the export process for data from Team Drives. It occurs at the moment the user clicks on the export CTA, tracking the beginning of data extraction processes from Team Drives, regardless of the export's scope.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/FuycMyx9wB/trigger/2tIp1wRzn
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {string} [properties.teamsPlanName] - Name of the Team's plan at time of event. If a team is not on a plan, do not send property.
   * @param {int} [properties.teamsPlanId] - Plan Type ID of the Team at time of event. If a team is not on a plan, do not send property.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/FuycMyx9wB}
   */
  function teamsDrivesExportStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanName(properties.teamsPlanName)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanID(properties.teamsPlanId)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Drives Export Started",
          Object.keys(properties),
          [
            "platform",
            "organizationId",
            "organizationGroupId",
            "teamsPlanName",
            "teamsPlanId",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "FuycMyx9wB",
          "d727f9665aa6dc8e13457c9d54d29d322610572a4f728d0d2957634329e3e3ef",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Drives Export Started",
        {
          Platform: properties.platform,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          "Teams Plan Name": properties.teamsPlanName,
          "Teams Plan ID": properties.teamsPlanId,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "FuycMyx9wB",
          "Teams Drives Export Started",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "125AY5RLNY",
              name: "Teams Plan Name",
              value: properties.teamsPlanName,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "TbSVW_o_GH",
              name: "Teams Plan ID",
              value: properties.teamsPlanId,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Drives Export Started': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Drives Export Started",
          {
            Platform: properties.platform,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            "Teams Plan Name": properties.teamsPlanName,
            "Teams Plan ID": properties.teamsPlanId,
          },
          "FuycMyx9wB",
          "d727f9665aa6dc8e13457c9d54d29d322610572a4f728d0d2957634329e3e3ef"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Drives Export Started", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan ID": properties.teamsPlanId,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Drives Export Started", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan ID": properties.teamsPlanId,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Drives Export Completed: This event is recorded when the export process of Team Drives data successfully completes. It marks the successful end of data extraction, capturing the moment when the user starts to download a file, enhanced by download formats (PDF, CSV) and number of drivers that the export contains.

   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/Oqm0_zgCdL/trigger/nM-DKZnbn
   * 2.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/Oqm0_zgCdL/trigger/U2jlfaVoD
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {string} [properties.teamsPlanName] - Name of the Team's plan at time of event. If a team is not on a plan, do not send property.
   * @param {int} [properties.teamsPlanId] - Plan Type ID of the Team at time of event. If a team is not on a plan, do not send property.
   * @param {string} properties.downloadFormat - File format of a report download
   * @param {int} [properties.exportedDriverCount] - Number of drivers present in the export operation.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/Oqm0_zgCdL}
   */
  function teamsDrivesExportCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanName(properties.teamsPlanName)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanID(properties.teamsPlanId)
      );
      messages = messages.concat(
        assertDownloadFormat(properties.downloadFormat)
      );
      messages = messages.concat(
        assertOptionalExportedDriverCount(properties.exportedDriverCount)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Drives Export Completed",
          Object.keys(properties),
          [
            "platform",
            "organizationId",
            "organizationGroupId",
            "teamsPlanName",
            "teamsPlanId",
            "downloadFormat",
            "exportedDriverCount",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "Oqm0_zgCdL",
          "af0aa60e0f76d7ba05bed01d3441745a18d1dbb9bfcfee512df86169e24cb8d6",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Drives Export Completed",
        {
          Platform: properties.platform,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          "Teams Plan Name": properties.teamsPlanName,
          "Teams Plan ID": properties.teamsPlanId,
          "Download Format": properties.downloadFormat,
          "Exported Driver Count": properties.exportedDriverCount,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "Oqm0_zgCdL",
          "Teams Drives Export Completed",
          messages,
          [
            {
              id: "-PkiBW72m",
              name: "Download Format",
              value: properties.downloadFormat,
            },
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "125AY5RLNY",
              name: "Teams Plan Name",
              value: properties.teamsPlanName,
            },
            {
              id: "1vX-ssoiI",
              name: "Exported Driver Count",
              value: properties.exportedDriverCount,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "TbSVW_o_GH",
              name: "Teams Plan ID",
              value: properties.teamsPlanId,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Drives Export Completed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Drives Export Completed",
          {
            Platform: properties.platform,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            "Teams Plan Name": properties.teamsPlanName,
            "Teams Plan ID": properties.teamsPlanId,
            "Download Format": properties.downloadFormat,
            "Exported Driver Count": properties.exportedDriverCount,
          },
          "Oqm0_zgCdL",
          "af0aa60e0f76d7ba05bed01d3441745a18d1dbb9bfcfee512df86169e24cb8d6"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Drives Export Completed", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan ID": properties.teamsPlanId,
        "Download Format": properties.downloadFormat,
        "Exported Driver Count": properties.exportedDriverCount,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Drives Export Completed", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan ID": properties.teamsPlanId,
        "Download Format": properties.downloadFormat,
        "Exported Driver Count": properties.exportedDriverCount,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Exclude Commute Enabled: Turning the toggle on in teams dashboard settings to exclude commute mileage.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/1XaDRT9hjG/trigger/wHEP7kxpM
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.userId_ - The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {int} [properties.teamsPlanId] - Plan Type ID of the Team at time of event. If a team is not on a plan, do not send property.
   * @param {bool} properties.freeTrial - Indicates whether the event is associated with a free trial plan.
   * @param {string} properties.country - Country identifier for user or team
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {bool} [properties.commuteMileageEnabled] - User Property for commute milage setting being enabled or not.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/1XaDRT9hjG}
   */
  function excludeCommuteEnabled(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertUserId_(properties.userId_));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalTeamsPlanID(properties.teamsPlanId)
      );
      messages = messages.concat(assertFreeTrial(properties.freeTrial));
      messages = messages.concat(assertCountry(properties.country));
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalCommuteMileageEnabled(properties.commuteMileageEnabled)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Exclude Commute Enabled",
          Object.keys(properties),
          [
            "userId_",
            "platform",
            "teamsPlanId",
            "freeTrial",
            "country",
            "organizationId",
            "commuteMileageEnabled",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "1XaDRT9hjG",
          "1ea668855c14937670af53ad4e2885dae3a4cf43d88e9dc045247c24ad0d64a9",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Exclude Commute Enabled",
        {
          Platform: properties.platform,
          "Teams Plan ID": properties.teamsPlanId,
          "Free Trial": properties.freeTrial,
          Country: properties.country,
          "Organization ID": properties.organizationId,
        },
        {
          "Commute Mileage Enabled": properties.commuteMileageEnabled,
        },
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "1XaDRT9hjG",
          "Exclude Commute Enabled",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "TbSVW_o_GH",
              name: "Teams Plan ID",
              value: properties.teamsPlanId,
            },
            {
              id: "dVaX1T1uG",
              name: "Free Trial",
              value: properties.freeTrial,
            },
            { id: "p0_feuKMRI", name: "Country", value: properties.country },
          ],
          [
            {
              id: "eIcjynGHp",
              name: "Commute Mileage Enabled",
              value: properties.commuteMileageEnabled,
            },
          ],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Exclude Commute Enabled': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Exclude Commute Enabled",
          {
            Platform: properties.platform,
            "Teams Plan ID": properties.teamsPlanId,
            "Free Trial": properties.freeTrial,
            Country: properties.country,
            "Organization ID": properties.organizationId,
          },
          "1XaDRT9hjG",
          "1ea668855c14937670af53ad4e2885dae3a4cf43d88e9dc045247c24ad0d64a9"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.setUserProperties(properties.userId_, {
        "Commute Mileage Enabled": properties.commuteMileageEnabled,
      });
      RudderStackWebDashboard.logEvent("Exclude Commute Enabled", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Free Trial": properties.freeTrial,
        Country: properties.country,
        "Organization ID": properties.organizationId,
      });

      // destination Mixpanel
      Mixpanel.setUserProperties(properties.userId_, {
        "Commute Mileage Enabled": properties.commuteMileageEnabled,
      });
      Mixpanel.logEvent("Exclude Commute Enabled", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Free Trial": properties.freeTrial,
        Country: properties.country,
        "Organization ID": properties.organizationId,
      });

      // destination Braze
      Braze.setUserProperties(properties.userId_, {
        "Commute Mileage Enabled": properties.commuteMileageEnabled,
      });
      Braze.logEvent("Exclude Commute Enabled", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Free Trial": properties.freeTrial,
        Country: properties.country,
        "Organization ID": properties.organizationId,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Exclude Commute Disabled: Turning the toggle off in teams dashboard settings to exclude commute mileage.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/_eo1s_3le/trigger/NHFhS8pfP
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.userId_ - The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {int} [properties.teamsPlanId] - Plan Type ID of the Team at time of event. If a team is not on a plan, do not send property.
   * @param {bool} properties.freeTrial - Indicates whether the event is associated with a free trial plan.
   * @param {string} properties.country - Country identifier for user or team
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {bool} [properties.commuteMileageEnabled] - User Property for commute milage setting being enabled or not.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/_eo1s_3le}
   */
  function excludeCommuteDisabled(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertUserId_(properties.userId_));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalTeamsPlanID(properties.teamsPlanId)
      );
      messages = messages.concat(assertFreeTrial(properties.freeTrial));
      messages = messages.concat(assertCountry(properties.country));
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalCommuteMileageEnabled(properties.commuteMileageEnabled)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Exclude Commute Disabled",
          Object.keys(properties),
          [
            "userId_",
            "platform",
            "teamsPlanId",
            "freeTrial",
            "country",
            "organizationId",
            "commuteMileageEnabled",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "_eo1s_3le",
          "40243be330e4ec3aa6fdf1ff463c09a1ad97a5787ecfd2df45b51aa523e99ad9",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Exclude Commute Disabled",
        {
          Platform: properties.platform,
          "Teams Plan ID": properties.teamsPlanId,
          "Free Trial": properties.freeTrial,
          Country: properties.country,
          "Organization ID": properties.organizationId,
        },
        {
          "Commute Mileage Enabled": properties.commuteMileageEnabled,
        },
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "_eo1s_3le",
          "Exclude Commute Disabled",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "TbSVW_o_GH",
              name: "Teams Plan ID",
              value: properties.teamsPlanId,
            },
            {
              id: "dVaX1T1uG",
              name: "Free Trial",
              value: properties.freeTrial,
            },
            { id: "p0_feuKMRI", name: "Country", value: properties.country },
          ],
          [
            {
              id: "eIcjynGHp",
              name: "Commute Mileage Enabled",
              value: properties.commuteMileageEnabled,
            },
          ],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Exclude Commute Disabled': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Exclude Commute Disabled",
          {
            Platform: properties.platform,
            "Teams Plan ID": properties.teamsPlanId,
            "Free Trial": properties.freeTrial,
            Country: properties.country,
            "Organization ID": properties.organizationId,
          },
          "_eo1s_3le",
          "40243be330e4ec3aa6fdf1ff463c09a1ad97a5787ecfd2df45b51aa523e99ad9"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.setUserProperties(properties.userId_, {
        "Commute Mileage Enabled": properties.commuteMileageEnabled,
      });
      RudderStackWebDashboard.logEvent("Exclude Commute Disabled", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Free Trial": properties.freeTrial,
        Country: properties.country,
        "Organization ID": properties.organizationId,
      });

      // destination Mixpanel
      Mixpanel.setUserProperties(properties.userId_, {
        "Commute Mileage Enabled": properties.commuteMileageEnabled,
      });
      Mixpanel.logEvent("Exclude Commute Disabled", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Free Trial": properties.freeTrial,
        Country: properties.country,
        "Organization ID": properties.organizationId,
      });

      // destination Braze
      Braze.setUserProperties(properties.userId_, {
        "Commute Mileage Enabled": properties.commuteMileageEnabled,
      });
      Braze.logEvent("Exclude Commute Disabled", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Free Trial": properties.freeTrial,
        Country: properties.country,
        "Organization ID": properties.organizationId,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Exclude Commute Settings Update Started: Edit the commute mileage value in teams dashboard settings.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/9YKy0lLYa/trigger/7wzGAT1hD
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {int} [properties.teamsPlanId] - Plan Type ID of the Team at time of event. If a team is not on a plan, do not send property.
   * @param {bool} properties.freeTrial - Indicates whether the event is associated with a free trial plan.
   * @param {string} properties.country - Country identifier for user or team
   * @param {string} [properties.organizationId] - Team's Organization ID
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/9YKy0lLYa}
   */
  function excludeCommuteSettingsUpdateStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalTeamsPlanID(properties.teamsPlanId)
      );
      messages = messages.concat(assertFreeTrial(properties.freeTrial));
      messages = messages.concat(assertCountry(properties.country));
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Exclude Commute Settings Update Started",
          Object.keys(properties),
          ["platform", "teamsPlanId", "freeTrial", "country", "organizationId"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "9YKy0lLYa",
          "5a7a5e3dd2da22d52c279bc33160d628ed6622d3a4d90357e3b95c3683d1dc31",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Exclude Commute Settings Update Started",
        {
          Platform: properties.platform,
          "Teams Plan ID": properties.teamsPlanId,
          "Free Trial": properties.freeTrial,
          Country: properties.country,
          "Organization ID": properties.organizationId,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "9YKy0lLYa",
          "Exclude Commute Settings Update Started",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "TbSVW_o_GH",
              name: "Teams Plan ID",
              value: properties.teamsPlanId,
            },
            {
              id: "dVaX1T1uG",
              name: "Free Trial",
              value: properties.freeTrial,
            },
            { id: "p0_feuKMRI", name: "Country", value: properties.country },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Exclude Commute Settings Update Started': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Exclude Commute Settings Update Started",
          {
            Platform: properties.platform,
            "Teams Plan ID": properties.teamsPlanId,
            "Free Trial": properties.freeTrial,
            Country: properties.country,
            "Organization ID": properties.organizationId,
          },
          "9YKy0lLYa",
          "5a7a5e3dd2da22d52c279bc33160d628ed6622d3a4d90357e3b95c3683d1dc31"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent(
        "Exclude Commute Settings Update Started",
        {
          Platform: properties.platform,
          "Teams Plan ID": properties.teamsPlanId,
          "Free Trial": properties.freeTrial,
          Country: properties.country,
          "Organization ID": properties.organizationId,
        }
      );

      // destination Mixpanel
      Mixpanel.logEvent("Exclude Commute Settings Update Started", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Free Trial": properties.freeTrial,
        Country: properties.country,
        "Organization ID": properties.organizationId,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Exclude Commute Settings Update Completed: Edit the commute mileage value in teams dashboard settings and it succeeds.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/6DOUdoUPp/trigger/OXXfek4oB
   * 2. success message
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/6DOUdoUPp/trigger/zPil47Q7V
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {int} [properties.teamsPlanId] - Plan Type ID of the Team at time of event. If a team is not on a plan, do not send property.
   * @param {bool} properties.freeTrial - Indicates whether the event is associated with a free trial plan.
   * @param {string} properties.country - Country identifier for user or team
   * @param {string} [properties.organizationId] - Team's Organization ID
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/6DOUdoUPp}
   */
  function excludeCommuteSettingsUpdateCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalTeamsPlanID(properties.teamsPlanId)
      );
      messages = messages.concat(assertFreeTrial(properties.freeTrial));
      messages = messages.concat(assertCountry(properties.country));
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Exclude Commute Settings Update Completed",
          Object.keys(properties),
          ["platform", "teamsPlanId", "freeTrial", "country", "organizationId"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "6DOUdoUPp",
          "174acf1edbed26d1d0da695b5308137d8a3e3eea46b0321be6a9d6609ad1a272",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Exclude Commute Settings Update Completed",
        {
          Platform: properties.platform,
          "Teams Plan ID": properties.teamsPlanId,
          "Free Trial": properties.freeTrial,
          Country: properties.country,
          "Organization ID": properties.organizationId,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "6DOUdoUPp",
          "Exclude Commute Settings Update Completed",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "TbSVW_o_GH",
              name: "Teams Plan ID",
              value: properties.teamsPlanId,
            },
            {
              id: "dVaX1T1uG",
              name: "Free Trial",
              value: properties.freeTrial,
            },
            { id: "p0_feuKMRI", name: "Country", value: properties.country },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Exclude Commute Settings Update Completed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Exclude Commute Settings Update Completed",
          {
            Platform: properties.platform,
            "Teams Plan ID": properties.teamsPlanId,
            "Free Trial": properties.freeTrial,
            Country: properties.country,
            "Organization ID": properties.organizationId,
          },
          "6DOUdoUPp",
          "174acf1edbed26d1d0da695b5308137d8a3e3eea46b0321be6a9d6609ad1a272"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent(
        "Exclude Commute Settings Update Completed",
        {
          Platform: properties.platform,
          "Teams Plan ID": properties.teamsPlanId,
          "Free Trial": properties.freeTrial,
          Country: properties.country,
          "Organization ID": properties.organizationId,
        }
      );

      // destination Mixpanel
      Mixpanel.logEvent("Exclude Commute Settings Update Completed", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Free Trial": properties.freeTrial,
        Country: properties.country,
        "Organization ID": properties.organizationId,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Exclude Commute Settings Update Failed: Edit the commute mileage value in teams dashboard settings and it fails to update.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/qXqJ9-40W/trigger/48sKy8hqiU
   * 2. failure toast
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/qXqJ9-40W/trigger/pJBycG9jn
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {int} [properties.teamsPlanId] - Plan Type ID of the Team at time of event. If a team is not on a plan, do not send property.
   * @param {bool} properties.freeTrial - Indicates whether the event is associated with a free trial plan.
   * @param {string} properties.country - Country identifier for user or team
   * @param {string} [properties.organizationId] - Team's Organization ID
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/qXqJ9-40W}
   */
  function excludeCommuteSettingsUpdateFailed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalTeamsPlanID(properties.teamsPlanId)
      );
      messages = messages.concat(assertFreeTrial(properties.freeTrial));
      messages = messages.concat(assertCountry(properties.country));
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Exclude Commute Settings Update Failed",
          Object.keys(properties),
          ["platform", "teamsPlanId", "freeTrial", "country", "organizationId"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "qXqJ9-40W",
          "e830010a263860f701531ca4f1e08391a90d52f54e80ed27039f9c09732771d2",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Exclude Commute Settings Update Failed",
        {
          Platform: properties.platform,
          "Teams Plan ID": properties.teamsPlanId,
          "Free Trial": properties.freeTrial,
          Country: properties.country,
          "Organization ID": properties.organizationId,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "qXqJ9-40W",
          "Exclude Commute Settings Update Failed",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "TbSVW_o_GH",
              name: "Teams Plan ID",
              value: properties.teamsPlanId,
            },
            {
              id: "dVaX1T1uG",
              name: "Free Trial",
              value: properties.freeTrial,
            },
            { id: "p0_feuKMRI", name: "Country", value: properties.country },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Exclude Commute Settings Update Failed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Exclude Commute Settings Update Failed",
          {
            Platform: properties.platform,
            "Teams Plan ID": properties.teamsPlanId,
            "Free Trial": properties.freeTrial,
            Country: properties.country,
            "Organization ID": properties.organizationId,
          },
          "qXqJ9-40W",
          "e830010a263860f701531ca4f1e08391a90d52f54e80ed27039f9c09732771d2"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent(
        "Exclude Commute Settings Update Failed",
        {
          Platform: properties.platform,
          "Teams Plan ID": properties.teamsPlanId,
          "Free Trial": properties.freeTrial,
          Country: properties.country,
          "Organization ID": properties.organizationId,
        }
      );

      // destination Mixpanel
      Mixpanel.logEvent("Exclude Commute Settings Update Failed", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Free Trial": properties.freeTrial,
        Country: properties.country,
        "Organization ID": properties.organizationId,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Drive Review Completed: This event occurs when an admin successfully reviews a drive (or multiple drives) and assigns it a status from the Drives to approve page.

   *
   * When to trigger this event:
   * 1. Quick approve
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/7hxGfeCdF/trigger/CYDpu4LXI
   * 2.  Bulk approve/reject multiple drives
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/7hxGfeCdF/trigger/dakV_XvWC
   * 3. Single drive review
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/7hxGfeCdF/trigger/jW9Z_1vzN
   * 4. Single drive review from drive details sidebar
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/7hxGfeCdF/trigger/6Z3h3WYO2
   * 5. From the All drives page
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/7hxGfeCdF/trigger/wxE3T3y91
   * 6. Bulk update from All drives page
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/7hxGfeCdF/trigger/Q61XfOc8B
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {string} [properties.teamsPlanName] - Name of the Team's plan at time of event. If a team is not on a plan, do not send property.
   * @param {int} [properties.teamsPlanId] - Plan Type ID of the Team at time of event. If a team is not on a plan, do not send property.
   * @param {int} properties.driveCount - Number of drives
   * @param {string} properties.reviewAction - The action taken when reviewing drives
   * @param {string} properties.webPage - The page or screen on the web where the event sourced from
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/7hxGfeCdF}
   */
  function teamsDriveReviewCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanName(properties.teamsPlanName)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanID(properties.teamsPlanId)
      );
      messages = messages.concat(assertDriveCount(properties.driveCount));
      messages = messages.concat(assertReviewAction(properties.reviewAction));
      messages = messages.concat(assertWebPage(properties.webPage));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Drive Review Completed",
          Object.keys(properties),
          [
            "platform",
            "organizationId",
            "organizationGroupId",
            "teamsPlanName",
            "teamsPlanId",
            "driveCount",
            "reviewAction",
            "webPage",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "7hxGfeCdF",
          "694505261db30ac9ff69e0399570242cb96d5814724a285f68e826880f7ac812",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Drive Review Completed",
        {
          Platform: properties.platform,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          "Teams Plan Name": properties.teamsPlanName,
          "Teams Plan ID": properties.teamsPlanId,
          "Drive Count": properties.driveCount,
          "Review Action": properties.reviewAction,
          "Web Page": properties.webPage,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "7hxGfeCdF",
          "Teams Drive Review Completed",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "125AY5RLNY",
              name: "Teams Plan Name",
              value: properties.teamsPlanName,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            {
              id: "FWTawJHUN",
              name: "Review Action",
              value: properties.reviewAction,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "JDI2RsZke",
              name: "Drive Count",
              value: properties.driveCount,
            },
            { id: "MZLkJ3Cmi", name: "Web Page", value: properties.webPage },
            {
              id: "TbSVW_o_GH",
              name: "Teams Plan ID",
              value: properties.teamsPlanId,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Drive Review Completed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Drive Review Completed",
          {
            Platform: properties.platform,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            "Teams Plan Name": properties.teamsPlanName,
            "Teams Plan ID": properties.teamsPlanId,
            "Drive Count": properties.driveCount,
            "Review Action": properties.reviewAction,
            "Web Page": properties.webPage,
          },
          "7hxGfeCdF",
          "694505261db30ac9ff69e0399570242cb96d5814724a285f68e826880f7ac812"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Drive Review Completed", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan ID": properties.teamsPlanId,
        "Drive Count": properties.driveCount,
        "Review Action": properties.reviewAction,
        "Web Page": properties.webPage,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Drive Review Completed", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan ID": properties.teamsPlanId,
        "Drive Count": properties.driveCount,
        "Review Action": properties.reviewAction,
        "Web Page": properties.webPage,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Drive Review CTA Selected: This event occurs after an admin completes reviewing a drive (or drives) of a driver from the Drives to approve page. Following the review, the admin may choose to take the next action from displayed CTAs.

   *
   * When to trigger this event:
   * 1. All drives
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/hyu0WsmFt/trigger/mJRN3WZLF
   * 2. Continue Reviewing
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/hyu0WsmFt/trigger/7bYfTEwp8
   * 3. Undo
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/hyu0WsmFt/trigger/SOL3JRvHE
   * 4. Undo - single drive
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/hyu0WsmFt/trigger/B8VmDCxRr
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {string} [properties.teamsPlanName] - Name of the Team's plan at time of event. If a team is not on a plan, do not send property.
   * @param {int} [properties.teamsPlanId] - Plan Type ID of the Team at time of event. If a team is not on a plan, do not send property.
   * @param {string} properties.driveReviewCta - The CTA options the admin may select after completing reviewing a driver's drives.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/hyu0WsmFt}
   */
  function teamsDriveReviewCtaSelected(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanName(properties.teamsPlanName)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanID(properties.teamsPlanId)
      );
      messages = messages.concat(
        assertDriveReviewCTA(properties.driveReviewCta)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Drive Review CTA Selected",
          Object.keys(properties),
          [
            "platform",
            "organizationId",
            "organizationGroupId",
            "teamsPlanName",
            "teamsPlanId",
            "driveReviewCta",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "hyu0WsmFt",
          "a6f80f2fdf0a6c03f79682a589e2f456bc73fd129c596b2acdf63abcf55953a2",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Drive Review CTA Selected",
        {
          Platform: properties.platform,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          "Teams Plan Name": properties.teamsPlanName,
          "Teams Plan ID": properties.teamsPlanId,
          "Drive Review CTA": properties.driveReviewCta,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "hyu0WsmFt",
          "Teams Drive Review CTA Selected",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "125AY5RLNY",
              name: "Teams Plan Name",
              value: properties.teamsPlanName,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "TbSVW_o_GH",
              name: "Teams Plan ID",
              value: properties.teamsPlanId,
            },
            {
              id: "evNSdcoS7",
              name: "Drive Review CTA",
              value: properties.driveReviewCta,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Drive Review CTA Selected': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Drive Review CTA Selected",
          {
            Platform: properties.platform,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            "Teams Plan Name": properties.teamsPlanName,
            "Teams Plan ID": properties.teamsPlanId,
            "Drive Review CTA": properties.driveReviewCta,
          },
          "hyu0WsmFt",
          "a6f80f2fdf0a6c03f79682a589e2f456bc73fd129c596b2acdf63abcf55953a2"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Drive Review CTA Selected", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan ID": properties.teamsPlanId,
        "Drive Review CTA": properties.driveReviewCta,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Drive Review CTA Selected", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan ID": properties.teamsPlanId,
        "Drive Review CTA": properties.driveReviewCta,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Drive Review All Selected: This event occurs when an admin clicks on "Select all # across pages" while reviewing drives from the Drives to approve page.

   *
   * When to trigger this event:
   * 1. From Drives to approve page
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/nWSUyizp_/trigger/dhT-d1qOh
   * 2. From All drives page
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/nWSUyizp_/trigger/4-dJWi7QL
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {string} [properties.teamsPlanName] - Name of the Team's plan at time of event. If a team is not on a plan, do not send property.
   * @param {int} [properties.teamsPlanId] - Plan Type ID of the Team at time of event. If a team is not on a plan, do not send property.
   * @param {int} properties.driveCount - Number of drives
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/nWSUyizp_}
   */
  function teamsDriveReviewAllSelected(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanName(properties.teamsPlanName)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanID(properties.teamsPlanId)
      );
      messages = messages.concat(assertDriveCount(properties.driveCount));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Drive Review All Selected",
          Object.keys(properties),
          [
            "platform",
            "organizationId",
            "organizationGroupId",
            "teamsPlanName",
            "teamsPlanId",
            "driveCount",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "nWSUyizp_",
          "313232b4672618dee78e40877ca0a8d5a668047cc4b89552ebb00f865e25ca7d",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Drive Review All Selected",
        {
          Platform: properties.platform,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          "Teams Plan Name": properties.teamsPlanName,
          "Teams Plan ID": properties.teamsPlanId,
          "Drive Count": properties.driveCount,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "nWSUyizp_",
          "Teams Drive Review All Selected",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "125AY5RLNY",
              name: "Teams Plan Name",
              value: properties.teamsPlanName,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "JDI2RsZke",
              name: "Drive Count",
              value: properties.driveCount,
            },
            {
              id: "TbSVW_o_GH",
              name: "Teams Plan ID",
              value: properties.teamsPlanId,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Drive Review All Selected': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Drive Review All Selected",
          {
            Platform: properties.platform,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            "Teams Plan Name": properties.teamsPlanName,
            "Teams Plan ID": properties.teamsPlanId,
            "Drive Count": properties.driveCount,
          },
          "nWSUyizp_",
          "313232b4672618dee78e40877ca0a8d5a668047cc4b89552ebb00f865e25ca7d"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Drive Review All Selected", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan ID": properties.teamsPlanId,
        "Drive Count": properties.driveCount,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Drive Review All Selected", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan ID": properties.teamsPlanId,
        "Drive Count": properties.driveCount,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Drive Review Failed: This event occurs when an admin receives an error when reviewing a drive (or multiple drives). Failure may occur from any of these triggers.

   *
   * When to trigger this event:
   * 1. Quick approve
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/j4w87HTyB/trigger/SeyIfTN-IE
   * 2.  Bulk approve/reject multiple drives
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/j4w87HTyB/trigger/OdJHGkl-AZ
   * 3. Single drive review
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/j4w87HTyB/trigger/GTs7RwBpwn
   * 4. Single drive review from drive details sidebar
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/j4w87HTyB/trigger/LdCkN6lXaB
   * 5. From the All drives page
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/j4w87HTyB/trigger/xXRNfW-zY
   * 6. Bulk update from the All drives page
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/j4w87HTyB/trigger/3PSkcwuKy
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {string} [properties.teamsPlanName] - Name of the Team's plan at time of event. If a team is not on a plan, do not send property.
   * @param {int} [properties.teamsPlanId] - Plan Type ID of the Team at time of event. If a team is not on a plan, do not send property.
   * @param {string} properties.reviewAction - The action taken when reviewing drives
   * @param {string} properties.webPage - The page or screen on the web where the event sourced from
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/j4w87HTyB}
   */
  function teamsDriveReviewFailed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanName(properties.teamsPlanName)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanID(properties.teamsPlanId)
      );
      messages = messages.concat(assertReviewAction(properties.reviewAction));
      messages = messages.concat(assertWebPage(properties.webPage));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Drive Review Failed",
          Object.keys(properties),
          [
            "platform",
            "organizationId",
            "organizationGroupId",
            "teamsPlanName",
            "teamsPlanId",
            "reviewAction",
            "webPage",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "j4w87HTyB",
          "80ecfb6c44f01e10eb91fdcee40d4c19179df0a126562f95706a96243c78fc3b",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Drive Review Failed",
        {
          Platform: properties.platform,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          "Teams Plan Name": properties.teamsPlanName,
          "Teams Plan ID": properties.teamsPlanId,
          "Review Action": properties.reviewAction,
          "Web Page": properties.webPage,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "j4w87HTyB",
          "Teams Drive Review Failed",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "125AY5RLNY",
              name: "Teams Plan Name",
              value: properties.teamsPlanName,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            {
              id: "FWTawJHUN",
              name: "Review Action",
              value: properties.reviewAction,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            { id: "MZLkJ3Cmi", name: "Web Page", value: properties.webPage },
            {
              id: "TbSVW_o_GH",
              name: "Teams Plan ID",
              value: properties.teamsPlanId,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Drive Review Failed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Drive Review Failed",
          {
            Platform: properties.platform,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            "Teams Plan Name": properties.teamsPlanName,
            "Teams Plan ID": properties.teamsPlanId,
            "Review Action": properties.reviewAction,
            "Web Page": properties.webPage,
          },
          "j4w87HTyB",
          "80ecfb6c44f01e10eb91fdcee40d4c19179df0a126562f95706a96243c78fc3b"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Drive Review Failed", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan ID": properties.teamsPlanId,
        "Review Action": properties.reviewAction,
        "Web Page": properties.webPage,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Drive Review Failed", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan ID": properties.teamsPlanId,
        "Review Action": properties.reviewAction,
        "Web Page": properties.webPage,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Drive Review Started: This event occurs when an admin successfully reviews a drive (or multiple drives) and assigns it a status from the Drives to approve page.

   *
   * When to trigger this event:
   * 1. Quick approve
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/oGRPDdI_0/trigger/GUcjxO4AlX
   * 2.  Bulk approve/reject multiple drives
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/oGRPDdI_0/trigger/kOXjHZ6HfR
   * 3. Single drive review
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/oGRPDdI_0/trigger/UOtREPnmZ4
   * 4. Single drive review from drive details sidebar
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/oGRPDdI_0/trigger/mUxYTmfmej
   * 5. From the All drives page
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/oGRPDdI_0/trigger/rPfmAfQ9i
   * 6. Bulk update from All drives page
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/oGRPDdI_0/trigger/P8T3pVTj_
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {string} [properties.teamsPlanName] - Name of the Team's plan at time of event. If a team is not on a plan, do not send property.
   * @param {int} [properties.teamsPlanId] - Plan Type ID of the Team at time of event. If a team is not on a plan, do not send property.
   * @param {string} properties.webPage - The page or screen on the web where the event sourced from
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/oGRPDdI_0}
   */
  function teamsDriveReviewStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanName(properties.teamsPlanName)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanID(properties.teamsPlanId)
      );
      messages = messages.concat(assertWebPage(properties.webPage));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Drive Review Started",
          Object.keys(properties),
          [
            "platform",
            "organizationId",
            "organizationGroupId",
            "teamsPlanName",
            "teamsPlanId",
            "webPage",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "oGRPDdI_0",
          "b979769cc7c1d02d3f17e9086706550d4d7619fd68d4658ba1994e3f49b0209a",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Drive Review Started",
        {
          Platform: properties.platform,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          "Teams Plan Name": properties.teamsPlanName,
          "Teams Plan ID": properties.teamsPlanId,
          "Web Page": properties.webPage,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "oGRPDdI_0",
          "Teams Drive Review Started",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "125AY5RLNY",
              name: "Teams Plan Name",
              value: properties.teamsPlanName,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            { id: "MZLkJ3Cmi", name: "Web Page", value: properties.webPage },
            {
              id: "TbSVW_o_GH",
              name: "Teams Plan ID",
              value: properties.teamsPlanId,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Drive Review Started': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Drive Review Started",
          {
            Platform: properties.platform,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            "Teams Plan Name": properties.teamsPlanName,
            "Teams Plan ID": properties.teamsPlanId,
            "Web Page": properties.webPage,
          },
          "oGRPDdI_0",
          "b979769cc7c1d02d3f17e9086706550d4d7619fd68d4658ba1994e3f49b0209a"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Drive Review Started", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan ID": properties.teamsPlanId,
        "Web Page": properties.webPage,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Drive Review Started", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan ID": properties.teamsPlanId,
        "Web Page": properties.webPage,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Automatic Report Submission Updated: Team Member updates recurrence on the Automatic Report Submission feature
   *
   * When to trigger this event:
   * 1. Team member updates the recurrence on Automatic Report Submission from the Drivers Dashboard - Settings page
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/1818kPUhv/trigger/TIdmFwPx1s
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} properties.automaticReportsRecurrence - The recurrence schedule set by team member for automatic reports.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/1818kPUhv}
   */
  function automaticReportSubmissionUpdated(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertAutomaticReportsRecurrence(properties.automaticReportsRecurrence)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Automatic Report Submission Updated",
          Object.keys(properties),
          ["platform", "automaticReportsRecurrence"]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "1818kPUhv",
          "2d2302db60c6267346ef83124e4e5299fe15e1e5f29548f1ff8935cc26ac3ec2",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Automatic Report Submission Updated",
        {
          Platform: properties.platform,
          "Automatic Reports Recurrence": properties.automaticReportsRecurrence,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "1818kPUhv",
          "Automatic Report Submission Updated",
          messages,
          [
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "Zr7LvUpVN",
              name: "Automatic Reports Recurrence",
              value: properties.automaticReportsRecurrence,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Automatic Report Submission Updated': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Automatic Report Submission Updated",
          {
            Platform: properties.platform,
            "Automatic Reports Recurrence":
              properties.automaticReportsRecurrence,
          },
          "1818kPUhv",
          "2d2302db60c6267346ef83124e4e5299fe15e1e5f29548f1ff8935cc26ac3ec2"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Automatic Report Submission Updated", {
        Platform: properties.platform,
        "Automatic Reports Recurrence": properties.automaticReportsRecurrence,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Automatic Report Submission Updated", {
        Platform: properties.platform,
        "Automatic Reports Recurrence": properties.automaticReportsRecurrence,
      });

      // destination Braze
      Braze.logEvent("Automatic Report Submission Updated", {
        Platform: properties.platform,
        "Automatic Reports Recurrence": properties.automaticReportsRecurrence,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Drive Review Completed - Braze: This event occurs when an admin successfully reviews a drive (or multiple drives) and assigns it a status from the Drives to approve page.

This is similar to the other event Teams Drive Review Completed. The difference is that this event is for the destination Braze and is rate limited to control event volume being ingested into Braze.

   *
   * When to trigger this event:
   * 1. Quick approve
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/a0T_nWaKj/trigger/7N8bjjIVBC
   * 2.  Bulk approve/reject multiple drives
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/a0T_nWaKj/trigger/tJ4pYGudDp
   * 3. Single drive review
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/a0T_nWaKj/trigger/CjyGcIxnYX
   * 4. Single drive review from drive details sidebar
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/a0T_nWaKj/trigger/VbgUIsIQI_
   * 5. From the All drives page
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/a0T_nWaKj/trigger/UYIo0KzbOS
   * 6. Bulk update from All drives page
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/a0T_nWaKj/trigger/WozwTf9fPk
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {string} [properties.teamsPlanName] - Name of the Team's plan at time of event. If a team is not on a plan, do not send property.
   * @param {int} [properties.teamsPlanId] - Plan Type ID of the Team at time of event. If a team is not on a plan, do not send property.
   * @param {int} properties.driveCount - Number of drives
   * @param {string} properties.reviewAction - The action taken when reviewing drives
   * @param {string} properties.webPage - The page or screen on the web where the event sourced from
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/a0T_nWaKj}
   */
  function teamsDriveReviewCompletedBraze(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanName(properties.teamsPlanName)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanID(properties.teamsPlanId)
      );
      messages = messages.concat(assertDriveCount(properties.driveCount));
      messages = messages.concat(assertReviewAction(properties.reviewAction));
      messages = messages.concat(assertWebPage(properties.webPage));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Drive Review Completed - Braze",
          Object.keys(properties),
          [
            "platform",
            "organizationId",
            "organizationGroupId",
            "teamsPlanName",
            "teamsPlanId",
            "driveCount",
            "reviewAction",
            "webPage",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "a0T_nWaKj",
          "d90a897ae4c91d8eaf179927a4020e2ba3bcd098db54cf06ba29378591c934d7",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Drive Review Completed - Braze",
        {
          Platform: properties.platform,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          "Teams Plan Name": properties.teamsPlanName,
          "Teams Plan ID": properties.teamsPlanId,
          "Drive Count": properties.driveCount,
          "Review Action": properties.reviewAction,
          "Web Page": properties.webPage,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "a0T_nWaKj",
          "Teams Drive Review Completed - Braze",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "125AY5RLNY",
              name: "Teams Plan Name",
              value: properties.teamsPlanName,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            {
              id: "FWTawJHUN",
              name: "Review Action",
              value: properties.reviewAction,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "JDI2RsZke",
              name: "Drive Count",
              value: properties.driveCount,
            },
            { id: "MZLkJ3Cmi", name: "Web Page", value: properties.webPage },
            {
              id: "TbSVW_o_GH",
              name: "Teams Plan ID",
              value: properties.teamsPlanId,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Drive Review Completed - Braze': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Drive Review Completed - Braze",
          {
            Platform: properties.platform,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            "Teams Plan Name": properties.teamsPlanName,
            "Teams Plan ID": properties.teamsPlanId,
            "Drive Count": properties.driveCount,
            "Review Action": properties.reviewAction,
            "Web Page": properties.webPage,
          },
          "a0T_nWaKj",
          "d90a897ae4c91d8eaf179927a4020e2ba3bcd098db54cf06ba29378591c934d7"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Drive Review Completed - Braze", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan ID": properties.teamsPlanId,
        "Drive Count": properties.driveCount,
        "Review Action": properties.reviewAction,
        "Web Page": properties.webPage,
      });

      // destination Braze
      Braze.logEvent("Teams Drive Review Completed - Braze", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan ID": properties.teamsPlanId,
        "Drive Count": properties.driveCount,
        "Review Action": properties.reviewAction,
        "Web Page": properties.webPage,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Drive Comment Started: This event occurs when a team admin starts to type a comment on a reported drive.
   *
   * When to trigger this event:
   * 1. from Drives to Approve page
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/hhLBKbwAl/trigger/1qkspjSf4
   * 2. from All drives page
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/hhLBKbwAl/trigger/QvBNDIRAU
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {string} [properties.teamsPlanName] - Name of the Team's plan at time of event. If a team is not on a plan, do not send property.
   * @param {int} [properties.teamsPlanId] - Plan Type ID of the Team at time of event. If a team is not on a plan, do not send property.
   * @param {string} properties.webPage - The page or screen on the web where the event sourced from
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/hhLBKbwAl}
   */
  function teamsDriveCommentStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanName(properties.teamsPlanName)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanID(properties.teamsPlanId)
      );
      messages = messages.concat(assertWebPage(properties.webPage));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Drive Comment Started",
          Object.keys(properties),
          [
            "platform",
            "organizationId",
            "organizationGroupId",
            "teamsPlanName",
            "teamsPlanId",
            "webPage",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "hhLBKbwAl",
          "bce0811edd243121fe06f87408d469ec5d8541be7fdb588284282a43f51adbb1",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Drive Comment Started",
        {
          Platform: properties.platform,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          "Teams Plan Name": properties.teamsPlanName,
          "Teams Plan ID": properties.teamsPlanId,
          "Web Page": properties.webPage,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "hhLBKbwAl",
          "Teams Drive Comment Started",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "125AY5RLNY",
              name: "Teams Plan Name",
              value: properties.teamsPlanName,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            { id: "MZLkJ3Cmi", name: "Web Page", value: properties.webPage },
            {
              id: "TbSVW_o_GH",
              name: "Teams Plan ID",
              value: properties.teamsPlanId,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Drive Comment Started': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Drive Comment Started",
          {
            Platform: properties.platform,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            "Teams Plan Name": properties.teamsPlanName,
            "Teams Plan ID": properties.teamsPlanId,
            "Web Page": properties.webPage,
          },
          "hhLBKbwAl",
          "bce0811edd243121fe06f87408d469ec5d8541be7fdb588284282a43f51adbb1"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Drive Comment Started", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan ID": properties.teamsPlanId,
        "Web Page": properties.webPage,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Drive Comment Started", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan ID": properties.teamsPlanId,
        "Web Page": properties.webPage,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Drive Comment Completed: This event occurs when a team admin successfully saves a comment on a reported drive.
   *
   * When to trigger this event:
   * 1. from Drives to Approve page
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/L4pst1Kxk/trigger/30sLYO5JDg
   * 2. from All drives page
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/L4pst1Kxk/trigger/muhxXHYtgX
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {string} [properties.teamsPlanName] - Name of the Team's plan at time of event. If a team is not on a plan, do not send property.
   * @param {int} [properties.teamsPlanId] - Plan Type ID of the Team at time of event. If a team is not on a plan, do not send property.
   * @param {string} properties.webPage - The page or screen on the web where the event sourced from
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/L4pst1Kxk}
   */
  function teamsDriveCommentCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanName(properties.teamsPlanName)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanID(properties.teamsPlanId)
      );
      messages = messages.concat(assertWebPage(properties.webPage));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Drive Comment Completed",
          Object.keys(properties),
          [
            "platform",
            "organizationId",
            "organizationGroupId",
            "teamsPlanName",
            "teamsPlanId",
            "webPage",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "L4pst1Kxk",
          "1ab373036e68075b029996ce7634f0620855934096be1765553d644f8a146af2",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Drive Comment Completed",
        {
          Platform: properties.platform,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          "Teams Plan Name": properties.teamsPlanName,
          "Teams Plan ID": properties.teamsPlanId,
          "Web Page": properties.webPage,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "L4pst1Kxk",
          "Teams Drive Comment Completed",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "125AY5RLNY",
              name: "Teams Plan Name",
              value: properties.teamsPlanName,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            { id: "MZLkJ3Cmi", name: "Web Page", value: properties.webPage },
            {
              id: "TbSVW_o_GH",
              name: "Teams Plan ID",
              value: properties.teamsPlanId,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Drive Comment Completed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Drive Comment Completed",
          {
            Platform: properties.platform,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            "Teams Plan Name": properties.teamsPlanName,
            "Teams Plan ID": properties.teamsPlanId,
            "Web Page": properties.webPage,
          },
          "L4pst1Kxk",
          "1ab373036e68075b029996ce7634f0620855934096be1765553d644f8a146af2"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Drive Comment Completed", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan ID": properties.teamsPlanId,
        "Web Page": properties.webPage,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Drive Comment Completed", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan ID": properties.teamsPlanId,
        "Web Page": properties.webPage,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Teams Drive Comment Failed: This event occurs when a team admin attempts to submit comment on a reported drive, but it fails.
   *
   * When to trigger this event:
   * 1. from Drives to Approve page
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/GF_2SKt-7/trigger/S2648_-Ota
   * 2. from All drives page
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/GF_2SKt-7/trigger/cFmFfP3_LY
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {string} [properties.teamsPlanName] - Name of the Team's plan at time of event. If a team is not on a plan, do not send property.
   * @param {int} [properties.teamsPlanId] - Plan Type ID of the Team at time of event. If a team is not on a plan, do not send property.
   * @param {string} properties.webPage - The page or screen on the web where the event sourced from
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/GF_2SKt-7}
   */
  function teamsDriveCommentFailed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanName(properties.teamsPlanName)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanID(properties.teamsPlanId)
      );
      messages = messages.concat(assertWebPage(properties.webPage));
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Teams Drive Comment Failed",
          Object.keys(properties),
          [
            "platform",
            "organizationId",
            "organizationGroupId",
            "teamsPlanName",
            "teamsPlanId",
            "webPage",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "GF_2SKt-7",
          "e5af7892d46fc420830e65c7648680bf0692c592065e1f68681f257100da0b99",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Teams Drive Comment Failed",
        {
          Platform: properties.platform,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          "Teams Plan Name": properties.teamsPlanName,
          "Teams Plan ID": properties.teamsPlanId,
          "Web Page": properties.webPage,
        },
        {},
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "GF_2SKt-7",
          "Teams Drive Comment Failed",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "125AY5RLNY",
              name: "Teams Plan Name",
              value: properties.teamsPlanName,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            { id: "MZLkJ3Cmi", name: "Web Page", value: properties.webPage },
            {
              id: "TbSVW_o_GH",
              name: "Teams Plan ID",
              value: properties.teamsPlanId,
            },
          ],
          [],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Teams Drive Comment Failed': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Teams Drive Comment Failed",
          {
            Platform: properties.platform,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            "Teams Plan Name": properties.teamsPlanName,
            "Teams Plan ID": properties.teamsPlanId,
            "Web Page": properties.webPage,
          },
          "GF_2SKt-7",
          "e5af7892d46fc420830e65c7648680bf0692c592065e1f68681f257100da0b99"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.logEvent("Teams Drive Comment Failed", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan ID": properties.teamsPlanId,
        "Web Page": properties.webPage,
      });

      // destination Mixpanel
      Mixpanel.logEvent("Teams Drive Comment Failed", {
        Platform: properties.platform,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan Name": properties.teamsPlanName,
        "Teams Plan ID": properties.teamsPlanId,
        "Web Page": properties.webPage,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Automatic Review Enabled: Turning the toggle on in teams dashboard settings to automatic review.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/Ti1TaAoqb/trigger/TZNGrFK-u
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.userId_ - The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {int} [properties.teamsPlanId] - Plan Type ID of the Team at time of event. If a team is not on a plan, do not send property.
   * @param {bool} properties.freeTrial - Indicates whether the event is associated with a free trial plan.
   * @param {string} properties.country - Country identifier for user or team
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {string} [properties.teamsPlanName] - Name of the Team's plan at time of event. If a team is not on a plan, do not send property.
   * @param {bool} [properties.automaticReviewEnabled] - User Property for Automatic Review setting being enabled or not.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/Ti1TaAoqb}
   */
  function automaticReviewEnabled(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertUserId_(properties.userId_));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalTeamsPlanID(properties.teamsPlanId)
      );
      messages = messages.concat(assertFreeTrial(properties.freeTrial));
      messages = messages.concat(assertCountry(properties.country));
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanName(properties.teamsPlanName)
      );
      messages = messages.concat(
        assertOptionalAutomaticReviewEnabled(properties.automaticReviewEnabled)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Automatic Review Enabled",
          Object.keys(properties),
          [
            "userId_",
            "platform",
            "teamsPlanId",
            "freeTrial",
            "country",
            "organizationId",
            "organizationGroupId",
            "teamsPlanName",
            "automaticReviewEnabled",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "Ti1TaAoqb",
          "ab8a8920b1f65463ffae92cb2351ffb457400bed7ecb203940ed4c50673cdeb7",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Automatic Review Enabled",
        {
          Platform: properties.platform,
          "Teams Plan ID": properties.teamsPlanId,
          "Free Trial": properties.freeTrial,
          Country: properties.country,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          "Teams Plan Name": properties.teamsPlanName,
        },
        {
          "Automatic Review Enabled": properties.automaticReviewEnabled,
        },
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "Ti1TaAoqb",
          "Automatic Review Enabled",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "125AY5RLNY",
              name: "Teams Plan Name",
              value: properties.teamsPlanName,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "TbSVW_o_GH",
              name: "Teams Plan ID",
              value: properties.teamsPlanId,
            },
            {
              id: "dVaX1T1uG",
              name: "Free Trial",
              value: properties.freeTrial,
            },
            { id: "p0_feuKMRI", name: "Country", value: properties.country },
          ],
          [
            {
              id: "Ak-PHZQ7S",
              name: "Automatic Review Enabled",
              value: properties.automaticReviewEnabled,
            },
          ],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Automatic Review Enabled': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Automatic Review Enabled",
          {
            Platform: properties.platform,
            "Teams Plan ID": properties.teamsPlanId,
            "Free Trial": properties.freeTrial,
            Country: properties.country,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            "Teams Plan Name": properties.teamsPlanName,
          },
          "Ti1TaAoqb",
          "ab8a8920b1f65463ffae92cb2351ffb457400bed7ecb203940ed4c50673cdeb7"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.setUserProperties(properties.userId_, {
        "Automatic Review Enabled": properties.automaticReviewEnabled,
      });
      RudderStackWebDashboard.logEvent("Automatic Review Enabled", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Free Trial": properties.freeTrial,
        Country: properties.country,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan Name": properties.teamsPlanName,
      });

      // destination Mixpanel
      Mixpanel.setUserProperties(properties.userId_, {
        "Automatic Review Enabled": properties.automaticReviewEnabled,
      });
      Mixpanel.logEvent("Automatic Review Enabled", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Free Trial": properties.freeTrial,
        Country: properties.country,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan Name": properties.teamsPlanName,
      });

      // destination Braze
      Braze.setUserProperties(properties.userId_, {
        "Automatic Review Enabled": properties.automaticReviewEnabled,
      });
      Braze.logEvent("Automatic Review Enabled", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Free Trial": properties.freeTrial,
        Country: properties.country,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan Name": properties.teamsPlanName,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Automatic Review Disabled: Turning the toggle off in teams dashboard settings to automatic review.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/VCtCo_pjL/trigger/F9Rztq9na7
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.userId_ - The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
   * @param {string} properties.platform - Platform the user was on at the time of event
   * @param {int} [properties.teamsPlanId] - Plan Type ID of the Team at time of event. If a team is not on a plan, do not send property.
   * @param {bool} properties.freeTrial - Indicates whether the event is associated with a free trial plan.
   * @param {string} properties.country - Country identifier for user or team
   * @param {string} [properties.organizationId] - Team's Organization ID
   * @param {string} [properties.organizationGroupId] - Organization Group ID of the Team
   * @param {string} [properties.teamsPlanName] - Name of the Team's plan at time of event. If a team is not on a plan, do not send property.
   * @param {bool} [properties.automaticReviewEnabled] - User Property for Automatic Review setting being enabled or not.
   *
   * @see {@link https://www.avo.app/schemas/ATL22HeaAit5ZqQrVv0s/events/VCtCo_pjL}
   */
  function automaticReviewDisabled(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertUserId_(properties.userId_));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(
        assertOptionalTeamsPlanID(properties.teamsPlanId)
      );
      messages = messages.concat(assertFreeTrial(properties.freeTrial));
      messages = messages.concat(assertCountry(properties.country));
      messages = messages.concat(
        assertOptionalOrganizationID(properties.organizationId)
      );
      messages = messages.concat(
        assertOptionalOrganizationGroupID(properties.organizationGroupId)
      );
      messages = messages.concat(
        assertOptionalTeamsPlanName(properties.teamsPlanName)
      );
      messages = messages.concat(
        assertOptionalAutomaticReviewEnabled(properties.automaticReviewEnabled)
      );
      messages = messages.concat(
        AvoAssert.assertNoAdditionalProperties(
          "Automatic Review Disabled",
          Object.keys(properties),
          [
            "userId_",
            "platform",
            "teamsPlanId",
            "freeTrial",
            "country",
            "organizationId",
            "organizationGroupId",
            "teamsPlanName",
            "automaticReviewEnabled",
          ]
        )
      );
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(
          __AVO_ENV__,
          "VCtCo_pjL",
          "7836edeab62fd297092344b4ad1ddf9148eef06715847460dc2b8aa15a814458",
          messages.map(function (m) {
            return Object.assign(
              {},
              {
                tag: m.tag,
                propertyId: m.propertyId,
                additionalProperties: m.additionalProperties,
                actualType: m.actualType,
              }
            );
          }),
          "event"
        );
      }

      InternalAvoLogger.logEventSent(
        "Automatic Review Disabled",
        {
          Platform: properties.platform,
          "Teams Plan ID": properties.teamsPlanId,
          "Free Trial": properties.freeTrial,
          Country: properties.country,
          "Organization ID": properties.organizationId,
          "Organization Group ID": properties.organizationGroupId,
          "Teams Plan Name": properties.teamsPlanName,
        },
        {
          "Automatic Review Enabled": properties.automaticReviewEnabled,
        },
        {}
      );
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log(
          "VCtCo_pjL",
          "Automatic Review Disabled",
          messages,
          [
            {
              id: "-WqF2QiMYl",
              name: "Organization ID",
              value: properties.organizationId,
            },
            {
              id: "125AY5RLNY",
              name: "Teams Plan Name",
              value: properties.teamsPlanName,
            },
            {
              id: "DTTXRDLbGJ",
              name: "Organization Group ID",
              value: properties.organizationGroupId,
            },
            { id: "FfkzdkMHsZ", name: "Platform", value: properties.platform },
            {
              id: "TbSVW_o_GH",
              name: "Teams Plan ID",
              value: properties.teamsPlanId,
            },
            {
              id: "dVaX1T1uG",
              name: "Free Trial",
              value: properties.freeTrial,
            },
            { id: "p0_feuKMRI", name: "Country", value: properties.country },
          ],
          [
            {
              id: "Ak-PHZQ7S",
              name: "Automatic Review Enabled",
              value: properties.automaticReviewEnabled,
            },
          ],
          []
        );
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error(
            "Error sending event 'Automatic Review Disabled': " +
              messages[0].message
          );
        }
      } else {
        messages.forEach(function (m) {
          console[__REPORT_FAILURE_AS__ || "error"]("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
          "Automatic Review Disabled",
          {
            Platform: properties.platform,
            "Teams Plan ID": properties.teamsPlanId,
            "Free Trial": properties.freeTrial,
            Country: properties.country,
            "Organization ID": properties.organizationId,
            "Organization Group ID": properties.organizationGroupId,
            "Teams Plan Name": properties.teamsPlanName,
          },
          "VCtCo_pjL",
          "7836edeab62fd297092344b4ad1ddf9148eef06715847460dc2b8aa15a814458"
        );
      }
      // destination RudderStackWebDashboard
      RudderStackWebDashboard.setUserProperties(properties.userId_, {
        "Automatic Review Enabled": properties.automaticReviewEnabled,
      });
      RudderStackWebDashboard.logEvent("Automatic Review Disabled", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Free Trial": properties.freeTrial,
        Country: properties.country,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan Name": properties.teamsPlanName,
      });

      // destination Mixpanel
      Mixpanel.setUserProperties(properties.userId_, {
        "Automatic Review Enabled": properties.automaticReviewEnabled,
      });
      Mixpanel.logEvent("Automatic Review Disabled", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Free Trial": properties.freeTrial,
        Country: properties.country,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan Name": properties.teamsPlanName,
      });

      // destination Braze
      Braze.setUserProperties(properties.userId_, {
        "Automatic Review Enabled": properties.automaticReviewEnabled,
      });
      Braze.logEvent("Automatic Review Disabled", {
        Platform: properties.platform,
        "Teams Plan ID": properties.teamsPlanId,
        "Free Trial": properties.freeTrial,
        Country: properties.country,
        "Organization ID": properties.organizationId,
        "Organization Group ID": properties.organizationGroupId,
        "Teams Plan Name": properties.teamsPlanName,
      });
    } else {
      // do nothing
    }
  }

  exports.TeamsInviteSource = TeamsInviteSource;
  exports.DownloadFormat = DownloadFormat;
  exports.IntegrationStepName = IntegrationStepName;
  exports.TeamsPlanName = TeamsPlanName;
  exports.UserSelectionAction = UserSelectionAction;
  exports.PasswordResetFailure = PasswordResetFailure;
  exports.ConsolidatedReportTimeframe = ConsolidatedReportTimeframe;
  exports.ResendType = ResendType;
  exports.SignupOriginProduct = SignupOriginProduct;
  exports.ExistingSASubscription = ExistingSASubscription;
  exports.TeamsSignupStepName = TeamsSignupStepName;
  exports.ReportCreationFailure = ReportCreationFailure;
  exports.FrequentDrivePromptAction = FrequentDrivePromptAction;
  exports.CustomPurposeSource = CustomPurposeSource;
  exports.Page = Page;
  exports.OverlayCTA = OverlayCTA;
  exports.DistanceUnit = DistanceUnit;
  exports.OverlayInteraction = OverlayInteraction;
  exports.TeamsSignupSource = TeamsSignupSource;
  exports.FrequentUnclassifiedDrivesAction = FrequentUnclassifiedDrivesAction;
  exports.ReportMarkDrives = ReportMarkDrives;
  exports.SignupSource = SignupSource;
  exports.FrequentDrivePreference = FrequentDrivePreference;
  exports.ReportDownloadSource = ReportDownloadSource;
  exports.OverlayType = OverlayType;
  exports.OverlayCategory = OverlayCategory;
  exports.DriveReportedFilter = DriveReportedFilter;
  exports.TeamsDowngradeSource = TeamsDowngradeSource;
  exports.ReportsDriveFilter = ReportsDriveFilter;
  exports.FilterDriveFrequentDrives = FilterDriveFrequentDrives;
  exports.TeamsUpgradeFeature = TeamsUpgradeFeature;
  exports.SignupFailure = SignupFailure;
  exports.ReviewAction = ReviewAction;
  exports.Platform = Platform;
  exports.FilterDriveWithoutNotes = FilterDriveWithoutNotes;
  exports.SearchSelectionType = SearchSelectionType;
  exports.ReportCreationStepName = ReportCreationStepName;
  exports.LoginFailure = LoginFailure;
  exports.InviteFailureReason = InviteFailureReason;
  exports.ReportsDateFilter = ReportsDateFilter;
  exports.FilterDriveWorkHours = FilterDriveWorkHours;
  exports.DriveSelectionMethod = DriveSelectionMethod;
  exports.LoginSessionPreference = LoginSessionPreference;
  exports.DashboardSwitchedTo = DashboardSwitchedTo;
  exports.ReportDetailsDriveFilter = ReportDetailsDriveFilter;
  exports.Integration = Integration;
  exports.WebPage = WebPage;
  exports.DriveClassificationPurpose = DriveClassificationPurpose;
  exports.CancellationAbandonedMethod = CancellationAbandonedMethod;
  exports.AutoClassifyOutsideWorkHoursPreference =
    AutoClassifyOutsideWorkHoursPreference;
  exports.EditUsernameStepName = EditUsernameStepName;
  exports.WorkHoursUpdateSource = WorkHoursUpdateSource;
  exports.ConsolidatedReportFormat = ConsolidatedReportFormat;
  exports.VehiclePriority = VehiclePriority;
  exports.PaymentService = PaymentService;
  exports.DriveSearch = DriveSearch;
  exports.IntegrationStatus = IntegrationStatus;
  exports.UserAction = UserAction;
  exports.TeamSetting = TeamSetting;
  exports.TeamsUpdatePaymentSource = TeamsUpdatePaymentSource;
  exports.VehiclePriorityUpdate = VehiclePriorityUpdate;
  exports.TeamsResubscribeModalSource = TeamsResubscribeModalSource;
  exports.TeamDrivesDriversFilter = TeamDrivesDriversFilter;
  exports.UserSelectionType = UserSelectionType;
  exports.CustomPurposeUpdate = CustomPurposeUpdate;
  exports.DashboardSwitchFrom = DashboardSwitchFrom;
  exports.TeamsPlanSelectionName = TeamsPlanSelectionName;
  exports.BlogSource = BlogSource;
  exports.OtherEmailPreferenceChange = OtherEmailPreferenceChange;
  exports.TeamsUpgradeSource = TeamsUpgradeSource;
  exports.SharedNamedLocationStepName = SharedNamedLocationStepName;
  exports.LoginSource = LoginSource;
  exports.ExistingDriveClassificationType = ExistingDriveClassificationType;
  exports.ReportReminderRepeatsScheduleSettingType =
    ReportReminderRepeatsScheduleSettingType;
  exports.ReviewDriveTypeFilter = ReviewDriveTypeFilter;
  exports.EmailValidationMethod = EmailValidationMethod;
  exports.TeamsSignupStepInteraction = TeamsSignupStepInteraction;
  exports.TeamsPlanInterval = TeamsPlanInterval;
  exports.DriveDeletionReason = DriveDeletionReason;
  exports.TeamUserRole = TeamUserRole;
  exports.TeamsPlanSelectionInterval = TeamsPlanSelectionInterval;
  exports.AutomaticReportsRecurrence = AutomaticReportsRecurrence;
  exports.ShareSource = ShareSource;
  exports.DriveDetail = DriveDetail;
  exports.VehicleDetailsUpdate = VehicleDetailsUpdate;
  exports.UpgradeSource = UpgradeSource;
  exports.VehicleVisibility = VehicleVisibility;
  exports.ReviewStatusFilter = ReviewStatusFilter;
  exports.TeamsUserUpdate = TeamsUserUpdate;
  exports.EmailAuthenticationMethod = EmailAuthenticationMethod;
  exports.VehicleVisibilityUpdate = VehicleVisibilityUpdate;
  exports.Currency = Currency;
  exports.PreviousWebPage = PreviousWebPage;
  exports.DriveReviewCTA = DriveReviewCTA;
  exports.SignupOriginSubscription = SignupOriginSubscription;
  exports.ReportRecipientType = ReportRecipientType;
  exports.BulkUploadStepName = BulkUploadStepName;
  exports.PromotionalEmailPreferenceChange = PromotionalEmailPreferenceChange;
  exports.InviteAdminStepName = InviteAdminStepName;
  exports.WeeklyEmailPreferenceChange = WeeklyEmailPreferenceChange;
  exports.EmailPreferenceChangeMethod = EmailPreferenceChangeMethod;
  exports.AppDownloadRequestMethod = AppDownloadRequestMethod;
  exports.AddVehicleMethod = AddVehicleMethod;
  exports.IntegrationProcess = IntegrationProcess;
  exports.ReportsVehicleFilter = ReportsVehicleFilter;
  exports.TeamsReportsSubmissionFilter = TeamsReportsSubmissionFilter;
  exports.DriveDateFilter = DriveDateFilter;
  exports.FrequentDriveEditAction = FrequentDriveEditAction;
  exports.WorkHourFailure = WorkHourFailure;
  exports.DriveClassificationType = DriveClassificationType;
  exports.Country = Country;
  exports.ReportDetailsSearchFilter = ReportDetailsSearchFilter;
  exports.CustomRatesEffectiveDate = CustomRatesEffectiveDate;
  exports.CustomRatesUpdateType = CustomRatesUpdateType;
  exports.SharedNamedLocationFailure = SharedNamedLocationFailure;
  exports.TeamsSubscriptionCancellationStep = TeamsSubscriptionCancellationStep;
  exports.NamedLocationEdit = NamedLocationEdit;
  exports.TeamDrivesPurposeFilter = TeamDrivesPurposeFilter;
  exports.SubscriptionType = SubscriptionType;
  exports.ReportOpenSource = ReportOpenSource;
  exports.CustomRatesSelection = CustomRatesSelection;
  exports.FilterDriveManuallyClassified = FilterDriveManuallyClassified;
  exports.MonthlyEmailPreferenceChange = MonthlyEmailPreferenceChange;
  exports.DriveClassificationFilter = DriveClassificationFilter;
  exports.OverlayDescription = OverlayDescription;
  exports.ModalAbandonMethod = ModalAbandonMethod;
  exports.TeamsReportsDriversFilter = TeamsReportsDriversFilter;
  exports.ReportEmailSource = ReportEmailSource;
  exports.DriverReportSelectionType = DriverReportSelectionType;
  exports.AutoClassifyDuringWorkHoursPreference =
    AutoClassifyDuringWorkHoursPreference;
  exports.VehicleType = VehicleType;
  exports.WorkHoursSchedule = WorkHoursSchedule;
  exports.SignupOriginBillingCycle = SignupOriginBillingCycle;
  exports.Intent = Intent;
  exports.setAvoLogger = setAvoLogger;
  exports.signupEmailAdded = signupEmailAdded;
  exports.signupCompleted = signupCompleted;
  exports.signupStarted = signupStarted;
  exports.overlayItemInteracted = overlayItemInteracted;
  exports.loginStarted = loginStarted;
  exports.loginEmailAdded = loginEmailAdded;
  exports.loginCompleted = loginCompleted;
  exports.passwordResetStarted = passwordResetStarted;
  exports.passwordResetRequested = passwordResetRequested;
  exports.passwordResetCompleted = passwordResetCompleted;
  exports.loginFailed = loginFailed;
  exports.passwordResetFailed = passwordResetFailed;
  exports.upgradeStarted = upgradeStarted;
  exports.teamsSignupStarted = teamsSignupStarted;
  exports.teamsSignupStepCompleted = teamsSignupStepCompleted;
  exports.teamsSignupCompleted = teamsSignupCompleted;
  exports.teamsUpgradeStarted = teamsUpgradeStarted;
  exports.teamsUpgradePlanSelected = teamsUpgradePlanSelected;
  exports.teamsUpgradeCompleted = teamsUpgradeCompleted;
  exports.teamsInviteStarted = teamsInviteStarted;
  exports.teamsInviteEmailAdded = teamsInviteEmailAdded;
  exports.teamsInviteCompleted = teamsInviteCompleted;
  exports.teamsInviteFailed = teamsInviteFailed;
  exports.teamsDeletionStarted = teamsDeletionStarted;
  exports.teamsDeletionCompleted = teamsDeletionCompleted;
  exports.teamsSettingUpdated = teamsSettingUpdated;
  exports.helpSelected = helpSelected;
  exports.teamsRemoveUserStarted = teamsRemoveUserStarted;
  exports.teamsRemoveUserCompleted = teamsRemoveUserCompleted;
  exports.teamsUpdateUserStarted = teamsUpdateUserStarted;
  exports.teamsUpdateUserCompleted = teamsUpdateUserCompleted;
  exports.driverReportDownloaded = driverReportDownloaded;
  exports.driverReportEmailStarted = driverReportEmailStarted;
  exports.driverReportEmailCompleted = driverReportEmailCompleted;
  exports.driverReportRejectionStarted = driverReportRejectionStarted;
  exports.driverReportRejectionCompleted = driverReportRejectionCompleted;
  exports.driverReportRejectionCancelled = driverReportRejectionCancelled;
  exports.teamsInviteAccepted = teamsInviteAccepted;
  exports.teamsInviteResent = teamsInviteResent;
  exports.teamsInviteRevoked = teamsInviteRevoked;
  exports.experimentViewed = experimentViewed;
  exports.bulkUploadStarted = bulkUploadStarted;
  exports.bulkUploadStepCompleted = bulkUploadStepCompleted;
  exports.bulkUploadCompleted = bulkUploadCompleted;
  exports.bulkUploadFailed = bulkUploadFailed;
  exports.teamsUserListDownloaded = teamsUserListDownloaded;
  exports.userSelected = userSelected;
  exports.teamsCustomRatesUpdateStarted = teamsCustomRatesUpdateStarted;
  exports.teamsCustomRatesUpdateCompleted = teamsCustomRatesUpdateCompleted;
  exports.shareMileiqSelected = shareMileiqSelected;
  exports.blogSelected = blogSelected;
  exports.vehicleAddStarted = vehicleAddStarted;
  exports.vehicleUpdated = vehicleUpdated;
  exports.vehicleAddCompleted = vehicleAddCompleted;
  exports.appDownloadRequested = appDownloadRequested;
  exports.appDownloadRequestFailed = appDownloadRequestFailed;
  exports.upgradeCompleted = upgradeCompleted;
  exports.subscriptionUpdateStarted = subscriptionUpdateStarted;
  exports.subscriptionUpdateCompleted = subscriptionUpdateCompleted;
  exports.frequentDrivesPreferenceChanged = frequentDrivesPreferenceChanged;
  exports.workHoursUpdateStarted = workHoursUpdateStarted;
  exports.workHoursUpdateCompleted = workHoursUpdateCompleted;
  exports.workHoursUpdateFailed = workHoursUpdateFailed;
  exports.customPurposeAddStarted = customPurposeAddStarted;
  exports.customPurposeAddCompleted = customPurposeAddCompleted;
  exports.customPurposeUpdated = customPurposeUpdated;
  exports.distanceUnitUpdated = distanceUnitUpdated;
  exports.distanceRateUpdateCompleted = distanceRateUpdateCompleted;
  exports.reportsFiltered = reportsFiltered;
  exports.reportCreationStarted = reportCreationStarted;
  exports.reportCreationCompleted = reportCreationCompleted;
  exports.reportCreationFailed = reportCreationFailed;
  exports.reportDownloaded = reportDownloaded;
  exports.reportDeleted = reportDeleted;
  exports.integrationStarted = integrationStarted;
  exports.integrationStepCompleted = integrationStepCompleted;
  exports.integrationCompleted = integrationCompleted;
  exports.integrationFailed = integrationFailed;
  exports.integrationEnableStarted = integrationEnableStarted;
  exports.integrationEnableCompleted = integrationEnableCompleted;
  exports.integrationEditStarted = integrationEditStarted;
  exports.integrationEditCompleted = integrationEditCompleted;
  exports.integrationEditFailed = integrationEditFailed;
  exports.integrationRemoved = integrationRemoved;
  exports.integrationChecked = integrationChecked;
  exports.frequentDrivePrompted = frequentDrivePrompted;
  exports.frequentDriveEdited = frequentDriveEdited;
  exports.driveMapEnlarged = driveMapEnlarged;
  exports.driveAddStarted = driveAddStarted;
  exports.driveAddCompleted = driveAddCompleted;
  exports.namedLocationCreated = namedLocationCreated;
  exports.namedLocationEdited = namedLocationEdited;
  exports.driveDuplicateStarted = driveDuplicateStarted;
  exports.driveDuplicateCompleted = driveDuplicateCompleted;
  exports.driveJoinStarted = driveJoinStarted;
  exports.driveJoinCompleted = driveJoinCompleted;
  exports.driveDeleteStarted = driveDeleteStarted;
  exports.driveDeleteCompleted = driveDeleteCompleted;
  exports.driveClassifyStarted = driveClassifyStarted;
  exports.driveClassifyCompleted = driveClassifyCompleted;
  exports.driveEdited = driveEdited;
  exports.drivesFiltered = drivesFiltered;
  exports.drivesAdvanceFiltered = drivesAdvanceFiltered;
  exports.driveSelected = driveSelected;
  exports.accountDropdownSelected = accountDropdownSelected;
  exports.accountSignedOut = accountSignedOut;
  exports.dashboardSwitched = dashboardSwitched;
  exports.emailSettingUpdated = emailSettingUpdated;
  exports.distanceRateUpdateStarted = distanceRateUpdateStarted;
  exports.productPreferenceSelected = productPreferenceSelected;
  exports.inviteAdminStarted = inviteAdminStarted;
  exports.inviteAdminStepCompleted = inviteAdminStepCompleted;
  exports.inviteAdminCompleted = inviteAdminCompleted;
  exports.featureDetailSelected = featureDetailSelected;
  exports.teamsReportsFiltered = teamsReportsFiltered;
  exports.driverReportSelected = driverReportSelected;
  exports.driverReportOpened = driverReportOpened;
  exports.driverReportDriveSelected = driverReportDriveSelected;
  exports.driverReportDetailsFiltered = driverReportDetailsFiltered;
  exports.teamsConsolidatedReportStarted = teamsConsolidatedReportStarted;
  exports.teamsConsolidatedReportCompleted = teamsConsolidatedReportCompleted;
  exports.productPreferenceSubmitted = productPreferenceSubmitted;
  exports.usernameEditStarted = usernameEditStarted;
  exports.usernameEditStepCompleted = usernameEditStepCompleted;
  exports.usernameEditCompleted = usernameEditCompleted;
  exports.pageViewed = pageViewed;
  exports.addSharedNamedLocationStarted = addSharedNamedLocationStarted;
  exports.addSharedNamedLocationStep = addSharedNamedLocationStep;
  exports.addSharedNamedLocationCompleted = addSharedNamedLocationCompleted;
  exports.renameSharedNamedLocationStarted = renameSharedNamedLocationStarted;
  exports.renameSharedNamedLocationCompleted =
    renameSharedNamedLocationCompleted;
  exports.deleteSharedNamedLocationStarted = deleteSharedNamedLocationStarted;
  exports.deleteSharedNamedLocationCompleted =
    deleteSharedNamedLocationCompleted;
  exports.sharedNamedLocationFailed = sharedNamedLocationFailed;
  exports.teamsSubscriptionCancelationStarted =
    teamsSubscriptionCancelationStarted;
  exports.teamsSubscriptionCancelationCompleted =
    teamsSubscriptionCancelationCompleted;
  exports.actionUndone = actionUndone;
  exports.searchStarted = searchStarted;
  exports.searchCompleted = searchCompleted;
  exports.teamsFreeTrialSelected = teamsFreeTrialSelected;
  exports.teamsFreeTrialRejected = teamsFreeTrialRejected;
  exports.teamsUpgradeAbandoned = teamsUpgradeAbandoned;
  exports.reportRemindersEnabled = reportRemindersEnabled;
  exports.reportRemindersScheduleUpdated = reportRemindersScheduleUpdated;
  exports.reportRemindersDisabled = reportRemindersDisabled;
  exports.signupFailed = signupFailed;
  exports.automaticReportSubmissionEnabled = automaticReportSubmissionEnabled;
  exports.automaticReportSubmissionDisabled = automaticReportSubmissionDisabled;
  exports.subscriptionCancelStarted = subscriptionCancelStarted;
  exports.subscriptionCancelReasonSelected = subscriptionCancelReasonSelected;
  exports.subscriptionCancelCompleted = subscriptionCancelCompleted;
  exports.teamsDowngradeStarted = teamsDowngradeStarted;
  exports.teamsDowngradeCompleted = teamsDowngradeCompleted;
  exports.teamsDiscountClaimed = teamsDiscountClaimed;
  exports.teamsAllTimeStatsViewed = teamsAllTimeStatsViewed;
  exports.teamsSubscriptionCancellationAbandoned =
    teamsSubscriptionCancellationAbandoned;
  exports.webPageViewed = webPageViewed;
  exports.teamsOverviewMetricsFailed = teamsOverviewMetricsFailed;
  exports.profileNameAddStarted = profileNameAddStarted;
  exports.profileNameAddCompleted = profileNameAddCompleted;
  exports.profileNameUpdateStarted = profileNameUpdateStarted;
  exports.profileNameUpdateCompleted = profileNameUpdateCompleted;
  exports.teamsDunningWarningModalStarted = teamsDunningWarningModalStarted;
  exports.teamsDunningWarningModalAbandoned = teamsDunningWarningModalAbandoned;
  exports.teamsUpdatePaymentStarted = teamsUpdatePaymentStarted;
  exports.teamsUpdatePaymentCompleted = teamsUpdatePaymentCompleted;
  exports.teamsResubscribeModalStarted = teamsResubscribeModalStarted;
  exports.teamsResubscribeModalAbandoned = teamsResubscribeModalAbandoned;
  exports.teamsUpdatePaymentFailed = teamsUpdatePaymentFailed;
  exports.teamsUpdatePaymentAbandoned = teamsUpdatePaymentAbandoned;
  exports.reportCreationStepCompleted = reportCreationStepCompleted;
  exports.contactAddStarted = contactAddStarted;
  exports.contactAddCompleted = contactAddCompleted;
  exports.teamsDrivesSummaryFiltered = teamsDrivesSummaryFiltered;
  exports.teamsDrivesListFiltered = teamsDrivesListFiltered;
  exports.teamsDrivesListOpened = teamsDrivesListOpened;
  exports.teamsDriveSelected = teamsDriveSelected;
  exports.teamsDrivesExportStarted = teamsDrivesExportStarted;
  exports.teamsDrivesExportCompleted = teamsDrivesExportCompleted;
  exports.excludeCommuteEnabled = excludeCommuteEnabled;
  exports.excludeCommuteDisabled = excludeCommuteDisabled;
  exports.excludeCommuteSettingsUpdateStarted =
    excludeCommuteSettingsUpdateStarted;
  exports.excludeCommuteSettingsUpdateCompleted =
    excludeCommuteSettingsUpdateCompleted;
  exports.excludeCommuteSettingsUpdateFailed =
    excludeCommuteSettingsUpdateFailed;
  exports.teamsDriveReviewCompleted = teamsDriveReviewCompleted;
  exports.teamsDriveReviewCtaSelected = teamsDriveReviewCtaSelected;
  exports.teamsDriveReviewAllSelected = teamsDriveReviewAllSelected;
  exports.teamsDriveReviewFailed = teamsDriveReviewFailed;
  exports.teamsDriveReviewStarted = teamsDriveReviewStarted;
  exports.automaticReportSubmissionUpdated = automaticReportSubmissionUpdated;
  exports.teamsDriveReviewCompletedBraze = teamsDriveReviewCompletedBraze;
  exports.teamsDriveCommentStarted = teamsDriveCommentStarted;
  exports.teamsDriveCommentCompleted = teamsDriveCommentCompleted;
  exports.teamsDriveCommentFailed = teamsDriveCommentFailed;
  exports.automaticReviewEnabled = automaticReviewEnabled;
  exports.automaticReviewDisabled = automaticReviewDisabled;
  exports.setup_ = setup_;
  exports.initAvo = initAvo;
  exports.WebDebuggerPosition = WebDebuggerPosition;
  exports.avoInspectorApiKey = avoInspectorApiKey;
})(typeof exports === "undefined" ? (this.Avo = {}) : exports);

// AVOMODULEMAP:"Avo"
// AVOEVENTMAP:["signupEmailAdded","signupCompleted","signupStarted","overlayItemInteracted","loginStarted","loginEmailAdded","loginCompleted","passwordResetStarted","passwordResetRequested","passwordResetCompleted","loginFailed","passwordResetFailed","upgradeStarted","teamsSignupStarted","teamsSignupStepCompleted","teamsSignupCompleted","teamsUpgradeStarted","teamsUpgradePlanSelected","teamsUpgradeCompleted","teamsInviteStarted","teamsInviteEmailAdded","teamsInviteCompleted","teamsInviteFailed","teamsDeletionStarted","teamsDeletionCompleted","teamsSettingUpdated","helpSelected","teamsRemoveUserStarted","teamsRemoveUserCompleted","teamsUpdateUserStarted","teamsUpdateUserCompleted","driverReportDownloaded","driverReportEmailStarted","driverReportEmailCompleted","driverReportRejectionStarted","driverReportRejectionCompleted","driverReportRejectionCancelled","teamsInviteAccepted","teamsInviteResent","teamsInviteRevoked","experimentViewed","bulkUploadStarted","bulkUploadStepCompleted","bulkUploadCompleted","bulkUploadFailed","teamsUserListDownloaded","userSelected","teamsCustomRatesUpdateStarted","teamsCustomRatesUpdateCompleted","shareMileiqSelected","blogSelected","vehicleAddStarted","vehicleUpdated","vehicleAddCompleted","appDownloadRequested","appDownloadRequestFailed","upgradeCompleted","subscriptionUpdateStarted","subscriptionUpdateCompleted","frequentDrivesPreferenceChanged","workHoursUpdateStarted","workHoursUpdateCompleted","workHoursUpdateFailed","customPurposeAddStarted","customPurposeAddCompleted","customPurposeUpdated","distanceUnitUpdated","distanceRateUpdateCompleted","reportsFiltered","reportCreationStarted","reportCreationCompleted","reportCreationFailed","reportDownloaded","reportDeleted","integrationStarted","integrationStepCompleted","integrationCompleted","integrationFailed","integrationEnableStarted","integrationEnableCompleted","integrationEditStarted","integrationEditCompleted","integrationEditFailed","integrationRemoved","integrationChecked","frequentDrivePrompted","frequentDriveEdited","driveMapEnlarged","driveAddStarted","driveAddCompleted","namedLocationCreated","namedLocationEdited","driveDuplicateStarted","driveDuplicateCompleted","driveJoinStarted","driveJoinCompleted","driveDeleteStarted","driveDeleteCompleted","driveClassifyStarted","driveClassifyCompleted","driveEdited","drivesFiltered","drivesAdvanceFiltered","driveSelected","accountDropdownSelected","accountSignedOut","dashboardSwitched","emailSettingUpdated","distanceRateUpdateStarted","productPreferenceSelected","inviteAdminStarted","inviteAdminStepCompleted","inviteAdminCompleted","featureDetailSelected","teamsReportsFiltered","driverReportSelected","driverReportOpened","driverReportDriveSelected","driverReportDetailsFiltered","teamsConsolidatedReportStarted","teamsConsolidatedReportCompleted","productPreferenceSubmitted","usernameEditStarted","usernameEditStepCompleted","usernameEditCompleted","pageViewed","addSharedNamedLocationStarted","addSharedNamedLocationStep","addSharedNamedLocationCompleted","renameSharedNamedLocationStarted","renameSharedNamedLocationCompleted","deleteSharedNamedLocationStarted","deleteSharedNamedLocationCompleted","sharedNamedLocationFailed","teamsSubscriptionCancelationStarted","teamsSubscriptionCancelationCompleted","actionUndone","searchStarted","searchCompleted","teamsFreeTrialSelected","teamsFreeTrialRejected","teamsUpgradeAbandoned","reportRemindersEnabled","reportRemindersScheduleUpdated","reportRemindersDisabled","signupFailed","automaticReportSubmissionEnabled","automaticReportSubmissionDisabled","subscriptionCancelStarted","subscriptionCancelReasonSelected","subscriptionCancelCompleted","teamsDowngradeStarted","teamsDowngradeCompleted","teamsDiscountClaimed","teamsAllTimeStatsViewed","teamsSubscriptionCancellationAbandoned","webPageViewed","teamsOverviewMetricsFailed","profileNameAddStarted","profileNameAddCompleted","profileNameUpdateStarted","profileNameUpdateCompleted","teamsDunningWarningModalStarted","teamsDunningWarningModalAbandoned","teamsUpdatePaymentStarted","teamsUpdatePaymentCompleted","teamsResubscribeModalStarted","teamsResubscribeModalAbandoned","teamsUpdatePaymentFailed","teamsUpdatePaymentAbandoned","reportCreationStepCompleted","contactAddStarted","contactAddCompleted","teamsDrivesSummaryFiltered","teamsDrivesListFiltered","teamsDrivesListOpened","teamsDriveSelected","teamsDrivesExportStarted","teamsDrivesExportCompleted","excludeCommuteEnabled","excludeCommuteDisabled","excludeCommuteSettingsUpdateStarted","excludeCommuteSettingsUpdateCompleted","excludeCommuteSettingsUpdateFailed","teamsDriveReviewCompleted","teamsDriveReviewCtaSelected","teamsDriveReviewAllSelected","teamsDriveReviewFailed","teamsDriveReviewStarted","automaticReportSubmissionUpdated","teamsDriveReviewCompletedBraze","teamsDriveCommentStarted","teamsDriveCommentCompleted","teamsDriveCommentFailed","automaticReviewEnabled","automaticReviewDisabled"]
